import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: unknown; output: unknown; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: unknown; output: unknown; }
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: unknown; output: unknown; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: unknown; output: unknown; }
  /**
   * Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: unknown; output: unknown; }
};

/** A class used to define a mutation for accepting an LLM customization and updating the note or template in the database. */
export type AcceptLlmCustomization = {
  __typename?: 'AcceptLLMCustomization';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A class used to define the input fields required to accept an LLM customization.
 *
 * Attributes:
 *     llm_customization_uuid (str): The UUID of the LLM customization. This field is required.
 */
export type AcceptLlmCustomizationsInput = {
  accepted: Scalars['Boolean']['input'];
  finalContent: Scalars['String']['input'];
  llmCustomizationUuid: Scalars['String']['input'];
};

/**
 * Mutation to add a user as a member of the team for which they
 * are accepting an invitation to
 */
export type AcceptTeamInvitation = {
  __typename?: 'AcceptTeamInvitation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Represents a billing account in Scribenote.
 *
 * Accounts manage subscription status, Stripe integration, and PDF branding settings.
 * Multiple users can share the same account (team accounts).
 *
 * Note: The `id` field is intentionally excluded from the GraphQL schema for security.
 */
export type Account = {
  __typename?: 'Account';
  accountDetails?: Maybe<AccountDetails>;
  accountType?: Maybe<Scalars['String']['output']>;
  autoUsageDetails?: Maybe<AutoUsageDetails>;
  createdAt: Scalars['DateTime']['output'];
  freeTrialExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  headerInfoPdf?: Maybe<Scalars['String']['output']>;
  isStudent?: Maybe<Scalars['Boolean']['output']>;
  isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  isTeamsCustomer?: Maybe<Scalars['Boolean']['output']>;
  logoContentType?: Maybe<Scalars['String']['output']>;
  logoFileLink?: Maybe<Scalars['String']['output']>;
  logoStorageObjectName?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<Scalars['GenericScalar']['output']>;
  shouldHidePresetTemplates?: Maybe<Scalars['Boolean']['output']>;
  shouldUseSimpleAppearancePdf?: Maybe<Scalars['Boolean']['output']>;
  signUpCoupon?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type AccountDetails = {
  __typename?: 'AccountDetails';
  billingFrequency?: Maybe<Scalars['String']['output']>;
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardExpiryDate?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  cardholderAddress?: Maybe<Scalars['String']['output']>;
  cardholderName?: Maybe<Scalars['String']['output']>;
  isCanceled?: Maybe<Scalars['Boolean']['output']>;
  isCanceledFinal?: Maybe<Scalars['Boolean']['output']>;
  isOnFreeTrial?: Maybe<Scalars['Boolean']['output']>;
  nextBillingDate?: Maybe<Scalars['String']['output']>;
  nextInvoiceInfo?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  planPrice?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export enum ActionEnum {
  Add = 'ADD',
  Remove = 'REMOVE'
}

/**
 * A class used to define the input fields required to add feedback to an LLM customization.
 *
 * Attributes:
 *     llm_customization_uuid (str): The UUID of the LLM customization. This field is required.
 *     rating (str): The rating that is either 'good' or 'bad'. This field is required.
 *     feedback (str): The feedback in comment form. This field is not required.
 */
export type AddFeedbackInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  llmCustomizationUuid: Scalars['String']['input'];
  rating: Scalars['String']['input'];
};

export type AddFeedbackToCustomization = {
  __typename?: 'AddFeedbackToCustomization';
  ok?: Maybe<Scalars['String']['output']>;
};

export type AddFeedbackToLog = {
  __typename?: 'AddFeedbackToLog';
  ok?: Maybe<Scalars['String']['output']>;
};

/**
 * Admin-only add of users to the MPH Companion opt-in segment.
 *
 * Gated by `admin_portal:editor`. Each valid, existing user UUID is added
 * (with the `user-uuid-` prefix) to the environment-appropriate LaunchDarkly
 * segment in a single call; malformed or unknown uuids are skipped with a
 * reason. Input is canonicalized and deduped so casing/repeats don't matter.
 * In production a `TOPREQ-NNN` tracking ticket is required and recorded (with
 * the acting admin and a link to the ticket) in the segment's LaunchDarkly
 * change history; outside production the ticket is optional.
 */
export type AddMphCompanionMembers = {
  __typename?: 'AddMphCompanionMembers';
  added: Array<AdminMphCompanionMember>;
  skipped: Array<AddMphCompanionSkipped>;
};

/** Reason a uuid in AddMphCompanionMembers wasn't added. */
export enum AddMphCompanionSkipReason {
  AlreadyMember = 'ALREADY_MEMBER',
  InvalidUuid = 'INVALID_UUID',
  NotFound = 'NOT_FOUND'
}

/** A skipped uuid + reason from an AddMphCompanionMembers call. */
export type AddMphCompanionSkipped = {
  __typename?: 'AddMphCompanionSkipped';
  reason: AddMphCompanionSkipReason;
  uuid: Scalars['String']['output'];
};

/**
 * Attach a standalone note to an existing group or to another note.
 *
 * `target_uuid` may be a NoteGroup UUID or a Note UUID — the server
 * resolves it. See AddNoteToGroupUseCase for full semantics.
 */
export type AddNoteToGroup = {
  __typename?: 'AddNoteToGroup';
  noteGroup?: Maybe<NoteGroup>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AddOrgAdmin = {
  __typename?: 'AddOrgAdmin';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A class used to define the input fields required to add users to a team within an organization.
 *
 * Attributes:
 *     email (str): The email address of the user. This field is required.
 *     first_name (str): The first name of the user. This field is required.
 *     last_name (str): The last name of the user. This field is required.
 *     role_id (int): The role of the user. This field is optional.
 */
export type AddUserData = {
  accountType: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isAdmin: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  roleId: Scalars['Int']['input'];
};

export type AddUsersToTeam = {
  __typename?: 'AddUsersToTeam';
  ok?: Maybe<Scalars['Boolean']['output']>;
  provisionedUsers?: Maybe<ProvisionedUsers>;
};

/**
 * A class used to define the input fields required to add a user to a team.
 * Allows for adding new users or existing users to a team via a direct add.
 *
 * Attributes:
 *     new_user_data (List[AddUserData]): A list of user data for new users to add to the team. This field is required.
 *     existing_user_data (List[AddUserData]): A list of user data for existing users to add to the team. This field is required.
 *     team_uuid (str): The UUID of the team. This field is required.
 */
export type AddUsersToTeamInput = {
  createdAt: Scalars['DateTime']['input'];
  existingUserData: Array<InputMaybe<AddUserData>>;
  newUserData: Array<InputMaybe<AddUserData>>;
  teamUuid: Scalars['String']['input'];
};

/** Basic account fields returned by the admin user lookup query. */
export type AdminAccountInfo = {
  __typename?: 'AdminAccountInfo';
  accountType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  freeTrialExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isTeamsCustomer?: Maybe<Scalars['Boolean']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** A (account_type, count) pair in a Stripe customer's linkage summary. */
export type AdminAccountTypeCount = {
  __typename?: 'AdminAccountTypeCount';
  accountType: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

/** Full admin view of a single agent session — metadata, tokens, treats, events. */
export type AdminAgentSessionDetail = {
  __typename?: 'AdminAgentSessionDetail';
  attachments: Array<Attachment>;
  createdAt: Scalars['DateTime']['output'];
  effort: Scalars['String']['output'];
  events: AgentSessionEventsPage;
  managedAgentEnv?: Maybe<Scalars['String']['output']>;
  managedAgentId?: Maybe<Scalars['String']['output']>;
  managedAgentVersion?: Maybe<Scalars['String']['output']>;
  managedSessionId: Scalars['String']['output'];
  modelName: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  tokens: AdminAgentSessionTokens;
  totalTreatsUsed: Scalars['Int']['output'];
  treatsBreakdown: Array<AdminAgentSessionTreatLine>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userUuid?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** Row for the admin agent-session list view. */
export type AdminAgentSessionListItem = {
  __typename?: 'AdminAgentSessionListItem';
  attachmentCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  inputTokens: Scalars['Int']['output'];
  modelName: Scalars['String']['output'];
  outputTokens: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  transactionCount: Scalars['Int']['output'];
  treatsUsed: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

/** Page of an admin user's agent sessions plus user-wide context. */
export type AdminAgentSessionListResult = {
  __typename?: 'AdminAgentSessionListResult';
  account?: Maybe<AdminAccountInfo>;
  sessions: Array<AdminAgentSessionListItem>;
  totals: AdminAgentSessionTotals;
  treats?: Maybe<AdminTreatInfo>;
  user?: Maybe<AdminUserInfo>;
};

/** Aggregated token usage for an agent session. */
export type AdminAgentSessionTokens = {
  __typename?: 'AdminAgentSessionTokens';
  cacheCreation: Scalars['Int']['output'];
  cacheRead: Scalars['Int']['output'];
  input: Scalars['Int']['output'];
  output: Scalars['Int']['output'];
};

/** User-wide totals across all agent sessions, ignoring list pagination. */
export type AdminAgentSessionTotals = {
  __typename?: 'AdminAgentSessionTotals';
  attachmentCount: Scalars['Int']['output'];
  cacheCreationTokens: Scalars['Int']['output'];
  cacheReadTokens: Scalars['Int']['output'];
  inputTokens: Scalars['Int']['output'];
  outputTokens: Scalars['Int']['output'];
  sessionCount: Scalars['Int']['output'];
  transactionCount: Scalars['Int']['output'];
  treatsUsed: Scalars['Int']['output'];
};

/** A single (companion, model) line item of treat usage for a session. */
export type AdminAgentSessionTreatLine = {
  __typename?: 'AdminAgentSessionTreatLine';
  cacheCreationTokens: Scalars['Int']['output'];
  cacheReadTokens: Scalars['Int']['output'];
  companionType?: Maybe<Scalars['String']['output']>;
  inputTokens: Scalars['Int']['output'];
  modelName?: Maybe<Scalars['String']['output']>;
  outputTokens: Scalars['Int']['output'];
  transactionCount: Scalars['Int']['output'];
  treatsUsed: Scalars['Int']['output'];
};

/** An org-linked Stripe customer surfaced by the wire-up picker. */
export type AdminBillingCustomerRow = {
  __typename?: 'AdminBillingCustomerRow';
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationUuid?: Maybe<Scalars['String']['output']>;
  stripeCustomerId: Scalars['String']['output'];
};

/** Result of adminSearchBillingCustomers. */
export type AdminBillingCustomerSearchResult = {
  __typename?: 'AdminBillingCustomerSearchResult';
  customers: Array<AdminBillingCustomerRow>;
};

export type AdminBulkDeleteApplied = {
  __typename?: 'AdminBulkDeleteApplied';
  flagSet: Scalars['Boolean']['output'];
  flagWasSet: Scalars['Boolean']['output'];
  isMphOrgAdmin: Scalars['Boolean']['output'];
  rowNumber: Scalars['Int']['output'];
  userEmail: Scalars['String']['output'];
  userUuid: Scalars['String']['output'];
  wasDeleted: Scalars['Boolean']['output'];
};

export type AdminBulkDeleteRejected = {
  __typename?: 'AdminBulkDeleteRejected';
  reason: MphBulkDeleteRejectReason;
  rowNumber: Scalars['Int']['output'];
  userUuid: Scalars['String']['output'];
};

export type AdminBulkDeleteRowInput = {
  rowNumber: Scalars['Int']['input'];
  userUuid: Scalars['String']['input'];
};

/**
 * Superadmin-only. Soft-deletes users by uuid (BE-2902).
 *
 * Runs `UserService.mark_for_deletion` per user and reads the Redis
 * sentinel before and after. Already-deleted users are applied and get the
 * sentinel re-set. Memberships, notes and billing are unchanged. Dry run by
 * default.
 */
export type AdminBulkMarkUsersForDeletion = {
  __typename?: 'AdminBulkMarkUsersForDeletion';
  applied: Array<AdminBulkDeleteApplied>;
  dryRun: Scalars['Boolean']['output'];
  rejected: Array<AdminBulkDeleteRejected>;
  success: Scalars['Boolean']['output'];
};

/** Team reference in MPH bulk tool results (uuid + org tell same-named teams apart). */
export type AdminBulkTeamRef = {
  __typename?: 'AdminBulkTeamRef';
  name?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** One Pay It Furward cash-out (prepaid card redemption). Money in cents. */
export type AdminCashOut = {
  __typename?: 'AdminCashOut';
  amountCents: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  errorFromTremendous: Scalars['Boolean']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  status: CreditRedemptionStatus;
  tremendousOrderId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Page of a user's cash-outs, newest first, + total. */
export type AdminCashOutsPage = {
  __typename?: 'AdminCashOutsPage';
  cashOuts: Array<AdminCashOut>;
  total: Scalars['Int']['output'];
};

/**
 * Admin-only hard delete of a team that nothing is attached to.
 *
 * Gated by `admin_portal:editor`. Refuses unless the team has no
 * memberships and no notes, because `notes.team_id` is
 * `ON DELETE SET NULL` and `user_team` is `ON DELETE CASCADE` — the
 * database would happily take the team down and quietly orphan the
 * notes and drop the memberships with it. The point of this mutation is
 * to remove an empty shell, never to remove data along with it, so the
 * check is the mutation.
 *
 * The refusal names the counts that blocked it, so an operator who hits
 * this on a stale page is told what is actually in the way.
 *
 * The check and the delete are not atomic. A membership or note created
 * between them is dropped or orphaned with the team. Accepted: it needs
 * a write racing against an already-empty team.
 *
 * Audit-logged as `delete_team` by `TeamService.delete`.
 */
export type AdminDeleteTeam = {
  __typename?: 'AdminDeleteTeam';
  name?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

/**
 * Admin-only deletion of a verified phone number.
 *
 * ``soft_delete`` removes the Twilio OutgoingCallerId when this is the last
 * VERIFIED record for the number, freeing it for re-verification.
 * Twilio failures are logged at the service layer but do not block the soft delete.
 */
export type AdminDeleteVerifiedPhoneNumber = {
  __typename?: 'AdminDeleteVerifiedPhoneNumber';
  ok: Scalars['Boolean']['output'];
};

/**
 * Admin-only edit of a billing account's limited editable fields.
 *
 * Gated by `admin_portal:editor`. Audit-logged via `log_changes` so
 * the entry captures the old → new field diff.
 */
export type AdminEditAccount = {
  __typename?: 'AdminEditAccount';
  account?: Maybe<AdminAccountInfo>;
};

export type AdminEditOrganization = {
  __typename?: 'AdminEditOrganization';
  name: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

/**
 * All-or-nothing edit of an org's outbound email overrides. Every row is
 * validated (shape, Postmark, placeholder allowlist) before any is written.
 */
export type AdminEditOrganizationEmailSettings = {
  __typename?: 'AdminEditOrganizationEmailSettings';
  ok: Scalars['Boolean']['output'];
  settings: Array<AdminOrganizationEmailSetting>;
  uuid: Scalars['String']['output'];
};

/**
 * Admin-only edit of an organization's recording-consent settings.
 *
 * Replaces the support-SQL edits documented in
 * docs/runbooks/recording_consent_export.md with an audited app write path.
 * Gated by `admin_portal:editor`; the field-level before/after diff is
 * written to the internal audit log via `log_changes`
 * (action `update_org_recording_consent`).
 *
 * Semantics (mirroring the runbook's invariants):
 * - Omitted arguments are left untouched; a no-op call writes no audit entry.
 * - `requiresRecordingConsent` is the sole enforcement gate — setting it
 *   TRUE starts consent enforcement for the org's users immediately.
 * - `consentHeader` is presentation-only and versionless; blank/whitespace
 *   clears the override (falls back to the app default).
 * - `consentText` + `consentTextVersion` are an ATOMIC PAIR: provide both
 *   to set the override, or blank both to revert to the app defaults.
 *   Changing the text requires a version label that is NEW for the org —
 *   never one already stamped onto events with different wording — because
 *   exports group events by version label.
 */
export type AdminEditOrganizationRecordingConsent = {
  __typename?: 'AdminEditOrganizationRecordingConsent';
  consentHeader?: Maybe<Scalars['String']['output']>;
  consentText?: Maybe<Scalars['String']['output']>;
  consentTextVersion?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  requiresRecordingConsent: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type AdminEditTeam = {
  __typename?: 'AdminEditTeam';
  name: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

/**
 * Admin-only edit of one membership: role, team-admin status, or both.
 *
 * Every argument but the two identifiers is optional; whatever is
 * omitted is read back off the row and written unchanged, so a caller
 * editing one field can't clobber the other.
 *
 * Deliberately billing-inert. The customer-facing `UpdateUserTeam`
 * moves the org's Stripe subscription quantity when a role change
 * crosses the billable boundary (`is_billable_role` — DVM and Locum);
 * this mutation only corrects membership data, so staff can't shift a
 * customer's bill from a table cell. Nothing here touches Stripe or
 * the account type. Team-admin status has no billing dimension at all.
 *
 * That leaves a real gap on the role side: after a boundary-crossing
 * change the org's seat count and its billable-role count can
 * disagree. Rather than reconcile it silently,
 * `crosses_billable_boundary` reports it for the caller to surface —
 * computed from the same helper the billing logic uses, so the two
 * can't drift apart.
 *
 * That flag means exactly what its name says — the role crossed the
 * DVM/Locum line — and deliberately nothing more. What a crossing
 * *means* for billing depends on the member's plan and whose card
 * they are on, and the admin portal decides that client-side (see
 * `apps/admin/src/pages/teams/billingImpact.ts` in the frontend
 * repo): billing follows the plan, so a free-plan member is not a
 * billed seat whichever role they hold, and a member on their own
 * card affects their own subscription rather than the org's.
 * Narrowing this flag to "a seat actually moved" was tried and
 * reverted — it silenced the free-plan case, which still needs
 * saying, just differently.
 *
 * `team_active_admin_count` excludes deleted and disabled users, who
 * keep their `user_team.is_admin` flag through a soft delete — it is
 * the one to threshold a last-admin warning on. `team_admin_count`
 * counts every admin membership and so matches the badges a members
 * table renders; returning both lets a client show the discrepancy
 * rather than silently disagreeing with itself.
 *
 * `team_admin_count` is returned so a client can warn before (and
 * reflect after) a change that leaves a team with no admins. Removing
 * the last one is allowed: staff sometimes need to unwind a team, and
 * a hard block would leave them no way to do it here.
 *
 * Audit trail comes from `UserTeamService.update_user_team_settings`
 * (`log_changes` → `update_team_member_role`), same delegation as
 * `AdminEditTeam`.
 */
export type AdminEditTeamMember = {
  __typename?: 'AdminEditTeamMember';
  crossesBillableBoundary: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  ok: Scalars['Boolean']['output'];
  role?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['Int']['output']>;
  teamActiveAdminCount: Scalars['Int']['output'];
  teamAdminCount: Scalars['Int']['output'];
};

/**
 * Admin-only edit of basic user profile fields.
 *
 * Gated by `admin_portal:editor`. Updates are logged to the audit
 * trail via `UserService.update` (which wraps
 * `AuditLogService.log_changes`), so the entry shows the admin actor,
 * their role, and the field-level diff. Only fields explicitly
 * provided are touched; a no-op call writes no audit entry.
 */
export type AdminEditUser = {
  __typename?: 'AdminEditUser';
  user?: Maybe<AdminUserInfo>;
};

/**
 * Admin-only grant of permanent treats to a user's account.
 *
 * Gated by `admin_portal:editor`. Credits the account's permanent
 * treat balance and logs the adjustment for auditability.
 */
export type AdminGiveTreats = {
  __typename?: 'AdminGiveTreats';
  monthlyBalance?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  permanentBalance?: Maybe<Scalars['Int']['output']>;
  totalBalance?: Maybe<Scalars['Int']['output']>;
};

/** An organization on a Stripe customer. A customer can back several. */
export type AdminLinkedOrg = {
  __typename?: 'AdminLinkedOrg';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** What removing one membership would mean for the org's Stripe bill. */
export type AdminMemberRemovalBillingCheck = {
  __typename?: 'AdminMemberRemovalBillingCheck';
  downgradesAccount: Scalars['Boolean']['output'];
  freesABilledSeat: Scalars['Boolean']['output'];
  lastTeamInOrg: Scalars['Boolean']['output'];
  onOrgStripeCustomer: Scalars['Boolean']['output'];
  orgStripeCustomerId?: Maybe<Scalars['String']['output']>;
};

/** What one membership carries on its team. */
export type AdminMemberRemovalImpact = {
  __typename?: 'AdminMemberRemovalImpact';
  companionSessionCount: Scalars['Int']['output'];
  noteCount: Scalars['Int']['output'];
  sharedPhoneNumbers: Array<Scalars['String']['output']>;
};

/** Everything the remove-from-team dialog needs for one membership. */
export type AdminMemberRemovalPreflight = {
  __typename?: 'AdminMemberRemovalPreflight';
  billingCheck?: Maybe<AdminMemberRemovalBillingCheck>;
  impact: AdminMemberRemovalImpact;
  isTeamOwner: Scalars['Boolean']['output'];
};

/**
 * One org group in the admin user-membership rollup.
 *
 * Direct-only org admins (no team in the org) appear with an empty
 * `teams` list. Teams with no parent org collapse into a single group
 * whose org identity fields are null. `is_admin` is set across the
 * board whenever `users.org_id` matches this org — not just for the
 * direct-only case.
 */
export type AdminMembershipOrgGroup = {
  __typename?: 'AdminMembershipOrgGroup';
  id?: Maybe<Scalars['Int']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  teams: Array<AdminMembershipTeam>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** A single team-membership row in the admin user-membership rollup. */
export type AdminMembershipTeam = {
  __typename?: 'AdminMembershipTeam';
  id?: Maybe<Scalars['Int']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/**
 * Re-parent a team into another org. Editor scope. Rewrites `teams.org_id`
 * only; Stripe and account rows are untouched. Guards and disclosure come from
 * `team_move_check`. Audits `update_team`, `remove_team_from_org`, `add_team_to_org`.
 */
export type AdminMoveTeamToOrg = {
  __typename?: 'AdminMoveTeamToOrg';
  moveCheck: AdminTeamMoveCheck;
  ok: Scalars['Boolean']['output'];
  org: AdminOrganizationInfo;
  uuid: Scalars['String']['output'];
};

/**
 * Superadmin-only. Sets `user_team.role_id` per row on a named MPH team (BE-2901).
 *
 * Does not change `users.role_id`, `is_admin` or billing. Unresolved rows and
 * users not on the team are returned in `rejected`. Dry run by default.
 */
export type AdminMphBulkAssignTeamRoles = {
  __typename?: 'AdminMphBulkAssignTeamRoles';
  applied: Array<AdminMphBulkRoleApplied>;
  dryRun: Scalars['Boolean']['output'];
  rejected: Array<AdminMphBulkRoleRejected>;
  success: Scalars['Boolean']['output'];
};

export type AdminMphBulkReassignApplied = {
  __typename?: 'AdminMphBulkReassignApplied';
  carriedTeamDefaults: Array<Scalars['String']['output']>;
  lostOrgAdmin: Scalars['Boolean']['output'];
  lostTeamAdmin: Scalars['Boolean']['output'];
  notesMoved: Scalars['Int']['output'];
  removedTeams: Array<AdminBulkTeamRef>;
  roleUnset: Scalars['Boolean']['output'];
  rowNumber: Scalars['Int']['output'];
  team: AdminBulkTeamRef;
  userEmail: Scalars['String']['output'];
};

export type AdminMphBulkReassignRejected = {
  __typename?: 'AdminMphBulkReassignRejected';
  candidates: Array<AdminBulkTeamRef>;
  reason: MphBulkReassignRejectReason;
  rowNumber: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
};

export type AdminMphBulkReassignRowInput = {
  rowNumber: Scalars['Int']['input'];
  teamName: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

/**
 * Superadmin-only. Makes the named MPH team each user's only team (BE-2900).
 *
 * Moves all the user's notes to the team, ends their other memberships
 * (any org), and clears team-admin and org-admin status. No billing
 * changes. Rows not resolving to one user and one team are returned in
 * `rejected`. Dry run by default.
 */
export type AdminMphBulkReassignTeams = {
  __typename?: 'AdminMphBulkReassignTeams';
  applied: Array<AdminMphBulkReassignApplied>;
  dryRun: Scalars['Boolean']['output'];
  rejected: Array<AdminMphBulkReassignRejected>;
  success: Scalars['Boolean']['output'];
};

export type AdminMphBulkRoleApplied = {
  __typename?: 'AdminMphBulkRoleApplied';
  changed: Scalars['Boolean']['output'];
  previousRole?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  team: AdminBulkTeamRef;
  userEmail: Scalars['String']['output'];
};

export type AdminMphBulkRoleRejected = {
  __typename?: 'AdminMphBulkRoleRejected';
  candidates: Array<AdminBulkTeamRef>;
  reason: MphBulkRoleRejectReason;
  role: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
};

export type AdminMphBulkRoleRowInput = {
  role: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
  teamName: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

/** Row in the MPH > Companion table; `found` is False for a segment UUID with no matching user. */
export type AdminMphCompanionMember = {
  __typename?: 'AdminMphCompanionMember';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  found: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  teams: Array<AdminMphCompanionTeam>;
  uuid: Scalars['String']['output'];
};

/** Page of MPH Companion segment members, plus the resolved segment and its LaunchDarkly URL. */
export type AdminMphCompanionMembersResult = {
  __typename?: 'AdminMphCompanionMembersResult';
  items: Array<AdminMphCompanionMember>;
  requiresTrackingTicket: Scalars['Boolean']['output'];
  segment: Scalars['String']['output'];
  segmentUrl: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

/** Team reference (uuid + name) attached to an MPH Companion member row. */
export type AdminMphCompanionTeam = {
  __typename?: 'AdminMphCompanionTeam';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/**
 * Full admin view of a single note — every `AdminNoteFields`
 * column plus the full transcription and a signed audio URL.
 */
export type AdminNoteDetail = AdminNoteFields & {
  __typename?: 'AdminNoteDetail';
  audioUrl?: Maybe<Scalars['String']['output']>;
  audioUrlError: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dentalChartStatus?: Maybe<Scalars['String']['output']>;
  hasDentalChart?: Maybe<Scalars['Boolean']['output']>;
  inboxLocation?: Maybe<InboxLocation>;
  isScribephone?: Maybe<Scalars['Boolean']['output']>;
  isTyped?: Maybe<Scalars['Boolean']['output']>;
  jobType?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  ownerUuid?: Maybe<Scalars['String']['output']>;
  recordingLength?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  templateOwnerUuid?: Maybe<Scalars['String']['output']>;
  templateUuid?: Maybe<Scalars['String']['output']>;
  timeToProcess?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
  user?: Maybe<AdminUserInfo>;
  uuid: Scalars['String']['output'];
};

/**
 * Row fields shared across the admin Notes feeds (the `adminUserNotes`
 * / `adminTeamNotes` lists and the `adminUserNote` detail) so the FE
 * spreads one fragment into all of them.
 */
export type AdminNoteFields = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dentalChartStatus?: Maybe<Scalars['String']['output']>;
  hasDentalChart?: Maybe<Scalars['Boolean']['output']>;
  inboxLocation?: Maybe<InboxLocation>;
  isScribephone?: Maybe<Scalars['Boolean']['output']>;
  isTyped?: Maybe<Scalars['Boolean']['output']>;
  jobType?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  ownerUuid?: Maybe<Scalars['String']['output']>;
  recordingLength?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  templateOwnerUuid?: Maybe<Scalars['String']['output']>;
  templateUuid?: Maybe<Scalars['String']['output']>;
  timeToProcess?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/**
 * Row in the admin Notes tab table. Every column the spec calls for
 * plus the joined team/template context, with no transcript or audio.
 * The detail modal uses `adminUserNote(uuid)` for the heavier payload.
 */
export type AdminNoteRow = AdminNoteFields & {
  __typename?: 'AdminNoteRow';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dentalChartStatus?: Maybe<Scalars['String']['output']>;
  hasDentalChart?: Maybe<Scalars['Boolean']['output']>;
  inboxLocation?: Maybe<InboxLocation>;
  isScribephone?: Maybe<Scalars['Boolean']['output']>;
  isTyped?: Maybe<Scalars['Boolean']['output']>;
  jobType?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  ownerUuid?: Maybe<Scalars['String']['output']>;
  recordingLength?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  templateOwnerUuid?: Maybe<Scalars['String']['output']>;
  templateUuid?: Maybe<Scalars['String']['output']>;
  timeToProcess?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/**
 * One choice for the admin Notes Template filter. ``job_type`` +
 * ``template_name`` render the label via templateDisplay(); adaptive
 * templates set ``template_name``, built-in modes only ``job_type``.
 * ``value`` is the encoded filter value to send back, built server-side so
 * the encoder sits with the decoder.
 */
export type AdminNoteTemplateOption = {
  __typename?: 'AdminNoteTemplateOption';
  jobType?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * Page of admin Notes rows + total count, ordered newest first.
 *
 * The Template filter's choices are deliberately NOT here: they span the whole
 * entity scope rather than the page, so returning them per request meant a
 * DISTINCT scan over every note the entity owns on every page click and every
 * debounced keystroke, and one the filters could never narrow. Fetch them once
 * per entity from ``adminNotesTemplateOptions``.
 */
export type AdminNotesPage = {
  __typename?: 'AdminNotesPage';
  notes: Array<AdminNoteRow>;
  total: Scalars['Int']['output'];
};

/** GraphQL mirror of `OrgEmailKey`; values are the registry keys. */
export enum AdminOrgEmailKey {
  AccountDeleted = 'ACCOUNT_DELETED',
  ClientSummary = 'CLIENT_SUMMARY',
  DeleteCustomerRequest = 'DELETE_CUSTOMER_REQUEST',
  EmailConfirmationCode = 'EMAIL_CONFIRMATION_CODE',
  ExportNoteEmbeddedCustom = 'EXPORT_NOTE_EMBEDDED_CUSTOM',
  ExportNoteEmbeddedSoap = 'EXPORT_NOTE_EMBEDDED_SOAP',
  ExportNoteLink = 'EXPORT_NOTE_LINK',
  MobileDashboardToDesktop = 'MOBILE_DASHBOARD_TO_DESKTOP',
  MobileNoteToDesktop = 'MOBILE_NOTE_TO_DESKTOP',
  PasswordReset = 'PASSWORD_RESET',
  PracticeManagerSetupExistingUser = 'PRACTICE_MANAGER_SETUP_EXISTING_USER',
  PracticeManagerSetupNewUser = 'PRACTICE_MANAGER_SETUP_NEW_USER',
  SharedTemplateNotification = 'SHARED_TEMPLATE_NOTIFICATION',
  TeamInviteAccepted = 'TEAM_INVITE_ACCEPTED',
  TeamInviteExistingUser = 'TEAM_INVITE_EXISTING_USER',
  TeamInviteNewUser = 'TEAM_INVITE_NEW_USER',
  TeamInviteRejected = 'TEAM_INVITE_REJECTED',
  TemplateRemovedFromGroup = 'TEMPLATE_REMOVED_FROM_GROUP',
  TranscriptionAlert = 'TRANSCRIPTION_ALERT',
  UserAddedByAdmin = 'USER_ADDED_BY_ADMIN',
  UserCreatedByAdmin = 'USER_CREATED_BY_ADMIN',
  UserDeactivatedByTeam = 'USER_DEACTIVATED_BY_TEAM'
}

/** One row of the Custom Outbound Email Templates card. */
export type AdminOrgEmailSettingInput = {
  emailKey: AdminOrgEmailKey;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  templateAlias?: InputMaybe<Scalars['String']['input']>;
};

/** A Postmark template rendered with the sample model for one email key. */
export type AdminOrgEmailTemplatePreview = {
  __typename?: 'AdminOrgEmailTemplatePreview';
  active: Scalars['Boolean']['output'];
  emailKey: AdminOrgEmailKey;
  htmlBody: Scalars['String']['output'];
  placeholders: Array<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  templateAlias: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
  textBody: Scalars['String']['output'];
  unsupportedPlaceholders: Array<Scalars['String']['output']>;
};

export type AdminOrganizationAdmin = {
  __typename?: 'AdminOrganizationAdmin';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/**
 * Reconciliation of Stripe's quantity against what its orgs are billed for.
 *
 * Replaces the Retool "Billing Info" callout. Stripe holds ONE quantity per
 * customer, and a customer can back several orgs (one clinic paying for all
 * of them), so the quantity is compared against the COMBINED count across
 * every org on the customer, not this org alone. `billable_count` is this
 * org's share, in its own basis; `organizations` is the breakdown;
 * `combined_billable_count` is what the quantity should equal.
 *
 * Per-seat orgs contribute distinct billed users (see
 * `count_billable_seats_on_customer`, which counts a user on teams in two of
 * the orgs once). Per-team orgs contribute teams with an active unlimited DVM
 * or Locum. A customer mixing the two bases still gets a verdict on the sum,
 * with `mixed_billing_bases` set so the client can disclose it.
 *
 * UNDERBILLING means Stripe is short. When the customer is shared, Stripe
 * cannot say which org is short, so neither does this.
 */
export type AdminOrganizationBilling = {
  __typename?: 'AdminOrganizationBilling';
  billableCount: Scalars['Int']['output'];
  billingBasis?: Maybe<OrgBillingBasis>;
  combinedBillableCount?: Maybe<Scalars['Int']['output']>;
  mixedBillingBases: Scalars['Boolean']['output'];
  organizations: Array<OrgBillingShare>;
  status: OrgBillingStatus;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  subscriptionQuantity?: Maybe<Scalars['Int']['output']>;
};

export type AdminOrganizationDetail = {
  __typename?: 'AdminOrganizationDetail';
  admins: Array<AdminOrganizationAdmin>;
  billingModeId?: Maybe<Scalars['Int']['output']>;
  billingModeName?: Maybe<Scalars['String']['output']>;
  consentHeader?: Maybe<Scalars['String']['output']>;
  consentText?: Maybe<Scalars['String']['output']>;
  consentTextVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultConsentHeader: Scalars['String']['output'];
  defaultConsentText: Scalars['String']['output'];
  defaultConsentTextVersion: Scalars['String']['output'];
  emailDomain?: Maybe<Scalars['String']['output']>;
  emailDomainSecondary?: Maybe<Scalars['String']['output']>;
  emailDomainTertiary?: Maybe<Scalars['String']['output']>;
  emailSettings: Array<AdminOrganizationEmailSetting>;
  id?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  outboundEmailOverridesEnabled: Scalars['Boolean']['output'];
  requiresRecordingConsent: Scalars['Boolean']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  teams: AdminOrganizationTeamsPage;
  uuid?: Maybe<Scalars['String']['output']>;
};


export type AdminOrganizationDetailTeamsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** One org-customisable email: the registry default plus any override. */
export type AdminOrganizationEmailSetting = {
  __typename?: 'AdminOrganizationEmailSetting';
  category: Scalars['String']['output'];
  customisable: Scalars['Boolean']['output'];
  defaultTemplateAlias: Scalars['String']['output'];
  description: Scalars['String']['output'];
  effectiveTemplateAlias: Scalars['String']['output'];
  emailKey: AdminOrgEmailKey;
  enabled: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  templateAlias?: Maybe<Scalars['String']['output']>;
};

export type AdminOrganizationInfo = {
  __typename?: 'AdminOrganizationInfo';
  billingModeId?: Maybe<Scalars['Int']['output']>;
  billingModeName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/**
 * A user belonging to a team in the org — the "set org admin" candidates.
 *
 * `is_admin` marks those who already hold ORG-admin status, so the picker can
 * show them as such instead of offering them again.
 */
export type AdminOrganizationMember = {
  __typename?: 'AdminOrganizationMember';
  adminOfOrganization?: Maybe<AdminOrganizationSummary>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  teams: Array<AdminOrganizationMemberTeam>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/**
 * One of a member's teams inside the org, and their role on it.
 *
 * `is_team_admin` is TEAM admin (`user_teams.is_admin`) — a different thing
 * from org admin (`users.org_id`), which is what the picker grants. It is
 * shown because team admins are usually the right people to promote.
 */
export type AdminOrganizationMemberTeam = {
  __typename?: 'AdminOrganizationMemberTeam';
  isTeamAdmin: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type AdminOrganizationMembersPage = {
  __typename?: 'AdminOrganizationMembersPage';
  members: Array<AdminOrganizationMember>;
  total: Scalars['Int']['output'];
};

export type AdminOrganizationSummary = {
  __typename?: 'AdminOrganizationSummary';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type AdminOrganizationTeam = {
  __typename?: 'AdminOrganizationTeam';
  id?: Maybe<Scalars['Int']['output']>;
  memberCount: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type AdminOrganizationTeamsPage = {
  __typename?: 'AdminOrganizationTeamsPage';
  teams: Array<AdminOrganizationTeam>;
  total: Scalars['Int']['output'];
};

export type AdminOrganizationsList = {
  __typename?: 'AdminOrganizationsList';
  organizations: Array<AdminOrganizationSummary>;
  total: Scalars['Int']['output'];
};

/** Pay It Furward referral record for a user. Monetary values are cents. */
export type AdminReferralInfo = {
  __typename?: 'AdminReferralInfo';
  canRedeem: Scalars['Boolean']['output'];
  creditsBalanceCents: Scalars['Int']['output'];
  minRedemptionAmountCents: Scalars['Int']['output'];
  numCashOuts: Scalars['Int']['output'];
  numPaidReferrals: Scalars['Int']['output'];
  numReferredSignups: Scalars['Int']['output'];
  referralCode?: Maybe<Scalars['String']['output']>;
  referrerEmail?: Maybe<Scalars['String']['output']>;
  referrerUuid?: Maybe<Scalars['String']['output']>;
  totalCreditsEarnedCents: Scalars['Int']['output'];
  totalCreditsRedeemedCents: Scalars['Int']['output'];
};

/** A user who signed up with the looked-up user's referral code. */
export type AdminReferredUser = {
  __typename?: 'AdminReferredUser';
  accountType?: Maybe<Scalars['String']['output']>;
  creditsEarnedCents?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  signedUpAt?: Maybe<Scalars['DateTime']['output']>;
  upgradedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Page of users referred by one user, newest signup first, + total. */
export type AdminReferredUsersPage = {
  __typename?: 'AdminReferredUsersPage';
  allTotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  users: Array<AdminReferredUser>;
};

/**
 * Admin-only removal of one membership. Editor scope.
 *
 * Ends a membership. It deletes nobody and nothing; the member keeps their
 * account, notes and verified numbers, which stop belonging to this team.
 * Touches neither Stripe nor the account type.
 */
export type AdminRemoveTeamMember = {
  __typename?: 'AdminRemoveTeamMember';
  membershipId: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  teamActiveAdminCount: Scalars['Int']['output'];
  teamAdminCount: Scalars['Int']['output'];
};

export type AdminResendInvitation = {
  __typename?: 'AdminResendInvitation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminRevokeInvitation = {
  __typename?: 'AdminRevokeInvitation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Admin-only clear of an organization's Stripe customer.
 *
 * Replaces Retool's "Revoke Org Stripe ID" button. Kept separate from the
 * update mutation — rather than treating a blank id as "clear" — so that
 * unlinking is always a deliberate call, matching the two-button shape of
 * the tool it replaces and the wire-up/un-wire pair on users.
 *
 * Like the update, this changes nothing in Stripe.
 */
export type AdminRevokeOrganizationStripeCustomer = {
  __typename?: 'AdminRevokeOrganizationStripeCustomer';
  ok: Scalars['Boolean']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/**
 * A settable team role, for the admin portal's role pickers.
 *
 * `is_billable` comes from the same `is_billable_role` helper the
 * customer-facing billing logic uses, so a client warning about a
 * billable-role change can't drift from what actually gets billed.
 */
export type AdminRoleOption = {
  __typename?: 'AdminRoleOption';
  id: Scalars['Int']['output'];
  isBillable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/**
 * Admin-only grant or revoke of org-admin status for one user.
 *
 * Org-admin status is `users.org_id` pointing at the org, so this is a
 * single-field write either way. Both directions replace a Retool action:
 * `isAdmin: true` its "Set Admin of <org>" picker, `isAdmin: false` its
 * removal. Unlike Retool, both are audited and membership-gated.
 *
 * An org can hold many admins, so granting ADDS to the list rather than
 * replacing the current holder.
 *
 * Granting requires the user to already belong to a team in the org — the
 * portal's picker only offers those users, and this is the server-side
 * enforcement of that rule.
 */
export type AdminSetOrganizationAdmin = {
  __typename?: 'AdminSetOrganizationAdmin';
  admins: Array<AdminOrganizationAdmin>;
  ok: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

/** What a Stripe customer id maps to in our system (orgs + accounts), for the wire-up confirm. */
export type AdminStripeCustomerLinkage = {
  __typename?: 'AdminStripeCustomerLinkage';
  accountTypeBreakdown: Array<AdminAccountTypeCount>;
  accountsOnCustomer: Scalars['Int']['output'];
  organizations: Array<AdminLinkedOrg>;
  sampleUserEmails: Array<Scalars['String']['output']>;
  stripeCustomerId: Scalars['String']['output'];
};

/**
 * Whether a team is safe to delete, and what is holding it back.
 *
 * A team may only be deleted once nothing points at it: every member has
 * moved off (taking their notes with them) and no note carries its id.
 * Both the confirm dialog and the ``adminDeleteTeam`` guard read this
 * same helper, so what an operator is told and what the server enforces
 * cannot drift apart.
 */
export type AdminTeamDeletionCheck = {
  __typename?: 'AdminTeamDeletionCheck';
  blockerSummary?: Maybe<Scalars['String']['output']>;
  canDelete: Scalars['Boolean']['output'];
  memberCount: Scalars['Int']['output'];
  noteCount: Scalars['Int']['output'];
};

export type AdminTeamDetail = {
  __typename?: 'AdminTeamDetail';
  activeAdminCount: Scalars['Int']['output'];
  adminCount: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletionCheck: AdminTeamDeletionCheck;
  id?: Maybe<Scalars['Int']['output']>;
  memberRemovalPreflight?: Maybe<AdminMemberRemovalPreflight>;
  /** @deprecated Use the adminTeamMembers root query, which also supports filters. This field is kept only so the frontend can deploy after the backend; it will be removed once nothing selects it. */
  members: AdminTeamMembersPage;
  moveCheck?: Maybe<AdminTeamMoveCheck>;
  name?: Maybe<Scalars['String']['output']>;
  noteCount: Scalars['Int']['output'];
  org?: Maybe<AdminOrganizationInfo>;
  orgId?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};


export type AdminTeamDetailMemberRemovalPreflightArgs = {
  userUuid: Scalars['String']['input'];
};


export type AdminTeamDetailMembersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminTeamDetailMoveCheckArgs = {
  targetOrgUuid: Scalars['String']['input'];
};

export type AdminTeamMember = {
  __typename?: 'AdminTeamMember';
  accountType?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  freeTrialExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  membershipId: Scalars['String']['output'];
  otherTeamCount: Scalars['Int']['output'];
  role?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['Int']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  userCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type AdminTeamMembersPage = {
  __typename?: 'AdminTeamMembersPage';
  members: Array<AdminTeamMember>;
  total: Scalars['Int']['output'];
};

/**
 * Preflight for `adminMoveTeamToOrg`, from the same `team_move_check` the
 * mutation guards on. `blocker_code` is the error code the mutation would
 * raise. `members_on_source_customer` are the seats that stay on the source
 * org's Stripe customer after the move.
 */
export type AdminTeamMoveCheck = {
  __typename?: 'AdminTeamMoveCheck';
  billingModeChanges: Scalars['Boolean']['output'];
  blockerCode?: Maybe<Scalars['String']['output']>;
  canMove: Scalars['Boolean']['output'];
  clashingTeam?: Maybe<AdminTeamSummary>;
  membersOnSourceCustomer: Array<AdminTeamMember>;
  sameStripeCustomer: Scalars['Boolean']['output'];
  sourceOrg?: Maybe<AdminOrganizationInfo>;
  sourceOrgRequiresRecordingConsent: Scalars['Boolean']['output'];
  ssoMemberCount: Scalars['Int']['output'];
  targetOrg: AdminOrganizationInfo;
};

export type AdminTeamSummary = {
  __typename?: 'AdminTeamSummary';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type AdminTeamsList = {
  __typename?: 'AdminTeamsList';
  teams: Array<AdminTeamSummary>;
  total: Scalars['Int']['output'];
};

/** A team or organization that set a template as its default. */
export type AdminTemplateDefault = {
  __typename?: 'AdminTemplateDefault';
  kind: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** A template's structure and preferences, for the admin detail modal. */
export type AdminTemplateDetail = {
  __typename?: 'AdminTemplateDetail';
  fields: Array<AdminTemplateField>;
  name: Scalars['String']['output'];
  userPreferences?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** A SOAP section, or the single CUSTOM body with the vet's inline instructions. */
export type AdminTemplateField = {
  __typename?: 'AdminTemplateField';
  fieldIdx: Scalars['Int']['output'];
  fieldName: Scalars['String']['output'];
  fieldValue: Scalars['String']['output'];
};

/** Treat balance snapshot for an account. */
export type AdminTreatBalanceInfo = {
  __typename?: 'AdminTreatBalanceInfo';
  monthlyBalance?: Maybe<Scalars['Int']['output']>;
  nextResetAt?: Maybe<Scalars['DateTime']['output']>;
  permanentBalance?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<AdminTreatPlan>;
  totalBalance?: Maybe<Scalars['Int']['output']>;
};

/** Treat balance and active plan for an account. */
export type AdminTreatInfo = {
  __typename?: 'AdminTreatInfo';
  balance?: Maybe<AdminTreatBalanceInfo>;
};

/** Active Companion subscription for an account. */
export type AdminTreatPlan = {
  __typename?: 'AdminTreatPlan';
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  monthlyTreats?: Maybe<Scalars['Int']['output']>;
  planKey?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Admin-only un-wire: the inverse of wire-up.
 *
 * Reverts the account to Basic and clears its Stripe customer id, replicating
 * the legacy Retool "revoke" action (which downgraded via the internal
 * `updateAccountPlan(account_type="basic")` mutation AND nulled
 * `stripe_customer_id` in raw SQL). Treats and free-trial expiry are left
 * untouched, matching that tool. Set fields inline rather than via
 * `AccountService.downgrade_account`, which also flips `is_teams_customer` and
 * conditionally keeps the Stripe id — neither of which the Retool revoke did.
 */
export type AdminUnwireAccount = {
  __typename?: 'AdminUnwireAccount';
  account?: Maybe<AdminAccountInfo>;
};

/**
 * Admin-only re-point of an organization's Stripe customer.
 *
 * The org-level counterpart of `AdminWireUpAccount`, replacing Retool's
 * "Update Org Stripe ID" button.
 *
 * Changes NOTHING in Stripe — it only re-points which customer this org
 * reads from. Existing subscriptions and seat/quantity counts are untouched
 * and must be adjusted in Stripe directly if they also need to change.
 *
 * Pointing at a customer another org already holds returns a non-blocking
 * `ORG_STRIPE_CUSTOMER_SHARED` warning and is recorded in the audit entry.
 * Not refused: support occasionally has to do it deliberately, so the
 * requirement is that it be deliberate and traceable rather than prevented.
 */
export type AdminUpdateOrganizationStripeCustomer = {
  __typename?: 'AdminUpdateOrganizationStripeCustomer';
  ok: Scalars['Boolean']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  warnings: Array<OrgStripeWarning>;
};

/**
 * Cheap aggregate counts surfaced alongside adminUserLookup so the
 * admin user view can render tab badges without firing the heavier
 * list queries.
 */
export type AdminUserCounts = {
  __typename?: 'AdminUserCounts';
  notes: Scalars['Int']['output'];
  templates: Scalars['Int']['output'];
};

/**
 * Basic user fields returned by the admin user lookup query.
 *
 * Dedicated admin-only type so the public `User` type stays lean
 * (the public `User` intentionally excludes `id`) while admins still
 * see the internal id.
 */
export type AdminUserInfo = {
  __typename?: 'AdminUserInfo';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  lastLoggedInAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Row in an admin user-list view (User Deletion, Inactive Accounts). */
export type AdminUserListItem = {
  __typename?: 'AdminUserListItem';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  lastLoggedInAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  noteCount: Scalars['Int']['output'];
  organizations: Array<AdminUserOrg>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  templateCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  verifiedPhoneCount: Scalars['Int']['output'];
};

/** Page of users + total count for an admin user-list view. */
export type AdminUserListResult = {
  __typename?: 'AdminUserListResult';
  items: Array<AdminUserListItem>;
  total: Scalars['Int']['output'];
};

/** User + associated account + treat + referral info returned by adminUserLookup. */
export type AdminUserLookupResult = {
  __typename?: 'AdminUserLookupResult';
  account?: Maybe<AdminAccountInfo>;
  counts?: Maybe<AdminUserCounts>;
  referral?: Maybe<AdminReferralInfo>;
  treats?: Maybe<AdminTreatInfo>;
  user?: Maybe<AdminUserInfo>;
};

/**
 * Result of adminUserMembership: a list of org groups, each with the
 * user's teams in that org.
 */
export type AdminUserMembershipResult = {
  __typename?: 'AdminUserMembershipResult';
  orgs: Array<AdminMembershipOrgGroup>;
};

/** An organization grouping a user's teams; null uuid/name is the "Ungrouped" bucket. */
export type AdminUserOrg = {
  __typename?: 'AdminUserOrg';
  name?: Maybe<Scalars['String']['output']>;
  teams: Array<AdminUserTeam>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Team reference (uuid + name) nested under an organization. */
export type AdminUserTeam = {
  __typename?: 'AdminUserTeam';
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** Row in the admin user Templates tab: one template the user created. */
export type AdminUserTemplate = {
  __typename?: 'AdminUserTemplate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultFor: Array<AdminTemplateDefault>;
  dentalChart: Scalars['Boolean']['output'];
  emailShareCount: Scalars['Int']['output'];
  isFavourite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  noteCount: Scalars['Int']['output'];
  sharedWithTeams: Array<AdminUserTeam>;
  sharingType: Scalars['String']['output'];
  templateType: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

/** Page of templates one user created, most recently updated first, + total. */
export type AdminUserTemplatesPage = {
  __typename?: 'AdminUserTemplatesPage';
  templates: Array<AdminUserTemplate>;
  total: Scalars['Int']['output'];
};

/** Result of adminVerifiedPhoneLookup. */
export type AdminVerifiedPhoneLookupResult = {
  __typename?: 'AdminVerifiedPhoneLookupResult';
  verifications: Array<AdminVerifiedPhoneVerification>;
};

/** Verification record returned by adminVerifiedPhoneLookup. */
export type AdminVerifiedPhoneVerification = {
  __typename?: 'AdminVerifiedPhoneVerification';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
  team?: Maybe<AdminVerifiedPhoneVerifierTeam>;
  twilioVerificationApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  twilioVerificationStatus?: Maybe<TwilioVerificationStatus>;
  twilioVerificationSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<AdminVerifiedPhoneVerifierUser>;
  verifiedPhoneNumberUuid?: Maybe<Scalars['String']['output']>;
};

/** Team info for a verifier in the admin phone lookup. */
export type AdminVerifiedPhoneVerifierTeam = {
  __typename?: 'AdminVerifiedPhoneVerifierTeam';
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** User info for a verifier in the admin phone lookup. */
export type AdminVerifiedPhoneVerifierUser = {
  __typename?: 'AdminVerifiedPhoneVerifierUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Admin-only wire-up of a user to the Unlimited plan. */
export type AdminWireUpAccount = {
  __typename?: 'AdminWireUpAccount';
  account?: Maybe<AdminAccountInfo>;
  warnings: Array<WireUpWarning>;
};

/** A Managed Agent session (Companion 2.0). */
export type AgentSession = {
  __typename?: 'AgentSession';
  createdAt: Scalars['DateTime']['output'];
  effort: Scalars['String']['output'];
  managedAgentEnv?: Maybe<Scalars['String']['output']>;
  managedAgentId?: Maybe<Scalars['String']['output']>;
  managedAgentVersion?: Maybe<Scalars['String']['output']>;
  managedSessionId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

/** A single event from a Managed Agent session. */
export type AgentSessionEvent = {
  __typename?: 'AgentSessionEvent';
  attachments: Array<Attachment>;
  companionsUsed: Array<Scalars['String']['output']>;
  content?: Maybe<Scalars['GenericScalar']['output']>;
  id: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  type: Scalars['String']['output'];
};

/** Paginated page of Managed Agent session events. */
export type AgentSessionEventsPage = {
  __typename?: 'AgentSessionEventsPage';
  events: Array<AgentSessionEvent>;
  nextPage?: Maybe<Scalars['String']['output']>;
  pendingPermissions: Array<CompanionToolPermissionRequest>;
  turnInFlight: Scalars['Boolean']['output'];
};

/** A persistent Companion permission grant for a scoped tool action. */
export type AgentToolPermissionGrant = {
  __typename?: 'AgentToolPermissionGrant';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  policyVersion: Scalars['String']['output'];
  toolAction: Scalars['String']['output'];
  toolName: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type AllowedRole = {
  __typename?: 'AllowedRole';
  name: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type AppendRecording = {
  __typename?: 'AppendRecording';
  note?: Maybe<Note>;
  ok?: Maybe<Scalars['String']['output']>;
};

export type AssociateQuicknotesWithPatient = {
  __typename?: 'AssociateQuicknotesWithPatient';
  ok?: Maybe<Scalars['String']['output']>;
};

/**
 * Attachment GraphQL type - file attachments for notes, patients, companion
 * sessions, and agent sessions (Companion 2.0).
 *
 * Attachments are uploaded files (images, PDFs, etc.) that can be associated
 * with notes, patients, companion sessions, or agent sessions.
 */
export type Attachment = {
  __typename?: 'Attachment';
  agentSession?: Maybe<AgentSession>;
  agentSessionUuid?: Maybe<Scalars['String']['output']>;
  companionSession?: Maybe<CompanionSession>;
  companionSessionUuid?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  extractedData?: Maybe<Scalars['String']['output']>;
  fileLink?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  managedFileId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Int']['output']>;
  patient?: Maybe<Patient>;
  patientId?: Maybe<Scalars['Int']['output']>;
  sentInEventId?: Maybe<Scalars['String']['output']>;
  storageObjectName?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type AttachmentInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  storageObjectName?: InputMaybe<Scalars['String']['input']>;
};

/** A single audit log entry. */
export type AuditLogEntry = {
  __typename?: 'AuditLogEntry';
  action?: Maybe<Scalars['String']['output']>;
  actorEmail?: Maybe<Scalars['String']['output']>;
  actorUuid?: Maybe<Scalars['String']['output']>;
  adminPortalRole?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  details?: Maybe<Scalars['GenericScalar']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  targetDisplayName?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  targetUuid?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

/** Paginated audit log result. */
export type AuditLogResult = {
  __typename?: 'AuditLogResult';
  entries?: Maybe<Array<Maybe<AuditLogEntry>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

/**
 * AuditTrail GraphQL type - tracks changes to notes and patients.
 *
 * Each audit trail entry records a revision with a diff stored in S3.
 */
export type AuditTrail = {
  __typename?: 'AuditTrail';
  auditLogType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fileLink?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  noteUuid?: Maybe<Scalars['String']['output']>;
  patientUuid?: Maybe<Scalars['String']['output']>;
  revisionNumber?: Maybe<Scalars['Int']['output']>;
  storageObjectName?: Maybe<Scalars['String']['output']>;
  userUuid?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents an auto-generated template.
 * Includes metadata like name, description, type, and user preferences.
 */
export type AutoTemplate = {
  __typename?: 'AutoTemplate';
  createdAt: Scalars['DateTime']['output'];
  dentalChart?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<AutoTemplateField>>>;
  id: Scalars['ID']['output'];
  isFavourite?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Array<Maybe<Note>>>;
  pdfStorageObjectName?: Maybe<Scalars['String']['output']>;
  sharedEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sharingType: SharingTypeEnum;
  teamDefaults?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  templatePreviews?: Maybe<Array<Maybe<TemplatePreviews>>>;
  templateType: TemplateTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  userPreferences?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/**
 * Represents a single field within an auto template.
 * Includes metadata like field name, index, and value.
 */
export type AutoTemplateField = {
  __typename?: 'AutoTemplateField';
  autoTemplate?: Maybe<AutoTemplate>;
  fieldIdx: Scalars['Int']['output'];
  fieldName: FieldNameEnum;
  fieldValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  templateId: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type AutoUsageDetails = {
  __typename?: 'AutoUsageDetails';
  isActiveAutoUser?: Maybe<Scalars['Boolean']['output']>;
  monthlyTotalPrice?: Maybe<Scalars['String']['output']>;
  monthlyUsageCount?: Maybe<Scalars['String']['output']>;
};

export type BirthdayParts = {
  __typename?: 'BirthdayParts';
  dd?: Maybe<Scalars['String']['output']>;
  mm?: Maybe<Scalars['String']['output']>;
  yyyy?: Maybe<Scalars['String']['output']>;
};

/** Reason a uuid in BulkRestoreUsers wasn't restored. */
export enum BulkRestoreSkipReason {
  InvalidUuid = 'INVALID_UUID',
  NotFound = 'NOT_FOUND',
  NotSoftDeleted = 'NOT_SOFT_DELETED'
}

/**
 * A skipped uuid + reason from a BulkRestoreUsers call.
 *
 * `email` is populated when the uuid resolved to a real user
 * (e.g. `NOT_SOFT_DELETED`); null when no user was found
 * (`INVALID_UUID`, `NOT_FOUND`).
 */
export type BulkRestoreSkipped = {
  __typename?: 'BulkRestoreSkipped';
  email?: Maybe<Scalars['String']['output']>;
  reason: BulkRestoreSkipReason;
  uuid: Scalars['String']['output'];
};

/**
 * Admin-only bulk restore of soft-deleted users.
 *
 * Bulk counterpart to `RestoreUser`. Gated by `admin_portal:editor`.
 * Skips invalid / unknown / already-active uuids with a reason.
 * Input uuids are canonicalized (lowercase `str(UUID)`) so input casing
 * doesn't affect lookup outcomes; the response echoes the canonical form.
 */
export type BulkRestoreUsers = {
  __typename?: 'BulkRestoreUsers';
  restoredUuids: Array<Scalars['String']['output']>;
  skipped: Array<BulkRestoreSkipped>;
};

/** Mutation only to be used by administrators authenticated by retool or for bulk account administrator by a team admin */
export type BulkSetExpiryPolicy = {
  __typename?: 'BulkSetExpiryPolicy';
  ok?: Maybe<Scalars['String']['output']>;
};

/** Mutation only to be used by administrators authenticated by retool or for bulk account administrator by a team admin */
export type BulkSetRole = {
  __typename?: 'BulkSetRole';
  ok?: Maybe<Scalars['String']['output']>;
};

/**
 * Admin-only: hard-delete a broadcast notification.
 *
 * Used to retract a system banner before its ``expires_at`` (e.g. an
 * outage notice posted in error). User notifications are canceled by
 * their owner via ``CancelNotification``; this mutation only operates
 * on broadcast rows (``user_id IS NULL``).
 */
export type CancelBroadcastNotification = {
  __typename?: 'CancelBroadcastNotification';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Hard-delete a notification owned by the current user.
 *
 * Used to cancel a scheduled notification before it becomes visible.
 * Also works for already-visible rows if the caller wants to forget
 * them entirely (vs dismiss, which leaves a row).
 */
export type CancelNotification = {
  __typename?: 'CancelNotification';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangeScribephoneConsentMode = {
  __typename?: 'ChangeScribephoneConsentMode';
  error?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** To be called with the deconstructor at the end of useEffet() */
export type CheckinNote = {
  __typename?: 'CheckinNote';
  ok?: Maybe<Scalars['String']['output']>;
};

/**
 * To be called when edit note is loaded. If the note has not been checked out, check it out via redis. If the note is checked out,
 * check who has checked it out, if it's the current user, then follow the checked out flow. Otherwise prompt the user that the
 * current note might be being edited by user.first_name user.last_name
 */
export type CheckoutNote = {
  __typename?: 'CheckoutNote';
  ok?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** This is the interface to the ClientSummaryPreferencesModel class. */
export type ClientSummaryPreferences = {
  __typename?: 'ClientSummaryPreferences';
  abnormalPhysicalFindings?: Maybe<Scalars['Boolean']['output']>;
  allFindings?: Maybe<Scalars['Boolean']['output']>;
  backmatter?: Maybe<Scalars['String']['output']>;
  diagnostics?: Maybe<Scalars['Boolean']['output']>;
  diet?: Maybe<Scalars['Boolean']['output']>;
  followUpAppointments?: Maybe<Scalars['Boolean']['output']>;
  frontmatter?: Maybe<Scalars['String']['output']>;
  homeCare?: Maybe<Scalars['Boolean']['output']>;
  medications?: Maybe<Scalars['Boolean']['output']>;
  oneLineSummary?: Maybe<Scalars['Boolean']['output']>;
  ownerInstructions?: Maybe<Scalars['Boolean']['output']>;
  pointFormSummary?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  vaccinations?: Maybe<Scalars['Boolean']['output']>;
  visitSummary?: Maybe<Scalars['Boolean']['output']>;
  vitals?: Maybe<Scalars['Boolean']['output']>;
};

export type ClientSummaryPreferencesType = {
  __typename?: 'ClientSummaryPreferencesType';
  abnormalPhysicalFindings?: Maybe<Scalars['Boolean']['output']>;
  allFindings?: Maybe<Scalars['Boolean']['output']>;
  backmatter?: Maybe<Scalars['String']['output']>;
  diagnostics?: Maybe<Scalars['Boolean']['output']>;
  diet?: Maybe<Scalars['Boolean']['output']>;
  followUpAppointments?: Maybe<Scalars['Boolean']['output']>;
  frontmatter?: Maybe<Scalars['String']['output']>;
  homeCare?: Maybe<Scalars['Boolean']['output']>;
  medications?: Maybe<Scalars['Boolean']['output']>;
  oneLineSummary?: Maybe<Scalars['Boolean']['output']>;
  ownerInstructions?: Maybe<Scalars['Boolean']['output']>;
  pointFormSummary?: Maybe<Scalars['Boolean']['output']>;
  vaccinations?: Maybe<Scalars['Boolean']['output']>;
  visitSummary?: Maybe<Scalars['Boolean']['output']>;
  vitals?: Maybe<Scalars['Boolean']['output']>;
};

export type CloseCompanionSession = {
  __typename?: 'CloseCompanionSession';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanionAccountSettings = {
  __typename?: 'CompanionAccountSettings';
  accountType?: Maybe<Scalars['String']['output']>;
  freeTrialExpiresAt?: Maybe<Scalars['String']['output']>;
  isTeamsCustomer?: Maybe<Scalars['Boolean']['output']>;
  preferences?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * User identity + team memberships + settings, injected into the
 * companion agent at session start. Not for general client consumption —
 * fields are chosen for agent context, not UI rendering.
 *
 * ``user`` and ``teams`` populate only when the query is called with
 * ``includeInitialContext: true``; the agent fetches them once per
 * session and omits them on later refresh calls. ``settings`` always
 * populates.
 */
export type CompanionContext = {
  __typename?: 'CompanionContext';
  settings?: Maybe<CompanionContextSettings>;
  teams?: Maybe<Array<Maybe<CompanionContextTeam>>>;
  user?: Maybe<CompanionContextUser>;
};

export type CompanionContextSettings = {
  __typename?: 'CompanionContextSettings';
  account?: Maybe<CompanionAccountSettings>;
  organizations?: Maybe<Array<Maybe<CompanionOrganizationSettings>>>;
  user?: Maybe<CompanionUserSettings>;
};

export type CompanionContextTeam = {
  __typename?: 'CompanionContextTeam';
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  memberCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationUuid?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type CompanionContextUser = {
  __typename?: 'CompanionContextUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type CompanionOrganizationSettings = {
  __typename?: 'CompanionOrganizationSettings';
  globalScribephoneConsentMode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/**
 * Parent object used for scoping all companion interactions.
 *
 * Contains messages, tasks, estimates, and knowledge from Companion AI sessions.
 * The user_id, team_id, and note_id fields are intentionally excluded from the schema.
 */
export type CompanionSession = {
  __typename?: 'CompanionSession';
  agentVersion?: Maybe<Scalars['String']['output']>;
  attachments: Array<Attachment>;
  companionSessionUuid: Scalars['String']['output'];
  companionsUsed: Array<CompanionTypeEnum>;
  createdAt: Scalars['DateTime']['output'];
  estimates: Array<CompanionSessionEstimate>;
  inventory?: Maybe<Inventory>;
  inventoryUuid?: Maybe<Scalars['String']['output']>;
  knowledge: Array<CompanionSessionKnowledge>;
  messages: Array<CompanionSessionMessage>;
  note?: Maybe<Note>;
  sessionType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusSummary: CompanionSessionStatusSummary;
  statusText?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tasks: Array<CompanionSessionTask>;
  team?: Maybe<Team>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

/** Deprecated. Companion estimate feature removed. */
export type CompanionSessionEstimate = {
  __typename?: 'CompanionSessionEstimate';
  companionSession?: Maybe<CompanionSession>;
  companionSessionEstimateUuid: Scalars['String']['output'];
  companionSessionUuid: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  items: Array<CompanionSessionEstimateItem>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Deprecated. Companion estimate feature removed. */
export type CompanionSessionEstimateItem = {
  __typename?: 'CompanionSessionEstimateItem';
  choices: Array<CompanionSessionEstimateItemChoice>;
  companionSessionEstimate?: Maybe<CompanionSessionEstimate>;
  companionSessionEstimateItemUuid: Scalars['String']['output'];
  companionSessionEstimateUuid: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  quantity: Scalars['Int']['output'];
};

/** Deprecated. Companion estimate feature removed. */
export type CompanionSessionEstimateItemChoice = {
  __typename?: 'CompanionSessionEstimateItemChoice';
  companionSessionEstimateItem?: Maybe<CompanionSessionEstimateItem>;
  companionSessionEstimateItemUuid: Scalars['String']['output'];
  inventoryItem?: Maybe<InventoryItem>;
  inventoryItemUuid: Scalars['String']['output'];
  isSelected: Scalars['Boolean']['output'];
};

/** Piece of knowledge that was gathered during a companion-powered appointment. */
export type CompanionSessionKnowledge = {
  __typename?: 'CompanionSessionKnowledge';
  companionSession?: Maybe<CompanionSession>;
  companionSessionUuid: Scalars['String']['output'];
  knowledgeKey: Scalars['String']['output'];
  knowledgeValue: Scalars['String']['output'];
};

/** Message sent during a companion session. */
export type CompanionSessionMessage = {
  __typename?: 'CompanionSessionMessage';
  companionSession?: Maybe<CompanionSession>;
  companionSessionMessageUuid: Scalars['String']['output'];
  companionSessionUuid: Scalars['String']['output'];
  companionType?: Maybe<CompanionTypeEnum>;
  createdAt: Scalars['DateTime']['output'];
  role: Scalars['String']['output'];
  status: CompanionSessionMessageStatusEnum;
  textContent: Scalars['String']['output'];
};

/** An enumeration. */
export enum CompanionSessionMessageStatusEnum {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED'
}

export type CompanionSessionMessageStatusSummary = {
  __typename?: 'CompanionSessionMessageStatusSummary';
  failed: Scalars['Int']['output'];
  processing: Scalars['Int']['output'];
  succeeded: Scalars['Int']['output'];
};

export type CompanionSessionStatusSummary = {
  __typename?: 'CompanionSessionStatusSummary';
  messages: CompanionSessionMessageStatusSummary;
  tasks: CompanionSessionTaskStatusSummary;
};

/** A single task executed in the scope of a companion session. */
export type CompanionSessionTask = {
  __typename?: 'CompanionSessionTask';
  companionSession?: Maybe<CompanionSession>;
  companionSessionTaskUuid: Scalars['String']['output'];
  companionSessionUuid: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  status: CompanionSessionTaskStatusEnum;
  taskStepDescription?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum CompanionSessionTaskStatusEnum {
  Accepted = 'ACCEPTED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Started = 'STARTED',
  Succeeded = 'SUCCEEDED'
}

export type CompanionSessionTaskStatusSummary = {
  __typename?: 'CompanionSessionTaskStatusSummary';
  accepted: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  started: Scalars['Int']['output'];
  succeeded: Scalars['Int']['output'];
};

/** An enumeration. */
export enum CompanionSessionTypeEnum {
  Billing = 'BILLING',
  History = 'HISTORY',
  Writing = 'WRITING'
}

/**
 * Companion treat subscription for a user's account.
 *
 * Returned by ``User.companionSubscription``. Resolves to ``null`` when
 * the user has never subscribed. A canceled subscription is still
 * returned with ``status='CANCELED'`` so the frontend can distinguish
 * "never subscribed" (null) from "canceled, can resubscribe".
 *
 * ``activeUntil`` is populated when Stripe has been told to cancel at
 * period end — the FE uses it to render "canceling, ends <date>". It is
 * null for fully-active subscriptions and for subs that have already
 * ended.
 */
export type CompanionSubscription = {
  __typename?: 'CompanionSubscription';
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  monthlyTreats: Scalars['Int']['output'];
  planKey: Scalars['String']['output'];
  status: CompanionSubscriptionStatus;
};

/** An enumeration. */
export enum CompanionSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED'
}

/** One row of structured detail rendered inside a permission card. */
export type CompanionToolPermissionDetail = {
  __typename?: 'CompanionToolPermissionDetail';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Pending or expired permission card derived from session events.
 *
 * Shape mirrors the live ``companion-tool-permission-request`` WS payload.
 * ``status`` is null for actionable pending, ``"expired"`` for stale asks
 * past the agent deadline; ``expires_at`` is always null on hydration.
 */
export type CompanionToolPermissionRequest = {
  __typename?: 'CompanionToolPermissionRequest';
  agentSessionUuid: Scalars['String']['output'];
  canPersist: Scalars['Boolean']['output'];
  details: Array<CompanionToolPermissionDetail>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  grantDisplayName: Scalars['String']['output'];
  persistLabel: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  toolAction: Scalars['String']['output'];
  toolKind: Scalars['String']['output'];
  toolName: Scalars['String']['output'];
};

/** An enumeration. */
export enum CompanionTypeEnum {
  Bill = 'BILL',
  Quill = 'QUILL',
  Sage = 'SAGE',
  Summi = 'SUMMI'
}

export type CompanionUserSettings = {
  __typename?: 'CompanionUserSettings';
  onboardingClinic?: Maybe<Scalars['String']['output']>;
  onboardingMilestones?: Maybe<Scalars['GenericScalar']['output']>;
  pimsProvider?: Maybe<Scalars['String']['output']>;
  scribephoneConsentMode?: Maybe<Scalars['String']['output']>;
};

export type ConfirmUser = {
  __typename?: 'ConfirmUser';
  ok?: Maybe<Scalars['String']['output']>;
};

/**
 * Creates a copy of an existing template for the authenticated user.
 * The copy will have 'Copy of ' prepended to the name by default (unless a custom name is provided),
 * be marked as a favourite, and set to PRIVATE sharing.
 */
export type CopyAutoTemplate = {
  __typename?: 'CopyAutoTemplate';
  ok?: Maybe<Scalars['Boolean']['output']>;
  templateUuid?: Maybe<Scalars['String']['output']>;
};

export type CopyNotesToPatient = {
  __typename?: 'CopyNotesToPatient';
  ok?: Maybe<Scalars['String']['output']>;
};

export type CorrectPatientNameInNote = {
  __typename?: 'CorrectPatientNameInNote';
  ok?: Maybe<Scalars['Boolean']['output']>;
  patientRecordStatus?: Maybe<Scalars['String']['output']>;
  replacedCount?: Maybe<Scalars['Int']['output']>;
  sectionsAffected?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Persist a new Managed Agent session created by the agent service. */
export type CreateAgentSession = {
  __typename?: 'CreateAgentSession';
  ok?: Maybe<Scalars['Boolean']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

/** Persist an Always Allow grant for a Companion tool action. */
export type CreateAgentToolPermissionGrant = {
  __typename?: 'CreateAgentToolPermissionGrant';
  grant?: Maybe<AgentToolPermissionGrant>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateAutoTemplate = {
  __typename?: 'CreateAutoTemplate';
  ok?: Maybe<Scalars['Boolean']['output']>;
  templateUuid?: Maybe<Scalars['String']['output']>;
};

/** A class used to define the input fields required to create a new auto template. */
export type CreateAutoTemplateInput = {
  dentalChart?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isFavourite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pdfStorageObjectName?: InputMaybe<Scalars['String']['input']>;
  templateFields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  templateType?: InputMaybe<TemplateType>;
  userPreferences?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Admin-only: create a broadcast notification visible to all users.
 *
 * Used for system banners (Otto-style outage notices). Per-user
 * read/dismiss state is not persisted — clients dismiss locally.
 */
export type CreateBroadcastNotification = {
  __typename?: 'CreateBroadcastNotification';
  notification?: Maybe<UserNotification>;
};

/** Creates a new companion session. This will close any existing open companion sessions */
export type CreateCompanionSession = {
  __typename?: 'CreateCompanionSession';
  companionSessionUuid?: Maybe<Scalars['UUID']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A class used to define a mutation for creating a new organization and inserting it into the database.
 * This is used for internal tooling to create organizations for new enterprises. This is different from the normal flow
 * of creating an organization via the Scribenote app, as this is deliberatly done by an internal user on behalf of a pilot.
 * Here org creation happens separate from team creation, and a billing profile is required to be passed in.
 *
 * Attributes:
 *     org_name (str): The name of the organization.
 *     billing_mode_id (int): The billing mode of the organization.
 *     location (str): The location of the organization.
 *     email_domain (str): The primary email domain of the organization.
 *     email_domain_secondary (str): Optional second allowed email domain.
 *     email_domain_tertiary (str): Optional third allowed email domain.
 *     stripe_customer_id (str): The Stripe customer ID of the organization.
 */
export type CreateCustomOrg = {
  __typename?: 'CreateCustomOrg';
  orgId?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Create multiple notes from a single recording using a template group. */
export type CreateGroupedNotes = {
  __typename?: 'CreateGroupedNotes';
  noteGroup?: Maybe<NoteGroup>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A class used to define the input fields required to create a new LLM customization.
 *
 * Attributes:
 *     note_uuid (str): The UUID of the note. This field is required.
 *     user_uuid (str): The UUID of the user. This field is required.
 *     note_section (str): The section of the note. This field is required.
 *     action_type (str): The type of customization. This field is required.
 *     params (json): The parameters for the action. This field is required.
 */
export type CreateLlmCustomizationsInput = {
  actionType: Scalars['String']['input'];
  beforeContent: Scalars['String']['input'];
  llmCustomizationUuid: Scalars['String']['input'];
  noteSection: Scalars['String']['input'];
  noteUuid: Scalars['String']['input'];
  params: Scalars['JSONString']['input'];
  streamingTaskUuid: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};

export type CreateNote = {
  __typename?: 'CreateNote';
  note?: Maybe<Note>;
  successMessage?: Maybe<Scalars['String']['output']>;
};

/**
 * A class used to define the input fields required to create a new organization.
 *
 * Attributes:
 *     organization_name (str): The name of the organization. This field is required.
 *     location (str): The location of the organization. This field is required.
 *     email_domain (str): The email domain of the organization. This field is required.
 */
export type CreateOrgInput = {
  createdAt: Scalars['DateTime']['input'];
  emailDomain: Scalars['String']['input'];
  location: Scalars['String']['input'];
  name: Scalars['String']['input'];
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A class used to define a mutation for creating a new organization and inserting it into the database.
 *
 * Attributes:
 *     ok (Boolean): A flag indicating whether the mutation was successful.
 *     organization (Organization): The newly created organization.
 *
 * Arguments:
 *     create_org_input (CreateOrgInput): The input fields required to create a new organization. This argument is required.
 *
 * Raises:
 *     CustomException: If the password in the request headers is not correct.
 */
export type CreateOrganization = {
  __typename?: 'CreateOrganization';
  ok?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Organization>;
};

export type CreatePatient = {
  __typename?: 'CreatePatient';
  patient?: Maybe<Patient>;
};

export type CreatePatientNote = {
  __typename?: 'CreatePatientNote';
  note?: Maybe<Note>;
  successMessage?: Maybe<Scalars['String']['output']>;
};

export type CreateQuickNote = {
  __typename?: 'CreateQuickNote';
  note?: Maybe<Note>;
  successMessage?: Maybe<Scalars['String']['output']>;
};

/**
 * Creates a new team and inserts it into db
 *
 * Arguments:
 *     team_name(String): The name of the team
 */
export type CreateTeam = {
  __typename?: 'CreateTeam';
  ok?: Maybe<Scalars['Boolean']['output']>;
  teamUuid?: Maybe<Scalars['String']['output']>;
};

/**
 * A class used to define a mutation for creating a new team and inserting it into the database.
 * This is used for internal tooling to create teams for new enterprises. This is different form the normal flow
 * of creating a team via the Scribenote app, as this is deliberatly done by an internal user on behalf of a pilot.
 * Here team creation happens separate from org creation, and a billing profile is required to be passed in.
 *
 * Attributes:
 *     team_name (str): The name of the team.
 *     org_id (int): The ID of the organization.
 *     location (str): The location of the team.
 */
export type CreateTeamUnderOrg = {
  __typename?: 'CreateTeamUnderOrg';
  orgId?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
};

export type CreateTemplateGroup = {
  __typename?: 'CreateTemplateGroup';
  ok?: Maybe<Scalars['Boolean']['output']>;
  templateGroup?: Maybe<TemplateGroup>;
};

export type CreateTemplatePreview = {
  __typename?: 'CreateTemplatePreview';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * FOR INTERNAL USE ONLY
 *
 * A GraphQL mutation class for creating a test user.
 *
 * Methods:
 *     mutate(root, info, **kwargs):
 *         Handles the mutation logic for creating a test user.
 */
export type CreateTestUser = {
  __typename?: 'CreateTestUser';
  accountType?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noteUuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  orgId?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/**
 * A class used to define the input fields required to create a new test user.
 *
 * Attributes:
 *     email (str): The email address of the user. This field is required.
 *     first_name (str): The first name of the user. This field is required.
 *     last_name (str): The last name of the user. This field is required.
 *     email_domain (str): The email domain for organization creation. This field is optional.
 *     trial_period (str): Flexible trial period (e.g., '1min', '1hr', '1day'). This field is optional.
 */
export type CreateTestUserInput = {
  accountType?: InputMaybe<TestAccountType>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  numNotes?: InputMaybe<NumNotes>;
  trialPeriod?: InputMaybe<Scalars['String']['input']>;
  withOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateUser = {
  __typename?: 'CreateUser';
  accessCsrf?: Maybe<Scalars['String']['output']>;
  accessJwt?: Maybe<Scalars['String']['output']>;
  hasReferrer?: Maybe<Scalars['Boolean']['output']>;
  isValidVlCode?: Maybe<Scalars['Boolean']['output']>;
  refreshJwt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<LoginUserResponse>;
};

/**
 * Mutation to create a user as a member of the team for which they
 * are accepting an invitation to
 */
export type CreateUserFromTeamInvitation = {
  __typename?: 'CreateUserFromTeamInvitation';
  accessCsrf?: Maybe<Scalars['String']['output']>;
  isValidVlCode?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<LoginUserResponse>;
};

export type CreateV1Team = {
  __typename?: 'CreateV1Team';
  ok?: Maybe<Scalars['Boolean']['output']>;
  team?: Maybe<Team>;
};

/**
 * A class used to define the input fields required to create a new team.
 *
 * Attributes:
 *     name (str): The name of the team. This field is required.
 *     location (str): The location of the team. This field is optional.
 */
export type CreateV1TeamInput = {
  freeUsers: Scalars['Int']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numCustomerIds: Scalars['Int']['input'];
  paidUsers: Scalars['Int']['input'];
};

/** Status constants for credit redemptions. */
export enum CreditRedemptionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

/**
 * Custom form field attached to a note for free-text or structured input.
 *
 * Supports different field types (text, numeric, checkbox) for flexible data capture.
 */
export type CustomFormField = {
  __typename?: 'CustomFormField';
  fieldType?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Int']['output']>;
  textValue?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Custom objective field for physical exam findings in veterinary SOAP notes. */
export type CustomObjectiveField = {
  __typename?: 'CustomObjectiveField';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Int']['output']>;
  symmetricalValueLeft?: Maybe<Scalars['String']['output']>;
  symmetricalValueRight?: Maybe<Scalars['String']['output']>;
  symmetryLabels?: Maybe<SymmetryLabel>;
  symmetryType?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomObjectiveFieldsInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  symmetricalValueLeft?: InputMaybe<Scalars['String']['input']>;
  symmetricalValueRight?: InputMaybe<Scalars['String']['input']>;
  symmetryLabels?: InputMaybe<Scalars['String']['input']>;
  symmetryType: Scalars['String']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A class used to define a mutation for deactivating a user from a team within an organization. */
export type DeactivateOrgTeamUser = {
  __typename?: 'DeactivateOrgTeamUser';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Bill a completed Managed Agent turn against the user's treat balance. */
export type DeductAgentSessionTreats = {
  __typename?: 'DeductAgentSessionTreats';
  deducted?: Maybe<Scalars['Boolean']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  remainingBalance?: Maybe<Scalars['Int']['output']>;
};

/**
 * Delete a Managed Agent session and its uploaded attachments.
 *
 * Propagates the delete to Anthropic so the Managed Agent session is
 * not orphaned on their side. A 404 (already gone) is treated as
 * idempotent success and the local delete proceeds; any other
 * upstream failure aborts the local delete so the two sides stay in
 * sync and the caller can retry. DB-level cascades remove rows in
 * ``attachments`` (CASCADE) and null-out ``treats.agent_session_id``
 * (SET NULL).
 */
export type DeleteAgentSession = {
  __typename?: 'DeleteAgentSession';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAttachment = {
  __typename?: 'DeleteAttachment';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAutoTemplate = {
  __typename?: 'DeleteAutoTemplate';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCompanionSession = {
  __typename?: 'DeleteCompanionSession';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteHeaderImage = {
  __typename?: 'DeleteHeaderImage';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteNote = {
  __typename?: 'DeleteNote';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteNoteAudioRecording = {
  __typename?: 'DeleteNoteAudioRecording';
  ok?: Maybe<Scalars['String']['output']>;
};

export type DeleteNotes = {
  __typename?: 'DeleteNotes';
  ok?: Maybe<Scalars['String']['output']>;
};

export type DeletePatient = {
  __typename?: 'DeletePatient';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Deletes a team if the user is an organization admin and the team is empty (only the current user is on the team).
 *
 * Arguments:
 *     team_uuid(String): The UUID of the team to delete
 */
export type DeleteTeam = {
  __typename?: 'DeleteTeam';
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTemplate = {
  __typename?: 'DeleteTemplate';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTemplateGroup = {
  __typename?: 'DeleteTemplateGroup';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteUser = {
  __typename?: 'DeleteUser';
  ok?: Maybe<Scalars['String']['output']>;
};

/** Delete a verified phone number. */
export type DeleteVerifiedPhoneNumber = {
  __typename?: 'DeleteVerifiedPhoneNumber';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Mutation to deny a team invitation from the user who received it */
export type DenyTeamInvitation = {
  __typename?: 'DenyTeamInvitation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * GraphQL mutation to exchange Descope session token for admin portal session.
 *
 * The Descope session token must be provided in the Authorization header:
 *     Authorization: Bearer <descope_session_token>
 *
 * Requires an admin_portal:* role in the JWT. Returns 403-equivalent error
 * if the user is authenticated but lacks an admin role.
 */
export type DescopeAdminPortalSession = {
  __typename?: 'DescopeAdminPortalSession';
  accessCsrf: Scalars['String']['output'];
  accessJwt: Scalars['String']['output'];
  adminRole: Scalars['String']['output'];
  user: LoginUserResponse;
};

/**
 * GraphQL mutation to exchange Descope session token for Scribenote JWT (mobile).
 *
 * The Descope session token must be provided in the Authorization header:
 *     Authorization: Bearer <descope_session_token>
 */
export type DescopeMobileSession = {
  __typename?: 'DescopeMobileSession';
  accessJwt: Scalars['String']['output'];
  refreshJwt: Scalars['String']['output'];
  userUuid: Scalars['String']['output'];
};

/**
 * GraphQL mutation to exchange Descope session token for Scribenote JWT (web).
 *
 * The Descope session token must be provided in the Authorization header:
 *     Authorization: Bearer <descope_session_token>
 */
export type DescopeWebSession = {
  __typename?: 'DescopeWebSession';
  accessCsrf: Scalars['String']['output'];
  user: LoginUserResponse;
};

/**
 * Clear the patient link on a set of notes (reverse of MoveNotesToPatient).
 *
 * Scoped to the caller's notes. Deliberately does NOT reverse the side effects
 * of the attach flow — patient weight derived from note weight is left alone,
 * and attachments stay put — because unlinking a note shouldn't silently
 * rewrite unrelated state on the patient.
 *
 * Returns `affected_uuids` (the UUIDs that actually changed) in addition to
 * `ok` and `affected_count` so clients can tell the user the truth when some
 * UUIDs were skipped (foreign, missing, or already detached). The audit
 * trail is only written for the UUIDs that actually moved — passing the
 * full requested list would create false `detach_from_patient` entries.
 */
export type DetachNotesFromPatient = {
  __typename?: 'DetachNotesFromPatient';
  affectedCount?: Maybe<Scalars['Int']['output']>;
  affectedUuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Dismiss a notification (hides it permanently). */
export type DismissNotification = {
  __typename?: 'DismissNotification';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Dismiss all notifications of a type for a specific note.
 *
 * Useful when user triggers reprocess — dismiss "new audio available".
 */
export type DismissNotificationsByNote = {
  __typename?: 'DismissNotificationsByNote';
  dismissedCount?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type EditAccountPreferences = {
  __typename?: 'EditAccountPreferences';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type EditClientSummaryPreferences = {
  __typename?: 'EditClientSummaryPreferences';
  clientSummaryPreferences?: Maybe<ClientSummaryPreferencesType>;
};

export type EditObjectiveNormalDefaults = {
  __typename?: 'EditObjectiveNormalDefaults';
  objectiveNormalDefaults?: Maybe<ObjectiveNormalDefaults>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type EditPdfSettings = {
  __typename?: 'EditPDFSettings';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type EditPatient = {
  __typename?: 'EditPatient';
  patient?: Maybe<Patient>;
};

export type EditTemplate = {
  __typename?: 'EditTemplate';
  ok?: Maybe<Scalars['Boolean']['output']>;
  template?: Maybe<Template>;
};

/**
 * A general mutation for updating generic user fields.
 * Use for non complicated operations on the user model.
 * Ie, flipping a boolean state. Changing a string, etc.
 * Fields requiring heavier data processing should be in their own mutation.
 */
export type EditUser = {
  __typename?: 'EditUser';
  user?: Maybe<User>;
};

export type ExistingAccount = {
  __typename?: 'ExistingAccount';
  accountType?: Maybe<Scalars['String']['output']>;
  isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ExistingTeam = {
  __typename?: 'ExistingTeam';
  name?: Maybe<Scalars['String']['output']>;
};

export type ExistingUser = {
  __typename?: 'ExistingUser';
  account?: Maybe<ExistingAccount>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Maybe<ExistingTeam>>>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Input type for a single extension step. */
export type ExtensionStepInput = {
  press?: InputMaybe<Scalars['String']['input']>;
  wait?: InputMaybe<Scalars['Int']['input']>;
};

/** GraphQL type for feature activation status. */
export type FeatureActivation = {
  __typename?: 'FeatureActivation';
  featureName: Scalars['String']['output'];
  isActivated: Scalars['Boolean']['output'];
};

export type FieldInput = {
  fieldIdx: Scalars['Int']['input'];
  fieldName: FieldName;
  fieldValue: Scalars['String']['input'];
};

export enum FieldName {
  Assessment = 'ASSESSMENT',
  Custom = 'CUSTOM',
  Objective = 'OBJECTIVE',
  Plan = 'PLAN',
  Subjective = 'SUBJECTIVE',
  UserPreferences = 'USER_PREFERENCES'
}

/** Enum for auto template field names (SOAP sections or custom). */
export enum FieldNameEnum {
  Assessment = 'ASSESSMENT',
  Custom = 'CUSTOM',
  Objective = 'OBJECTIVE',
  Plan = 'PLAN',
  Subjective = 'SUBJECTIVE'
}

export type FlagNoteToSupport = {
  __typename?: 'FlagNoteToSupport';
  ok?: Maybe<Scalars['String']['output']>;
};

/** Placeholder mutation for adaptive client summaries. */
export type GenerateAdaptiveClientSummary = {
  __typename?: 'GenerateAdaptiveClientSummary';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Enqueue a Celery task that summarizes the first turn of an agent
 * session (user message + agent response) into a title. Returns
 * immediately — the worker writes the title via the in-house LLM
 * orchestrator and broadcasts a ``companion-session-title-update``
 * WebSocket event on success.
 */
export type GenerateAgentSessionTitle = {
  __typename?: 'GenerateAgentSessionTitle';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateClientSummary = {
  __typename?: 'GenerateClientSummary';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateClientSummaryNext = {
  __typename?: 'GenerateClientSummaryNext';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** A class used to define a mutation for creating a new LLM customization and inserting it into the database. */
export type GenerateLlmCustomization = {
  __typename?: 'GenerateLLMCustomization';
  ok?: Maybe<Scalars['Boolean']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  streamingTaskUuid?: Maybe<Scalars['String']['output']>;
};

export type GoogleAuthInput = {
  email: Scalars['String']['input'];
  idToken: Scalars['String']['input'];
};

export type GoogleAuthResponse = {
  __typename?: 'GoogleAuthResponse';
  accessCsrf?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Used to delete a note from the database.
 * This is a hard delete, meaning the note is removed from the database including the audit trail.
 */
export type HardDeleteNotes = {
  __typename?: 'HardDeleteNotes';
  ok?: Maybe<Scalars['String']['output']>;
};

/**
 * Used to delete a user from the database.
 * This is a hard delete, and should only be used in the case of a user requesting their data be removed.
 */
export type HardDeleteUser = {
  __typename?: 'HardDeleteUser';
  ok?: Maybe<Scalars['String']['output']>;
};

/** Admin Notes Status values. */
export enum InboxLocation {
  Drafts = 'DRAFTS',
  Export = 'EXPORT',
  Exported = 'EXPORTED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Review = 'REVIEW',
  Unprocessed = 'UNPROCESSED'
}

export type InboxNotes = {
  __typename?: 'InboxNotes';
  notes?: Maybe<Array<Maybe<Note>>>;
  totalNotes?: Maybe<Scalars['Int']['output']>;
};

export type InboxTabCount = {
  __typename?: 'InboxTabCount';
  numExportedItems?: Maybe<Scalars['Int']['output']>;
  numForExport?: Maybe<Scalars['Int']['output']>;
  numForReview?: Maybe<Scalars['Int']['output']>;
  numNowProcessing?: Maybe<Scalars['Int']['output']>;
  numSavedDrafts?: Maybe<Scalars['Int']['output']>;
};

export type IncrementAutoUsage = {
  __typename?: 'IncrementAutoUsage';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A class used to define a mutation that ties a user to a task stream uuid.
 *
 * Attributes:
 *     ok (Boolean): A flag indicating whether the mutation was successful.
 *
 * Arguments:
 *     task_uuid (String): The unique identifier for the task stream to be initialized.
 */
export type InitializeStream = {
  __typename?: 'InitializeStream';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Deprecated. Inventory feature removed. */
export type Inventory = {
  __typename?: 'Inventory';
  companionSessions?: Maybe<Array<Maybe<CompanionSession>>>;
  createdAt: Scalars['DateTime']['output'];
  inventoryUuid: Scalars['String']['output'];
  search?: Maybe<Array<Maybe<InventoryItem>>>;
  status: InventoryStatusEnum;
  team?: Maybe<Team>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};


/** Deprecated. Inventory feature removed. */
export type InventorySearchArgs = {
  query: Scalars['String']['input'];
};

/** Deprecated. Inventory feature removed. */
export type InventoryItem = {
  __typename?: 'InventoryItem';
  description: Scalars['String']['output'];
  dispensingFeeCents: Scalars['Int']['output'];
  inventory?: Maybe<Inventory>;
  inventoryItemUuid: Scalars['String']['output'];
  inventoryUuid: Scalars['String']['output'];
  priceCents: Scalars['Int']['output'];
  productCode: Scalars['String']['output'];
};

/** An enumeration. */
export enum InventoryStatusEnum {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

/**
 * A class used to define the input fields required to invite users to a team within an organization.
 *
 * Attributes:
 *     email (str): The email address of the user. This field is required.
 *     first_name (str): The first name of the user. This field is required.
 *     last_name (str): The last name of the user. This field is required.
 *     role_id (int): The role of the user. This field is optional.
 */
export type InviteUserData = {
  accountType: Scalars['String']['input'];
  email: Scalars['String']['input'];
  isAdmin: Scalars['Boolean']['input'];
  roleId: Scalars['Int']['input'];
};

/**
 * Invites a user to a team
 * Arguments:
 *     invitation_input(List): A list of InviteUsersToTeamInput objects
 *     team_uuid(String): The uuid of the team to which the user is being invited
 */
export type InviteUsersToTeam = {
  __typename?: 'InviteUsersToTeam';
  ok?: Maybe<Scalars['Boolean']['output']>;
  provisionedUsers?: Maybe<ProvisionedUsers>;
};

/**
 * A class used to define the input fields required to add a user to a team.
 * Allows for adding new users or existing users to a team via invitation.
 *
 * Attributes:
 *     new_user_data (List[AddUserData]): A list of user data for new users to add to the team. This field is required.
 *     existing_user_data (List[AddUserData]): A list of user data for existing users to add to the team. This field is required.
 *     team_uuid (str): The UUID of the team. This field is required.
 */
export type InviteUsersToTeamInput = {
  createdAt: Scalars['DateTime']['input'];
  existingUserData: Array<InputMaybe<InviteUserData>>;
  newUserData: Array<InputMaybe<InviteUserData>>;
  teamUuid: Scalars['String']['input'];
};

export type LinkRecordingConsentToNote = {
  __typename?: 'LinkRecordingConsentToNote';
  ok: Scalars['Boolean']['output'];
};

export type LogRecordingConsent = {
  __typename?: 'LogRecordingConsent';
  consentEventUuid: Scalars['UUID']['output'];
};

export type LogScribephoneConsent = {
  __typename?: 'LogScribephoneConsent';
  error?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type LoginUser = {
  __typename?: 'LoginUser';
  accessCsrf?: Maybe<Scalars['String']['output']>;
  accessJwt?: Maybe<Scalars['String']['output']>;
  refreshJwt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<LoginUserResponse>;
};

export type LoginUserAccount = {
  __typename?: 'LoginUserAccount';
  accountType?: Maybe<Scalars['String']['output']>;
  freeTrialExpiresAt?: Maybe<Scalars['Boolean']['output']>;
  isSubscribed?: Maybe<Scalars['Boolean']['output']>;
};

export type LoginUserOrganization = {
  __typename?: 'LoginUserOrganization';
  uuid?: Maybe<Scalars['String']['output']>;
};

export type LoginUserResponse = {
  __typename?: 'LoginUserResponse';
  account?: Maybe<LoginUserAccount>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<LoginUserOrganization>;
  teams?: Maybe<Array<Maybe<LoginUserTeam>>>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type LoginUserTeam = {
  __typename?: 'LoginUserTeam';
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type LogoutUser = {
  __typename?: 'LogoutUser';
  ok?: Maybe<Scalars['String']['output']>;
};

/**
 * Record the Anthropic event id an attachment was sent in.
 *
 * Called by the agent relay after ``events.send`` returns so hydration can
 * re-associate uploads with the exact user.message they accompanied.
 */
export type MarkAgentSessionAttachmentsSent = {
  __typename?: 'MarkAgentSessionAttachmentsSent';
  ok?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

/** Record that a persistent Companion permission grant was used. */
export type MarkAgentToolPermissionGrantUsed = {
  __typename?: 'MarkAgentToolPermissionGrantUsed';
  grant?: Maybe<AgentToolPermissionGrant>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Mark a notification as read. */
export type MarkNotificationRead = {
  __typename?: 'MarkNotificationRead';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Admin-only soft-delete of a user ("Mark for Deletion").
 *
 * Gated by `admin_portal:editor`. Audit-logged via `log_changes`.
 * Idempotent on the soft-deleted state.
 */
export type MarkUserForDeletion = {
  __typename?: 'MarkUserForDeletion';
  user?: Maybe<AdminUserInfo>;
};

export type ModifiedUser = {
  __typename?: 'ModifiedUser';
  email?: Maybe<Scalars['String']['output']>;
  inviteUuid?: Maybe<Scalars['String']['output']>;
  isExistingUser?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ModifyNote = {
  __typename?: 'ModifyNote';
  note?: Maybe<Note>;
  successMessage?: Maybe<Scalars['String']['output']>;
};

export type ModifyNotes = {
  __typename?: 'ModifyNotes';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type MoveNotesToPatient = {
  __typename?: 'MoveNotesToPatient';
  ok?: Maybe<Scalars['String']['output']>;
};

/** Why a bulk soft-delete row was not applied. */
export enum MphBulkDeleteRejectReason {
  ApplyFailed = 'APPLY_FAILED',
  DuplicateUuidInFile = 'DUPLICATE_UUID_IN_FILE',
  InvalidUuid = 'INVALID_UUID',
  MalformedRow = 'MALFORMED_ROW',
  UserNotFound = 'USER_NOT_FOUND'
}

/** Why an MPH bulk team-reassignment row was not applied. */
export enum MphBulkReassignRejectReason {
  ApplyFailed = 'APPLY_FAILED',
  DuplicateUserInFile = 'DUPLICATE_USER_IN_FILE',
  MalformedRow = 'MALFORMED_ROW',
  TeamAmbiguous = 'TEAM_AMBIGUOUS',
  TeamNotFound = 'TEAM_NOT_FOUND',
  UserAmbiguous = 'USER_AMBIGUOUS',
  UserDeleted = 'USER_DELETED',
  UserEmailNotMphDomain = 'USER_EMAIL_NOT_MPH_DOMAIN',
  UserNotFound = 'USER_NOT_FOUND'
}

/** Why an MPH bulk role-assignment row was not applied. */
export enum MphBulkRoleRejectReason {
  ApplyFailed = 'APPLY_FAILED',
  DuplicateRow = 'DUPLICATE_ROW',
  InvalidRole = 'INVALID_ROLE',
  MalformedRow = 'MALFORMED_ROW',
  TeamAmbiguous = 'TEAM_AMBIGUOUS',
  TeamNotFound = 'TEAM_NOT_FOUND',
  UserAmbiguous = 'USER_AMBIGUOUS',
  UserDeleted = 'USER_DELETED',
  UserDisabled = 'USER_DISABLED',
  UserNotFound = 'USER_NOT_FOUND',
  UserNotOnTeam = 'USER_NOT_ON_TEAM'
}

/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type Mutations = {
  __typename?: 'Mutations';
  /** A class used to define a mutation for accepting an LLM customization and updating the note or template in the database. */
  acceptLlmCustomization?: Maybe<AcceptLlmCustomization>;
  /**
   * Mutation to add a user as a member of the team for which they
   * are accepting an invitation to
   */
  acceptTeamInvitation?: Maybe<AcceptTeamInvitation>;
  addFeedbackToCustomization?: Maybe<AddFeedbackToCustomization>;
  addFeedbackToLog?: Maybe<AddFeedbackToLog>;
  /**
   * Admin-only add of users to the MPH Companion opt-in segment.
   *
   * Gated by `admin_portal:editor`. Each valid, existing user UUID is added
   * (with the `user-uuid-` prefix) to the environment-appropriate LaunchDarkly
   * segment in a single call; malformed or unknown uuids are skipped with a
   * reason. Input is canonicalized and deduped so casing/repeats don't matter.
   * In production a `TOPREQ-NNN` tracking ticket is required and recorded (with
   * the acting admin and a link to the ticket) in the segment's LaunchDarkly
   * change history; outside production the ticket is optional.
   */
  addMphCompanionMembers?: Maybe<AddMphCompanionMembers>;
  /**
   * Attach a standalone note to an existing group or to another note.
   *
   * `target_uuid` may be a NoteGroup UUID or a Note UUID — the server
   * resolves it. See AddNoteToGroupUseCase for full semantics.
   */
  addNoteToGroup?: Maybe<AddNoteToGroup>;
  addOrgAdmin?: Maybe<AddOrgAdmin>;
  addUsersToTeam?: Maybe<AddUsersToTeam>;
  /**
   * Superadmin-only. Soft-deletes users by uuid (BE-2902).
   *
   * Runs `UserService.mark_for_deletion` per user and reads the Redis
   * sentinel before and after. Already-deleted users are applied and get the
   * sentinel re-set. Memberships, notes and billing are unchanged. Dry run by
   * default.
   */
  adminBulkMarkUsersForDeletion?: Maybe<AdminBulkMarkUsersForDeletion>;
  /**
   * Admin-only hard delete of a team that nothing is attached to.
   *
   * Gated by `admin_portal:editor`. Refuses unless the team has no
   * memberships and no notes, because `notes.team_id` is
   * `ON DELETE SET NULL` and `user_team` is `ON DELETE CASCADE` — the
   * database would happily take the team down and quietly orphan the
   * notes and drop the memberships with it. The point of this mutation is
   * to remove an empty shell, never to remove data along with it, so the
   * check is the mutation.
   *
   * The refusal names the counts that blocked it, so an operator who hits
   * this on a stale page is told what is actually in the way.
   *
   * The check and the delete are not atomic. A membership or note created
   * between them is dropped or orphaned with the team. Accepted: it needs
   * a write racing against an already-empty team.
   *
   * Audit-logged as `delete_team` by `TeamService.delete`.
   */
  adminDeleteTeam?: Maybe<AdminDeleteTeam>;
  /**
   * Admin-only deletion of a verified phone number.
   *
   * ``soft_delete`` removes the Twilio OutgoingCallerId when this is the last
   * VERIFIED record for the number, freeing it for re-verification.
   * Twilio failures are logged at the service layer but do not block the soft delete.
   */
  adminDeleteVerifiedPhoneNumber?: Maybe<AdminDeleteVerifiedPhoneNumber>;
  /**
   * Admin-only edit of a billing account's limited editable fields.
   *
   * Gated by `admin_portal:editor`. Audit-logged via `log_changes` so
   * the entry captures the old → new field diff.
   */
  adminEditAccount?: Maybe<AdminEditAccount>;
  adminEditOrganization?: Maybe<AdminEditOrganization>;
  /**
   * All-or-nothing edit of an org's outbound email overrides. Every row is
   * validated (shape, Postmark, placeholder allowlist) before any is written.
   */
  adminEditOrganizationEmailSettings?: Maybe<AdminEditOrganizationEmailSettings>;
  /**
   * Admin-only edit of an organization's recording-consent settings.
   *
   * Replaces the support-SQL edits documented in
   * docs/runbooks/recording_consent_export.md with an audited app write path.
   * Gated by `admin_portal:editor`; the field-level before/after diff is
   * written to the internal audit log via `log_changes`
   * (action `update_org_recording_consent`).
   *
   * Semantics (mirroring the runbook's invariants):
   * - Omitted arguments are left untouched; a no-op call writes no audit entry.
   * - `requiresRecordingConsent` is the sole enforcement gate — setting it
   *   TRUE starts consent enforcement for the org's users immediately.
   * - `consentHeader` is presentation-only and versionless; blank/whitespace
   *   clears the override (falls back to the app default).
   * - `consentText` + `consentTextVersion` are an ATOMIC PAIR: provide both
   *   to set the override, or blank both to revert to the app defaults.
   *   Changing the text requires a version label that is NEW for the org —
   *   never one already stamped onto events with different wording — because
   *   exports group events by version label.
   */
  adminEditOrganizationRecordingConsent?: Maybe<AdminEditOrganizationRecordingConsent>;
  adminEditTeam?: Maybe<AdminEditTeam>;
  /**
   * Admin-only edit of one membership: role, team-admin status, or both.
   *
   * Every argument but the two identifiers is optional; whatever is
   * omitted is read back off the row and written unchanged, so a caller
   * editing one field can't clobber the other.
   *
   * Deliberately billing-inert. The customer-facing `UpdateUserTeam`
   * moves the org's Stripe subscription quantity when a role change
   * crosses the billable boundary (`is_billable_role` — DVM and Locum);
   * this mutation only corrects membership data, so staff can't shift a
   * customer's bill from a table cell. Nothing here touches Stripe or
   * the account type. Team-admin status has no billing dimension at all.
   *
   * That leaves a real gap on the role side: after a boundary-crossing
   * change the org's seat count and its billable-role count can
   * disagree. Rather than reconcile it silently,
   * `crosses_billable_boundary` reports it for the caller to surface —
   * computed from the same helper the billing logic uses, so the two
   * can't drift apart.
   *
   * That flag means exactly what its name says — the role crossed the
   * DVM/Locum line — and deliberately nothing more. What a crossing
   * *means* for billing depends on the member's plan and whose card
   * they are on, and the admin portal decides that client-side (see
   * `apps/admin/src/pages/teams/billingImpact.ts` in the frontend
   * repo): billing follows the plan, so a free-plan member is not a
   * billed seat whichever role they hold, and a member on their own
   * card affects their own subscription rather than the org's.
   * Narrowing this flag to "a seat actually moved" was tried and
   * reverted — it silenced the free-plan case, which still needs
   * saying, just differently.
   *
   * `team_active_admin_count` excludes deleted and disabled users, who
   * keep their `user_team.is_admin` flag through a soft delete — it is
   * the one to threshold a last-admin warning on. `team_admin_count`
   * counts every admin membership and so matches the badges a members
   * table renders; returning both lets a client show the discrepancy
   * rather than silently disagreeing with itself.
   *
   * `team_admin_count` is returned so a client can warn before (and
   * reflect after) a change that leaves a team with no admins. Removing
   * the last one is allowed: staff sometimes need to unwind a team, and
   * a hard block would leave them no way to do it here.
   *
   * Audit trail comes from `UserTeamService.update_user_team_settings`
   * (`log_changes` → `update_team_member_role`), same delegation as
   * `AdminEditTeam`.
   */
  adminEditTeamMember?: Maybe<AdminEditTeamMember>;
  /**
   * Admin-only edit of basic user profile fields.
   *
   * Gated by `admin_portal:editor`. Updates are logged to the audit
   * trail via `UserService.update` (which wraps
   * `AuditLogService.log_changes`), so the entry shows the admin actor,
   * their role, and the field-level diff. Only fields explicitly
   * provided are touched; a no-op call writes no audit entry.
   */
  adminEditUser?: Maybe<AdminEditUser>;
  /**
   * Admin-only grant of permanent treats to a user's account.
   *
   * Gated by `admin_portal:editor`. Credits the account's permanent
   * treat balance and logs the adjustment for auditability.
   */
  adminGiveTreats?: Maybe<AdminGiveTreats>;
  /**
   * Re-parent a team into another org. Editor scope. Rewrites `teams.org_id`
   * only; Stripe and account rows are untouched. Guards and disclosure come from
   * `team_move_check`. Audits `update_team`, `remove_team_from_org`, `add_team_to_org`.
   */
  adminMoveTeamToOrg?: Maybe<AdminMoveTeamToOrg>;
  /**
   * Superadmin-only. Sets `user_team.role_id` per row on a named MPH team (BE-2901).
   *
   * Does not change `users.role_id`, `is_admin` or billing. Unresolved rows and
   * users not on the team are returned in `rejected`. Dry run by default.
   */
  adminMphBulkAssignTeamRoles?: Maybe<AdminMphBulkAssignTeamRoles>;
  /**
   * Superadmin-only. Makes the named MPH team each user's only team (BE-2900).
   *
   * Moves all the user's notes to the team, ends their other memberships
   * (any org), and clears team-admin and org-admin status. No billing
   * changes. Rows not resolving to one user and one team are returned in
   * `rejected`. Dry run by default.
   */
  adminMphBulkReassignTeams?: Maybe<AdminMphBulkReassignTeams>;
  /**
   * Admin-only removal of one membership. Editor scope.
   *
   * Ends a membership. It deletes nobody and nothing; the member keeps their
   * account, notes and verified numbers, which stop belonging to this team.
   * Touches neither Stripe nor the account type.
   */
  adminRemoveTeamMember?: Maybe<AdminRemoveTeamMember>;
  adminResendInvitation?: Maybe<AdminResendInvitation>;
  adminRevokeInvitation?: Maybe<AdminRevokeInvitation>;
  /**
   * Admin-only clear of an organization's Stripe customer.
   *
   * Replaces Retool's "Revoke Org Stripe ID" button. Kept separate from the
   * update mutation — rather than treating a blank id as "clear" — so that
   * unlinking is always a deliberate call, matching the two-button shape of
   * the tool it replaces and the wire-up/un-wire pair on users.
   *
   * Like the update, this changes nothing in Stripe.
   */
  adminRevokeOrganizationStripeCustomer?: Maybe<AdminRevokeOrganizationStripeCustomer>;
  /**
   * Admin-only grant or revoke of org-admin status for one user.
   *
   * Org-admin status is `users.org_id` pointing at the org, so this is a
   * single-field write either way. Both directions replace a Retool action:
   * `isAdmin: true` its "Set Admin of <org>" picker, `isAdmin: false` its
   * removal. Unlike Retool, both are audited and membership-gated.
   *
   * An org can hold many admins, so granting ADDS to the list rather than
   * replacing the current holder.
   *
   * Granting requires the user to already belong to a team in the org — the
   * portal's picker only offers those users, and this is the server-side
   * enforcement of that rule.
   */
  adminSetOrganizationAdmin?: Maybe<AdminSetOrganizationAdmin>;
  /**
   * Admin-only un-wire: the inverse of wire-up.
   *
   * Reverts the account to Basic and clears its Stripe customer id, replicating
   * the legacy Retool "revoke" action (which downgraded via the internal
   * `updateAccountPlan(account_type="basic")` mutation AND nulled
   * `stripe_customer_id` in raw SQL). Treats and free-trial expiry are left
   * untouched, matching that tool. Set fields inline rather than via
   * `AccountService.downgrade_account`, which also flips `is_teams_customer` and
   * conditionally keeps the Stripe id — neither of which the Retool revoke did.
   */
  adminUnwireAccount?: Maybe<AdminUnwireAccount>;
  /**
   * Admin-only re-point of an organization's Stripe customer.
   *
   * The org-level counterpart of `AdminWireUpAccount`, replacing Retool's
   * "Update Org Stripe ID" button.
   *
   * Changes NOTHING in Stripe — it only re-points which customer this org
   * reads from. Existing subscriptions and seat/quantity counts are untouched
   * and must be adjusted in Stripe directly if they also need to change.
   *
   * Pointing at a customer another org already holds returns a non-blocking
   * `ORG_STRIPE_CUSTOMER_SHARED` warning and is recorded in the audit entry.
   * Not refused: support occasionally has to do it deliberately, so the
   * requirement is that it be deliberate and traceable rather than prevented.
   */
  adminUpdateOrganizationStripeCustomer?: Maybe<AdminUpdateOrganizationStripeCustomer>;
  /** Admin-only wire-up of a user to the Unlimited plan. */
  adminWireUpAccount?: Maybe<AdminWireUpAccount>;
  appendRecording?: Maybe<AppendRecording>;
  associateQuicknotesWithPatient?: Maybe<AssociateQuicknotesWithPatient>;
  /**
   * Admin-only bulk restore of soft-deleted users.
   *
   * Bulk counterpart to `RestoreUser`. Gated by `admin_portal:editor`.
   * Skips invalid / unknown / already-active uuids with a reason.
   * Input uuids are canonicalized (lowercase `str(UUID)`) so input casing
   * doesn't affect lookup outcomes; the response echoes the canonical form.
   */
  bulkRestoreUsers?: Maybe<BulkRestoreUsers>;
  /** Mutation only to be used by administrators authenticated by retool or for bulk account administrator by a team admin */
  bulkSetExpiryPolicy?: Maybe<BulkSetExpiryPolicy>;
  /** Mutation only to be used by administrators authenticated by retool or for bulk account administrator by a team admin */
  bulkSetRole?: Maybe<BulkSetRole>;
  /**
   * Admin-only: hard-delete a broadcast notification.
   *
   * Used to retract a system banner before its ``expires_at`` (e.g. an
   * outage notice posted in error). User notifications are canceled by
   * their owner via ``CancelNotification``; this mutation only operates
   * on broadcast rows (``user_id IS NULL``).
   */
  cancelBroadcastNotification?: Maybe<CancelBroadcastNotification>;
  /**
   * Hard-delete a notification owned by the current user.
   *
   * Used to cancel a scheduled notification before it becomes visible.
   * Also works for already-visible rows if the caller wants to forget
   * them entirely (vs dismiss, which leaves a row).
   */
  cancelNotification?: Maybe<CancelNotification>;
  changeScribephoneConsentMode?: Maybe<ChangeScribephoneConsentMode>;
  /** To be called with the deconstructor at the end of useEffet() */
  checkinNote?: Maybe<CheckinNote>;
  /**
   * To be called when edit note is loaded. If the note has not been checked out, check it out via redis. If the note is checked out,
   * check who has checked it out, if it's the current user, then follow the checked out flow. Otherwise prompt the user that the
   * current note might be being edited by user.first_name user.last_name
   */
  checkoutNote?: Maybe<CheckoutNote>;
  closeCompanionSession?: Maybe<CloseCompanionSession>;
  confirmUser?: Maybe<ConfirmUser>;
  /**
   * Creates a copy of an existing template for the authenticated user.
   * The copy will have 'Copy of ' prepended to the name by default (unless a custom name is provided),
   * be marked as a favourite, and set to PRIVATE sharing.
   */
  copyAutoTemplate?: Maybe<CopyAutoTemplate>;
  copyNotesToPatient?: Maybe<CopyNotesToPatient>;
  correctPatientNameInNote?: Maybe<CorrectPatientNameInNote>;
  /** Persist a new Managed Agent session created by the agent service. */
  createAgentSession?: Maybe<CreateAgentSession>;
  /** Persist an Always Allow grant for a Companion tool action. */
  createAgentToolPermissionGrant?: Maybe<CreateAgentToolPermissionGrant>;
  createAutoTemplate?: Maybe<CreateAutoTemplate>;
  /**
   * Admin-only: create a broadcast notification visible to all users.
   *
   * Used for system banners (Otto-style outage notices). Per-user
   * read/dismiss state is not persisted — clients dismiss locally.
   */
  createBroadcastNotification?: Maybe<CreateBroadcastNotification>;
  /** Creates a new companion session. This will close any existing open companion sessions */
  createCompanionSession?: Maybe<CreateCompanionSession>;
  /**
   * A class used to define a mutation for creating a new organization and inserting it into the database.
   * This is used for internal tooling to create organizations for new enterprises. This is different from the normal flow
   * of creating an organization via the Scribenote app, as this is deliberatly done by an internal user on behalf of a pilot.
   * Here org creation happens separate from team creation, and a billing profile is required to be passed in.
   *
   * Attributes:
   *     org_name (str): The name of the organization.
   *     billing_mode_id (int): The billing mode of the organization.
   *     location (str): The location of the organization.
   *     email_domain (str): The primary email domain of the organization.
   *     email_domain_secondary (str): Optional second allowed email domain.
   *     email_domain_tertiary (str): Optional third allowed email domain.
   *     stripe_customer_id (str): The Stripe customer ID of the organization.
   */
  createCustomOrg?: Maybe<CreateCustomOrg>;
  /** Create multiple notes from a single recording using a template group. */
  createGroupedNotes?: Maybe<CreateGroupedNotes>;
  createNote?: Maybe<CreateNote>;
  /**
   * A class used to define a mutation for creating a new organization and inserting it into the database.
   *
   * Attributes:
   *     ok (Boolean): A flag indicating whether the mutation was successful.
   *     organization (Organization): The newly created organization.
   *
   * Arguments:
   *     create_org_input (CreateOrgInput): The input fields required to create a new organization. This argument is required.
   *
   * Raises:
   *     CustomException: If the password in the request headers is not correct.
   */
  createOrganization?: Maybe<CreateOrganization>;
  createPatient?: Maybe<CreatePatient>;
  createPatientNote?: Maybe<CreatePatientNote>;
  createQuickNote?: Maybe<CreateQuickNote>;
  /**
   * Creates a new team and inserts it into db
   *
   * Arguments:
   *     team_name(String): The name of the team
   */
  createTeam?: Maybe<CreateTeam>;
  /**
   * A class used to define a mutation for creating a new team and inserting it into the database.
   * This is used for internal tooling to create teams for new enterprises. This is different form the normal flow
   * of creating a team via the Scribenote app, as this is deliberatly done by an internal user on behalf of a pilot.
   * Here team creation happens separate from org creation, and a billing profile is required to be passed in.
   *
   * Attributes:
   *     team_name (str): The name of the team.
   *     org_id (int): The ID of the organization.
   *     location (str): The location of the team.
   */
  createTeamUnderOrg?: Maybe<CreateTeamUnderOrg>;
  createTemplateGroup?: Maybe<CreateTemplateGroup>;
  createTemplatePreview?: Maybe<CreateTemplatePreview>;
  /**
   * FOR INTERNAL USE ONLY
   *
   * A GraphQL mutation class for creating a test user.
   *
   * Methods:
   *     mutate(root, info, **kwargs):
   *         Handles the mutation logic for creating a test user.
   */
  createTestUser?: Maybe<CreateTestUser>;
  createUser?: Maybe<CreateUser>;
  /**
   * Mutation to create a user as a member of the team for which they
   * are accepting an invitation to
   */
  createUserFromTeamInvitation?: Maybe<CreateUserFromTeamInvitation>;
  createV1Team?: Maybe<CreateV1Team>;
  /** A class used to define a mutation for deactivating a user from a team within an organization. */
  deactivateOrgTeamUser?: Maybe<DeactivateOrgTeamUser>;
  /** Bill a completed Managed Agent turn against the user's treat balance. */
  deductAgentSessionTreats?: Maybe<DeductAgentSessionTreats>;
  /**
   * Delete a Managed Agent session and its uploaded attachments.
   *
   * Propagates the delete to Anthropic so the Managed Agent session is
   * not orphaned on their side. A 404 (already gone) is treated as
   * idempotent success and the local delete proceeds; any other
   * upstream failure aborts the local delete so the two sides stay in
   * sync and the caller can retry. DB-level cascades remove rows in
   * ``attachments`` (CASCADE) and null-out ``treats.agent_session_id``
   * (SET NULL).
   */
  deleteAgentSession?: Maybe<DeleteAgentSession>;
  deleteAttachment?: Maybe<DeleteAttachment>;
  deleteAutoTemplate?: Maybe<DeleteAutoTemplate>;
  deleteCompanionSession?: Maybe<DeleteCompanionSession>;
  deleteHeaderImage?: Maybe<DeleteHeaderImage>;
  deleteNote?: Maybe<DeleteNote>;
  deleteNoteAudioRecording?: Maybe<DeleteNoteAudioRecording>;
  deleteNotes?: Maybe<DeleteNotes>;
  deletePatient?: Maybe<DeletePatient>;
  /**
   * Deletes a team if the user is an organization admin and the team is empty (only the current user is on the team).
   *
   * Arguments:
   *     team_uuid(String): The UUID of the team to delete
   */
  deleteTeam?: Maybe<DeleteTeam>;
  deleteTemplate?: Maybe<DeleteTemplate>;
  deleteTemplateGroup?: Maybe<DeleteTemplateGroup>;
  deleteUser?: Maybe<DeleteUser>;
  /** Delete a verified phone number. */
  deleteVerifiedPhoneNumber?: Maybe<DeleteVerifiedPhoneNumber>;
  /** Mutation to deny a team invitation from the user who received it */
  denyTeamInvitation?: Maybe<DenyTeamInvitation>;
  /**
   * GraphQL mutation to exchange Descope session token for admin portal session.
   *
   * The Descope session token must be provided in the Authorization header:
   *     Authorization: Bearer <descope_session_token>
   *
   * Requires an admin_portal:* role in the JWT. Returns 403-equivalent error
   * if the user is authenticated but lacks an admin role.
   */
  descopeAdminPortalSession?: Maybe<DescopeAdminPortalSession>;
  /**
   * GraphQL mutation to exchange Descope session token for Scribenote JWT (mobile).
   *
   * The Descope session token must be provided in the Authorization header:
   *     Authorization: Bearer <descope_session_token>
   */
  descopeMobileSession?: Maybe<DescopeMobileSession>;
  /**
   * GraphQL mutation to exchange Descope session token for Scribenote JWT (web).
   *
   * The Descope session token must be provided in the Authorization header:
   *     Authorization: Bearer <descope_session_token>
   */
  descopeWebSession?: Maybe<DescopeWebSession>;
  /**
   * Clear the patient link on a set of notes (reverse of MoveNotesToPatient).
   *
   * Scoped to the caller's notes. Deliberately does NOT reverse the side effects
   * of the attach flow — patient weight derived from note weight is left alone,
   * and attachments stay put — because unlinking a note shouldn't silently
   * rewrite unrelated state on the patient.
   *
   * Returns `affected_uuids` (the UUIDs that actually changed) in addition to
   * `ok` and `affected_count` so clients can tell the user the truth when some
   * UUIDs were skipped (foreign, missing, or already detached). The audit
   * trail is only written for the UUIDs that actually moved — passing the
   * full requested list would create false `detach_from_patient` entries.
   */
  detachNotesFromPatient?: Maybe<DetachNotesFromPatient>;
  /** Dismiss a notification (hides it permanently). */
  dismissNotification?: Maybe<DismissNotification>;
  /**
   * Dismiss all notifications of a type for a specific note.
   *
   * Useful when user triggers reprocess — dismiss "new audio available".
   */
  dismissNotificationsByNote?: Maybe<DismissNotificationsByNote>;
  editAccountPreferences?: Maybe<EditAccountPreferences>;
  editClientSummaryPreferences?: Maybe<EditClientSummaryPreferences>;
  editObjectiveNormalDefaults?: Maybe<EditObjectiveNormalDefaults>;
  editPatient?: Maybe<EditPatient>;
  editPdfSettings?: Maybe<EditPdfSettings>;
  editTemplate?: Maybe<EditTemplate>;
  /**
   * A general mutation for updating generic user fields.
   * Use for non complicated operations on the user model.
   * Ie, flipping a boolean state. Changing a string, etc.
   * Fields requiring heavier data processing should be in their own mutation.
   */
  editUser?: Maybe<EditUser>;
  exchangeGoogleToken?: Maybe<GoogleAuthResponse>;
  flagNoteToSupport?: Maybe<FlagNoteToSupport>;
  /** Placeholder mutation for adaptive client summaries. */
  generateAdaptiveClientSummary?: Maybe<GenerateAdaptiveClientSummary>;
  /**
   * Enqueue a Celery task that summarizes the first turn of an agent
   * session (user message + agent response) into a title. Returns
   * immediately — the worker writes the title via the in-house LLM
   * orchestrator and broadcasts a ``companion-session-title-update``
   * WebSocket event on success.
   */
  generateAgentSessionTitle?: Maybe<GenerateAgentSessionTitle>;
  generateClientSummary?: Maybe<GenerateClientSummary>;
  generateClientSummaryNext?: Maybe<GenerateClientSummaryNext>;
  /** A class used to define a mutation for creating a new LLM customization and inserting it into the database. */
  generateLlmCustomizations?: Maybe<GenerateLlmCustomization>;
  /**
   * Used to delete a note from the database.
   * This is a hard delete, meaning the note is removed from the database including the audit trail.
   */
  hardDeleteNotes?: Maybe<HardDeleteNotes>;
  /**
   * Used to delete a user from the database.
   * This is a hard delete, and should only be used in the case of a user requesting their data be removed.
   */
  hardDeleteUser?: Maybe<HardDeleteUser>;
  incrementAutoUsage?: Maybe<IncrementAutoUsage>;
  /**
   * A class used to define a mutation that ties a user to a task stream uuid.
   *
   * Attributes:
   *     ok (Boolean): A flag indicating whether the mutation was successful.
   *
   * Arguments:
   *     task_uuid (String): The unique identifier for the task stream to be initialized.
   */
  initializeStream?: Maybe<InitializeStream>;
  /**
   * Invites a user to a team
   * Arguments:
   *     invitation_input(List): A list of InviteUsersToTeamInput objects
   *     team_uuid(String): The uuid of the team to which the user is being invited
   */
  inviteUsersToTeam?: Maybe<InviteUsersToTeam>;
  linkRecordingConsentToNote?: Maybe<LinkRecordingConsentToNote>;
  logRecordingConsent?: Maybe<LogRecordingConsent>;
  logScribephoneConsent?: Maybe<LogScribephoneConsent>;
  loginUser?: Maybe<LoginUser>;
  logoutUser?: Maybe<LogoutUser>;
  /**
   * Record the Anthropic event id an attachment was sent in.
   *
   * Called by the agent relay after ``events.send`` returns so hydration can
   * re-associate uploads with the exact user.message they accompanied.
   */
  markAgentSessionAttachmentsSent?: Maybe<MarkAgentSessionAttachmentsSent>;
  /** Record that a persistent Companion permission grant was used. */
  markAgentToolPermissionGrantUsed?: Maybe<MarkAgentToolPermissionGrantUsed>;
  /** Mark a notification as read. */
  markNotificationRead?: Maybe<MarkNotificationRead>;
  /**
   * Admin-only soft-delete of a user ("Mark for Deletion").
   *
   * Gated by `admin_portal:editor`. Audit-logged via `log_changes`.
   * Idempotent on the soft-deleted state.
   */
  markUserForDeletion?: Maybe<MarkUserForDeletion>;
  modifyNote?: Maybe<ModifyNote>;
  modifyNotes?: Maybe<ModifyNotes>;
  moveNotesToPatient?: Maybe<MoveNotesToPatient>;
  /**
   * Used on web to reauthenticate an active user if their session
   * is going to expire soon. This prevents someone who has been using the app
   * from seeing the "Session expiry" modal.
   */
  persistentLoginUser?: Maybe<PersistentLoginUser>;
  populateUserSampleTemplates?: Maybe<PopulateUserSampleTemplates>;
  /**
   * Record a pre-generated edit proposal (no LLM call) and broadcast it.
   *
   * Companion v2 twin of GenerateLLMCustomization — Otto produces after_content
   * itself and hands it here, and we emit the same
   * companion_llm_(template_)customization_{updates,completion} pair so the
   * existing approve/reject UI picks it up.
   */
  proposeLlmEdit?: Maybe<ProposeLlmEdit>;
  protectNote?: Maybe<ProtectNote>;
  /**
   * Redeems Pay It Furward credits for a prepaid Visa card.
   *
   * The prepaid card is sent via email to the user (or a specified recipient).
   * Minimum redemption amount is $25 (2500 cents).
   */
  redeemCredits?: Maybe<RedeemCredits>;
  /** Used to refresh the 24 hour access token on the mobile app */
  refreshUserToken?: Maybe<RefreshUserToken>;
  removeOrganizationDefaultTemplate?: Maybe<RemoveOrganizationDefaultTemplate>;
  removeTeamDefaultTemplate?: Maybe<RemoveTeamDefaultTemplate>;
  /**
   * A class used to define a mutation for removing users from teams within an organization.
   *
   * Attributes:
   *     ok (Boolean): A flag indicating whether the mutation was successful.
   *
   * Arguments:
   *     org_id (Int): The ID of the organization. This argument is required.
   *     team_id (Int): The ID of the team. This argument is required.
   *     user_ids (List(Int)): A list of user IDs to remove from the team. This argument is required.
   *
   * Raises:
   *     CustomException: If the password in the request headers is not correct.
   */
  removeUserFromOrgTeam?: Maybe<RemoveUserFromOrgTeam>;
  removeUserFromTeam?: Maybe<RemoveUserFromTeam>;
  /** Request phone number verification for caller ID. */
  requestPhoneVerification?: Maybe<RequestPhoneVerification>;
  requestTeamSetup?: Maybe<RequestTeamSetup>;
  resendConfirmUser?: Maybe<ResendUserConfirmation>;
  /**
   * Admin-only restore of a soft-deleted user.
   *
   * Reverse of `MarkUserForDeletion`. Gated by `admin_portal:editor`.
   * Audit-logged via `log_changes`. Idempotent on the active state.
   */
  restoreUser?: Maybe<RestoreUser>;
  retoolCreateQuickNote?: Maybe<RetoolCreateQuickNote>;
  retoolDeleteNotes?: Maybe<RetoolDeleteNotes>;
  /**
   * Used to retry failed auto-soaps and change templates.
   * Can optionally skip retranscription for template changes.
   */
  retryFailedAutoSoap?: Maybe<RetryFailedAutoSoap>;
  /** Revoke an active Companion permission grant for the current user. */
  revokeAgentToolPermissionGrant?: Maybe<RevokeAgentToolPermissionGrant>;
  /**
   * Create a notification for the current user.
   *
   * Omit ``active_at`` for an immediate notification. Set ``active_at``
   * in the future to schedule. Visibility is filtered query-side.
   */
  scheduleNotification?: Maybe<ScheduleNotification>;
  sendClientSummaryEmail?: Maybe<SendClientSummaryEmail>;
  sendCompanionSessionMessage?: Maybe<SendCompanionSessionMessage>;
  /** Send the authenticated user an email with an auto-login link to the dashboard on web. */
  sendDashboardDesktopLink?: Maybe<SendDashboardDesktopLink>;
  sendExportNoteEmail?: Maybe<SendExportNoteEmail>;
  /**
   * The user requests a password reset for an email
   * If that email belongs to a user, we send a reset email
   * with a short-lived single-use JWT (PURPOSE_TOKEN_TTL).
   * If clicked, they are taken to a link
   * Where they would post new password to UpdateForgottenPassword (above)
   */
  sendForgotPasswordEmail?: Maybe<SendForgotPasswordEmail>;
  /** Send the authenticated user an email with an auto-login link to a note on web. */
  sendNoteDesktopLink?: Maybe<SendNoteDesktopLink>;
  setAccountPreference?: Maybe<SetAccountPreference>;
  setOrganizationDefaultTemplate?: Maybe<SetOrganizationDefaultTemplate>;
  setTeamDefaultTemplate?: Maybe<SetTeamDefaultTemplate>;
  transferNoteOwnership?: Maybe<TransferNoteOwnership>;
  triggerDentalChartExtraction?: Maybe<TriggerDentalChartExtraction>;
  /** Remove a note from its group, making it fully independent. */
  ungroupNote?: Maybe<UngroupNote>;
  /**
   * Update an account's plan type and optionally its free trial expiration.
   *
   * This mutation is used by internal tooling (Retool) to update account plans
   * while ensuring changes go through the ORM, which triggers the Intercom sync
   * listener to keep user plan data in sync.
   *
   * Attributes:
   *     account_uuid (str): The UUID of the account to update.
   *     account_type (str): The new account type ('basic' or 'unlimited').
   *     free_trial_expires_at (DateTime): Optional datetime for trial expiration.
   */
  updateAccountPlan?: Maybe<UpdateAccountPlan>;
  /** Update the title of an existing Managed Agent session. */
  updateAgentSessionTitle?: Maybe<UpdateAgentSessionTitle>;
  updateAutoTemplate?: Maybe<UpdateAutoTemplate>;
  /**
   * After a user has recieved their password reset link via email, they click a link.
   * That link brings them to a /reset_password page on the front end.
   * They confirm their new password, then fire a request to this resource where we:
   * check that they pass us. If it is right, we update their password in the database.
   */
  updateForgottenPassword?: Maybe<UpdateForgottenPassword>;
  /** Replace the user's scribe.md memory with the supplied content. */
  updateScribeMd?: Maybe<UpdateScribeMd>;
  updateTemplateGroup?: Maybe<UpdateTemplateGroup>;
  updateTemplateSharing?: Maybe<UpdateTemplateSharing>;
  /**
   * A GraphQL mutation to add or remove users from a Feature Flag segment.
   *
   * Arguments:
   *     action (ActionEnum): The action to perform (ADD or REMOVE).
   *     segment_key (String): The key of the LaunchDarkly segment.
   *
   * Returns:
   *     success (Boolean): True if the operation succeeded, False otherwise.
   *     message (String): A message indicating the result of the operation.
   */
  updateUserFfSegment?: Maybe<UpdateUserFfSegment>;
  updateUserTeam?: Maybe<UpdateUserTeam>;
  /** Update team sharing for a verified phone number. */
  updateVerifiedPhoneNumberSharing?: Maybe<UpdateVerifiedPhoneNumberSharing>;
  /**
   * Register an uploaded file as an attachment on an agent session (Companion 2.0).
   *
   * The file is expected to have already been uploaded to the companion_uploads
   * S3 bucket via /sign_s3_agent_session_attachment/. This mutation validates
   * the bytes match an allowed MIME type, then persists an AttachmentModel row
   * linked to the agent session.
   */
  uploadAgentSessionAttachment?: Maybe<UploadAgentSessionAttachment>;
  uploadCompanionSessionAttachment?: Maybe<UploadCompanionSessionAttachment>;
  uploadHeaderImage?: Maybe<UploadHeaderImage>;
  uploadNoteAttachments?: Maybe<UploadNoteAttachments>;
  uploadPatientAttachments?: Maybe<UploadPatientAttachments>;
  uploadPdfAndExtractText?: Maybe<UploadPdfAndExtractText>;
  uploadSpeedTest?: Maybe<UploadSpeedTest>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAcceptLlmCustomizationArgs = {
  acceptLlmCustomizationInput: AcceptLlmCustomizationsInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAcceptTeamInvitationArgs = {
  inviteUuid?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAddFeedbackToCustomizationArgs = {
  addFeedbackInput: AddFeedbackInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAddFeedbackToLogArgs = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  noteType?: InputMaybe<Scalars['String']['input']>;
  noteUuid?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAddMphCompanionMembersArgs = {
  trackingTicket?: InputMaybe<Scalars['String']['input']>;
  userUuids: Array<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAddNoteToGroupArgs = {
  noteUuid: Scalars['String']['input'];
  targetUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAddOrgAdminArgs = {
  orgUuid: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAddUsersToTeamArgs = {
  addUsersToTeamInput: AddUsersToTeamInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminBulkMarkUsersForDeletionArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  rows: Array<AdminBulkDeleteRowInput>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminDeleteTeamArgs = {
  uuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminDeleteVerifiedPhoneNumberArgs = {
  userUuid: Scalars['String']['input'];
  verifiedPhoneNumberUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminEditAccountArgs = {
  freeTrialExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  isTeamsCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminEditOrganizationArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminEditOrganizationEmailSettingsArgs = {
  settings: Array<AdminOrgEmailSettingInput>;
  uuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminEditOrganizationRecordingConsentArgs = {
  consentHeader?: InputMaybe<Scalars['String']['input']>;
  consentText?: InputMaybe<Scalars['String']['input']>;
  consentTextVersion?: InputMaybe<Scalars['String']['input']>;
  requiresRecordingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminEditTeamArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminEditTeamMemberArgs = {
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
  teamUuid: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminEditUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminGiveTreatsArgs = {
  amount: Scalars['Int']['input'];
  userUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminMoveTeamToOrgArgs = {
  targetOrgUuid: Scalars['String']['input'];
  teamUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminMphBulkAssignTeamRolesArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  rows: Array<AdminMphBulkRoleRowInput>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminMphBulkReassignTeamsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  rows: Array<AdminMphBulkReassignRowInput>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminRemoveTeamMemberArgs = {
  teamUuid: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminResendInvitationArgs = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  inviteeEmail?: InputMaybe<Scalars['String']['input']>;
  teamUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminRevokeInvitationArgs = {
  inviteeEmail?: InputMaybe<Scalars['String']['input']>;
  teamUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminRevokeOrganizationStripeCustomerArgs = {
  uuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminSetOrganizationAdminArgs = {
  isAdmin: Scalars['Boolean']['input'];
  userUuid: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminUnwireAccountArgs = {
  userUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminUpdateOrganizationStripeCustomerArgs = {
  stripeCustomerId: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAdminWireUpAccountArgs = {
  stripeCustomerId: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAppendRecordingArgs = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  noteUuid?: InputMaybe<Scalars['String']['input']>;
  storageObjectName?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsAssociateQuicknotesWithPatientArgs = {
  noteUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsBulkRestoreUsersArgs = {
  uuids: Array<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsBulkSetExpiryPolicyArgs = {
  expiryPolicy?: InputMaybe<Scalars['String']['input']>;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsBulkSetRoleArgs = {
  role?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCancelBroadcastNotificationArgs = {
  notificationUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCancelNotificationArgs = {
  notificationUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsChangeScribephoneConsentModeArgs = {
  consentMode: ScribephoneConsentEnum;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCheckinNoteArgs = {
  noteUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCheckoutNoteArgs = {
  noteUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCloseCompanionSessionArgs = {
  companionSessionUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsConfirmUserArgs = {
  confirmationCode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCopyAutoTemplateArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  templateUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCopyNotesToPatientArgs = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  noteUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientUuid?: InputMaybe<Scalars['String']['input']>;
  shouldCopyTitles?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCorrectPatientNameInNoteArgs = {
  newName: Scalars['String']['input'];
  noteUuid: Scalars['String']['input'];
  oldName: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateAgentSessionArgs = {
  effort?: InputMaybe<Scalars['String']['input']>;
  managedAgentEnv?: InputMaybe<Scalars['String']['input']>;
  managedAgentId?: InputMaybe<Scalars['String']['input']>;
  managedAgentVersion?: InputMaybe<Scalars['String']['input']>;
  managedSessionId: Scalars['String']['input'];
  modelName: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateAgentToolPermissionGrantArgs = {
  displayName: Scalars['String']['input'];
  policyVersion: Scalars['String']['input'];
  toolAction: Scalars['String']['input'];
  toolName: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateAutoTemplateArgs = {
  createTemplateInput: CreateAutoTemplateInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateBroadcastNotificationArgs = {
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  activeAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  extra?: InputMaybe<Scalars['JSONString']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notificationDomain?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateCompanionSessionArgs = {
  inventoryUuid?: InputMaybe<Scalars['String']['input']>;
  sessionType?: InputMaybe<Scalars['String']['input']>;
  teamUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateCustomOrgArgs = {
  billingModeId: Scalars['Int']['input'];
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  emailDomainSecondary?: InputMaybe<Scalars['String']['input']>;
  emailDomainTertiary?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  orgName: Scalars['String']['input'];
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateGroupedNotesArgs = {
  patientUuid?: InputMaybe<Scalars['String']['input']>;
  recordingConsentEventUuid?: InputMaybe<Scalars['UUID']['input']>;
  storageObjectName: Scalars['String']['input'];
  templateGroupUuid: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateNoteArgs = {
  audioStorageLink?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customObjectiveFields?: InputMaybe<Array<InputMaybe<CustomObjectiveFieldsInput>>>;
  excludedObjectiveFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  keyHistory?: InputMaybe<Scalars['String']['input']>;
  keyMedications?: InputMaybe<Scalars['String']['input']>;
  noteInput?: InputMaybe<NoteInput>;
  objectiveFields?: InputMaybe<ObjectiveFieldsInput>;
  patientUuid?: InputMaybe<Scalars['String']['input']>;
  recordingConsentEventUuid?: InputMaybe<Scalars['UUID']['input']>;
  shouldUseGenericObjective?: InputMaybe<Scalars['Boolean']['input']>;
  soapTags?: InputMaybe<Array<InputMaybe<SoapTag>>>;
  soapText?: InputMaybe<SoapText>;
  storageObjectName?: InputMaybe<Scalars['String']['input']>;
  taggedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  uuidsOfDeletedCustomObjectiveFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vaccinationStatus?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateOrganizationArgs = {
  createOrgInput: CreateOrgInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreatePatientArgs = {
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  breed?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emergencyContactInfo?: InputMaybe<Scalars['String']['input']>;
  isIntact?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameOfOwner?: InputMaybe<Scalars['String']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerContactInfo?: InputMaybe<Scalars['String']['input']>;
  patientInput?: InputMaybe<PatientInput>;
  sex?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  weeks?: InputMaybe<Scalars['Int']['input']>;
  years?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreatePatientNoteArgs = {
  audioStorageLink?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customObjectiveFields?: InputMaybe<Array<InputMaybe<CustomObjectiveFieldsInput>>>;
  excludedObjectiveFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  keyHistory?: InputMaybe<Scalars['String']['input']>;
  keyMedications?: InputMaybe<Scalars['String']['input']>;
  noteInput?: InputMaybe<NoteInput>;
  objectiveFields?: InputMaybe<ObjectiveFieldsInput>;
  quickNote?: InputMaybe<Scalars['String']['input']>;
  recordingConsentEventUuid?: InputMaybe<Scalars['UUID']['input']>;
  shouldUseGenericObjective?: InputMaybe<Scalars['Boolean']['input']>;
  soapTags?: InputMaybe<Array<InputMaybe<SoapTag>>>;
  soapText?: InputMaybe<SoapText>;
  storageObjectName?: InputMaybe<Scalars['String']['input']>;
  taggedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  uuidsOfDeletedCustomObjectiveFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vaccinationStatus?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateQuickNoteArgs = {
  noteInput?: InputMaybe<NoteInput>;
  recordingConsentEventUuid?: InputMaybe<Scalars['UUID']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateTeamArgs = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  orgUuid?: InputMaybe<Scalars['String']['input']>;
  teamName: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateTeamUnderOrgArgs = {
  location?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['Int']['input'];
  teamName: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateTemplateGroupArgs = {
  name: Scalars['String']['input'];
  sharingType?: InputMaybe<SharingTypeEnum>;
  templateUuids: Array<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateTemplatePreviewArgs = {
  createTemplatePreviewInput: TemplatePreviewInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateTestUserArgs = {
  testUserData: CreateTestUserInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateUserArgs = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAppointmentsBetaUser?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboardingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isScribe?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['Int']['input']>;
  signUpCoupon?: InputMaybe<Scalars['String']['input']>;
  vlReferredCode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateUserFromTeamInvitationArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  signUpCoupon?: InputMaybe<Scalars['String']['input']>;
  vlReferredCode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsCreateV1TeamArgs = {
  teamData: CreateV1TeamInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeactivateOrgTeamUserArgs = {
  rmTeamUserInput: RmTeamUserInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeductAgentSessionTreatsArgs = {
  agentSessionUuid: Scalars['String']['input'];
  cacheCreationInputTokens?: InputMaybe<Scalars['Int']['input']>;
  cacheReadInputTokens?: InputMaybe<Scalars['Int']['input']>;
  inputTokens: Scalars['Int']['input'];
  outputTokens: Scalars['Int']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeleteAgentSessionArgs = {
  agentSessionUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeleteAttachmentArgs = {
  attachmentUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeleteAutoTemplateArgs = {
  templateUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeleteCompanionSessionArgs = {
  companionSessionUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeleteNoteArgs = {
  noteUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeleteNoteAudioRecordingArgs = {
  noteUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeleteNotesArgs = {
  noteUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeletePatientArgs = {
  patientUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeleteTeamArgs = {
  teamUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeleteTemplateArgs = {
  templateUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeleteTemplateGroupArgs = {
  groupUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDeleteVerifiedPhoneNumberArgs = {
  verifiedPhoneUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDenyTeamInvitationArgs = {
  inviteUuid?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDetachNotesFromPatientArgs = {
  noteUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDismissNotificationArgs = {
  notificationUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsDismissNotificationsByNoteArgs = {
  noteUuid: Scalars['String']['input'];
  notificationType: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsEditAccountPreferencesArgs = {
  shouldHidePresetTemplates?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsEditClientSummaryPreferencesArgs = {
  abnormalPhysicalFindings?: InputMaybe<Scalars['Boolean']['input']>;
  allFindings?: InputMaybe<Scalars['Boolean']['input']>;
  backmatter?: InputMaybe<Scalars['String']['input']>;
  diagnostics?: InputMaybe<Scalars['Boolean']['input']>;
  diet?: InputMaybe<Scalars['Boolean']['input']>;
  followUpAppointments?: InputMaybe<Scalars['Boolean']['input']>;
  frontmatter?: InputMaybe<Scalars['String']['input']>;
  homeCare?: InputMaybe<Scalars['Boolean']['input']>;
  medications?: InputMaybe<Scalars['Boolean']['input']>;
  oneLineSummary?: InputMaybe<Scalars['Boolean']['input']>;
  ownerInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  pointFormSummary?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinations?: InputMaybe<Scalars['Boolean']['input']>;
  visitSummary?: InputMaybe<Scalars['Boolean']['input']>;
  vitals?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsEditObjectiveNormalDefaultsArgs = {
  objectiveNormalDefaultsInput: ObjectiveNormalDefaultsInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsEditPatientArgs = {
  patientInput?: InputMaybe<PatientInput>;
  patientUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsEditPdfSettingsArgs = {
  headerInfoPdf?: InputMaybe<Scalars['String']['input']>;
  shouldUseSimpleAppearancePdf?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsEditTemplateArgs = {
  customObjectiveFields?: InputMaybe<Array<InputMaybe<CustomObjectiveFieldsInput>>>;
  excludedObjectiveFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyHistory?: InputMaybe<Scalars['String']['input']>;
  keyMedications?: InputMaybe<Scalars['String']['input']>;
  noteInput?: InputMaybe<NoteInput>;
  noteUuid?: InputMaybe<Scalars['String']['input']>;
  objectiveFields?: InputMaybe<ObjectiveFieldsInput>;
  shouldUseGenericObjective?: InputMaybe<Scalars['Boolean']['input']>;
  soapText?: InputMaybe<SoapText>;
  templateFields?: InputMaybe<TemplateFieldsInput>;
  templateUuid?: InputMaybe<Scalars['String']['input']>;
  uuidsOfDeletedCustomObjectiveFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vaccinationStatus?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsEditUserArgs = {
  autoExportEmail?: InputMaybe<Scalars['String']['input']>;
  bonusAppointments?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAppointmentsBetaUser?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboardingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingClinic?: InputMaybe<Scalars['String']['input']>;
  onboardingCorporateGroup?: InputMaybe<Scalars['String']['input']>;
  onboardingMilestones?: InputMaybe<Scalars['GenericScalar']['input']>;
  onboardingReferralSource?: InputMaybe<Scalars['String']['input']>;
  pimsProvider?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
  shouldEmbedEmailExports?: InputMaybe<Scalars['Boolean']['input']>;
  shouldUseAutoSoaps?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsExchangeGoogleTokenArgs = {
  input: GoogleAuthInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsFlagNoteToSupportArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  noteUuid?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsGenerateAdaptiveClientSummaryArgs = {
  noteUuid: Scalars['String']['input'];
  templateUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsGenerateAgentSessionTitleArgs = {
  agentSessionUuid: Scalars['String']['input'];
  firstMessage: Scalars['String']['input'];
  firstResponse: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsGenerateClientSummaryArgs = {
  noteUuid: Scalars['String']['input'];
  streamingTaskUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsGenerateClientSummaryNextArgs = {
  assessment?: InputMaybe<Scalars['String']['input']>;
  formOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noteUuid?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  streamingTaskUuid?: InputMaybe<Scalars['String']['input']>;
  subjective?: InputMaybe<Scalars['String']['input']>;
  summaryType?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsGenerateLlmCustomizationsArgs = {
  createLlmCustomizationInput: CreateLlmCustomizationsInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsHardDeleteNotesArgs = {
  noteUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsHardDeleteUserArgs = {
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsIncrementAutoUsageArgs = {
  noteUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsInitializeStreamArgs = {
  taskUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsInviteUsersToTeamArgs = {
  inviteUsersToTeamInput: InviteUsersToTeamInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsLinkRecordingConsentToNoteArgs = {
  consentEventUuid: Scalars['UUID']['input'];
  noteUuid: Scalars['UUID']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsLogRecordingConsentArgs = {
  action: RecordingConsentAction;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  noteUuid?: InputMaybe<Scalars['UUID']['input']>;
  source: RecordingConsentSource;
  surface: RecordingConsentSurface;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsLoginUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsMarkAgentSessionAttachmentsSentArgs = {
  agentSessionUuid: Scalars['String']['input'];
  attachmentUuids: Array<InputMaybe<Scalars['String']['input']>>;
  eventId: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsMarkAgentToolPermissionGrantUsedArgs = {
  policyVersion: Scalars['String']['input'];
  toolAction: Scalars['String']['input'];
  toolName: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsMarkNotificationReadArgs = {
  notificationUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsMarkUserForDeletionArgs = {
  uuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsModifyNoteArgs = {
  customObjectiveFields?: InputMaybe<Array<InputMaybe<CustomObjectiveFieldsInput>>>;
  excludedObjectiveFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  keyHistory?: InputMaybe<Scalars['String']['input']>;
  keyMedications?: InputMaybe<Scalars['String']['input']>;
  noteInput?: InputMaybe<NoteInput>;
  noteUuid?: InputMaybe<Scalars['String']['input']>;
  objectiveFields?: InputMaybe<ObjectiveFieldsInput>;
  quickNote?: InputMaybe<Scalars['String']['input']>;
  shouldUseGenericObjective?: InputMaybe<Scalars['Boolean']['input']>;
  soapTags?: InputMaybe<Array<InputMaybe<SoapTag>>>;
  soapText?: InputMaybe<SoapText>;
  taggedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  uuidsOfDeletedCustomObjectiveFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vaccinationStatus?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsModifyNotesArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  noteUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsMoveNotesToPatientArgs = {
  noteUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsProposeLlmEditArgs = {
  proposeLlmEditInput: ProposeLlmEditInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsProtectNoteArgs = {
  noteUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsRedeemCreditsArgs = {
  amountCents: Scalars['Int']['input'];
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsRemoveOrganizationDefaultTemplateArgs = {
  orgUuid: Scalars['String']['input'];
  templateUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsRemoveTeamDefaultTemplateArgs = {
  teamUuids: Array<Scalars['String']['input']>;
  templateUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsRemoveUserFromOrgTeamArgs = {
  rmTeamUserInput: RmTeamUserInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsRemoveUserFromTeamArgs = {
  teamUuid: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsRequestPhoneVerificationArgs = {
  extension?: InputMaybe<Array<InputMaybe<ExtensionStepInput>>>;
  phoneNumber: Scalars['String']['input'];
  teamUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsRequestTeamSetupArgs = {
  customMessage: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsRestoreUserArgs = {
  uuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsRetoolCreateQuickNoteArgs = {
  noteInput?: InputMaybe<NoteInput>;
  recordingConsentEventUuid?: InputMaybe<Scalars['UUID']['input']>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsRetoolDeleteNotesArgs = {
  noteUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsRetryFailedAutoSoapArgs = {
  jobType?: InputMaybe<Scalars['String']['input']>;
  noteUuid?: InputMaybe<Scalars['String']['input']>;
  skipTranscription?: InputMaybe<Scalars['Boolean']['input']>;
  templateUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsRevokeAgentToolPermissionGrantArgs = {
  uuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsScheduleNotificationArgs = {
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  activeAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  extra?: InputMaybe<Scalars['JSONString']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notificationDomain?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsSendClientSummaryEmailArgs = {
  clientSummary?: InputMaybe<Scalars['String']['input']>;
  toEmail?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsSendCompanionSessionMessageArgs = {
  companionSessionUuid: Scalars['String']['input'];
  noteUuid?: InputMaybe<Scalars['String']['input']>;
  streamingTaskUuid?: InputMaybe<Scalars['String']['input']>;
  templateUuid?: InputMaybe<Scalars['String']['input']>;
  textContent: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsSendExportNoteEmailArgs = {
  areAttachmentsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  grantedNoteUuid?: InputMaybe<Scalars['String']['input']>;
  isForAssistant?: InputMaybe<Scalars['Boolean']['input']>;
  shouldEmbedEmailExports?: InputMaybe<Scalars['Boolean']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  toEmail?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsSendForgotPasswordEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsSendNoteDesktopLinkArgs = {
  noteUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsSetAccountPreferenceArgs = {
  key: Scalars['String']['input'];
  value: Scalars['GenericScalar']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsSetOrganizationDefaultTemplateArgs = {
  orgUuid: Scalars['String']['input'];
  templateUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsSetTeamDefaultTemplateArgs = {
  teamUuids: Array<Scalars['String']['input']>;
  templateUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsTransferNoteOwnershipArgs = {
  applyCustomDefaults?: InputMaybe<Scalars['Boolean']['input']>;
  newOwnerUuid?: InputMaybe<Scalars['String']['input']>;
  newTeamUuid?: InputMaybe<Scalars['String']['input']>;
  noteUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsTriggerDentalChartExtractionArgs = {
  noteUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUngroupNoteArgs = {
  noteUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUpdateAccountPlanArgs = {
  accountType: Scalars['String']['input'];
  accountUuid: Scalars['String']['input'];
  freeTrialExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUpdateAgentSessionTitleArgs = {
  agentSessionUuid: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUpdateAutoTemplateArgs = {
  updateTemplateInput: UpdateAutoTemplateInput;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUpdateForgottenPasswordArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUpdateScribeMdArgs = {
  content: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUpdateTemplateGroupArgs = {
  groupUuid: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sharingType?: InputMaybe<SharingTypeEnum>;
  templateUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUpdateTemplateSharingArgs = {
  sharedEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sharingType: Scalars['String']['input'];
  templateUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUpdateUserFfSegmentArgs = {
  action: ActionEnum;
  segmentKey: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUpdateUserTeamArgs = {
  accountType?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
  teamUuid: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUpdateVerifiedPhoneNumberSharingArgs = {
  teamUuid?: InputMaybe<Scalars['String']['input']>;
  verifiedPhoneUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUploadAgentSessionAttachmentArgs = {
  agentSessionUuid: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  managedFileId?: InputMaybe<Scalars['String']['input']>;
  sentInEventId?: InputMaybe<Scalars['String']['input']>;
  storageObjectName: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUploadCompanionSessionAttachmentArgs = {
  companionSessionUuid: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  storageObjectName: Scalars['String']['input'];
  streamingTaskUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUploadHeaderImageArgs = {
  logoContentType: Scalars['String']['input'];
  logoStorageObjectName: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUploadNoteAttachmentsArgs = {
  attachments: Array<InputMaybe<AttachmentInput>>;
  createdAt: Scalars['DateTime']['input'];
  noteUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUploadPatientAttachmentsArgs = {
  attachments: Array<InputMaybe<AttachmentInput>>;
  createdAt: Scalars['DateTime']['input'];
  patientUuid: Scalars['String']['input'];
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUploadPdfAndExtractTextArgs = {
  storageObjectName: Scalars['String']['input'];
  templateType: Scalars['String']['input'];
  templateUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The root mutation object.
 * All mutations should be listed here.
 */
export type MutationsUploadSpeedTestArgs = {
  file: Scalars['String']['input'];
};

/**
 * Represents a veterinary medical note created from voice recordings or manual entry.
 *
 * Notes contain SOAP sections (Subjective, Objective, Assessment, Plan), physical exam
 * findings, and can be associated with patients, templates, and companion sessions.
 * The id and audio_storage_object fields are intentionally excluded from the schema.
 */
export type Note = {
  __typename?: 'Note';
  additionalNotes?: Maybe<Scalars['String']['output']>;
  assessment?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  audioStorageLink?: Maybe<Scalars['String']['output']>;
  auditTrail?: Maybe<Array<Maybe<AuditTrail>>>;
  autoTemplates?: Maybe<AutoTemplate>;
  bodyConditionScore?: Maybe<Scalars['String']['output']>;
  capillaryRefillTime?: Maybe<Scalars['String']['output']>;
  cardiovascular?: Maybe<Scalars['String']['output']>;
  clientSummary?: Maybe<Scalars['String']['output']>;
  coatAndSkin?: Maybe<Scalars['String']['output']>;
  companionSession?: Maybe<CompanionSession>;
  createdAt: Scalars['DateTime']['output'];
  customFormFields?: Maybe<Array<Maybe<CustomFormField>>>;
  customObjectiveFields?: Maybe<Array<Maybe<CustomObjectiveField>>>;
  dataExtraction?: Maybe<Scalars['String']['output']>;
  dentalChartData?: Maybe<Scalars['JSONString']['output']>;
  dentalChartStatus?: Maybe<Scalars['String']['output']>;
  ears?: Maybe<Scalars['String']['output']>;
  evaluatorSessionId?: Maybe<Scalars['String']['output']>;
  eyes?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  gastrointestinal?: Maybe<Scalars['String']['output']>;
  hasBeenExported: Scalars['Boolean']['output'];
  heartRate?: Maybe<Scalars['String']['output']>;
  isApproved: Scalars['Boolean']['output'];
  isAutoSoap: Scalars['Boolean']['output'];
  isBeingScribed?: Maybe<Scalars['Boolean']['output']>;
  isDraft: Scalars['Boolean']['output'];
  isFree?: Maybe<Scalars['Boolean']['output']>;
  isHallucinating?: Maybe<Scalars['Boolean']['output']>;
  isIncomplete: Scalars['Boolean']['output'];
  isMadeWithScribephone?: Maybe<Scalars['Boolean']['output']>;
  isMarkedAsFailed?: Maybe<Scalars['Boolean']['output']>;
  isMarkedAsProcessing?: Maybe<Scalars['Boolean']['output']>;
  isMarkedAsReview?: Maybe<Scalars['Boolean']['output']>;
  isMarkedAsSubmitted?: Maybe<Scalars['Boolean']['output']>;
  isNewRecording?: Maybe<Scalars['Boolean']['output']>;
  isProcessing: Scalars['Boolean']['output'];
  isTagged: Scalars['Boolean']['output'];
  isUnacceptable?: Maybe<Scalars['Boolean']['output']>;
  jobType?: Maybe<Scalars['String']['output']>;
  jobTypeName?: Maybe<Scalars['String']['output']>;
  keyHistory?: Maybe<Scalars['String']['output']>;
  keyMedications?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  lymphatic?: Maybe<Scalars['String']['output']>;
  musculoskeletal?: Maybe<Scalars['String']['output']>;
  neurological?: Maybe<Scalars['String']['output']>;
  noteGroup?: Maybe<NoteGroup>;
  noteGroupId?: Maybe<Scalars['String']['output']>;
  objective?: Maybe<Scalars['String']['output']>;
  oral?: Maybe<Scalars['String']['output']>;
  overall?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  patientId?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  quickNote?: Maybe<Scalars['String']['output']>;
  recordingLength?: Maybe<Scalars['Int']['output']>;
  reproductiveAndUrinary?: Maybe<Scalars['String']['output']>;
  respiratory?: Maybe<Scalars['String']['output']>;
  respiratoryRate?: Maybe<Scalars['String']['output']>;
  shouldUseCustomForm?: Maybe<Scalars['Boolean']['output']>;
  shouldUseGenericObjective?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<NoteStatus>;
  storageObjectName?: Maybe<Scalars['String']['output']>;
  subjective?: Maybe<Scalars['String']['output']>;
  taggedAt?: Maybe<Scalars['DateTime']['output']>;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['Int']['output']>;
  temperature?: Maybe<Scalars['String']['output']>;
  template?: Maybe<Template>;
  templateId?: Maybe<Scalars['Int']['output']>;
  templatePreviews?: Maybe<Array<Maybe<TemplatePreviews>>>;
  thumbsUp?: Maybe<Scalars['Boolean']['output']>;
  timeToProcess?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
  transcriptionJsonStorageLink?: Maybe<Scalars['String']['output']>;
  transcriptionJsonStorageName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  vaccinationStatus?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

/** The filterable admin Notes columns. */
export enum NoteFilterField {
  CreatedAt = 'CREATED_AT',
  HasDentalChart = 'HAS_DENTAL_CHART',
  LastUpdatedAt = 'LAST_UPDATED_AT',
  Owner = 'OWNER',
  Recording = 'RECORDING',
  Scribephone = 'SCRIBEPHONE',
  Status = 'STATUS',
  Team = 'TEAM',
  Template = 'TEMPLATE',
  Title = 'TITLE',
  Uuid = 'UUID'
}

/**
 * One admin Notes query-builder condition. ``field`` and ``operator`` are
 * enums, so an unknown one is a validation error rather than a condition that
 * quietly matches everything. Which operators apply follows from the field's
 * type (text: CONTAINS/EQUALS, choice: IS/IS_NOT, date: BEFORE/AFTER/ON).
 * Text and date fields use ``value``; choice fields use ``values``, OR-combined
 * within the one condition. Separate conditions are AND-combined. ``value`` is
 * nullable (a choice condition sends none); list items are not.
 */
export type NoteFilterInput = {
  field: NoteFilterField;
  operator: NoteFilterOperator;
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The operators an admin Notes filter condition can use. */
export enum NoteFilterOperator {
  After = 'AFTER',
  Before = 'BEFORE',
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  Is = 'IS',
  IsNot = 'IS_NOT',
  On = 'ON'
}

/** A group of notes produced from a single recording via a template group. */
export type NoteGroup = {
  __typename?: 'NoteGroup';
  createdAt: Scalars['DateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<NoteGroupNote>>>;
  uuid: Scalars['String']['output'];
};

/** A note's membership in a group, with its position. */
export type NoteGroupNote = {
  __typename?: 'NoteGroupNote';
  note?: Maybe<Note>;
  position: Scalars['Int']['output'];
};

export type NoteInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  assessment?: InputMaybe<Scalars['String']['input']>;
  audioStorageLink?: InputMaybe<Scalars['String']['input']>;
  clientSummary?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customObjectiveFields?: InputMaybe<Array<InputMaybe<CustomObjectiveFieldsInput>>>;
  customText?: InputMaybe<Scalars['String']['input']>;
  excludedObjectiveFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasBeenExported?: InputMaybe<Scalars['Boolean']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isAutosave?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboardingDemo?: InputMaybe<Scalars['Boolean']['input']>;
  isTagged?: InputMaybe<Scalars['Boolean']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  keyHistory?: InputMaybe<Scalars['String']['input']>;
  keyMedications?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  noteUuid?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  objectiveFields?: InputMaybe<ObjectiveFieldsInput>;
  patientUuid?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  quickNote?: InputMaybe<Scalars['String']['input']>;
  recordingAs?: InputMaybe<Scalars['String']['input']>;
  recordingLength?: InputMaybe<Scalars['Int']['input']>;
  shouldUseCustomForm?: InputMaybe<Scalars['Boolean']['input']>;
  shouldUseGenericObjective?: InputMaybe<Scalars['Boolean']['input']>;
  soapTags?: InputMaybe<Array<InputMaybe<SoapTag>>>;
  status?: InputMaybe<NoteStatus>;
  storageObjectName?: InputMaybe<Scalars['String']['input']>;
  subjective?: InputMaybe<Scalars['String']['input']>;
  taggedAt?: InputMaybe<Scalars['DateTime']['input']>;
  teamUuid?: InputMaybe<Scalars['String']['input']>;
  templateUuid?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
  uuidsOfDeletedCustomObjectiveFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vaccinationStatus?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum NoteStatus {
  Export = 'EXPORT',
  Exported = 'EXPORTED',
  Processing = 'PROCESSING',
  Review = 'REVIEW',
  Unprocessed = 'UNPROCESSED'
}

/**
 * A class for the input to create a test user, which for each field, is a number of notes for a particular job type.
 *
 * Attributes:
 *     All fields are optional and default to 0 if not specified.
 *
 *     soap (int): The number of SOAP notes for the test user. This field is optional.
 *     callback (int): The number of callback notes for the test user. This field is optional.
 *     recap (int): The number of recap notes for the test user. This field is optional.
 *     dental (int): The number of dental notes for the test user. This field is optional.
 *     dictation (int): The number of dictation notes for the test user. This field is optional.
 */
export type NumNotes = {
  callback?: InputMaybe<Scalars['Int']['input']>;
  dental?: InputMaybe<Scalars['Int']['input']>;
  dictation?: InputMaybe<Scalars['Int']['input']>;
  recap?: InputMaybe<Scalars['Int']['input']>;
  soap?: InputMaybe<Scalars['Int']['input']>;
};

export type ObjectiveFieldsInput = {
  bodyConditionScore?: InputMaybe<Scalars['String']['input']>;
  capillaryRefillTime?: InputMaybe<Scalars['String']['input']>;
  cardiovascular?: InputMaybe<Scalars['String']['input']>;
  coatAndSkin?: InputMaybe<Scalars['String']['input']>;
  ears?: InputMaybe<Scalars['String']['input']>;
  eyes?: InputMaybe<Scalars['String']['input']>;
  gastrointestinal?: InputMaybe<Scalars['String']['input']>;
  heartRate?: InputMaybe<Scalars['String']['input']>;
  lymphatic?: InputMaybe<Scalars['String']['input']>;
  musculoskeletal?: InputMaybe<Scalars['String']['input']>;
  neurological?: InputMaybe<Scalars['String']['input']>;
  oral?: InputMaybe<Scalars['String']['input']>;
  overall?: InputMaybe<Scalars['String']['input']>;
  reproductiveAndUrinary?: InputMaybe<Scalars['String']['input']>;
  respiratory?: InputMaybe<Scalars['String']['input']>;
  respiratoryRate?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

/** User's default values for objective exam findings. */
export type ObjectiveNormalDefaults = {
  __typename?: 'ObjectiveNormalDefaults';
  bodyConditionScore?: Maybe<Scalars['String']['output']>;
  capillaryRefillTime?: Maybe<Scalars['String']['output']>;
  cardiovascular?: Maybe<Scalars['String']['output']>;
  ears?: Maybe<Scalars['String']['output']>;
  eyes?: Maybe<Scalars['String']['output']>;
  fearAnxietyStressScore?: Maybe<Scalars['String']['output']>;
  furSkin?: Maybe<Scalars['String']['output']>;
  gastrointestinal?: Maybe<Scalars['String']['output']>;
  heartRate?: Maybe<Scalars['String']['output']>;
  hydrationStatus?: Maybe<Scalars['String']['output']>;
  lymphatic?: Maybe<Scalars['String']['output']>;
  masses?: Maybe<Scalars['String']['output']>;
  mucousMembranes?: Maybe<Scalars['String']['output']>;
  musculoskeletal?: Maybe<Scalars['String']['output']>;
  nasal?: Maybe<Scalars['String']['output']>;
  neurological?: Maybe<Scalars['String']['output']>;
  oralDental?: Maybe<Scalars['String']['output']>;
  painScore?: Maybe<Scalars['String']['output']>;
  reproductiveUrinary?: Maybe<Scalars['String']['output']>;
  respiratory?: Maybe<Scalars['String']['output']>;
  respiratoryRate?: Maybe<Scalars['String']['output']>;
  shouldUse?: Maybe<Scalars['Boolean']['output']>;
  temperature?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type ObjectiveNormalDefaultsInput = {
  bodyConditionScore?: InputMaybe<Scalars['String']['input']>;
  capillaryRefillTime?: InputMaybe<Scalars['String']['input']>;
  cardiovascular?: InputMaybe<Scalars['String']['input']>;
  ears?: InputMaybe<Scalars['String']['input']>;
  eyes?: InputMaybe<Scalars['String']['input']>;
  fearAnxietyStressScore?: InputMaybe<Scalars['String']['input']>;
  furSkin?: InputMaybe<Scalars['String']['input']>;
  gastrointestinal?: InputMaybe<Scalars['String']['input']>;
  heartRate?: InputMaybe<Scalars['String']['input']>;
  hydrationStatus?: InputMaybe<Scalars['String']['input']>;
  lymphatic?: InputMaybe<Scalars['String']['input']>;
  masses?: InputMaybe<Scalars['String']['input']>;
  mucousMembranes?: InputMaybe<Scalars['String']['input']>;
  musculoskeletal?: InputMaybe<Scalars['String']['input']>;
  nasal?: InputMaybe<Scalars['String']['input']>;
  neurological?: InputMaybe<Scalars['String']['input']>;
  oralDental?: InputMaybe<Scalars['String']['input']>;
  painScore?: InputMaybe<Scalars['String']['input']>;
  reproductiveUrinary?: InputMaybe<Scalars['String']['input']>;
  respiratory?: InputMaybe<Scalars['String']['input']>;
  respiratoryRate?: InputMaybe<Scalars['String']['input']>;
  shouldUse?: InputMaybe<Scalars['Boolean']['input']>;
  temperature?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Dedicated type for onboarding progress data.
 *
 * Separates onboarding-specific fields (which involve DB aggregations)
 * from the main User type to avoid running them on every CurrentUser fetch.
 */
export type OnboardingProgress = {
  __typename?: 'OnboardingProgress';
  distinctNoteCreationDays?: Maybe<Scalars['Int']['output']>;
  hasApprovedNote?: Maybe<Scalars['Boolean']['output']>;
  hasCreatedTemplate?: Maybe<Scalars['Boolean']['output']>;
  hasExportedNote?: Maybe<Scalars['Boolean']['output']>;
  onboardingMilestones?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * What an org is billed on. Decides which count Stripe's quantity is
 * compared against: distinct billed users, or teams with an active unlimited
 * DVM or Locum.
 */
export enum OrgBillingBasis {
  Seats = 'SEATS',
  Teams = 'TEAMS'
}

/** One org on the Stripe customer, with what it contributes to the total. */
export type OrgBillingShare = {
  __typename?: 'OrgBillingShare';
  billableCount: Scalars['Int']['output'];
  billingBasis?: Maybe<OrgBillingBasis>;
  organization: AdminOrganizationSummary;
};

/** How Stripe's quantity compares to what the customer's orgs are billed for. */
export enum OrgBillingStatus {
  Match = 'MATCH',
  Overbilling = 'OVERBILLING',
  Underbilling = 'UNDERBILLING',
  Unknown = 'UNKNOWN'
}

/**
 * A single non-blocking warning from adminUpdateOrganizationStripeCustomer.
 *
 * `organizations` carries the uuid as well as the name, so the portal can
 * link straight to the other org — and so two orgs sharing a name are
 * distinguishable, which a list of names alone cannot do.
 *
 * `organization_names` is the older, name-only shape. Kept while the portal
 * moves over; drop it once nothing reads it.
 */
export type OrgStripeWarning = {
  __typename?: 'OrgStripeWarning';
  organizationNames: Array<Scalars['String']['output']>;
  organizations: Array<OrgStripeWarningOrganization>;
  reason: OrgStripeWarningReason;
};

/** One organization named in a warning, with the uuid needed to link to it. */
export type OrgStripeWarningOrganization = {
  __typename?: 'OrgStripeWarningOrganization';
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** Non-blocking advisory from an org Stripe change; the client owns the copy. */
export enum OrgStripeWarningReason {
  OrgStripeCustomerShared = 'ORG_STRIPE_CUSTOMER_SHARED'
}

/**
 * Represents an organization (multi-team practice group) in Scribenote.
 *
 * Organizations are the top-level data isolation boundary. They group Teams
 * and manage enterprise billing, admin access, and default settings.
 *
 * Note: Most fields are only accessible to organization admins.
 */
export type Organization = {
  __typename?: 'Organization';
  admins?: Maybe<Array<Maybe<User>>>;
  allowsDirectMemberAdd?: Maybe<Scalars['Boolean']['output']>;
  billingModeId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultPassword?: Maybe<Scalars['String']['output']>;
  defaultTemplates: Array<Maybe<AutoTemplate>>;
  emailDomain: Scalars['String']['output'];
  emailDomainSecondary?: Maybe<Scalars['String']['output']>;
  emailDomainTertiary?: Maybe<Scalars['String']['output']>;
  globalScribephoneConsentMode?: Maybe<ScribephoneConsentEnum>;
  id: Scalars['ID']['output'];
  isAutomatedBilling?: Maybe<Scalars['Boolean']['output']>;
  isManualBilling?: Maybe<Scalars['Boolean']['output']>;
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numTeams?: Maybe<Scalars['Int']['output']>;
  numUsers?: Maybe<Scalars['Int']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Maybe<Team>>>;
  uuid: Scalars['String']['output'];
};

export type OrganizationRecordingConsentEvents = {
  __typename?: 'OrganizationRecordingConsentEvents';
  events: Array<RecordingConsentEvent>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type ParsedPatientSignalment = {
  __typename?: 'ParsedPatientSignalment';
  breed?: Maybe<Scalars['String']['output']>;
  patientName: Scalars['String']['output'];
  species?: Maybe<Scalars['String']['output']>;
};

export type ParsedPatientSignalmentInput = {
  breed?: InputMaybe<Scalars['String']['input']>;
  patientName: Scalars['String']['input'];
  species?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents a patient (animal) in the system.
 * Contains medical history, owner info, and links to notes and attachments.
 */
export type Patient = {
  __typename?: 'Patient';
  age?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  auditTrail?: Maybe<Array<Maybe<AuditTrail>>>;
  birthday?: Maybe<Scalars['DateTime']['output']>;
  birthdayParts?: Maybe<BirthdayParts>;
  breed?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emergencyContactInfo?: Maybe<Scalars['String']['output']>;
  isIntact?: Maybe<Scalars['Boolean']['output']>;
  keyHistory?: Maybe<Scalars['String']['output']>;
  keyMedications?: Maybe<Scalars['String']['output']>;
  lastNameOfOwner?: Maybe<Scalars['String']['output']>;
  microchip?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  ownerContactInfo?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  vaccinationStatus?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};


/**
 * Represents a patient (animal) in the system.
 * Contains medical history, owner info, and links to notes and attachments.
 */
export type PatientNotesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PatientInput = {
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  breed?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emergencyContactInfo?: InputMaybe<Scalars['String']['input']>;
  isIntact?: InputMaybe<Scalars['Boolean']['input']>;
  keyHistory?: InputMaybe<Scalars['String']['input']>;
  keyMedications?: InputMaybe<Scalars['String']['input']>;
  lastNameOfOwner?: InputMaybe<Scalars['String']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerContactInfo?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  vaccinationStatus?: InputMaybe<Scalars['String']['input']>;
  weeks?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
  years?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Used on web to reauthenticate an active user if their session
 * is going to expire soon. This prevents someone who has been using the app
 * from seeing the "Session expiry" modal.
 */
export type PersistentLoginUser = {
  __typename?: 'PersistentLoginUser';
  accessCsrf?: Maybe<Scalars['String']['output']>;
  accessJwt?: Maybe<Scalars['String']['output']>;
  refreshJwt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<LoginUserResponse>;
};

export type PopulateUserSampleTemplates = {
  __typename?: 'PopulateUserSampleTemplates';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Record a pre-generated edit proposal (no LLM call) and broadcast it.
 *
 * Companion v2 twin of GenerateLLMCustomization — Otto produces after_content
 * itself and hands it here, and we emit the same
 * companion_llm_(template_)customization_{updates,completion} pair so the
 * existing approve/reject UI picks it up.
 */
export type ProposeLlmEdit = {
  __typename?: 'ProposeLLMEdit';
  llmCustomizationUuid?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Exactly one target: (note_uuid + note_section) OR (template_uuid + template_section).
 *
 * `before_content` is read from the DB at record time, not accepted here —
 * that way the approve/reject diff always renders against authoritative state
 * instead of whatever snapshot the agent thought it saw.
 *
 * The WS broadcast channel is derived server-side from the authenticated
 * user — we never trust a caller-supplied channel because that would let any
 * user with the WRITING_COMPANION flag inject fake proposals into another
 * user's WS stream.
 */
export type ProposeLlmEditInput = {
  actionType: Scalars['String']['input'];
  afterContent: Scalars['String']['input'];
  llmCustomizationUuid: Scalars['String']['input'];
  noteSection?: InputMaybe<Scalars['String']['input']>;
  noteUuid?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['JSONString']['input']>;
  templateSection?: InputMaybe<Scalars['String']['input']>;
  templateUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ProtectNote = {
  __typename?: 'ProtectNote';
  ok?: Maybe<Scalars['String']['output']>;
};

export type ProvisionedUsers = {
  __typename?: 'ProvisionedUsers';
  existing?: Maybe<Array<Maybe<ModifiedUser>>>;
  newUsers?: Maybe<Array<Maybe<ModifiedUser>>>;
};

/** An enumeration. */
export enum RecordingConsentAction {
  Acknowledged = 'ACKNOWLEDGED',
  Declined = 'DECLINED'
}

export type RecordingConsentEvent = {
  __typename?: 'RecordingConsentEvent';
  action: RecordingConsentAction;
  consentText: Scalars['String']['output'];
  consentTextVersion: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  noteUuid?: Maybe<Scalars['UUID']['output']>;
  source: RecordingConsentSource;
  surface: RecordingConsentSurface;
  userEmail: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

/** An enumeration. */
export enum RecordingConsentSource {
  Mobile = 'MOBILE',
  PetPassVet = 'PET_PASS_VET',
  Web = 'WEB'
}

/** An enumeration. */
export enum RecordingConsentSurface {
  Append = 'APPEND',
  Recording = 'RECORDING',
  Scribephone = 'SCRIBEPHONE',
  Upload = 'UPLOAD'
}

/**
 * Redeems Pay It Furward credits for a prepaid Visa card.
 *
 * The prepaid card is sent via email to the user (or a specified recipient).
 * Minimum redemption amount is $25 (2500 cents).
 */
export type RedeemCredits = {
  __typename?: 'RedeemCredits';
  message?: Maybe<Scalars['String']['output']>;
  remainingBalanceCents?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * GraphQL type for user referral data in the Pay It Furward program.
 *
 * Exposes:
 * - referralCode: User's unique referral code to share with friends
 * - numSignupsReferred: Count of people who signed up using this code
 * - numSuccessfulReferrals: Count of referrals that resulted in Pro upgrades
 * - creditsBalance: Current Pay It Furward credits available
 * - canRedeem: Whether user can redeem credits (min $25)
 */
export type Referral = {
  __typename?: 'Referral';
  canRedeem?: Maybe<Scalars['Boolean']['output']>;
  creditsBalance?: Maybe<Scalars['String']['output']>;
  creditsBalanceCents: Scalars['Int']['output'];
  hasReferrer?: Maybe<Scalars['Boolean']['output']>;
  minRedemptionAmountCents?: Maybe<Scalars['Int']['output']>;
  numPaidReferrals?: Maybe<Scalars['Int']['output']>;
  numPremiumReferralsMade?: Maybe<Scalars['Int']['output']>;
  numReferralsMade?: Maybe<Scalars['Int']['output']>;
  numReferredSignups?: Maybe<Scalars['Int']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  referrerEmail?: Maybe<Scalars['String']['output']>;
  referrerUserId?: Maybe<Scalars['Int']['output']>;
  signUpReferrerType?: Maybe<Scalars['String']['output']>;
  subscriptionReferrerType?: Maybe<Scalars['String']['output']>;
  totalCreditsEarned?: Maybe<Scalars['String']['output']>;
  totalCreditsEarnedCents: Scalars['Int']['output'];
  totalCreditsRedeemed?: Maybe<Scalars['String']['output']>;
  totalCreditsRedeemedCents: Scalars['Int']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Used to refresh the 24 hour access token on the mobile app */
export type RefreshUserToken = {
  __typename?: 'RefreshUserToken';
  accessJwt?: Maybe<Scalars['String']['output']>;
};

export type RemoveOrganizationDefaultTemplate = {
  __typename?: 'RemoveOrganizationDefaultTemplate';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveTeamDefaultTemplate = {
  __typename?: 'RemoveTeamDefaultTemplate';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A class used to define a mutation for removing users from teams within an organization.
 *
 * Attributes:
 *     ok (Boolean): A flag indicating whether the mutation was successful.
 *
 * Arguments:
 *     org_id (Int): The ID of the organization. This argument is required.
 *     team_id (Int): The ID of the team. This argument is required.
 *     user_ids (List(Int)): A list of user IDs to remove from the team. This argument is required.
 *
 * Raises:
 *     CustomException: If the password in the request headers is not correct.
 */
export type RemoveUserFromOrgTeam = {
  __typename?: 'RemoveUserFromOrgTeam';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveUserFromTeam = {
  __typename?: 'RemoveUserFromTeam';
  ok?: Maybe<Scalars['Boolean']['output']>;
  removedUser?: Maybe<ModifiedUser>;
};

/** Request phone number verification for caller ID. */
export type RequestPhoneVerification = {
  __typename?: 'RequestPhoneVerification';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  validationCode?: Maybe<Scalars['String']['output']>;
  verifiedPhoneUuid?: Maybe<Scalars['String']['output']>;
};

export type RequestTeamSetup = {
  __typename?: 'RequestTeamSetup';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type ResendUserConfirmation = {
  __typename?: 'ResendUserConfirmation';
  ok?: Maybe<Scalars['String']['output']>;
};

/**
 * Admin-only restore of a soft-deleted user.
 *
 * Reverse of `MarkUserForDeletion`. Gated by `admin_portal:editor`.
 * Audit-logged via `log_changes`. Idempotent on the active state.
 */
export type RestoreUser = {
  __typename?: 'RestoreUser';
  user?: Maybe<AdminUserInfo>;
};

export type RetoolCreateQuickNote = {
  __typename?: 'RetoolCreateQuickNote';
  note?: Maybe<Note>;
  successMessage?: Maybe<Scalars['String']['output']>;
};

export type RetoolDeleteNotes = {
  __typename?: 'RetoolDeleteNotes';
  ok?: Maybe<Scalars['String']['output']>;
};

/**
 * Used to retry failed auto-soaps and change templates.
 * Can optionally skip retranscription for template changes.
 */
export type RetryFailedAutoSoap = {
  __typename?: 'RetryFailedAutoSoap';
  ok?: Maybe<Scalars['String']['output']>;
};

/** Revoke an active Companion permission grant for the current user. */
export type RevokeAgentToolPermissionGrant = {
  __typename?: 'RevokeAgentToolPermissionGrant';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A class used to define the input fields required to remove or disable a user on an org team.
 *
 * Attributes:
 *     user_uuid (str): The UUID of the user to remove from the team. This field is required.
 *     team_uuid (str): The UUID of the team. This field is required.
 *     org_uuid (str): The UUID of the organization. This field is required
 */
export type RmTeamUserInput = {
  orgUuid: Scalars['String']['input'];
  teamUuid: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};

/** Resolvers for the role object. */
export type Role = {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type Root = {
  __typename?: 'Root';
  account?: Maybe<Account>;
  activeCompanionSession?: Maybe<CompanionSession>;
  adminAgentSession?: Maybe<AdminAgentSessionDetail>;
  adminAgentSessionsForUser?: Maybe<AdminAgentSessionListResult>;
  adminAuditLog?: Maybe<AuditLogResult>;
  adminBroadcastNotifications?: Maybe<Array<Maybe<UserNotification>>>;
  adminInactiveAccounts?: Maybe<AdminUserListResult>;
  adminMphCompanionMembers?: Maybe<AdminMphCompanionMembersResult>;
  adminNotesTemplateOptions: Array<AdminNoteTemplateOption>;
  adminOrgEmailTemplatePreview?: Maybe<AdminOrgEmailTemplatePreview>;
  adminOrganization?: Maybe<AdminOrganizationDetail>;
  adminOrganizationBilling?: Maybe<AdminOrganizationBilling>;
  adminOrganizationMembers?: Maybe<AdminOrganizationMembersPage>;
  adminOrganizations?: Maybe<AdminOrganizationsList>;
  adminRoleOptions: Array<AdminRoleOption>;
  adminSearchBillingCustomers?: Maybe<AdminBillingCustomerSearchResult>;
  adminSoftDeletedUsers?: Maybe<AdminUserListResult>;
  adminStripeCustomerLinkage?: Maybe<AdminStripeCustomerLinkage>;
  adminTeam?: Maybe<AdminTeamDetail>;
  adminTeamMembers?: Maybe<AdminTeamMembersPage>;
  adminTeamNotes?: Maybe<AdminNotesPage>;
  adminTeams?: Maybe<AdminTeamsList>;
  adminUserCashOuts?: Maybe<AdminCashOutsPage>;
  adminUserLookup?: Maybe<AdminUserLookupResult>;
  adminUserMembership?: Maybe<AdminUserMembershipResult>;
  adminUserNote?: Maybe<AdminNoteDetail>;
  adminUserNotes?: Maybe<AdminNotesPage>;
  adminUserReferredUsers?: Maybe<AdminReferredUsersPage>;
  adminUserTemplate?: Maybe<AdminTemplateDetail>;
  adminUserTemplates?: Maybe<AdminUserTemplatesPage>;
  adminVerifiedPhoneLookup?: Maybe<AdminVerifiedPhoneLookupResult>;
  agentSession?: Maybe<AgentSession>;
  agentSessionAttachments?: Maybe<Array<Maybe<Attachment>>>;
  agentSessionEvents?: Maybe<AgentSessionEventsPage>;
  agentSessions?: Maybe<Array<Maybe<AgentSession>>>;
  agentToolPermissionGrant?: Maybe<AgentToolPermissionGrant>;
  agentToolPermissionGrants: Array<AgentToolPermissionGrant>;
  allAllowedRoles?: Maybe<Array<Maybe<AllowedRole>>>;
  allNotes?: Maybe<Array<Maybe<Note>>>;
  auditTrail?: Maybe<AuditTrail>;
  autoTemplateById?: Maybe<AutoTemplate>;
  autoTemplates?: Maybe<Array<Maybe<AutoTemplate>>>;
  companionContext?: Maybe<CompanionContext>;
  companionSession?: Maybe<CompanionSession>;
  companionSessions?: Maybe<Array<Maybe<CompanionSession>>>;
  dashboardInboxNotes?: Maybe<InboxNotes>;
  defaultPhoneNumber?: Maybe<Scalars['String']['output']>;
  effectiveCompanionEffort: Scalars['String']['output'];
  existingUsers?: Maybe<UserChecks>;
  inboxNotes?: Maybe<InboxNotes>;
  inboxTabCount?: Maybe<InboxTabCount>;
  note?: Maybe<Note>;
  notes?: Maybe<Array<Maybe<Note>>>;
  onboardingProgress?: Maybe<OnboardingProgress>;
  organization?: Maybe<Organization>;
  organizationRecordingConsentEvents?: Maybe<OrganizationRecordingConsentEvents>;
  parsedHtmlPatientSignalement?: Maybe<ParsedPatientSignalment>;
  patient?: Maybe<Patient>;
  patientAnalytics?: Maybe<Array<Maybe<Patient>>>;
  patients?: Maybe<Array<Maybe<Patient>>>;
  pendingUserTeamInvites?: Maybe<Array<Maybe<TeamInvite>>>;
  pendingWritingCompanionProposals: Array<WritingCompanionProposal>;
  processingNote?: Maybe<Note>;
  quickNotes?: Maybe<InboxNotes>;
  role?: Maybe<Role>;
  rootUser?: Maybe<User>;
  scribeMd?: Maybe<Scalars['String']['output']>;
  searchSupportDocs?: Maybe<Array<Maybe<SupportDocSearchResult>>>;
  sharedAccessNote?: Maybe<Note>;
  shouldUpdatePoll?: Maybe<UserNotePollQuery>;
  shouldUpdateUserPoll?: Maybe<UserNotePollQuery>;
  team?: Maybe<Team>;
  teamInvite?: Maybe<TeamInviteResponse>;
  teamUserNoteCounts?: Maybe<TeamUserNoteCounts>;
  template?: Maybe<TemplateResponse>;
  templateGroups?: Maybe<Array<Maybe<TemplateGroup>>>;
  treatBalance?: Maybe<TreatBalance>;
  treatDailySummaries?: Maybe<Array<TreatDailySummary>>;
  unauthenticatedTeamInvite?: Maybe<TeamInviteResponse>;
  user?: Maybe<User>;
  userNotifications?: Maybe<Array<Maybe<UserNotification>>>;
  verifiedPhoneNumbers?: Maybe<Array<Maybe<VerifiedPhoneNumber>>>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminAgentSessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  sessionUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminAgentSessionsForUserArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminAuditLogArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  actorEmail?: InputMaybe<Scalars['String']['input']>;
  actorUuid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminBroadcastNotificationsArgs = {
  notificationDomain?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminInactiveAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminMphCompanionMembersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminNotesTemplateOptionsArgs = {
  teamUuid?: InputMaybe<Scalars['String']['input']>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminOrgEmailTemplatePreviewArgs = {
  emailKey: AdminOrgEmailKey;
  templateAlias: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminOrganizationArgs = {
  orgUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminOrganizationBillingArgs = {
  orgUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminOrganizationMembersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orgUuid: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminOrganizationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminSearchBillingCustomersArgs = {
  query: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminSoftDeletedUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminStripeCustomerLinkageArgs = {
  stripeCustomerId: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminTeamArgs = {
  teamUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminTeamMembersArgs = {
  filters?: InputMaybe<Array<TeamMemberFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  teamUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminTeamNotesArgs = {
  filters?: InputMaybe<Array<NoteFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  teamUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminTeamsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminUserCashOutsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminUserLookupArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminUserMembershipArgs = {
  uuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminUserNoteArgs = {
  noteUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminUserNotesArgs = {
  filters?: InputMaybe<Array<NoteFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminUserReferredUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminUserTemplateArgs = {
  templateUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminUserTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAdminVerifiedPhoneLookupArgs = {
  phoneNumber: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAgentSessionArgs = {
  agentSessionUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAgentSessionAttachmentsArgs = {
  agentSessionUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAgentSessionEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  agentSessionUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAgentSessionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAgentToolPermissionGrantArgs = {
  policyVersion: Scalars['String']['input'];
  toolAction: Scalars['String']['input'];
  toolName: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAuditTrailArgs = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAutoTemplateByIdArgs = {
  uuid: Scalars['UUID']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootAutoTemplatesArgs = {
  isFavourite?: InputMaybe<Scalars['Boolean']['input']>;
  teamUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootCompanionContextArgs = {
  includeInitialContext?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootCompanionSessionArgs = {
  companionSessionUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootCompanionSessionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sessionType?: InputMaybe<CompanionSessionTypeEnum>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootDashboardInboxNotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortAscending?: InputMaybe<Scalars['Boolean']['input']>;
  teamUuid?: InputMaybe<Scalars['String']['input']>;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootDefaultPhoneNumberArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootEffectiveCompanionEffortArgs = {
  requestedEffort: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootExistingUsersArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootInboxNotesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  hasBeenExported?: InputMaybe<Scalars['Boolean']['input']>;
  includeIrrelevantResults?: InputMaybe<Scalars['Boolean']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  smartSearch?: InputMaybe<SmartSearchInput>;
  sortAscending?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<NoteStatus>;
  teamUuid?: InputMaybe<Scalars['String']['input']>;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootInboxTabCountArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  teamUuid?: InputMaybe<Scalars['String']['input']>;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootNoteArgs = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootNotesArgs = {
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootOrganizationArgs = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootOrganizationRecordingConsentEventsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orgUuid: Scalars['UUID']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootParsedHtmlPatientSignalementArgs = {
  rawHtml: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootPatientArgs = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootPatientAnalyticsArgs = {
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootPendingWritingCompanionProposalsArgs = {
  noteUuid: Scalars['String']['input'];
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootProcessingNoteArgs = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootQuickNotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  teamUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootRoleArgs = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootSearchSupportDocsArgs = {
  query: Scalars['String']['input'];
  topK?: InputMaybe<Scalars['Int']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootSharedAccessNoteArgs = {
  noteAccessToken?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootTeamArgs = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootTeamInviteArgs = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootTeamUserNoteCountsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  teamUuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootTemplateArgs = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootTreatDailySummariesArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootUnauthenticatedTeamInviteArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
};


/**
 *
 *         The Root Query class.
 *         Only root queries should be listed here.
 *         Ie, the first part of a query, like
 *         user {
 *
 *         }
 *         or
 *         allNotes {
 *
 *         }
 *
 *         All other queries should be in the object they belong to in
 *         the queries module.
 *
 */
export type RootUserNotificationsArgs = {
  noteUuid?: InputMaybe<Scalars['String']['input']>;
  notificationDomain?: InputMaybe<Scalars['String']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Create a notification for the current user.
 *
 * Omit ``active_at`` for an immediate notification. Set ``active_at``
 * in the future to schedule. Visibility is filtered query-side.
 */
export type ScheduleNotification = {
  __typename?: 'ScheduleNotification';
  notification?: Maybe<UserNotification>;
};

/** An enumeration. */
export enum ScribephoneConsentEnum {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export type SendClientSummaryEmail = {
  __typename?: 'SendClientSummaryEmail';
  ok?: Maybe<Scalars['String']['output']>;
};

export type SendCompanionSessionMessage = {
  __typename?: 'SendCompanionSessionMessage';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Send the authenticated user an email with an auto-login link to the dashboard on web. */
export type SendDashboardDesktopLink = {
  __typename?: 'SendDashboardDesktopLink';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SendExportNoteEmail = {
  __typename?: 'SendExportNoteEmail';
  ok?: Maybe<Scalars['String']['output']>;
};

/**
 * The user requests a password reset for an email
 * If that email belongs to a user, we send a reset email
 * with a short-lived single-use JWT (PURPOSE_TOKEN_TTL).
 * If clicked, they are taken to a link
 * Where they would post new password to UpdateForgottenPassword (above)
 */
export type SendForgotPasswordEmail = {
  __typename?: 'SendForgotPasswordEmail';
  ok?: Maybe<Scalars['String']['output']>;
};

/** Send the authenticated user an email with an auto-login link to a note on web. */
export type SendNoteDesktopLink = {
  __typename?: 'SendNoteDesktopLink';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SetAccountPreference = {
  __typename?: 'SetAccountPreference';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SetOrganizationDefaultTemplate = {
  __typename?: 'SetOrganizationDefaultTemplate';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SetTeamDefaultTemplate = {
  __typename?: 'SetTeamDefaultTemplate';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Enum for template sharing visibility. */
export enum SharingTypeEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Team = 'TEAM'
}

export type SmartSearchInput = {
  patientSignalments?: InputMaybe<Array<ParsedPatientSignalmentInput>>;
};

export type SoapTag = {
  color?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SoapText = {
  assessment?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  subjective?: InputMaybe<Scalars['String']['input']>;
};

export type SupportDocSearchResult = {
  __typename?: 'SupportDocSearchResult';
  content?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/**
 * SymmetryLabel represents the left/right labels for symmetrical exam fields.
 *
 * Labels are split from the symmetry_type by "/" (e.g., "L/R" → left="L", right="R").
 * Common types: L/R (Left/Right), OS/OD (eyes), AS/AD (ears).
 */
export type SymmetryLabel = {
  __typename?: 'SymmetryLabel';
  left?: Maybe<Scalars['String']['output']>;
  right?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents a veterinary clinic or practice location within Scribenote.
 *
 * Teams are the primary organizational unit that groups users (DVMs, staff)
 * who work together at a shared location. Teams belong to Organizations
 * for multi-location practices.
 */
export type Team = {
  __typename?: 'Team';
  billingModeId?: Maybe<Scalars['Int']['output']>;
  companionSessions?: Maybe<Array<Maybe<CompanionSession>>>;
  createdAt: Scalars['DateTime']['output'];
  defaultTemplates: Array<Maybe<AutoTemplate>>;
  id: Scalars['ID']['output'];
  inventories?: Maybe<Array<Maybe<Inventory>>>;
  isAutomatedBilling?: Maybe<Scalars['Boolean']['output']>;
  isManualBilling?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  numUsers?: Maybe<Scalars['Int']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  teamInvites?: Maybe<Array<Maybe<TeamInvite>>>;
  userTeams?: Maybe<Array<Maybe<UserTeam>>>;
  users?: Maybe<Array<Maybe<User>>>;
  uuid?: Maybe<Scalars['String']['output']>;
  verifiedPhoneNumbers?: Maybe<Array<Maybe<VerifiedPhoneNumber>>>;
};

/**
 * Represents a pending invitation for a user to join a team.
 * Invitations can be in pending, accepted, rejected, or expired states.
 */
export type TeamInvite = {
  __typename?: 'TeamInvite';
  accountType: Scalars['String']['output'];
  inviteeEmail: Scalars['String']['output'];
  inviteeRoleId?: Maybe<Scalars['Int']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  isExistingUser: Scalars['Boolean']['output'];
  sender?: Maybe<User>;
  senderId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  team?: Maybe<Team>;
  teamId: Scalars['Int']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
  timeResponded?: Maybe<Scalars['DateTime']['output']>;
  timeSent: Scalars['DateTime']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type TeamInviteResponse = {
  __typename?: 'TeamInviteResponse';
  inviteeEmail?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** The filterable admin team Members columns. */
export enum TeamMemberFilterField {
  AccountType = 'ACCOUNT_TYPE',
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  LastActiveAt = 'LAST_ACTIVE_AT',
  MultiTeam = 'MULTI_TEAM',
  Name = 'NAME',
  Role = 'ROLE',
  Status = 'STATUS',
  StripeCustomer = 'STRIPE_CUSTOMER',
  TeamAdmin = 'TEAM_ADMIN',
  Uuid = 'UUID'
}

/**
 * One admin team Members query-builder condition. Same shape and contract
 * as ``NoteFilterInput`` — the two tables share the query-builder UI but keep
 * separate vocabularies, so each has its own field/operator enums rather than
 * one union in which half the values are invalid.
 *
 * ``field`` and ``operator`` are enums, so an unknown one is a validation
 * error rather than a condition that quietly matches everything. Which
 * operators apply follows from the field's type (text: CONTAINS/EQUALS,
 * choice: IS/IS_NOT, date: BEFORE/AFTER/ON). Text and date fields use
 * ``value``; choice fields use ``values``, OR-combined within the one
 * condition. Separate conditions are AND-combined. ``value`` is nullable (a
 * choice condition sends none); list items are not.
 */
export type TeamMemberFilterInput = {
  field: TeamMemberFilterField;
  operator: TeamMemberFilterOperator;
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The operators an admin team Members filter condition can use. */
export enum TeamMemberFilterOperator {
  After = 'AFTER',
  Before = 'BEFORE',
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  Is = 'IS',
  IsNot = 'IS_NOT',
  On = 'ON'
}

export type TeamUserNoteCount = {
  __typename?: 'TeamUserNoteCount';
  noteCount?: Maybe<Scalars['Int']['output']>;
  teamUuid?: Maybe<Scalars['String']['output']>;
  userUuid?: Maybe<Scalars['String']['output']>;
};

export type TeamUserNoteCounts = {
  __typename?: 'TeamUserNoteCounts';
  noteCounts?: Maybe<Array<Maybe<TeamUserNoteCount>>>;
};

/** Template for veterinary medical notes. */
export type Template = {
  __typename?: 'Template';
  colorScheme?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isPreset?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type TemplateFieldsInput = {
  colorScheme?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** A reusable preset of 2–5 ordered templates. */
export type TemplateGroup = {
  __typename?: 'TemplateGroup';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  sharingType: SharingTypeEnum;
  templates?: Maybe<Array<Maybe<TemplateGroupAutoTemplate>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UserSummary>;
  uuid: Scalars['String']['output'];
};

/** A template within a template group, with its position. */
export type TemplateGroupAutoTemplate = {
  __typename?: 'TemplateGroupAutoTemplate';
  autoTemplate?: Maybe<AutoTemplate>;
  autoTemplateId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
};

export type TemplatePreviewInput = {
  noteUuid?: InputMaybe<Scalars['String']['input']>;
  sampleTranscript: Scalars['String']['input'];
  templateFields: Array<InputMaybe<FieldInput>>;
  templateType: TemplateType;
  templateUuid: Scalars['String']['input'];
  userPreferences?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents a preview of an auto template.
 * Contains the preview content generated from the template.
 */
export type TemplatePreviews = {
  __typename?: 'TemplatePreviews';
  autoTemplate?: Maybe<AutoTemplate>;
  id: Scalars['ID']['output'];
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Int']['output']>;
  previewContent?: Maybe<Scalars['String']['output']>;
  templateId: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type TemplateResponse = {
  __typename?: 'TemplateResponse';
  colorScheme?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Note>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export enum TemplateType {
  Custom = 'CUSTOM',
  Soap = 'SOAP'
}

/** Enum for auto template types. */
export enum TemplateTypeEnum {
  Custom = 'CUSTOM',
  Soap = 'SOAP'
}

/** Enum for valid account types for test users. */
export enum TestAccountType {
  Basic = 'BASIC',
  FreeTrial = 'FREE_TRIAL',
  Unlimited = 'UNLIMITED'
}

export type TransferNoteOwnership = {
  __typename?: 'TransferNoteOwnership';
  failedNotes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ok?: Maybe<Scalars['String']['output']>;
};

/** Current treat balance and usage breakdown for the authenticated user. */
export type TreatBalance = {
  __typename?: 'TreatBalance';
  monthlyBalance: Scalars['Int']['output'];
  nextResetAt?: Maybe<Scalars['DateTime']['output']>;
  permanentBalance: Scalars['Int']['output'];
  totalBalance: Scalars['Int']['output'];
  usageByCompanion?: Maybe<Array<Maybe<TreatUsageByCompanion>>>;
};

/** Per-day rollup of a user's treat activity. */
export type TreatDailySummary = {
  __typename?: 'TreatDailySummary';
  date: Scalars['Date']['output'];
  netChange: Scalars['Int']['output'];
  treatsCredited: Scalars['Int']['output'];
  treatsUsed: Scalars['Int']['output'];
};

export type TreatUsageByCompanion = {
  __typename?: 'TreatUsageByCompanion';
  companionType: Scalars['String']['output'];
  treatsUsed: Scalars['Int']['output'];
};

export type TriggerDentalChartExtraction = {
  __typename?: 'TriggerDentalChartExtraction';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** GraphQL enum for Twilio verification status. */
export enum TwilioVerificationStatus {
  Denied = 'DENIED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

/** Remove a note from its group, making it fully independent. */
export type UngroupNote = {
  __typename?: 'UngroupNote';
  note?: Maybe<Note>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Update an account's plan type and optionally its free trial expiration.
 *
 * This mutation is used by internal tooling (Retool) to update account plans
 * while ensuring changes go through the ORM, which triggers the Intercom sync
 * listener to keep user plan data in sync.
 *
 * Attributes:
 *     account_uuid (str): The UUID of the account to update.
 *     account_type (str): The new account type ('basic' or 'unlimited').
 *     free_trial_expires_at (DateTime): Optional datetime for trial expiration.
 */
export type UpdateAccountPlan = {
  __typename?: 'UpdateAccountPlan';
  accountType?: Maybe<Scalars['String']['output']>;
  accountUuid?: Maybe<Scalars['String']['output']>;
  freeTrialExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Update the title of an existing Managed Agent session. */
export type UpdateAgentSessionTitle = {
  __typename?: 'UpdateAgentSessionTitle';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAutoTemplate = {
  __typename?: 'UpdateAutoTemplate';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** A class used to define the input fields required to update an existing auto template. */
export type UpdateAutoTemplateInput = {
  dentalChart?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isFavourite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pdfStorageObjectName?: InputMaybe<Scalars['String']['input']>;
  templateFields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  templateType?: InputMaybe<TemplateType>;
  templateUuid: Scalars['String']['input'];
  userPreferences?: InputMaybe<Scalars['String']['input']>;
};

/**
 * After a user has recieved their password reset link via email, they click a link.
 * That link brings them to a /reset_password page on the front end.
 * They confirm their new password, then fire a request to this resource where we:
 * check that they pass us. If it is right, we update their password in the database.
 */
export type UpdateForgottenPassword = {
  __typename?: 'UpdateForgottenPassword';
  ok?: Maybe<Scalars['String']['output']>;
};

/** Replace the user's scribe.md memory with the supplied content. */
export type UpdateScribeMd = {
  __typename?: 'UpdateScribeMd';
  ok?: Maybe<Scalars['Boolean']['output']>;
  scribeMd?: Maybe<Scalars['String']['output']>;
};

export type UpdateTemplateGroup = {
  __typename?: 'UpdateTemplateGroup';
  ok?: Maybe<Scalars['Boolean']['output']>;
  templateGroup?: Maybe<TemplateGroup>;
};

export type UpdateTemplateSharing = {
  __typename?: 'UpdateTemplateSharing';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A GraphQL mutation to add or remove users from a Feature Flag segment.
 *
 * Arguments:
 *     action (ActionEnum): The action to perform (ADD or REMOVE).
 *     segment_key (String): The key of the LaunchDarkly segment.
 *
 * Returns:
 *     success (Boolean): True if the operation succeeded, False otherwise.
 *     message (String): A message indicating the result of the operation.
 */
export type UpdateUserFfSegment = {
  __typename?: 'UpdateUserFFSegment';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateUserTeam = {
  __typename?: 'UpdateUserTeam';
  billingImplication?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Update team sharing for a verified phone number. */
export type UpdateVerifiedPhoneNumberSharing = {
  __typename?: 'UpdateVerifiedPhoneNumberSharing';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Register an uploaded file as an attachment on an agent session (Companion 2.0).
 *
 * The file is expected to have already been uploaded to the companion_uploads
 * S3 bucket via /sign_s3_agent_session_attachment/. This mutation validates
 * the bytes match an allowed MIME type, then persists an AttachmentModel row
 * linked to the agent session.
 */
export type UploadAgentSessionAttachment = {
  __typename?: 'UploadAgentSessionAttachment';
  fileLink?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type UploadCompanionSessionAttachment = {
  __typename?: 'UploadCompanionSessionAttachment';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadHeaderImage = {
  __typename?: 'UploadHeaderImage';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadNoteAttachments = {
  __typename?: 'UploadNoteAttachments';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadPatientAttachments = {
  __typename?: 'UploadPatientAttachments';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadPdfAndExtractText = {
  __typename?: 'UploadPdfAndExtractText';
  ASSESSMENT?: Maybe<Scalars['String']['output']>;
  CUSTOM?: Maybe<Scalars['String']['output']>;
  OBJECTIVE?: Maybe<Scalars['String']['output']>;
  PLAN?: Maybe<Scalars['String']['output']>;
  SUBJECTIVE?: Maybe<Scalars['String']['output']>;
};

export type UploadSpeedTest = {
  __typename?: 'UploadSpeedTest';
  result?: Maybe<UploadSpeedTestResult>;
};

export type UploadSpeedTestResult = {
  __typename?: 'UploadSpeedTestResult';
  fileSize?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Represents a Scribenote user (veterinarian, technician, or staff).
 *
 * Users belong to teams, create notes, and have associated accounts for billing.
 * The password field is intentionally excluded from the GraphQL schema.
 */
export type User = {
  __typename?: 'User';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['Int']['output']>;
  auditTrail?: Maybe<Array<Maybe<AuditTrail>>>;
  autoExportEmail?: Maybe<Scalars['String']['output']>;
  autoTemplates?: Maybe<Array<Maybe<AutoTemplate>>>;
  bonusAppointments?: Maybe<Scalars['Int']['output']>;
  canChangeScribephoneConsent?: Maybe<Scalars['Boolean']['output']>;
  clientSummaryPreferences?: Maybe<ClientSummaryPreferences>;
  companionSessions?: Maybe<Array<Maybe<CompanionSession>>>;
  companionSubscription?: Maybe<CompanionSubscription>;
  createdAt: Scalars['DateTime']['output'];
  distinctNoteCreationDays?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailExpiryDays?: Maybe<Scalars['Int']['output']>;
  expiryPolicy?: Maybe<Scalars['JSONString']['output']>;
  featureActivations?: Maybe<Array<Maybe<FeatureActivation>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasApprovedNote?: Maybe<Scalars['Boolean']['output']>;
  hasExportedNote?: Maybe<Scalars['Boolean']['output']>;
  hasReachedAutoSoapLimit?: Maybe<Scalars['Boolean']['output']>;
  hasReachedNoteLimit?: Maybe<Scalars['Boolean']['output']>;
  inventories?: Maybe<Array<Maybe<Inventory>>>;
  isAppointmentsBetaUser?: Maybe<Scalars['Boolean']['output']>;
  isConfirmed: Scalars['Boolean']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  isOnboardingComplete: Scalars['Boolean']['output'];
  isScribe?: Maybe<Scalars['Boolean']['output']>;
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  lastLoggedInAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  numAllowedStoredNotes?: Maybe<Scalars['Int']['output']>;
  numAppointmentsAllowed?: Maybe<Scalars['Int']['output']>;
  numAppointmentsUsed?: Maybe<Scalars['Int']['output']>;
  numAutoSoapsUsedToday?: Maybe<Scalars['Int']['output']>;
  numReferralsMade?: Maybe<Scalars['Int']['output']>;
  numReferredSignups?: Maybe<Scalars['Int']['output']>;
  numStoredNotes?: Maybe<Scalars['Int']['output']>;
  objectiveNormalDefaults?: Maybe<ObjectiveNormalDefaults>;
  onboardingClinic?: Maybe<Scalars['String']['output']>;
  onboardingCorporateGroup?: Maybe<Scalars['String']['output']>;
  onboardingMilestones?: Maybe<Scalars['GenericScalar']['output']>;
  onboardingReferralSource?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  patients?: Maybe<Array<Maybe<Patient>>>;
  pimsProvider?: Maybe<Scalars['String']['output']>;
  recordingConsentHeader?: Maybe<Scalars['String']['output']>;
  recordingConsentText?: Maybe<Scalars['String']['output']>;
  recordingConsentVersion?: Maybe<Scalars['String']['output']>;
  referral?: Maybe<Referral>;
  requiresRecordingConsent: Scalars['Boolean']['output'];
  role?: Maybe<Role>;
  roleId?: Maybe<Scalars['Int']['output']>;
  roleInt?: Maybe<Scalars['Int']['output']>;
  scribephoneConsentMode?: Maybe<ScribephoneConsentEnum>;
  scribephoneConsentOptIn?: Maybe<Scalars['Boolean']['output']>;
  shouldEmbedEmailExports?: Maybe<Scalars['Boolean']['output']>;
  shouldShowAutoSoapCounter?: Maybe<Scalars['Boolean']['output']>;
  shouldUseAutoSoaps?: Maybe<Scalars['Boolean']['output']>;
  teams?: Maybe<Array<Maybe<Team>>>;
  templates?: Maybe<Array<Maybe<Template>>>;
  totalNotesCreated?: Maybe<Scalars['Int']['output']>;
  userPermissions?: Maybe<Array<Maybe<UserPermission>>>;
  userTeams?: Maybe<Array<Maybe<UserTeam>>>;
  uuid?: Maybe<Scalars['String']['output']>;
  verifiedPhoneNumbers?: Maybe<Array<Maybe<VerifiedPhoneNumber>>>;
};


/**
 * Represents a Scribenote user (veterinarian, technician, or staff).
 *
 * Users belong to teams, create notes, and have associated accounts for billing.
 * The password field is intentionally excluded from the GraphQL schema.
 */
export type UserInventoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Represents a Scribenote user (veterinarian, technician, or staff).
 *
 * Users belong to teams, create notes, and have associated accounts for billing.
 * The password field is intentionally excluded from the GraphQL schema.
 */
export type UserNotesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  hasBeenExported?: InputMaybe<Scalars['Boolean']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isQuickNote?: InputMaybe<Scalars['Boolean']['input']>;
  isTagged?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserChecks = {
  __typename?: 'UserChecks';
  deactivatedUsers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  existingUsers?: Maybe<Array<Maybe<ExistingUser>>>;
  newUsers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * This is a fast query that hits redis with frequent polls instead of
 * our database. Redis is caching the last updated time of a given users
 * notes. When this changes, clients know to refetch note data.
 *
 * This is only relevant for NOTE updates, not other data.
 * Ie, used in cases like: update users note count, update a users inbox
 *     with the most up-to-date data, see if processing is done on a note, etc.
 *
 * It is broad reaching and could be optimized, but is much more
 * effective than hitting the database for note updates every ten seconds.
 */
export type UserNotePollQuery = {
  __typename?: 'UserNotePollQuery';
  lastUpdated?: Maybe<Scalars['Float']['output']>;
};

/** A notification delivered to a user. */
export type UserNotification = {
  __typename?: 'UserNotification';
  actionUrl?: Maybe<Scalars['String']['output']>;
  activeAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  extra?: Maybe<Scalars['JSONString']['output']>;
  isBroadcast: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  noteUuid?: Maybe<Scalars['String']['output']>;
  notificationDomain: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type UserPermission = {
  __typename?: 'UserPermission';
  isEnabled: Scalars['Boolean']['output'];
  permissionName: Scalars['String']['output'];
};

/**
 * Lightweight user identity for embedding in shared resources.
 *
 * Exposes only non-sensitive fields needed to display ownership.
 * Use this instead of the full User type when resolving user on
 * objects visible to users other than the owner.
 */
export type UserSummary = {
  __typename?: 'UserSummary';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/**
 * Association between User and Team with role and admin permissions.
 *
 * Represents a user's membership in a team, including their role (e.g., Vet, Tech)
 * and whether they have admin privileges for that team.
 */
export type UserTeam = {
  __typename?: 'UserTeam';
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isSelfSubscribed?: Maybe<Scalars['Boolean']['output']>;
  roleId?: Maybe<Scalars['Int']['output']>;
  team?: Maybe<Team>;
  user?: Maybe<User>;
};

/** A verified phone number for Scribephone caller ID */
export type VerifiedPhoneNumber = {
  __typename?: 'VerifiedPhoneNumber';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isOwnedByCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber: Scalars['String']['output'];
  team?: Maybe<Team>;
  teamUuid?: Maybe<Scalars['String']['output']>;
  twilioVerificationApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  twilioVerificationSid?: Maybe<Scalars['String']['output']>;
  twilioVerificationStatus?: Maybe<TwilioVerificationStatus>;
  twilioVerificationSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userUuid: Scalars['String']['output'];
  verifiedPhoneNumberUuid?: Maybe<Scalars['String']['output']>;
};

/** A single non-blocking warning from adminWireUpAccount. */
export type WireUpWarning = {
  __typename?: 'WireUpWarning';
  reason: WireUpWarningReason;
};

/** Non-blocking advisory reason from a wire-up; the frontend maps it to copy. */
export enum WireUpWarningReason {
  AlreadyUnlimitedNoTreats = 'ALREADY_UNLIMITED_NO_TREATS'
}

/**
 * A pending writing-companion edit proposal on a note.
 *
 * Field names mirror the ``companion_llm_customization_{updates,completion}``
 * WebSocket payloads so the frontend can hydrate a proposal that arrived while
 * no section editor was listening exactly as if the events had been received.
 */
export type WritingCompanionProposal = {
  __typename?: 'WritingCompanionProposal';
  accepted: Scalars['Boolean']['output'];
  actionType: Scalars['String']['output'];
  afterContent?: Maybe<Scalars['String']['output']>;
  beforeContent?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  noteSection: Scalars['String']['output'];
  noteUuid: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;




/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  AdminNoteFields:
    | ( AdminNoteDetail )
    | ( AdminNoteRow )
  ;
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AcceptLLMCustomization: ResolverTypeWrapper<AcceptLlmCustomization>;
  AcceptLLMCustomizationsInput: AcceptLlmCustomizationsInput;
  AcceptTeamInvitation: ResolverTypeWrapper<AcceptTeamInvitation>;
  Account: ResolverTypeWrapper<Account>;
  AccountDetails: ResolverTypeWrapper<AccountDetails>;
  ActionEnum: ActionEnum;
  AddFeedbackInput: AddFeedbackInput;
  AddFeedbackToCustomization: ResolverTypeWrapper<AddFeedbackToCustomization>;
  AddFeedbackToLog: ResolverTypeWrapper<AddFeedbackToLog>;
  AddMphCompanionMembers: ResolverTypeWrapper<AddMphCompanionMembers>;
  AddMphCompanionSkipReason: AddMphCompanionSkipReason;
  AddMphCompanionSkipped: ResolverTypeWrapper<AddMphCompanionSkipped>;
  AddNoteToGroup: ResolverTypeWrapper<AddNoteToGroup>;
  AddOrgAdmin: ResolverTypeWrapper<AddOrgAdmin>;
  AddUserData: AddUserData;
  AddUsersToTeam: ResolverTypeWrapper<AddUsersToTeam>;
  AddUsersToTeamInput: AddUsersToTeamInput;
  AdminAccountInfo: ResolverTypeWrapper<AdminAccountInfo>;
  AdminAccountTypeCount: ResolverTypeWrapper<AdminAccountTypeCount>;
  AdminAgentSessionDetail: ResolverTypeWrapper<AdminAgentSessionDetail>;
  AdminAgentSessionListItem: ResolverTypeWrapper<AdminAgentSessionListItem>;
  AdminAgentSessionListResult: ResolverTypeWrapper<AdminAgentSessionListResult>;
  AdminAgentSessionTokens: ResolverTypeWrapper<AdminAgentSessionTokens>;
  AdminAgentSessionTotals: ResolverTypeWrapper<AdminAgentSessionTotals>;
  AdminAgentSessionTreatLine: ResolverTypeWrapper<AdminAgentSessionTreatLine>;
  AdminBillingCustomerRow: ResolverTypeWrapper<AdminBillingCustomerRow>;
  AdminBillingCustomerSearchResult: ResolverTypeWrapper<AdminBillingCustomerSearchResult>;
  AdminBulkDeleteApplied: ResolverTypeWrapper<AdminBulkDeleteApplied>;
  AdminBulkDeleteRejected: ResolverTypeWrapper<AdminBulkDeleteRejected>;
  AdminBulkDeleteRowInput: AdminBulkDeleteRowInput;
  AdminBulkMarkUsersForDeletion: ResolverTypeWrapper<AdminBulkMarkUsersForDeletion>;
  AdminBulkTeamRef: ResolverTypeWrapper<AdminBulkTeamRef>;
  AdminCashOut: ResolverTypeWrapper<AdminCashOut>;
  AdminCashOutsPage: ResolverTypeWrapper<AdminCashOutsPage>;
  AdminDeleteTeam: ResolverTypeWrapper<AdminDeleteTeam>;
  AdminDeleteVerifiedPhoneNumber: ResolverTypeWrapper<AdminDeleteVerifiedPhoneNumber>;
  AdminEditAccount: ResolverTypeWrapper<AdminEditAccount>;
  AdminEditOrganization: ResolverTypeWrapper<AdminEditOrganization>;
  AdminEditOrganizationEmailSettings: ResolverTypeWrapper<AdminEditOrganizationEmailSettings>;
  AdminEditOrganizationRecordingConsent: ResolverTypeWrapper<AdminEditOrganizationRecordingConsent>;
  AdminEditTeam: ResolverTypeWrapper<AdminEditTeam>;
  AdminEditTeamMember: ResolverTypeWrapper<AdminEditTeamMember>;
  AdminEditUser: ResolverTypeWrapper<AdminEditUser>;
  AdminGiveTreats: ResolverTypeWrapper<AdminGiveTreats>;
  AdminLinkedOrg: ResolverTypeWrapper<AdminLinkedOrg>;
  AdminMemberRemovalBillingCheck: ResolverTypeWrapper<AdminMemberRemovalBillingCheck>;
  AdminMemberRemovalImpact: ResolverTypeWrapper<AdminMemberRemovalImpact>;
  AdminMemberRemovalPreflight: ResolverTypeWrapper<AdminMemberRemovalPreflight>;
  AdminMembershipOrgGroup: ResolverTypeWrapper<AdminMembershipOrgGroup>;
  AdminMembershipTeam: ResolverTypeWrapper<AdminMembershipTeam>;
  AdminMoveTeamToOrg: ResolverTypeWrapper<AdminMoveTeamToOrg>;
  AdminMphBulkAssignTeamRoles: ResolverTypeWrapper<AdminMphBulkAssignTeamRoles>;
  AdminMphBulkReassignApplied: ResolverTypeWrapper<AdminMphBulkReassignApplied>;
  AdminMphBulkReassignRejected: ResolverTypeWrapper<AdminMphBulkReassignRejected>;
  AdminMphBulkReassignRowInput: AdminMphBulkReassignRowInput;
  AdminMphBulkReassignTeams: ResolverTypeWrapper<AdminMphBulkReassignTeams>;
  AdminMphBulkRoleApplied: ResolverTypeWrapper<AdminMphBulkRoleApplied>;
  AdminMphBulkRoleRejected: ResolverTypeWrapper<AdminMphBulkRoleRejected>;
  AdminMphBulkRoleRowInput: AdminMphBulkRoleRowInput;
  AdminMphCompanionMember: ResolverTypeWrapper<AdminMphCompanionMember>;
  AdminMphCompanionMembersResult: ResolverTypeWrapper<AdminMphCompanionMembersResult>;
  AdminMphCompanionTeam: ResolverTypeWrapper<AdminMphCompanionTeam>;
  AdminNoteDetail: ResolverTypeWrapper<AdminNoteDetail>;
  AdminNoteFields: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AdminNoteFields']>;
  AdminNoteRow: ResolverTypeWrapper<AdminNoteRow>;
  AdminNoteTemplateOption: ResolverTypeWrapper<AdminNoteTemplateOption>;
  AdminNotesPage: ResolverTypeWrapper<AdminNotesPage>;
  AdminOrgEmailKey: AdminOrgEmailKey;
  AdminOrgEmailSettingInput: AdminOrgEmailSettingInput;
  AdminOrgEmailTemplatePreview: ResolverTypeWrapper<AdminOrgEmailTemplatePreview>;
  AdminOrganizationAdmin: ResolverTypeWrapper<AdminOrganizationAdmin>;
  AdminOrganizationBilling: ResolverTypeWrapper<AdminOrganizationBilling>;
  AdminOrganizationDetail: ResolverTypeWrapper<AdminOrganizationDetail>;
  AdminOrganizationEmailSetting: ResolverTypeWrapper<AdminOrganizationEmailSetting>;
  AdminOrganizationInfo: ResolverTypeWrapper<AdminOrganizationInfo>;
  AdminOrganizationMember: ResolverTypeWrapper<AdminOrganizationMember>;
  AdminOrganizationMemberTeam: ResolverTypeWrapper<AdminOrganizationMemberTeam>;
  AdminOrganizationMembersPage: ResolverTypeWrapper<AdminOrganizationMembersPage>;
  AdminOrganizationSummary: ResolverTypeWrapper<AdminOrganizationSummary>;
  AdminOrganizationTeam: ResolverTypeWrapper<AdminOrganizationTeam>;
  AdminOrganizationTeamsPage: ResolverTypeWrapper<AdminOrganizationTeamsPage>;
  AdminOrganizationsList: ResolverTypeWrapper<AdminOrganizationsList>;
  AdminReferralInfo: ResolverTypeWrapper<AdminReferralInfo>;
  AdminReferredUser: ResolverTypeWrapper<AdminReferredUser>;
  AdminReferredUsersPage: ResolverTypeWrapper<AdminReferredUsersPage>;
  AdminRemoveTeamMember: ResolverTypeWrapper<AdminRemoveTeamMember>;
  AdminResendInvitation: ResolverTypeWrapper<AdminResendInvitation>;
  AdminRevokeInvitation: ResolverTypeWrapper<AdminRevokeInvitation>;
  AdminRevokeOrganizationStripeCustomer: ResolverTypeWrapper<AdminRevokeOrganizationStripeCustomer>;
  AdminRoleOption: ResolverTypeWrapper<AdminRoleOption>;
  AdminSetOrganizationAdmin: ResolverTypeWrapper<AdminSetOrganizationAdmin>;
  AdminStripeCustomerLinkage: ResolverTypeWrapper<AdminStripeCustomerLinkage>;
  AdminTeamDeletionCheck: ResolverTypeWrapper<AdminTeamDeletionCheck>;
  AdminTeamDetail: ResolverTypeWrapper<AdminTeamDetail>;
  AdminTeamMember: ResolverTypeWrapper<AdminTeamMember>;
  AdminTeamMembersPage: ResolverTypeWrapper<AdminTeamMembersPage>;
  AdminTeamMoveCheck: ResolverTypeWrapper<AdminTeamMoveCheck>;
  AdminTeamSummary: ResolverTypeWrapper<AdminTeamSummary>;
  AdminTeamsList: ResolverTypeWrapper<AdminTeamsList>;
  AdminTemplateDefault: ResolverTypeWrapper<AdminTemplateDefault>;
  AdminTemplateDetail: ResolverTypeWrapper<AdminTemplateDetail>;
  AdminTemplateField: ResolverTypeWrapper<AdminTemplateField>;
  AdminTreatBalanceInfo: ResolverTypeWrapper<AdminTreatBalanceInfo>;
  AdminTreatInfo: ResolverTypeWrapper<AdminTreatInfo>;
  AdminTreatPlan: ResolverTypeWrapper<AdminTreatPlan>;
  AdminUnwireAccount: ResolverTypeWrapper<AdminUnwireAccount>;
  AdminUpdateOrganizationStripeCustomer: ResolverTypeWrapper<AdminUpdateOrganizationStripeCustomer>;
  AdminUserCounts: ResolverTypeWrapper<AdminUserCounts>;
  AdminUserInfo: ResolverTypeWrapper<AdminUserInfo>;
  AdminUserListItem: ResolverTypeWrapper<AdminUserListItem>;
  AdminUserListResult: ResolverTypeWrapper<AdminUserListResult>;
  AdminUserLookupResult: ResolverTypeWrapper<AdminUserLookupResult>;
  AdminUserMembershipResult: ResolverTypeWrapper<AdminUserMembershipResult>;
  AdminUserOrg: ResolverTypeWrapper<AdminUserOrg>;
  AdminUserTeam: ResolverTypeWrapper<AdminUserTeam>;
  AdminUserTemplate: ResolverTypeWrapper<AdminUserTemplate>;
  AdminUserTemplatesPage: ResolverTypeWrapper<AdminUserTemplatesPage>;
  AdminVerifiedPhoneLookupResult: ResolverTypeWrapper<AdminVerifiedPhoneLookupResult>;
  AdminVerifiedPhoneVerification: ResolverTypeWrapper<AdminVerifiedPhoneVerification>;
  AdminVerifiedPhoneVerifierTeam: ResolverTypeWrapper<AdminVerifiedPhoneVerifierTeam>;
  AdminVerifiedPhoneVerifierUser: ResolverTypeWrapper<AdminVerifiedPhoneVerifierUser>;
  AdminWireUpAccount: ResolverTypeWrapper<AdminWireUpAccount>;
  AgentSession: ResolverTypeWrapper<AgentSession>;
  AgentSessionEvent: ResolverTypeWrapper<AgentSessionEvent>;
  AgentSessionEventsPage: ResolverTypeWrapper<AgentSessionEventsPage>;
  AgentToolPermissionGrant: ResolverTypeWrapper<AgentToolPermissionGrant>;
  AllowedRole: ResolverTypeWrapper<AllowedRole>;
  AppendRecording: ResolverTypeWrapper<AppendRecording>;
  AssociateQuicknotesWithPatient: ResolverTypeWrapper<AssociateQuicknotesWithPatient>;
  Attachment: ResolverTypeWrapper<Attachment>;
  AttachmentInput: AttachmentInput;
  AuditLogEntry: ResolverTypeWrapper<AuditLogEntry>;
  AuditLogResult: ResolverTypeWrapper<AuditLogResult>;
  AuditTrail: ResolverTypeWrapper<AuditTrail>;
  AutoTemplate: ResolverTypeWrapper<AutoTemplate>;
  AutoTemplateField: ResolverTypeWrapper<AutoTemplateField>;
  AutoUsageDetails: ResolverTypeWrapper<AutoUsageDetails>;
  BirthdayParts: ResolverTypeWrapper<BirthdayParts>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BulkRestoreSkipReason: BulkRestoreSkipReason;
  BulkRestoreSkipped: ResolverTypeWrapper<BulkRestoreSkipped>;
  BulkRestoreUsers: ResolverTypeWrapper<BulkRestoreUsers>;
  BulkSetExpiryPolicy: ResolverTypeWrapper<BulkSetExpiryPolicy>;
  BulkSetRole: ResolverTypeWrapper<BulkSetRole>;
  CancelBroadcastNotification: ResolverTypeWrapper<CancelBroadcastNotification>;
  CancelNotification: ResolverTypeWrapper<CancelNotification>;
  ChangeScribephoneConsentMode: ResolverTypeWrapper<ChangeScribephoneConsentMode>;
  CheckinNote: ResolverTypeWrapper<CheckinNote>;
  CheckoutNote: ResolverTypeWrapper<CheckoutNote>;
  ClientSummaryPreferences: ResolverTypeWrapper<ClientSummaryPreferences>;
  ClientSummaryPreferencesType: ResolverTypeWrapper<ClientSummaryPreferencesType>;
  CloseCompanionSession: ResolverTypeWrapper<CloseCompanionSession>;
  CompanionAccountSettings: ResolverTypeWrapper<CompanionAccountSettings>;
  CompanionContext: ResolverTypeWrapper<CompanionContext>;
  CompanionContextSettings: ResolverTypeWrapper<CompanionContextSettings>;
  CompanionContextTeam: ResolverTypeWrapper<CompanionContextTeam>;
  CompanionContextUser: ResolverTypeWrapper<CompanionContextUser>;
  CompanionOrganizationSettings: ResolverTypeWrapper<CompanionOrganizationSettings>;
  CompanionSession: ResolverTypeWrapper<CompanionSession>;
  CompanionSessionEstimate: ResolverTypeWrapper<CompanionSessionEstimate>;
  CompanionSessionEstimateItem: ResolverTypeWrapper<CompanionSessionEstimateItem>;
  CompanionSessionEstimateItemChoice: ResolverTypeWrapper<CompanionSessionEstimateItemChoice>;
  CompanionSessionKnowledge: ResolverTypeWrapper<CompanionSessionKnowledge>;
  CompanionSessionMessage: ResolverTypeWrapper<CompanionSessionMessage>;
  CompanionSessionMessageStatusEnum: CompanionSessionMessageStatusEnum;
  CompanionSessionMessageStatusSummary: ResolverTypeWrapper<CompanionSessionMessageStatusSummary>;
  CompanionSessionStatusSummary: ResolverTypeWrapper<CompanionSessionStatusSummary>;
  CompanionSessionTask: ResolverTypeWrapper<CompanionSessionTask>;
  CompanionSessionTaskStatusEnum: CompanionSessionTaskStatusEnum;
  CompanionSessionTaskStatusSummary: ResolverTypeWrapper<CompanionSessionTaskStatusSummary>;
  CompanionSessionTypeEnum: CompanionSessionTypeEnum;
  CompanionSubscription: ResolverTypeWrapper<CompanionSubscription>;
  CompanionSubscriptionStatus: CompanionSubscriptionStatus;
  CompanionToolPermissionDetail: ResolverTypeWrapper<CompanionToolPermissionDetail>;
  CompanionToolPermissionRequest: ResolverTypeWrapper<CompanionToolPermissionRequest>;
  CompanionTypeEnum: CompanionTypeEnum;
  CompanionUserSettings: ResolverTypeWrapper<CompanionUserSettings>;
  ConfirmUser: ResolverTypeWrapper<ConfirmUser>;
  CopyAutoTemplate: ResolverTypeWrapper<CopyAutoTemplate>;
  CopyNotesToPatient: ResolverTypeWrapper<CopyNotesToPatient>;
  CorrectPatientNameInNote: ResolverTypeWrapper<CorrectPatientNameInNote>;
  CreateAgentSession: ResolverTypeWrapper<CreateAgentSession>;
  CreateAgentToolPermissionGrant: ResolverTypeWrapper<CreateAgentToolPermissionGrant>;
  CreateAutoTemplate: ResolverTypeWrapper<CreateAutoTemplate>;
  CreateAutoTemplateInput: CreateAutoTemplateInput;
  CreateBroadcastNotification: ResolverTypeWrapper<CreateBroadcastNotification>;
  CreateCompanionSession: ResolverTypeWrapper<CreateCompanionSession>;
  CreateCustomOrg: ResolverTypeWrapper<CreateCustomOrg>;
  CreateGroupedNotes: ResolverTypeWrapper<CreateGroupedNotes>;
  CreateLLMCustomizationsInput: CreateLlmCustomizationsInput;
  CreateNote: ResolverTypeWrapper<CreateNote>;
  CreateOrgInput: CreateOrgInput;
  CreateOrganization: ResolverTypeWrapper<CreateOrganization>;
  CreatePatient: ResolverTypeWrapper<CreatePatient>;
  CreatePatientNote: ResolverTypeWrapper<CreatePatientNote>;
  CreateQuickNote: ResolverTypeWrapper<CreateQuickNote>;
  CreateTeam: ResolverTypeWrapper<CreateTeam>;
  CreateTeamUnderOrg: ResolverTypeWrapper<CreateTeamUnderOrg>;
  CreateTemplateGroup: ResolverTypeWrapper<CreateTemplateGroup>;
  CreateTemplatePreview: ResolverTypeWrapper<CreateTemplatePreview>;
  CreateTestUser: ResolverTypeWrapper<CreateTestUser>;
  CreateTestUserInput: CreateTestUserInput;
  CreateUser: ResolverTypeWrapper<CreateUser>;
  CreateUserFromTeamInvitation: ResolverTypeWrapper<CreateUserFromTeamInvitation>;
  CreateV1Team: ResolverTypeWrapper<CreateV1Team>;
  CreateV1TeamInput: CreateV1TeamInput;
  CreditRedemptionStatus: CreditRedemptionStatus;
  CustomFormField: ResolverTypeWrapper<CustomFormField>;
  CustomObjectiveField: ResolverTypeWrapper<CustomObjectiveField>;
  CustomObjectiveFieldsInput: CustomObjectiveFieldsInput;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DeactivateOrgTeamUser: ResolverTypeWrapper<DeactivateOrgTeamUser>;
  DeductAgentSessionTreats: ResolverTypeWrapper<DeductAgentSessionTreats>;
  DeleteAgentSession: ResolverTypeWrapper<DeleteAgentSession>;
  DeleteAttachment: ResolverTypeWrapper<DeleteAttachment>;
  DeleteAutoTemplate: ResolverTypeWrapper<DeleteAutoTemplate>;
  DeleteCompanionSession: ResolverTypeWrapper<DeleteCompanionSession>;
  DeleteHeaderImage: ResolverTypeWrapper<DeleteHeaderImage>;
  DeleteNote: ResolverTypeWrapper<DeleteNote>;
  DeleteNoteAudioRecording: ResolverTypeWrapper<DeleteNoteAudioRecording>;
  DeleteNotes: ResolverTypeWrapper<DeleteNotes>;
  DeletePatient: ResolverTypeWrapper<DeletePatient>;
  DeleteTeam: ResolverTypeWrapper<DeleteTeam>;
  DeleteTemplate: ResolverTypeWrapper<DeleteTemplate>;
  DeleteTemplateGroup: ResolverTypeWrapper<DeleteTemplateGroup>;
  DeleteUser: ResolverTypeWrapper<DeleteUser>;
  DeleteVerifiedPhoneNumber: ResolverTypeWrapper<DeleteVerifiedPhoneNumber>;
  DenyTeamInvitation: ResolverTypeWrapper<DenyTeamInvitation>;
  DescopeAdminPortalSession: ResolverTypeWrapper<DescopeAdminPortalSession>;
  DescopeMobileSession: ResolverTypeWrapper<DescopeMobileSession>;
  DescopeWebSession: ResolverTypeWrapper<DescopeWebSession>;
  DetachNotesFromPatient: ResolverTypeWrapper<DetachNotesFromPatient>;
  DismissNotification: ResolverTypeWrapper<DismissNotification>;
  DismissNotificationsByNote: ResolverTypeWrapper<DismissNotificationsByNote>;
  EditAccountPreferences: ResolverTypeWrapper<EditAccountPreferences>;
  EditClientSummaryPreferences: ResolverTypeWrapper<EditClientSummaryPreferences>;
  EditObjectiveNormalDefaults: ResolverTypeWrapper<EditObjectiveNormalDefaults>;
  EditPDFSettings: ResolverTypeWrapper<EditPdfSettings>;
  EditPatient: ResolverTypeWrapper<EditPatient>;
  EditTemplate: ResolverTypeWrapper<EditTemplate>;
  EditUser: ResolverTypeWrapper<EditUser>;
  ExistingAccount: ResolverTypeWrapper<ExistingAccount>;
  ExistingTeam: ResolverTypeWrapper<ExistingTeam>;
  ExistingUser: ResolverTypeWrapper<ExistingUser>;
  ExtensionStepInput: ExtensionStepInput;
  FeatureActivation: ResolverTypeWrapper<FeatureActivation>;
  FieldInput: FieldInput;
  FieldName: FieldName;
  FieldNameEnum: FieldNameEnum;
  FlagNoteToSupport: ResolverTypeWrapper<FlagNoteToSupport>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GenerateAdaptiveClientSummary: ResolverTypeWrapper<GenerateAdaptiveClientSummary>;
  GenerateAgentSessionTitle: ResolverTypeWrapper<GenerateAgentSessionTitle>;
  GenerateClientSummary: ResolverTypeWrapper<GenerateClientSummary>;
  GenerateClientSummaryNext: ResolverTypeWrapper<GenerateClientSummaryNext>;
  GenerateLLMCustomization: ResolverTypeWrapper<GenerateLlmCustomization>;
  GenericScalar: ResolverTypeWrapper<Scalars['GenericScalar']['output']>;
  GoogleAuthInput: GoogleAuthInput;
  GoogleAuthResponse: ResolverTypeWrapper<GoogleAuthResponse>;
  HardDeleteNotes: ResolverTypeWrapper<HardDeleteNotes>;
  HardDeleteUser: ResolverTypeWrapper<HardDeleteUser>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  InboxLocation: InboxLocation;
  InboxNotes: ResolverTypeWrapper<InboxNotes>;
  InboxTabCount: ResolverTypeWrapper<InboxTabCount>;
  IncrementAutoUsage: ResolverTypeWrapper<IncrementAutoUsage>;
  InitializeStream: ResolverTypeWrapper<InitializeStream>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Inventory: ResolverTypeWrapper<Inventory>;
  InventoryItem: ResolverTypeWrapper<InventoryItem>;
  InventoryStatusEnum: InventoryStatusEnum;
  InviteUserData: InviteUserData;
  InviteUsersToTeam: ResolverTypeWrapper<InviteUsersToTeam>;
  InviteUsersToTeamInput: InviteUsersToTeamInput;
  JSONString: ResolverTypeWrapper<Scalars['JSONString']['output']>;
  LinkRecordingConsentToNote: ResolverTypeWrapper<LinkRecordingConsentToNote>;
  LogRecordingConsent: ResolverTypeWrapper<LogRecordingConsent>;
  LogScribephoneConsent: ResolverTypeWrapper<LogScribephoneConsent>;
  LoginUser: ResolverTypeWrapper<LoginUser>;
  LoginUserAccount: ResolverTypeWrapper<LoginUserAccount>;
  LoginUserOrganization: ResolverTypeWrapper<LoginUserOrganization>;
  LoginUserResponse: ResolverTypeWrapper<LoginUserResponse>;
  LoginUserTeam: ResolverTypeWrapper<LoginUserTeam>;
  LogoutUser: ResolverTypeWrapper<LogoutUser>;
  MarkAgentSessionAttachmentsSent: ResolverTypeWrapper<MarkAgentSessionAttachmentsSent>;
  MarkAgentToolPermissionGrantUsed: ResolverTypeWrapper<MarkAgentToolPermissionGrantUsed>;
  MarkNotificationRead: ResolverTypeWrapper<MarkNotificationRead>;
  MarkUserForDeletion: ResolverTypeWrapper<MarkUserForDeletion>;
  ModifiedUser: ResolverTypeWrapper<ModifiedUser>;
  ModifyNote: ResolverTypeWrapper<ModifyNote>;
  ModifyNotes: ResolverTypeWrapper<ModifyNotes>;
  MoveNotesToPatient: ResolverTypeWrapper<MoveNotesToPatient>;
  MphBulkDeleteRejectReason: MphBulkDeleteRejectReason;
  MphBulkReassignRejectReason: MphBulkReassignRejectReason;
  MphBulkRoleRejectReason: MphBulkRoleRejectReason;
  Mutations: ResolverTypeWrapper<Record<PropertyKey, never>>;
  Note: ResolverTypeWrapper<Note>;
  NoteFilterField: NoteFilterField;
  NoteFilterInput: NoteFilterInput;
  NoteFilterOperator: NoteFilterOperator;
  NoteGroup: ResolverTypeWrapper<NoteGroup>;
  NoteGroupNote: ResolverTypeWrapper<NoteGroupNote>;
  NoteInput: NoteInput;
  NoteStatus: NoteStatus;
  NumNotes: NumNotes;
  ObjectiveFieldsInput: ObjectiveFieldsInput;
  ObjectiveNormalDefaults: ResolverTypeWrapper<ObjectiveNormalDefaults>;
  ObjectiveNormalDefaultsInput: ObjectiveNormalDefaultsInput;
  OnboardingProgress: ResolverTypeWrapper<OnboardingProgress>;
  OrgBillingBasis: OrgBillingBasis;
  OrgBillingShare: ResolverTypeWrapper<OrgBillingShare>;
  OrgBillingStatus: OrgBillingStatus;
  OrgStripeWarning: ResolverTypeWrapper<OrgStripeWarning>;
  OrgStripeWarningOrganization: ResolverTypeWrapper<OrgStripeWarningOrganization>;
  OrgStripeWarningReason: OrgStripeWarningReason;
  Organization: ResolverTypeWrapper<Organization>;
  OrganizationRecordingConsentEvents: ResolverTypeWrapper<OrganizationRecordingConsentEvents>;
  ParsedPatientSignalment: ResolverTypeWrapper<ParsedPatientSignalment>;
  ParsedPatientSignalmentInput: ParsedPatientSignalmentInput;
  Patient: ResolverTypeWrapper<Patient>;
  PatientInput: PatientInput;
  PersistentLoginUser: ResolverTypeWrapper<PersistentLoginUser>;
  PopulateUserSampleTemplates: ResolverTypeWrapper<PopulateUserSampleTemplates>;
  ProposeLLMEdit: ResolverTypeWrapper<ProposeLlmEdit>;
  ProposeLLMEditInput: ProposeLlmEditInput;
  ProtectNote: ResolverTypeWrapper<ProtectNote>;
  ProvisionedUsers: ResolverTypeWrapper<ProvisionedUsers>;
  RecordingConsentAction: RecordingConsentAction;
  RecordingConsentEvent: ResolverTypeWrapper<RecordingConsentEvent>;
  RecordingConsentSource: RecordingConsentSource;
  RecordingConsentSurface: RecordingConsentSurface;
  RedeemCredits: ResolverTypeWrapper<RedeemCredits>;
  Referral: ResolverTypeWrapper<Referral>;
  RefreshUserToken: ResolverTypeWrapper<RefreshUserToken>;
  RemoveOrganizationDefaultTemplate: ResolverTypeWrapper<RemoveOrganizationDefaultTemplate>;
  RemoveTeamDefaultTemplate: ResolverTypeWrapper<RemoveTeamDefaultTemplate>;
  RemoveUserFromOrgTeam: ResolverTypeWrapper<RemoveUserFromOrgTeam>;
  RemoveUserFromTeam: ResolverTypeWrapper<RemoveUserFromTeam>;
  RequestPhoneVerification: ResolverTypeWrapper<RequestPhoneVerification>;
  RequestTeamSetup: ResolverTypeWrapper<RequestTeamSetup>;
  ResendUserConfirmation: ResolverTypeWrapper<ResendUserConfirmation>;
  RestoreUser: ResolverTypeWrapper<RestoreUser>;
  RetoolCreateQuickNote: ResolverTypeWrapper<RetoolCreateQuickNote>;
  RetoolDeleteNotes: ResolverTypeWrapper<RetoolDeleteNotes>;
  RetryFailedAutoSoap: ResolverTypeWrapper<RetryFailedAutoSoap>;
  RevokeAgentToolPermissionGrant: ResolverTypeWrapper<RevokeAgentToolPermissionGrant>;
  RmTeamUserInput: RmTeamUserInput;
  Role: ResolverTypeWrapper<Role>;
  Root: ResolverTypeWrapper<Record<PropertyKey, never>>;
  ScheduleNotification: ResolverTypeWrapper<ScheduleNotification>;
  ScribephoneConsentEnum: ScribephoneConsentEnum;
  SendClientSummaryEmail: ResolverTypeWrapper<SendClientSummaryEmail>;
  SendCompanionSessionMessage: ResolverTypeWrapper<SendCompanionSessionMessage>;
  SendDashboardDesktopLink: ResolverTypeWrapper<SendDashboardDesktopLink>;
  SendExportNoteEmail: ResolverTypeWrapper<SendExportNoteEmail>;
  SendForgotPasswordEmail: ResolverTypeWrapper<SendForgotPasswordEmail>;
  SendNoteDesktopLink: ResolverTypeWrapper<SendNoteDesktopLink>;
  SetAccountPreference: ResolverTypeWrapper<SetAccountPreference>;
  SetOrganizationDefaultTemplate: ResolverTypeWrapper<SetOrganizationDefaultTemplate>;
  SetTeamDefaultTemplate: ResolverTypeWrapper<SetTeamDefaultTemplate>;
  SharingTypeEnum: SharingTypeEnum;
  SmartSearchInput: SmartSearchInput;
  SoapTag: SoapTag;
  SoapText: SoapText;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SupportDocSearchResult: ResolverTypeWrapper<SupportDocSearchResult>;
  SymmetryLabel: ResolverTypeWrapper<SymmetryLabel>;
  Team: ResolverTypeWrapper<Team>;
  TeamInvite: ResolverTypeWrapper<TeamInvite>;
  TeamInviteResponse: ResolverTypeWrapper<TeamInviteResponse>;
  TeamMemberFilterField: TeamMemberFilterField;
  TeamMemberFilterInput: TeamMemberFilterInput;
  TeamMemberFilterOperator: TeamMemberFilterOperator;
  TeamUserNoteCount: ResolverTypeWrapper<TeamUserNoteCount>;
  TeamUserNoteCounts: ResolverTypeWrapper<TeamUserNoteCounts>;
  Template: ResolverTypeWrapper<Template>;
  TemplateFieldsInput: TemplateFieldsInput;
  TemplateGroup: ResolverTypeWrapper<TemplateGroup>;
  TemplateGroupAutoTemplate: ResolverTypeWrapper<TemplateGroupAutoTemplate>;
  TemplatePreviewInput: TemplatePreviewInput;
  TemplatePreviews: ResolverTypeWrapper<TemplatePreviews>;
  TemplateResponse: ResolverTypeWrapper<TemplateResponse>;
  TemplateType: TemplateType;
  TemplateTypeEnum: TemplateTypeEnum;
  TestAccountType: TestAccountType;
  TransferNoteOwnership: ResolverTypeWrapper<TransferNoteOwnership>;
  TreatBalance: ResolverTypeWrapper<TreatBalance>;
  TreatDailySummary: ResolverTypeWrapper<TreatDailySummary>;
  TreatUsageByCompanion: ResolverTypeWrapper<TreatUsageByCompanion>;
  TriggerDentalChartExtraction: ResolverTypeWrapper<TriggerDentalChartExtraction>;
  TwilioVerificationStatus: TwilioVerificationStatus;
  UUID: ResolverTypeWrapper<Scalars['UUID']['output']>;
  UngroupNote: ResolverTypeWrapper<UngroupNote>;
  UpdateAccountPlan: ResolverTypeWrapper<UpdateAccountPlan>;
  UpdateAgentSessionTitle: ResolverTypeWrapper<UpdateAgentSessionTitle>;
  UpdateAutoTemplate: ResolverTypeWrapper<UpdateAutoTemplate>;
  UpdateAutoTemplateInput: UpdateAutoTemplateInput;
  UpdateForgottenPassword: ResolverTypeWrapper<UpdateForgottenPassword>;
  UpdateScribeMd: ResolverTypeWrapper<UpdateScribeMd>;
  UpdateTemplateGroup: ResolverTypeWrapper<UpdateTemplateGroup>;
  UpdateTemplateSharing: ResolverTypeWrapper<UpdateTemplateSharing>;
  UpdateUserFFSegment: ResolverTypeWrapper<UpdateUserFfSegment>;
  UpdateUserTeam: ResolverTypeWrapper<UpdateUserTeam>;
  UpdateVerifiedPhoneNumberSharing: ResolverTypeWrapper<UpdateVerifiedPhoneNumberSharing>;
  UploadAgentSessionAttachment: ResolverTypeWrapper<UploadAgentSessionAttachment>;
  UploadCompanionSessionAttachment: ResolverTypeWrapper<UploadCompanionSessionAttachment>;
  UploadHeaderImage: ResolverTypeWrapper<UploadHeaderImage>;
  UploadNoteAttachments: ResolverTypeWrapper<UploadNoteAttachments>;
  UploadPatientAttachments: ResolverTypeWrapper<UploadPatientAttachments>;
  UploadPdfAndExtractText: ResolverTypeWrapper<UploadPdfAndExtractText>;
  UploadSpeedTest: ResolverTypeWrapper<UploadSpeedTest>;
  UploadSpeedTestResult: ResolverTypeWrapper<UploadSpeedTestResult>;
  User: ResolverTypeWrapper<User>;
  UserChecks: ResolverTypeWrapper<UserChecks>;
  UserNotePollQuery: ResolverTypeWrapper<UserNotePollQuery>;
  UserNotification: ResolverTypeWrapper<UserNotification>;
  UserPermission: ResolverTypeWrapper<UserPermission>;
  UserSummary: ResolverTypeWrapper<UserSummary>;
  UserTeam: ResolverTypeWrapper<UserTeam>;
  VerifiedPhoneNumber: ResolverTypeWrapper<VerifiedPhoneNumber>;
  WireUpWarning: ResolverTypeWrapper<WireUpWarning>;
  WireUpWarningReason: WireUpWarningReason;
  WritingCompanionProposal: ResolverTypeWrapper<WritingCompanionProposal>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AcceptLLMCustomization: AcceptLlmCustomization;
  AcceptLLMCustomizationsInput: AcceptLlmCustomizationsInput;
  AcceptTeamInvitation: AcceptTeamInvitation;
  Account: Account;
  AccountDetails: AccountDetails;
  AddFeedbackInput: AddFeedbackInput;
  AddFeedbackToCustomization: AddFeedbackToCustomization;
  AddFeedbackToLog: AddFeedbackToLog;
  AddMphCompanionMembers: AddMphCompanionMembers;
  AddMphCompanionSkipped: AddMphCompanionSkipped;
  AddNoteToGroup: AddNoteToGroup;
  AddOrgAdmin: AddOrgAdmin;
  AddUserData: AddUserData;
  AddUsersToTeam: AddUsersToTeam;
  AddUsersToTeamInput: AddUsersToTeamInput;
  AdminAccountInfo: AdminAccountInfo;
  AdminAccountTypeCount: AdminAccountTypeCount;
  AdminAgentSessionDetail: AdminAgentSessionDetail;
  AdminAgentSessionListItem: AdminAgentSessionListItem;
  AdminAgentSessionListResult: AdminAgentSessionListResult;
  AdminAgentSessionTokens: AdminAgentSessionTokens;
  AdminAgentSessionTotals: AdminAgentSessionTotals;
  AdminAgentSessionTreatLine: AdminAgentSessionTreatLine;
  AdminBillingCustomerRow: AdminBillingCustomerRow;
  AdminBillingCustomerSearchResult: AdminBillingCustomerSearchResult;
  AdminBulkDeleteApplied: AdminBulkDeleteApplied;
  AdminBulkDeleteRejected: AdminBulkDeleteRejected;
  AdminBulkDeleteRowInput: AdminBulkDeleteRowInput;
  AdminBulkMarkUsersForDeletion: AdminBulkMarkUsersForDeletion;
  AdminBulkTeamRef: AdminBulkTeamRef;
  AdminCashOut: AdminCashOut;
  AdminCashOutsPage: AdminCashOutsPage;
  AdminDeleteTeam: AdminDeleteTeam;
  AdminDeleteVerifiedPhoneNumber: AdminDeleteVerifiedPhoneNumber;
  AdminEditAccount: AdminEditAccount;
  AdminEditOrganization: AdminEditOrganization;
  AdminEditOrganizationEmailSettings: AdminEditOrganizationEmailSettings;
  AdminEditOrganizationRecordingConsent: AdminEditOrganizationRecordingConsent;
  AdminEditTeam: AdminEditTeam;
  AdminEditTeamMember: AdminEditTeamMember;
  AdminEditUser: AdminEditUser;
  AdminGiveTreats: AdminGiveTreats;
  AdminLinkedOrg: AdminLinkedOrg;
  AdminMemberRemovalBillingCheck: AdminMemberRemovalBillingCheck;
  AdminMemberRemovalImpact: AdminMemberRemovalImpact;
  AdminMemberRemovalPreflight: AdminMemberRemovalPreflight;
  AdminMembershipOrgGroup: AdminMembershipOrgGroup;
  AdminMembershipTeam: AdminMembershipTeam;
  AdminMoveTeamToOrg: AdminMoveTeamToOrg;
  AdminMphBulkAssignTeamRoles: AdminMphBulkAssignTeamRoles;
  AdminMphBulkReassignApplied: AdminMphBulkReassignApplied;
  AdminMphBulkReassignRejected: AdminMphBulkReassignRejected;
  AdminMphBulkReassignRowInput: AdminMphBulkReassignRowInput;
  AdminMphBulkReassignTeams: AdminMphBulkReassignTeams;
  AdminMphBulkRoleApplied: AdminMphBulkRoleApplied;
  AdminMphBulkRoleRejected: AdminMphBulkRoleRejected;
  AdminMphBulkRoleRowInput: AdminMphBulkRoleRowInput;
  AdminMphCompanionMember: AdminMphCompanionMember;
  AdminMphCompanionMembersResult: AdminMphCompanionMembersResult;
  AdminMphCompanionTeam: AdminMphCompanionTeam;
  AdminNoteDetail: AdminNoteDetail;
  AdminNoteFields: ResolversInterfaceTypes<ResolversParentTypes>['AdminNoteFields'];
  AdminNoteRow: AdminNoteRow;
  AdminNoteTemplateOption: AdminNoteTemplateOption;
  AdminNotesPage: AdminNotesPage;
  AdminOrgEmailSettingInput: AdminOrgEmailSettingInput;
  AdminOrgEmailTemplatePreview: AdminOrgEmailTemplatePreview;
  AdminOrganizationAdmin: AdminOrganizationAdmin;
  AdminOrganizationBilling: AdminOrganizationBilling;
  AdminOrganizationDetail: AdminOrganizationDetail;
  AdminOrganizationEmailSetting: AdminOrganizationEmailSetting;
  AdminOrganizationInfo: AdminOrganizationInfo;
  AdminOrganizationMember: AdminOrganizationMember;
  AdminOrganizationMemberTeam: AdminOrganizationMemberTeam;
  AdminOrganizationMembersPage: AdminOrganizationMembersPage;
  AdminOrganizationSummary: AdminOrganizationSummary;
  AdminOrganizationTeam: AdminOrganizationTeam;
  AdminOrganizationTeamsPage: AdminOrganizationTeamsPage;
  AdminOrganizationsList: AdminOrganizationsList;
  AdminReferralInfo: AdminReferralInfo;
  AdminReferredUser: AdminReferredUser;
  AdminReferredUsersPage: AdminReferredUsersPage;
  AdminRemoveTeamMember: AdminRemoveTeamMember;
  AdminResendInvitation: AdminResendInvitation;
  AdminRevokeInvitation: AdminRevokeInvitation;
  AdminRevokeOrganizationStripeCustomer: AdminRevokeOrganizationStripeCustomer;
  AdminRoleOption: AdminRoleOption;
  AdminSetOrganizationAdmin: AdminSetOrganizationAdmin;
  AdminStripeCustomerLinkage: AdminStripeCustomerLinkage;
  AdminTeamDeletionCheck: AdminTeamDeletionCheck;
  AdminTeamDetail: AdminTeamDetail;
  AdminTeamMember: AdminTeamMember;
  AdminTeamMembersPage: AdminTeamMembersPage;
  AdminTeamMoveCheck: AdminTeamMoveCheck;
  AdminTeamSummary: AdminTeamSummary;
  AdminTeamsList: AdminTeamsList;
  AdminTemplateDefault: AdminTemplateDefault;
  AdminTemplateDetail: AdminTemplateDetail;
  AdminTemplateField: AdminTemplateField;
  AdminTreatBalanceInfo: AdminTreatBalanceInfo;
  AdminTreatInfo: AdminTreatInfo;
  AdminTreatPlan: AdminTreatPlan;
  AdminUnwireAccount: AdminUnwireAccount;
  AdminUpdateOrganizationStripeCustomer: AdminUpdateOrganizationStripeCustomer;
  AdminUserCounts: AdminUserCounts;
  AdminUserInfo: AdminUserInfo;
  AdminUserListItem: AdminUserListItem;
  AdminUserListResult: AdminUserListResult;
  AdminUserLookupResult: AdminUserLookupResult;
  AdminUserMembershipResult: AdminUserMembershipResult;
  AdminUserOrg: AdminUserOrg;
  AdminUserTeam: AdminUserTeam;
  AdminUserTemplate: AdminUserTemplate;
  AdminUserTemplatesPage: AdminUserTemplatesPage;
  AdminVerifiedPhoneLookupResult: AdminVerifiedPhoneLookupResult;
  AdminVerifiedPhoneVerification: AdminVerifiedPhoneVerification;
  AdminVerifiedPhoneVerifierTeam: AdminVerifiedPhoneVerifierTeam;
  AdminVerifiedPhoneVerifierUser: AdminVerifiedPhoneVerifierUser;
  AdminWireUpAccount: AdminWireUpAccount;
  AgentSession: AgentSession;
  AgentSessionEvent: AgentSessionEvent;
  AgentSessionEventsPage: AgentSessionEventsPage;
  AgentToolPermissionGrant: AgentToolPermissionGrant;
  AllowedRole: AllowedRole;
  AppendRecording: AppendRecording;
  AssociateQuicknotesWithPatient: AssociateQuicknotesWithPatient;
  Attachment: Attachment;
  AttachmentInput: AttachmentInput;
  AuditLogEntry: AuditLogEntry;
  AuditLogResult: AuditLogResult;
  AuditTrail: AuditTrail;
  AutoTemplate: AutoTemplate;
  AutoTemplateField: AutoTemplateField;
  AutoUsageDetails: AutoUsageDetails;
  BirthdayParts: BirthdayParts;
  Boolean: Scalars['Boolean']['output'];
  BulkRestoreSkipped: BulkRestoreSkipped;
  BulkRestoreUsers: BulkRestoreUsers;
  BulkSetExpiryPolicy: BulkSetExpiryPolicy;
  BulkSetRole: BulkSetRole;
  CancelBroadcastNotification: CancelBroadcastNotification;
  CancelNotification: CancelNotification;
  ChangeScribephoneConsentMode: ChangeScribephoneConsentMode;
  CheckinNote: CheckinNote;
  CheckoutNote: CheckoutNote;
  ClientSummaryPreferences: ClientSummaryPreferences;
  ClientSummaryPreferencesType: ClientSummaryPreferencesType;
  CloseCompanionSession: CloseCompanionSession;
  CompanionAccountSettings: CompanionAccountSettings;
  CompanionContext: CompanionContext;
  CompanionContextSettings: CompanionContextSettings;
  CompanionContextTeam: CompanionContextTeam;
  CompanionContextUser: CompanionContextUser;
  CompanionOrganizationSettings: CompanionOrganizationSettings;
  CompanionSession: CompanionSession;
  CompanionSessionEstimate: CompanionSessionEstimate;
  CompanionSessionEstimateItem: CompanionSessionEstimateItem;
  CompanionSessionEstimateItemChoice: CompanionSessionEstimateItemChoice;
  CompanionSessionKnowledge: CompanionSessionKnowledge;
  CompanionSessionMessage: CompanionSessionMessage;
  CompanionSessionMessageStatusSummary: CompanionSessionMessageStatusSummary;
  CompanionSessionStatusSummary: CompanionSessionStatusSummary;
  CompanionSessionTask: CompanionSessionTask;
  CompanionSessionTaskStatusSummary: CompanionSessionTaskStatusSummary;
  CompanionSubscription: CompanionSubscription;
  CompanionToolPermissionDetail: CompanionToolPermissionDetail;
  CompanionToolPermissionRequest: CompanionToolPermissionRequest;
  CompanionUserSettings: CompanionUserSettings;
  ConfirmUser: ConfirmUser;
  CopyAutoTemplate: CopyAutoTemplate;
  CopyNotesToPatient: CopyNotesToPatient;
  CorrectPatientNameInNote: CorrectPatientNameInNote;
  CreateAgentSession: CreateAgentSession;
  CreateAgentToolPermissionGrant: CreateAgentToolPermissionGrant;
  CreateAutoTemplate: CreateAutoTemplate;
  CreateAutoTemplateInput: CreateAutoTemplateInput;
  CreateBroadcastNotification: CreateBroadcastNotification;
  CreateCompanionSession: CreateCompanionSession;
  CreateCustomOrg: CreateCustomOrg;
  CreateGroupedNotes: CreateGroupedNotes;
  CreateLLMCustomizationsInput: CreateLlmCustomizationsInput;
  CreateNote: CreateNote;
  CreateOrgInput: CreateOrgInput;
  CreateOrganization: CreateOrganization;
  CreatePatient: CreatePatient;
  CreatePatientNote: CreatePatientNote;
  CreateQuickNote: CreateQuickNote;
  CreateTeam: CreateTeam;
  CreateTeamUnderOrg: CreateTeamUnderOrg;
  CreateTemplateGroup: CreateTemplateGroup;
  CreateTemplatePreview: CreateTemplatePreview;
  CreateTestUser: CreateTestUser;
  CreateTestUserInput: CreateTestUserInput;
  CreateUser: CreateUser;
  CreateUserFromTeamInvitation: CreateUserFromTeamInvitation;
  CreateV1Team: CreateV1Team;
  CreateV1TeamInput: CreateV1TeamInput;
  CustomFormField: CustomFormField;
  CustomObjectiveField: CustomObjectiveField;
  CustomObjectiveFieldsInput: CustomObjectiveFieldsInput;
  Date: Scalars['Date']['output'];
  DateTime: Scalars['DateTime']['output'];
  DeactivateOrgTeamUser: DeactivateOrgTeamUser;
  DeductAgentSessionTreats: DeductAgentSessionTreats;
  DeleteAgentSession: DeleteAgentSession;
  DeleteAttachment: DeleteAttachment;
  DeleteAutoTemplate: DeleteAutoTemplate;
  DeleteCompanionSession: DeleteCompanionSession;
  DeleteHeaderImage: DeleteHeaderImage;
  DeleteNote: DeleteNote;
  DeleteNoteAudioRecording: DeleteNoteAudioRecording;
  DeleteNotes: DeleteNotes;
  DeletePatient: DeletePatient;
  DeleteTeam: DeleteTeam;
  DeleteTemplate: DeleteTemplate;
  DeleteTemplateGroup: DeleteTemplateGroup;
  DeleteUser: DeleteUser;
  DeleteVerifiedPhoneNumber: DeleteVerifiedPhoneNumber;
  DenyTeamInvitation: DenyTeamInvitation;
  DescopeAdminPortalSession: DescopeAdminPortalSession;
  DescopeMobileSession: DescopeMobileSession;
  DescopeWebSession: DescopeWebSession;
  DetachNotesFromPatient: DetachNotesFromPatient;
  DismissNotification: DismissNotification;
  DismissNotificationsByNote: DismissNotificationsByNote;
  EditAccountPreferences: EditAccountPreferences;
  EditClientSummaryPreferences: EditClientSummaryPreferences;
  EditObjectiveNormalDefaults: EditObjectiveNormalDefaults;
  EditPDFSettings: EditPdfSettings;
  EditPatient: EditPatient;
  EditTemplate: EditTemplate;
  EditUser: EditUser;
  ExistingAccount: ExistingAccount;
  ExistingTeam: ExistingTeam;
  ExistingUser: ExistingUser;
  ExtensionStepInput: ExtensionStepInput;
  FeatureActivation: FeatureActivation;
  FieldInput: FieldInput;
  FlagNoteToSupport: FlagNoteToSupport;
  Float: Scalars['Float']['output'];
  GenerateAdaptiveClientSummary: GenerateAdaptiveClientSummary;
  GenerateAgentSessionTitle: GenerateAgentSessionTitle;
  GenerateClientSummary: GenerateClientSummary;
  GenerateClientSummaryNext: GenerateClientSummaryNext;
  GenerateLLMCustomization: GenerateLlmCustomization;
  GenericScalar: Scalars['GenericScalar']['output'];
  GoogleAuthInput: GoogleAuthInput;
  GoogleAuthResponse: GoogleAuthResponse;
  HardDeleteNotes: HardDeleteNotes;
  HardDeleteUser: HardDeleteUser;
  ID: Scalars['ID']['output'];
  InboxNotes: InboxNotes;
  InboxTabCount: InboxTabCount;
  IncrementAutoUsage: IncrementAutoUsage;
  InitializeStream: InitializeStream;
  Int: Scalars['Int']['output'];
  Inventory: Inventory;
  InventoryItem: InventoryItem;
  InviteUserData: InviteUserData;
  InviteUsersToTeam: InviteUsersToTeam;
  InviteUsersToTeamInput: InviteUsersToTeamInput;
  JSONString: Scalars['JSONString']['output'];
  LinkRecordingConsentToNote: LinkRecordingConsentToNote;
  LogRecordingConsent: LogRecordingConsent;
  LogScribephoneConsent: LogScribephoneConsent;
  LoginUser: LoginUser;
  LoginUserAccount: LoginUserAccount;
  LoginUserOrganization: LoginUserOrganization;
  LoginUserResponse: LoginUserResponse;
  LoginUserTeam: LoginUserTeam;
  LogoutUser: LogoutUser;
  MarkAgentSessionAttachmentsSent: MarkAgentSessionAttachmentsSent;
  MarkAgentToolPermissionGrantUsed: MarkAgentToolPermissionGrantUsed;
  MarkNotificationRead: MarkNotificationRead;
  MarkUserForDeletion: MarkUserForDeletion;
  ModifiedUser: ModifiedUser;
  ModifyNote: ModifyNote;
  ModifyNotes: ModifyNotes;
  MoveNotesToPatient: MoveNotesToPatient;
  Mutations: Record<PropertyKey, never>;
  Note: Note;
  NoteFilterInput: NoteFilterInput;
  NoteGroup: NoteGroup;
  NoteGroupNote: NoteGroupNote;
  NoteInput: NoteInput;
  NumNotes: NumNotes;
  ObjectiveFieldsInput: ObjectiveFieldsInput;
  ObjectiveNormalDefaults: ObjectiveNormalDefaults;
  ObjectiveNormalDefaultsInput: ObjectiveNormalDefaultsInput;
  OnboardingProgress: OnboardingProgress;
  OrgBillingShare: OrgBillingShare;
  OrgStripeWarning: OrgStripeWarning;
  OrgStripeWarningOrganization: OrgStripeWarningOrganization;
  Organization: Organization;
  OrganizationRecordingConsentEvents: OrganizationRecordingConsentEvents;
  ParsedPatientSignalment: ParsedPatientSignalment;
  ParsedPatientSignalmentInput: ParsedPatientSignalmentInput;
  Patient: Patient;
  PatientInput: PatientInput;
  PersistentLoginUser: PersistentLoginUser;
  PopulateUserSampleTemplates: PopulateUserSampleTemplates;
  ProposeLLMEdit: ProposeLlmEdit;
  ProposeLLMEditInput: ProposeLlmEditInput;
  ProtectNote: ProtectNote;
  ProvisionedUsers: ProvisionedUsers;
  RecordingConsentEvent: RecordingConsentEvent;
  RedeemCredits: RedeemCredits;
  Referral: Referral;
  RefreshUserToken: RefreshUserToken;
  RemoveOrganizationDefaultTemplate: RemoveOrganizationDefaultTemplate;
  RemoveTeamDefaultTemplate: RemoveTeamDefaultTemplate;
  RemoveUserFromOrgTeam: RemoveUserFromOrgTeam;
  RemoveUserFromTeam: RemoveUserFromTeam;
  RequestPhoneVerification: RequestPhoneVerification;
  RequestTeamSetup: RequestTeamSetup;
  ResendUserConfirmation: ResendUserConfirmation;
  RestoreUser: RestoreUser;
  RetoolCreateQuickNote: RetoolCreateQuickNote;
  RetoolDeleteNotes: RetoolDeleteNotes;
  RetryFailedAutoSoap: RetryFailedAutoSoap;
  RevokeAgentToolPermissionGrant: RevokeAgentToolPermissionGrant;
  RmTeamUserInput: RmTeamUserInput;
  Role: Role;
  Root: Record<PropertyKey, never>;
  ScheduleNotification: ScheduleNotification;
  SendClientSummaryEmail: SendClientSummaryEmail;
  SendCompanionSessionMessage: SendCompanionSessionMessage;
  SendDashboardDesktopLink: SendDashboardDesktopLink;
  SendExportNoteEmail: SendExportNoteEmail;
  SendForgotPasswordEmail: SendForgotPasswordEmail;
  SendNoteDesktopLink: SendNoteDesktopLink;
  SetAccountPreference: SetAccountPreference;
  SetOrganizationDefaultTemplate: SetOrganizationDefaultTemplate;
  SetTeamDefaultTemplate: SetTeamDefaultTemplate;
  SmartSearchInput: SmartSearchInput;
  SoapTag: SoapTag;
  SoapText: SoapText;
  String: Scalars['String']['output'];
  SupportDocSearchResult: SupportDocSearchResult;
  SymmetryLabel: SymmetryLabel;
  Team: Team;
  TeamInvite: TeamInvite;
  TeamInviteResponse: TeamInviteResponse;
  TeamMemberFilterInput: TeamMemberFilterInput;
  TeamUserNoteCount: TeamUserNoteCount;
  TeamUserNoteCounts: TeamUserNoteCounts;
  Template: Template;
  TemplateFieldsInput: TemplateFieldsInput;
  TemplateGroup: TemplateGroup;
  TemplateGroupAutoTemplate: TemplateGroupAutoTemplate;
  TemplatePreviewInput: TemplatePreviewInput;
  TemplatePreviews: TemplatePreviews;
  TemplateResponse: TemplateResponse;
  TransferNoteOwnership: TransferNoteOwnership;
  TreatBalance: TreatBalance;
  TreatDailySummary: TreatDailySummary;
  TreatUsageByCompanion: TreatUsageByCompanion;
  TriggerDentalChartExtraction: TriggerDentalChartExtraction;
  UUID: Scalars['UUID']['output'];
  UngroupNote: UngroupNote;
  UpdateAccountPlan: UpdateAccountPlan;
  UpdateAgentSessionTitle: UpdateAgentSessionTitle;
  UpdateAutoTemplate: UpdateAutoTemplate;
  UpdateAutoTemplateInput: UpdateAutoTemplateInput;
  UpdateForgottenPassword: UpdateForgottenPassword;
  UpdateScribeMd: UpdateScribeMd;
  UpdateTemplateGroup: UpdateTemplateGroup;
  UpdateTemplateSharing: UpdateTemplateSharing;
  UpdateUserFFSegment: UpdateUserFfSegment;
  UpdateUserTeam: UpdateUserTeam;
  UpdateVerifiedPhoneNumberSharing: UpdateVerifiedPhoneNumberSharing;
  UploadAgentSessionAttachment: UploadAgentSessionAttachment;
  UploadCompanionSessionAttachment: UploadCompanionSessionAttachment;
  UploadHeaderImage: UploadHeaderImage;
  UploadNoteAttachments: UploadNoteAttachments;
  UploadPatientAttachments: UploadPatientAttachments;
  UploadPdfAndExtractText: UploadPdfAndExtractText;
  UploadSpeedTest: UploadSpeedTest;
  UploadSpeedTestResult: UploadSpeedTestResult;
  User: User;
  UserChecks: UserChecks;
  UserNotePollQuery: UserNotePollQuery;
  UserNotification: UserNotification;
  UserPermission: UserPermission;
  UserSummary: UserSummary;
  UserTeam: UserTeam;
  VerifiedPhoneNumber: VerifiedPhoneNumber;
  WireUpWarning: WireUpWarning;
  WritingCompanionProposal: WritingCompanionProposal;
};

export type AcceptLlmCustomizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptLLMCustomization'] = ResolversParentTypes['AcceptLLMCustomization']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type AcceptTeamInvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptTeamInvitation'] = ResolversParentTypes['AcceptTeamInvitation']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type AccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']> = {
  accountDetails?: Resolver<Maybe<ResolversTypes['AccountDetails']>, ParentType, ContextType>;
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  autoUsageDetails?: Resolver<Maybe<ResolversTypes['AutoUsageDetails']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  freeTrialExpiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  headerInfoPdf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isStudent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSubscribed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTeamsCustomer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  logoContentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoFileLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoStorageObjectName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<ResolversTypes['GenericScalar']>, ParentType, ContextType>;
  shouldHidePresetTemplates?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shouldUseSimpleAppearancePdf?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  signUpCoupon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AccountDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountDetails'] = ResolversParentTypes['AccountDetails']> = {
  billingFrequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardBrand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardExpiryDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardholderAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardholderName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isCanceled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCanceledFinal?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOnFreeTrial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nextBillingDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nextInvoiceInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type AddFeedbackToCustomizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddFeedbackToCustomization'] = ResolversParentTypes['AddFeedbackToCustomization']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AddFeedbackToLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddFeedbackToLog'] = ResolversParentTypes['AddFeedbackToLog']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AddMphCompanionMembersResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddMphCompanionMembers'] = ResolversParentTypes['AddMphCompanionMembers']> = {
  added?: Resolver<Array<ResolversTypes['AdminMphCompanionMember']>, ParentType, ContextType>;
  skipped?: Resolver<Array<ResolversTypes['AddMphCompanionSkipped']>, ParentType, ContextType>;
};

export type AddMphCompanionSkippedResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddMphCompanionSkipped'] = ResolversParentTypes['AddMphCompanionSkipped']> = {
  reason?: Resolver<ResolversTypes['AddMphCompanionSkipReason'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AddNoteToGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddNoteToGroup'] = ResolversParentTypes['AddNoteToGroup']> = {
  noteGroup?: Resolver<Maybe<ResolversTypes['NoteGroup']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type AddOrgAdminResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddOrgAdmin'] = ResolversParentTypes['AddOrgAdmin']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type AddUsersToTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddUsersToTeam'] = ResolversParentTypes['AddUsersToTeam']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  provisionedUsers?: Resolver<Maybe<ResolversTypes['ProvisionedUsers']>, ParentType, ContextType>;
};

export type AdminAccountInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAccountInfo'] = ResolversParentTypes['AdminAccountInfo']> = {
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  freeTrialExpiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isTeamsCustomer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminAccountTypeCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAccountTypeCount'] = ResolversParentTypes['AdminAccountTypeCount']> = {
  accountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminAgentSessionDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAgentSessionDetail'] = ResolversParentTypes['AdminAgentSessionDetail']> = {
  attachments?: Resolver<Array<ResolversTypes['Attachment']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  effort?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<ResolversTypes['AgentSessionEventsPage'], ParentType, ContextType>;
  managedAgentEnv?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  managedAgentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  managedAgentVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  managedSessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  modelName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokens?: Resolver<ResolversTypes['AdminAgentSessionTokens'], ParentType, ContextType>;
  totalTreatsUsed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  treatsBreakdown?: Resolver<Array<ResolversTypes['AdminAgentSessionTreatLine']>, ParentType, ContextType>;
  userEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminAgentSessionListItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAgentSessionListItem'] = ResolversParentTypes['AdminAgentSessionListItem']> = {
  attachmentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  inputTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  modelName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outputTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  treatsUsed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminAgentSessionListResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAgentSessionListResult'] = ResolversParentTypes['AdminAgentSessionListResult']> = {
  account?: Resolver<Maybe<ResolversTypes['AdminAccountInfo']>, ParentType, ContextType>;
  sessions?: Resolver<Array<ResolversTypes['AdminAgentSessionListItem']>, ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['AdminAgentSessionTotals'], ParentType, ContextType>;
  treats?: Resolver<Maybe<ResolversTypes['AdminTreatInfo']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['AdminUserInfo']>, ParentType, ContextType>;
};

export type AdminAgentSessionTokensResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAgentSessionTokens'] = ResolversParentTypes['AdminAgentSessionTokens']> = {
  cacheCreation?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cacheRead?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  input?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  output?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminAgentSessionTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAgentSessionTotals'] = ResolversParentTypes['AdminAgentSessionTotals']> = {
  attachmentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cacheCreationTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cacheReadTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inputTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  outputTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sessionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transactionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  treatsUsed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminAgentSessionTreatLineResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAgentSessionTreatLine'] = ResolversParentTypes['AdminAgentSessionTreatLine']> = {
  cacheCreationTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cacheReadTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  companionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inputTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  modelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outputTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transactionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  treatsUsed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminBillingCustomerRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminBillingCustomerRow'] = ResolversParentTypes['AdminBillingCustomerRow']> = {
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripeCustomerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminBillingCustomerSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminBillingCustomerSearchResult'] = ResolversParentTypes['AdminBillingCustomerSearchResult']> = {
  customers?: Resolver<Array<ResolversTypes['AdminBillingCustomerRow']>, ParentType, ContextType>;
};

export type AdminBulkDeleteAppliedResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminBulkDeleteApplied'] = ResolversParentTypes['AdminBulkDeleteApplied']> = {
  flagSet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  flagWasSet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isMphOrgAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rowNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  wasDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type AdminBulkDeleteRejectedResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminBulkDeleteRejected'] = ResolversParentTypes['AdminBulkDeleteRejected']> = {
  reason?: Resolver<ResolversTypes['MphBulkDeleteRejectReason'], ParentType, ContextType>;
  rowNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminBulkMarkUsersForDeletionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminBulkMarkUsersForDeletion'] = ResolversParentTypes['AdminBulkMarkUsersForDeletion']> = {
  applied?: Resolver<Array<ResolversTypes['AdminBulkDeleteApplied']>, ParentType, ContextType>;
  dryRun?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rejected?: Resolver<Array<ResolversTypes['AdminBulkDeleteRejected']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type AdminBulkTeamRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminBulkTeamRef'] = ResolversParentTypes['AdminBulkTeamRef']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminCashOutResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminCashOut'] = ResolversParentTypes['AdminCashOut']> = {
  amountCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  errorFromTremendous?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CreditRedemptionStatus'], ParentType, ContextType>;
  tremendousOrderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminCashOutsPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminCashOutsPage'] = ResolversParentTypes['AdminCashOutsPage']> = {
  cashOuts?: Resolver<Array<ResolversTypes['AdminCashOut']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminDeleteTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminDeleteTeam'] = ResolversParentTypes['AdminDeleteTeam']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminDeleteVerifiedPhoneNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminDeleteVerifiedPhoneNumber'] = ResolversParentTypes['AdminDeleteVerifiedPhoneNumber']> = {
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type AdminEditAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEditAccount'] = ResolversParentTypes['AdminEditAccount']> = {
  account?: Resolver<Maybe<ResolversTypes['AdminAccountInfo']>, ParentType, ContextType>;
};

export type AdminEditOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEditOrganization'] = ResolversParentTypes['AdminEditOrganization']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminEditOrganizationEmailSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEditOrganizationEmailSettings'] = ResolversParentTypes['AdminEditOrganizationEmailSettings']> = {
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  settings?: Resolver<Array<ResolversTypes['AdminOrganizationEmailSetting']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminEditOrganizationRecordingConsentResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEditOrganizationRecordingConsent'] = ResolversParentTypes['AdminEditOrganizationRecordingConsent']> = {
  consentHeader?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consentText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consentTextVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  requiresRecordingConsent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminEditTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEditTeam'] = ResolversParentTypes['AdminEditTeam']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminEditTeamMemberResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEditTeamMember'] = ResolversParentTypes['AdminEditTeamMember']> = {
  crossesBillableBoundary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roleId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  teamActiveAdminCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  teamAdminCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminEditUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEditUser'] = ResolversParentTypes['AdminEditUser']> = {
  user?: Resolver<Maybe<ResolversTypes['AdminUserInfo']>, ParentType, ContextType>;
};

export type AdminGiveTreatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminGiveTreats'] = ResolversParentTypes['AdminGiveTreats']> = {
  monthlyBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  permanentBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type AdminLinkedOrgResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminLinkedOrg'] = ResolversParentTypes['AdminLinkedOrg']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminMemberRemovalBillingCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMemberRemovalBillingCheck'] = ResolversParentTypes['AdminMemberRemovalBillingCheck']> = {
  downgradesAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  freesABilledSeat?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastTeamInOrg?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  onOrgStripeCustomer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  orgStripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminMemberRemovalImpactResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMemberRemovalImpact'] = ResolversParentTypes['AdminMemberRemovalImpact']> = {
  companionSessionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  noteCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sharedPhoneNumbers?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminMemberRemovalPreflightResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMemberRemovalPreflight'] = ResolversParentTypes['AdminMemberRemovalPreflight']> = {
  billingCheck?: Resolver<Maybe<ResolversTypes['AdminMemberRemovalBillingCheck']>, ParentType, ContextType>;
  impact?: Resolver<ResolversTypes['AdminMemberRemovalImpact'], ParentType, ContextType>;
  isTeamOwner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type AdminMembershipOrgGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMembershipOrgGroup'] = ResolversParentTypes['AdminMembershipOrgGroup']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teams?: Resolver<Array<ResolversTypes['AdminMembershipTeam']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminMembershipTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMembershipTeam'] = ResolversParentTypes['AdminMembershipTeam']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminMoveTeamToOrgResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMoveTeamToOrg'] = ResolversParentTypes['AdminMoveTeamToOrg']> = {
  moveCheck?: Resolver<ResolversTypes['AdminTeamMoveCheck'], ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  org?: Resolver<ResolversTypes['AdminOrganizationInfo'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminMphBulkAssignTeamRolesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMphBulkAssignTeamRoles'] = ResolversParentTypes['AdminMphBulkAssignTeamRoles']> = {
  applied?: Resolver<Array<ResolversTypes['AdminMphBulkRoleApplied']>, ParentType, ContextType>;
  dryRun?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rejected?: Resolver<Array<ResolversTypes['AdminMphBulkRoleRejected']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type AdminMphBulkReassignAppliedResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMphBulkReassignApplied'] = ResolversParentTypes['AdminMphBulkReassignApplied']> = {
  carriedTeamDefaults?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  lostOrgAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lostTeamAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  notesMoved?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  removedTeams?: Resolver<Array<ResolversTypes['AdminBulkTeamRef']>, ParentType, ContextType>;
  roleUnset?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rowNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  team?: Resolver<ResolversTypes['AdminBulkTeamRef'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminMphBulkReassignRejectedResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMphBulkReassignRejected'] = ResolversParentTypes['AdminMphBulkReassignRejected']> = {
  candidates?: Resolver<Array<ResolversTypes['AdminBulkTeamRef']>, ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['MphBulkReassignRejectReason'], ParentType, ContextType>;
  rowNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  teamName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminMphBulkReassignTeamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMphBulkReassignTeams'] = ResolversParentTypes['AdminMphBulkReassignTeams']> = {
  applied?: Resolver<Array<ResolversTypes['AdminMphBulkReassignApplied']>, ParentType, ContextType>;
  dryRun?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rejected?: Resolver<Array<ResolversTypes['AdminMphBulkReassignRejected']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type AdminMphBulkRoleAppliedResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMphBulkRoleApplied'] = ResolversParentTypes['AdminMphBulkRoleApplied']> = {
  changed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  previousRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  team?: Resolver<ResolversTypes['AdminBulkTeamRef'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminMphBulkRoleRejectedResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMphBulkRoleRejected'] = ResolversParentTypes['AdminMphBulkRoleRejected']> = {
  candidates?: Resolver<Array<ResolversTypes['AdminBulkTeamRef']>, ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['MphBulkRoleRejectReason'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  teamName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminMphCompanionMemberResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMphCompanionMember'] = ResolversParentTypes['AdminMphCompanionMember']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  found?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teams?: Resolver<Array<ResolversTypes['AdminMphCompanionTeam']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminMphCompanionMembersResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMphCompanionMembersResult'] = ResolversParentTypes['AdminMphCompanionMembersResult']> = {
  items?: Resolver<Array<ResolversTypes['AdminMphCompanionMember']>, ParentType, ContextType>;
  requiresTrackingTicket?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  segment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  segmentUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminMphCompanionTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminMphCompanionTeam'] = ResolversParentTypes['AdminMphCompanionTeam']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminNoteDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminNoteDetail'] = ResolversParentTypes['AdminNoteDetail']> = {
  audioUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  audioUrlError?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  dentalChartStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasDentalChart?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  inboxLocation?: Resolver<Maybe<ResolversTypes['InboxLocation']>, ParentType, ContextType>;
  isScribephone?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTyped?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  jobType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  ownerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordingLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teamName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateOwnerUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeToProcess?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transcription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['AdminUserInfo']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminNoteFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminNoteFields'] = ResolversParentTypes['AdminNoteFields']> = {
  __resolveType: TypeResolveFn<'AdminNoteDetail' | 'AdminNoteRow', ParentType, ContextType>;
};

export type AdminNoteRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminNoteRow'] = ResolversParentTypes['AdminNoteRow']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  dentalChartStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasDentalChart?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  inboxLocation?: Resolver<Maybe<ResolversTypes['InboxLocation']>, ParentType, ContextType>;
  isScribephone?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTyped?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  jobType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  ownerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordingLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teamName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateOwnerUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeToProcess?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminNoteTemplateOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminNoteTemplateOption'] = ResolversParentTypes['AdminNoteTemplateOption']> = {
  jobType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminNotesPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminNotesPage'] = ResolversParentTypes['AdminNotesPage']> = {
  notes?: Resolver<Array<ResolversTypes['AdminNoteRow']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminOrgEmailTemplatePreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminOrgEmailTemplatePreview'] = ResolversParentTypes['AdminOrgEmailTemplatePreview']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  emailKey?: Resolver<ResolversTypes['AdminOrgEmailKey'], ParentType, ContextType>;
  htmlBody?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholders?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  templateAlias?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  templateName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  textBody?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unsupportedPlaceholders?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminOrganizationAdminResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminOrganizationAdmin'] = ResolversParentTypes['AdminOrganizationAdmin']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminOrganizationBillingResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminOrganizationBilling'] = ResolversParentTypes['AdminOrganizationBilling']> = {
  billableCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  billingBasis?: Resolver<Maybe<ResolversTypes['OrgBillingBasis']>, ParentType, ContextType>;
  combinedBillableCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mixedBillingBases?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  organizations?: Resolver<Array<ResolversTypes['OrgBillingShare']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OrgBillingStatus'], ParentType, ContextType>;
  stripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type AdminOrganizationDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminOrganizationDetail'] = ResolversParentTypes['AdminOrganizationDetail']> = {
  admins?: Resolver<Array<ResolversTypes['AdminOrganizationAdmin']>, ParentType, ContextType>;
  billingModeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  billingModeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consentHeader?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consentText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consentTextVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  defaultConsentHeader?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultConsentText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultConsentTextVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailDomain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailDomainSecondary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailDomainTertiary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailSettings?: Resolver<Array<ResolversTypes['AdminOrganizationEmailSetting']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outboundEmailOverridesEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  requiresRecordingConsent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  stripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teams?: Resolver<ResolversTypes['AdminOrganizationTeamsPage'], ParentType, ContextType, RequireFields<AdminOrganizationDetailTeamsArgs, 'limit' | 'offset'>>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminOrganizationEmailSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminOrganizationEmailSetting'] = ResolversParentTypes['AdminOrganizationEmailSetting']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customisable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  defaultTemplateAlias?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  effectiveTemplateAlias?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailKey?: Resolver<ResolversTypes['AdminOrgEmailKey'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  templateAlias?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminOrganizationInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminOrganizationInfo'] = ResolversParentTypes['AdminOrganizationInfo']> = {
  billingModeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  billingModeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminOrganizationMemberResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminOrganizationMember'] = ResolversParentTypes['AdminOrganizationMember']> = {
  adminOfOrganization?: Resolver<Maybe<ResolversTypes['AdminOrganizationSummary']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teams?: Resolver<Array<ResolversTypes['AdminOrganizationMemberTeam']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminOrganizationMemberTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminOrganizationMemberTeam'] = ResolversParentTypes['AdminOrganizationMemberTeam']> = {
  isTeamAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminOrganizationMembersPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminOrganizationMembersPage'] = ResolversParentTypes['AdminOrganizationMembersPage']> = {
  members?: Resolver<Array<ResolversTypes['AdminOrganizationMember']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminOrganizationSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminOrganizationSummary'] = ResolversParentTypes['AdminOrganizationSummary']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminOrganizationTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminOrganizationTeam'] = ResolversParentTypes['AdminOrganizationTeam']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  memberCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminOrganizationTeamsPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminOrganizationTeamsPage'] = ResolversParentTypes['AdminOrganizationTeamsPage']> = {
  teams?: Resolver<Array<ResolversTypes['AdminOrganizationTeam']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminOrganizationsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminOrganizationsList'] = ResolversParentTypes['AdminOrganizationsList']> = {
  organizations?: Resolver<Array<ResolversTypes['AdminOrganizationSummary']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminReferralInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminReferralInfo'] = ResolversParentTypes['AdminReferralInfo']> = {
  canRedeem?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  creditsBalanceCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  minRedemptionAmountCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numCashOuts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numPaidReferrals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numReferredSignups?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referrerEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referrerUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCreditsEarnedCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCreditsRedeemedCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminReferredUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminReferredUser'] = ResolversParentTypes['AdminReferredUser']> = {
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditsEarnedCents?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  signedUpAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  upgradedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminReferredUsersPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminReferredUsersPage'] = ResolversParentTypes['AdminReferredUsersPage']> = {
  allTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['AdminReferredUser']>, ParentType, ContextType>;
};

export type AdminRemoveTeamMemberResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRemoveTeamMember'] = ResolversParentTypes['AdminRemoveTeamMember']> = {
  membershipId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  teamActiveAdminCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  teamAdminCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminResendInvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminResendInvitation'] = ResolversParentTypes['AdminResendInvitation']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type AdminRevokeInvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRevokeInvitation'] = ResolversParentTypes['AdminRevokeInvitation']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type AdminRevokeOrganizationStripeCustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRevokeOrganizationStripeCustomer'] = ResolversParentTypes['AdminRevokeOrganizationStripeCustomer']> = {
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  stripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminRoleOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRoleOption'] = ResolversParentTypes['AdminRoleOption']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isBillable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminSetOrganizationAdminResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminSetOrganizationAdmin'] = ResolversParentTypes['AdminSetOrganizationAdmin']> = {
  admins?: Resolver<Array<ResolversTypes['AdminOrganizationAdmin']>, ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminStripeCustomerLinkageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminStripeCustomerLinkage'] = ResolversParentTypes['AdminStripeCustomerLinkage']> = {
  accountTypeBreakdown?: Resolver<Array<ResolversTypes['AdminAccountTypeCount']>, ParentType, ContextType>;
  accountsOnCustomer?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  organizations?: Resolver<Array<ResolversTypes['AdminLinkedOrg']>, ParentType, ContextType>;
  sampleUserEmails?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  stripeCustomerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminTeamDeletionCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminTeamDeletionCheck'] = ResolversParentTypes['AdminTeamDeletionCheck']> = {
  blockerSummary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canDelete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  memberCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  noteCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminTeamDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminTeamDetail'] = ResolversParentTypes['AdminTeamDetail']> = {
  activeAdminCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  adminCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deletionCheck?: Resolver<ResolversTypes['AdminTeamDeletionCheck'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  memberRemovalPreflight?: Resolver<Maybe<ResolversTypes['AdminMemberRemovalPreflight']>, ParentType, ContextType, RequireFields<AdminTeamDetailMemberRemovalPreflightArgs, 'userUuid'>>;
  members?: Resolver<ResolversTypes['AdminTeamMembersPage'], ParentType, ContextType, RequireFields<AdminTeamDetailMembersArgs, 'limit' | 'offset'>>;
  moveCheck?: Resolver<Maybe<ResolversTypes['AdminTeamMoveCheck']>, ParentType, ContextType, RequireFields<AdminTeamDetailMoveCheckArgs, 'targetOrgUuid'>>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  org?: Resolver<Maybe<ResolversTypes['AdminOrganizationInfo']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminTeamMemberResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminTeamMember'] = ResolversParentTypes['AdminTeamMember']> = {
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  freeTrialExpiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastActiveAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  membershipId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  otherTeamCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roleId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userCreatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminTeamMembersPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminTeamMembersPage'] = ResolversParentTypes['AdminTeamMembersPage']> = {
  members?: Resolver<Array<ResolversTypes['AdminTeamMember']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminTeamMoveCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminTeamMoveCheck'] = ResolversParentTypes['AdminTeamMoveCheck']> = {
  billingModeChanges?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  blockerCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canMove?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  clashingTeam?: Resolver<Maybe<ResolversTypes['AdminTeamSummary']>, ParentType, ContextType>;
  membersOnSourceCustomer?: Resolver<Array<ResolversTypes['AdminTeamMember']>, ParentType, ContextType>;
  sameStripeCustomer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceOrg?: Resolver<Maybe<ResolversTypes['AdminOrganizationInfo']>, ParentType, ContextType>;
  sourceOrgRequiresRecordingConsent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ssoMemberCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  targetOrg?: Resolver<ResolversTypes['AdminOrganizationInfo'], ParentType, ContextType>;
};

export type AdminTeamSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminTeamSummary'] = ResolversParentTypes['AdminTeamSummary']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminTeamsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminTeamsList'] = ResolversParentTypes['AdminTeamsList']> = {
  teams?: Resolver<Array<ResolversTypes['AdminTeamSummary']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminTemplateDefaultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminTemplateDefault'] = ResolversParentTypes['AdminTemplateDefault']> = {
  kind?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminTemplateDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminTemplateDetail'] = ResolversParentTypes['AdminTemplateDetail']> = {
  fields?: Resolver<Array<ResolversTypes['AdminTemplateField']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userPreferences?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminTemplateFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminTemplateField'] = ResolversParentTypes['AdminTemplateField']> = {
  fieldIdx?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  fieldName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fieldValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminTreatBalanceInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminTreatBalanceInfo'] = ResolversParentTypes['AdminTreatBalanceInfo']> = {
  monthlyBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nextResetAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  permanentBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  plan?: Resolver<Maybe<ResolversTypes['AdminTreatPlan']>, ParentType, ContextType>;
  totalBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type AdminTreatInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminTreatInfo'] = ResolversParentTypes['AdminTreatInfo']> = {
  balance?: Resolver<Maybe<ResolversTypes['AdminTreatBalanceInfo']>, ParentType, ContextType>;
};

export type AdminTreatPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminTreatPlan'] = ResolversParentTypes['AdminTreatPlan']> = {
  activeUntil?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  monthlyTreats?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  planKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminUnwireAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUnwireAccount'] = ResolversParentTypes['AdminUnwireAccount']> = {
  account?: Resolver<Maybe<ResolversTypes['AdminAccountInfo']>, ParentType, ContextType>;
};

export type AdminUpdateOrganizationStripeCustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUpdateOrganizationStripeCustomer'] = ResolversParentTypes['AdminUpdateOrganizationStripeCustomer']> = {
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  stripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  warnings?: Resolver<Array<ResolversTypes['OrgStripeWarning']>, ParentType, ContextType>;
};

export type AdminUserCountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUserCounts'] = ResolversParentTypes['AdminUserCounts']> = {
  notes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  templates?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminUserInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUserInfo'] = ResolversParentTypes['AdminUserInfo']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastActive?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastLoggedInAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminUserListItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUserListItem'] = ResolversParentTypes['AdminUserListItem']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastActive?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastLoggedInAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  organizations?: Resolver<Array<ResolversTypes['AdminUserOrg']>, ParentType, ContextType>;
  stripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verifiedPhoneCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminUserListResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUserListResult'] = ResolversParentTypes['AdminUserListResult']> = {
  items?: Resolver<Array<ResolversTypes['AdminUserListItem']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminUserLookupResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUserLookupResult'] = ResolversParentTypes['AdminUserLookupResult']> = {
  account?: Resolver<Maybe<ResolversTypes['AdminAccountInfo']>, ParentType, ContextType>;
  counts?: Resolver<Maybe<ResolversTypes['AdminUserCounts']>, ParentType, ContextType>;
  referral?: Resolver<Maybe<ResolversTypes['AdminReferralInfo']>, ParentType, ContextType>;
  treats?: Resolver<Maybe<ResolversTypes['AdminTreatInfo']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['AdminUserInfo']>, ParentType, ContextType>;
};

export type AdminUserMembershipResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUserMembershipResult'] = ResolversParentTypes['AdminUserMembershipResult']> = {
  orgs?: Resolver<Array<ResolversTypes['AdminMembershipOrgGroup']>, ParentType, ContextType>;
};

export type AdminUserOrgResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUserOrg'] = ResolversParentTypes['AdminUserOrg']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teams?: Resolver<Array<ResolversTypes['AdminUserTeam']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminUserTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUserTeam'] = ResolversParentTypes['AdminUserTeam']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminUserTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUserTemplate'] = ResolversParentTypes['AdminUserTemplate']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  defaultFor?: Resolver<Array<ResolversTypes['AdminTemplateDefault']>, ParentType, ContextType>;
  dentalChart?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  emailShareCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isFavourite?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  noteCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sharedWithTeams?: Resolver<Array<ResolversTypes['AdminUserTeam']>, ParentType, ContextType>;
  sharingType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  templateType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminUserTemplatesPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUserTemplatesPage'] = ResolversParentTypes['AdminUserTemplatesPage']> = {
  templates?: Resolver<Array<ResolversTypes['AdminUserTemplate']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminVerifiedPhoneLookupResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminVerifiedPhoneLookupResult'] = ResolversParentTypes['AdminVerifiedPhoneLookupResult']> = {
  verifications?: Resolver<Array<ResolversTypes['AdminVerifiedPhoneVerification']>, ParentType, ContextType>;
};

export type AdminVerifiedPhoneVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminVerifiedPhoneVerification'] = ResolversParentTypes['AdminVerifiedPhoneVerification']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  extension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['AdminVerifiedPhoneVerifierTeam']>, ParentType, ContextType>;
  twilioVerificationApprovedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  twilioVerificationStatus?: Resolver<Maybe<ResolversTypes['TwilioVerificationStatus']>, ParentType, ContextType>;
  twilioVerificationSubmittedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['AdminVerifiedPhoneVerifierUser']>, ParentType, ContextType>;
  verifiedPhoneNumberUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminVerifiedPhoneVerifierTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminVerifiedPhoneVerifierTeam'] = ResolversParentTypes['AdminVerifiedPhoneVerifierTeam']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminVerifiedPhoneVerifierUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminVerifiedPhoneVerifierUser'] = ResolversParentTypes['AdminVerifiedPhoneVerifierUser']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminWireUpAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminWireUpAccount'] = ResolversParentTypes['AdminWireUpAccount']> = {
  account?: Resolver<Maybe<ResolversTypes['AdminAccountInfo']>, ParentType, ContextType>;
  warnings?: Resolver<Array<ResolversTypes['WireUpWarning']>, ParentType, ContextType>;
};

export type AgentSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentSession'] = ResolversParentTypes['AgentSession']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  effort?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  managedAgentEnv?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  managedAgentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  managedAgentVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  managedSessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
};

export type AgentSessionEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentSessionEvent'] = ResolversParentTypes['AgentSessionEvent']> = {
  attachments?: Resolver<Array<ResolversTypes['Attachment']>, ParentType, ContextType>;
  companionsUsed?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['GenericScalar']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AgentSessionEventsPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentSessionEventsPage'] = ResolversParentTypes['AgentSessionEventsPage']> = {
  events?: Resolver<Array<ResolversTypes['AgentSessionEvent']>, ParentType, ContextType>;
  nextPage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pendingPermissions?: Resolver<Array<ResolversTypes['CompanionToolPermissionRequest']>, ParentType, ContextType>;
  turnInFlight?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type AgentToolPermissionGrantResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentToolPermissionGrant'] = ResolversParentTypes['AgentToolPermissionGrant']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastUsedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  policyVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toolAction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toolName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
};

export type AllowedRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllowedRole'] = ResolversParentTypes['AllowedRole']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AppendRecordingResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppendRecording'] = ResolversParentTypes['AppendRecording']> = {
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AssociateQuicknotesWithPatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssociateQuicknotesWithPatient'] = ResolversParentTypes['AssociateQuicknotesWithPatient']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Attachment'] = ResolversParentTypes['Attachment']> = {
  agentSession?: Resolver<Maybe<ResolversTypes['AgentSession']>, ParentType, ContextType>;
  agentSessionUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companionSession?: Resolver<Maybe<ResolversTypes['CompanionSession']>, ParentType, ContextType>;
  companionSessionUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  extractedData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  managedFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  noteId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  patientId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sentInEventId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storageObjectName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AuditLogEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditLogEntry'] = ResolversParentTypes['AuditLogEntry']> = {
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actorEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actorUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adminPortalRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['GenericScalar']>, ParentType, ContextType>;
  deviceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ipAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userAgent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AuditLogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditLogResult'] = ResolversParentTypes['AuditLogResult']> = {
  entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['AuditLogEntry']>>>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type AuditTrailResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditTrail'] = ResolversParentTypes['AuditTrail']> = {
  auditLogType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  fileLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  patientUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  revisionNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  storageObjectName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AutoTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoTemplate'] = ResolversParentTypes['AutoTemplate']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  dentalChart?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['AutoTemplateField']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isFavourite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Note']>>>, ParentType, ContextType>;
  pdfStorageObjectName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sharedEmails?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  sharingType?: Resolver<ResolversTypes['SharingTypeEnum'], ParentType, ContextType>;
  teamDefaults?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  templatePreviews?: Resolver<Maybe<Array<Maybe<ResolversTypes['TemplatePreviews']>>>, ParentType, ContextType>;
  templateType?: Resolver<ResolversTypes['TemplateTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userPreferences?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AutoTemplateFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoTemplateField'] = ResolversParentTypes['AutoTemplateField']> = {
  autoTemplate?: Resolver<Maybe<ResolversTypes['AutoTemplate']>, ParentType, ContextType>;
  fieldIdx?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  fieldName?: Resolver<ResolversTypes['FieldNameEnum'], ParentType, ContextType>;
  fieldValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  templateId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AutoUsageDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoUsageDetails'] = ResolversParentTypes['AutoUsageDetails']> = {
  isActiveAutoUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  monthlyTotalPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  monthlyUsageCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type BirthdayPartsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BirthdayParts'] = ResolversParentTypes['BirthdayParts']> = {
  dd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mm?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yyyy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type BulkRestoreSkippedResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkRestoreSkipped'] = ResolversParentTypes['BulkRestoreSkipped']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['BulkRestoreSkipReason'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type BulkRestoreUsersResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkRestoreUsers'] = ResolversParentTypes['BulkRestoreUsers']> = {
  restoredUuids?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  skipped?: Resolver<Array<ResolversTypes['BulkRestoreSkipped']>, ParentType, ContextType>;
};

export type BulkSetExpiryPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkSetExpiryPolicy'] = ResolversParentTypes['BulkSetExpiryPolicy']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type BulkSetRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkSetRole'] = ResolversParentTypes['BulkSetRole']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CancelBroadcastNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelBroadcastNotification'] = ResolversParentTypes['CancelBroadcastNotification']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type CancelNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelNotification'] = ResolversParentTypes['CancelNotification']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ChangeScribephoneConsentModeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangeScribephoneConsentMode'] = ResolversParentTypes['ChangeScribephoneConsentMode']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type CheckinNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckinNote'] = ResolversParentTypes['CheckinNote']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CheckoutNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutNote'] = ResolversParentTypes['CheckoutNote']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
};

export type ClientSummaryPreferencesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientSummaryPreferences'] = ResolversParentTypes['ClientSummaryPreferences']> = {
  abnormalPhysicalFindings?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allFindings?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  backmatter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  diagnostics?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  diet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  followUpAppointments?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  frontmatter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  homeCare?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  medications?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  oneLineSummary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ownerInstructions?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pointFormSummary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  vaccinations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  visitSummary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  vitals?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ClientSummaryPreferencesTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientSummaryPreferencesType'] = ResolversParentTypes['ClientSummaryPreferencesType']> = {
  abnormalPhysicalFindings?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allFindings?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  backmatter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  diagnostics?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  diet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  followUpAppointments?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  frontmatter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  homeCare?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  medications?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  oneLineSummary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ownerInstructions?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pointFormSummary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  vaccinations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  visitSummary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  vitals?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type CloseCompanionSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloseCompanionSession'] = ResolversParentTypes['CloseCompanionSession']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type CompanionAccountSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionAccountSettings'] = ResolversParentTypes['CompanionAccountSettings']> = {
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  freeTrialExpiresAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isTeamsCustomer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<ResolversTypes['GenericScalar']>, ParentType, ContextType>;
};

export type CompanionContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionContext'] = ResolversParentTypes['CompanionContext']> = {
  settings?: Resolver<Maybe<ResolversTypes['CompanionContextSettings']>, ParentType, ContextType>;
  teams?: Resolver<Maybe<Array<Maybe<ResolversTypes['CompanionContextTeam']>>>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['CompanionContextUser']>, ParentType, ContextType>;
};

export type CompanionContextSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionContextSettings'] = ResolversParentTypes['CompanionContextSettings']> = {
  account?: Resolver<Maybe<ResolversTypes['CompanionAccountSettings']>, ParentType, ContextType>;
  organizations?: Resolver<Maybe<Array<Maybe<ResolversTypes['CompanionOrganizationSettings']>>>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['CompanionUserSettings']>, ParentType, ContextType>;
};

export type CompanionContextTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionContextTeam'] = ResolversParentTypes['CompanionContextTeam']> = {
  isAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  memberCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CompanionContextUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionContextUser'] = ResolversParentTypes['CompanionContextUser']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CompanionOrganizationSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionOrganizationSettings'] = ResolversParentTypes['CompanionOrganizationSettings']> = {
  globalScribephoneConsentMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CompanionSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionSession'] = ResolversParentTypes['CompanionSession']> = {
  agentVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attachments?: Resolver<Array<ResolversTypes['Attachment']>, ParentType, ContextType>;
  companionSessionUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companionsUsed?: Resolver<Array<ResolversTypes['CompanionTypeEnum']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  estimates?: Resolver<Array<ResolversTypes['CompanionSessionEstimate']>, ParentType, ContextType>;
  inventory?: Resolver<Maybe<ResolversTypes['Inventory']>, ParentType, ContextType>;
  inventoryUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  knowledge?: Resolver<Array<ResolversTypes['CompanionSessionKnowledge']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['CompanionSessionMessage']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  sessionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusSummary?: Resolver<ResolversTypes['CompanionSessionStatusSummary'], ParentType, ContextType>;
  statusText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tasks?: Resolver<Array<ResolversTypes['CompanionSessionTask']>, ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
};

export type CompanionSessionEstimateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionSessionEstimate'] = ResolversParentTypes['CompanionSessionEstimate']> = {
  companionSession?: Resolver<Maybe<ResolversTypes['CompanionSession']>, ParentType, ContextType>;
  companionSessionEstimateUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companionSessionUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['CompanionSessionEstimateItem']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
};

export type CompanionSessionEstimateItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionSessionEstimateItem'] = ResolversParentTypes['CompanionSessionEstimateItem']> = {
  choices?: Resolver<Array<ResolversTypes['CompanionSessionEstimateItemChoice']>, ParentType, ContextType>;
  companionSessionEstimate?: Resolver<Maybe<ResolversTypes['CompanionSessionEstimate']>, ParentType, ContextType>;
  companionSessionEstimateItemUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companionSessionEstimateUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type CompanionSessionEstimateItemChoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionSessionEstimateItemChoice'] = ResolversParentTypes['CompanionSessionEstimateItemChoice']> = {
  companionSessionEstimateItem?: Resolver<Maybe<ResolversTypes['CompanionSessionEstimateItem']>, ParentType, ContextType>;
  companionSessionEstimateItemUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inventoryItem?: Resolver<Maybe<ResolversTypes['InventoryItem']>, ParentType, ContextType>;
  inventoryItemUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isSelected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type CompanionSessionKnowledgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionSessionKnowledge'] = ResolversParentTypes['CompanionSessionKnowledge']> = {
  companionSession?: Resolver<Maybe<ResolversTypes['CompanionSession']>, ParentType, ContextType>;
  companionSessionUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  knowledgeKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  knowledgeValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CompanionSessionMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionSessionMessage'] = ResolversParentTypes['CompanionSessionMessage']> = {
  companionSession?: Resolver<Maybe<ResolversTypes['CompanionSession']>, ParentType, ContextType>;
  companionSessionMessageUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companionSessionUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companionType?: Resolver<Maybe<ResolversTypes['CompanionTypeEnum']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CompanionSessionMessageStatusEnum'], ParentType, ContextType>;
  textContent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CompanionSessionMessageStatusSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionSessionMessageStatusSummary'] = ResolversParentTypes['CompanionSessionMessageStatusSummary']> = {
  failed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  processing?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  succeeded?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type CompanionSessionStatusSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionSessionStatusSummary'] = ResolversParentTypes['CompanionSessionStatusSummary']> = {
  messages?: Resolver<ResolversTypes['CompanionSessionMessageStatusSummary'], ParentType, ContextType>;
  tasks?: Resolver<ResolversTypes['CompanionSessionTaskStatusSummary'], ParentType, ContextType>;
};

export type CompanionSessionTaskResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionSessionTask'] = ResolversParentTypes['CompanionSessionTask']> = {
  companionSession?: Resolver<Maybe<ResolversTypes['CompanionSession']>, ParentType, ContextType>;
  companionSessionTaskUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companionSessionUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CompanionSessionTaskStatusEnum'], ParentType, ContextType>;
  taskStepDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
};

export type CompanionSessionTaskStatusSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionSessionTaskStatusSummary'] = ResolversParentTypes['CompanionSessionTaskStatusSummary']> = {
  accepted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  failed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pending?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rejected?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  started?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  succeeded?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type CompanionSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionSubscription'] = ResolversParentTypes['CompanionSubscription']> = {
  activeUntil?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  monthlyTreats?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  planKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CompanionSubscriptionStatus'], ParentType, ContextType>;
};

export type CompanionToolPermissionDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionToolPermissionDetail'] = ResolversParentTypes['CompanionToolPermissionDetail']> = {
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CompanionToolPermissionRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionToolPermissionRequest'] = ResolversParentTypes['CompanionToolPermissionRequest']> = {
  agentSessionUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  canPersist?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  details?: Resolver<Array<ResolversTypes['CompanionToolPermissionDetail']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grantDisplayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  persistLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toolAction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toolKind?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toolName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CompanionUserSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanionUserSettings'] = ResolversParentTypes['CompanionUserSettings']> = {
  onboardingClinic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onboardingMilestones?: Resolver<Maybe<ResolversTypes['GenericScalar']>, ParentType, ContextType>;
  pimsProvider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scribephoneConsentMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ConfirmUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfirmUser'] = ResolversParentTypes['ConfirmUser']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CopyAutoTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CopyAutoTemplate'] = ResolversParentTypes['CopyAutoTemplate']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  templateUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CopyNotesToPatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['CopyNotesToPatient'] = ResolversParentTypes['CopyNotesToPatient']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CorrectPatientNameInNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['CorrectPatientNameInNote'] = ResolversParentTypes['CorrectPatientNameInNote']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  patientRecordStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replacedCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sectionsAffected?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
};

export type CreateAgentSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateAgentSession'] = ResolversParentTypes['CreateAgentSession']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
};

export type CreateAgentToolPermissionGrantResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateAgentToolPermissionGrant'] = ResolversParentTypes['CreateAgentToolPermissionGrant']> = {
  grant?: Resolver<Maybe<ResolversTypes['AgentToolPermissionGrant']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type CreateAutoTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateAutoTemplate'] = ResolversParentTypes['CreateAutoTemplate']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  templateUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CreateBroadcastNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateBroadcastNotification'] = ResolversParentTypes['CreateBroadcastNotification']> = {
  notification?: Resolver<Maybe<ResolversTypes['UserNotification']>, ParentType, ContextType>;
};

export type CreateCompanionSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateCompanionSession'] = ResolversParentTypes['CreateCompanionSession']> = {
  companionSessionUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type CreateCustomOrgResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateCustomOrg'] = ResolversParentTypes['CreateCustomOrg']> = {
  orgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type CreateGroupedNotesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateGroupedNotes'] = ResolversParentTypes['CreateGroupedNotes']> = {
  noteGroup?: Resolver<Maybe<ResolversTypes['NoteGroup']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type CreateNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateNote'] = ResolversParentTypes['CreateNote']> = {
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  successMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CreateOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOrganization'] = ResolversParentTypes['CreateOrganization']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType>;
};

export type CreatePatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatePatient'] = ResolversParentTypes['CreatePatient']> = {
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
};

export type CreatePatientNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatePatientNote'] = ResolversParentTypes['CreatePatientNote']> = {
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  successMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CreateQuickNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateQuickNote'] = ResolversParentTypes['CreateQuickNote']> = {
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  successMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CreateTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTeam'] = ResolversParentTypes['CreateTeam']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  teamUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CreateTeamUnderOrgResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTeamUnderOrg'] = ResolversParentTypes['CreateTeamUnderOrg']> = {
  orgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  teamId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type CreateTemplateGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTemplateGroup'] = ResolversParentTypes['CreateTemplateGroup']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  templateGroup?: Resolver<Maybe<ResolversTypes['TemplateGroup']>, ParentType, ContextType>;
};

export type CreateTemplatePreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTemplatePreview'] = ResolversParentTypes['CreateTemplatePreview']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type CreateTestUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTestUser'] = ResolversParentTypes['CreateTestUser']> = {
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CreateUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUser'] = ResolversParentTypes['CreateUser']> = {
  accessCsrf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accessJwt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasReferrer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isValidVlCode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  refreshJwt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['LoginUserResponse']>, ParentType, ContextType>;
};

export type CreateUserFromTeamInvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUserFromTeamInvitation'] = ResolversParentTypes['CreateUserFromTeamInvitation']> = {
  accessCsrf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValidVlCode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['LoginUserResponse']>, ParentType, ContextType>;
};

export type CreateV1TeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateV1Team'] = ResolversParentTypes['CreateV1Team']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>;
};

export type CustomFormFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomFormField'] = ResolversParentTypes['CustomFormField']> = {
  fieldType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  noteId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  textValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CustomObjectiveFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomObjectiveField'] = ResolversParentTypes['CustomObjectiveField']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  noteId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  symmetricalValueLeft?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  symmetricalValueRight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  symmetryLabels?: Resolver<Maybe<ResolversTypes['SymmetryLabel']>, ParentType, ContextType>;
  symmetryType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DeactivateOrgTeamUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateOrgTeamUser'] = ResolversParentTypes['DeactivateOrgTeamUser']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DeductAgentSessionTreatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeductAgentSessionTreats'] = ResolversParentTypes['DeductAgentSessionTreats']> = {
  deducted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  remainingBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type DeleteAgentSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteAgentSession'] = ResolversParentTypes['DeleteAgentSession']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DeleteAttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteAttachment'] = ResolversParentTypes['DeleteAttachment']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DeleteAutoTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteAutoTemplate'] = ResolversParentTypes['DeleteAutoTemplate']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DeleteCompanionSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteCompanionSession'] = ResolversParentTypes['DeleteCompanionSession']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DeleteHeaderImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteHeaderImage'] = ResolversParentTypes['DeleteHeaderImage']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DeleteNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteNote'] = ResolversParentTypes['DeleteNote']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DeleteNoteAudioRecordingResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteNoteAudioRecording'] = ResolversParentTypes['DeleteNoteAudioRecording']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DeleteNotesResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteNotes'] = ResolversParentTypes['DeleteNotes']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DeletePatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletePatient'] = ResolversParentTypes['DeletePatient']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DeleteTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteTeam'] = ResolversParentTypes['DeleteTeam']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DeleteTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteTemplate'] = ResolversParentTypes['DeleteTemplate']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DeleteTemplateGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteTemplateGroup'] = ResolversParentTypes['DeleteTemplateGroup']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DeleteUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteUser'] = ResolversParentTypes['DeleteUser']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DeleteVerifiedPhoneNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteVerifiedPhoneNumber'] = ResolversParentTypes['DeleteVerifiedPhoneNumber']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DenyTeamInvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DenyTeamInvitation'] = ResolversParentTypes['DenyTeamInvitation']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DescopeAdminPortalSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DescopeAdminPortalSession'] = ResolversParentTypes['DescopeAdminPortalSession']> = {
  accessCsrf?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accessJwt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  adminRole?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['LoginUserResponse'], ParentType, ContextType>;
};

export type DescopeMobileSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DescopeMobileSession'] = ResolversParentTypes['DescopeMobileSession']> = {
  accessJwt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refreshJwt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DescopeWebSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DescopeWebSession'] = ResolversParentTypes['DescopeWebSession']> = {
  accessCsrf?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['LoginUserResponse'], ParentType, ContextType>;
};

export type DetachNotesFromPatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['DetachNotesFromPatient'] = ResolversParentTypes['DetachNotesFromPatient']> = {
  affectedCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  affectedUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DismissNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DismissNotification'] = ResolversParentTypes['DismissNotification']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type DismissNotificationsByNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['DismissNotificationsByNote'] = ResolversParentTypes['DismissNotificationsByNote']> = {
  dismissedCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type EditAccountPreferencesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditAccountPreferences'] = ResolversParentTypes['EditAccountPreferences']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type EditClientSummaryPreferencesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditClientSummaryPreferences'] = ResolversParentTypes['EditClientSummaryPreferences']> = {
  clientSummaryPreferences?: Resolver<Maybe<ResolversTypes['ClientSummaryPreferencesType']>, ParentType, ContextType>;
};

export type EditObjectiveNormalDefaultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditObjectiveNormalDefaults'] = ResolversParentTypes['EditObjectiveNormalDefaults']> = {
  objectiveNormalDefaults?: Resolver<Maybe<ResolversTypes['ObjectiveNormalDefaults']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type EditPdfSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditPDFSettings'] = ResolversParentTypes['EditPDFSettings']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type EditPatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditPatient'] = ResolversParentTypes['EditPatient']> = {
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
};

export type EditTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditTemplate'] = ResolversParentTypes['EditTemplate']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  template?: Resolver<Maybe<ResolversTypes['Template']>, ParentType, ContextType>;
};

export type EditUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditUser'] = ResolversParentTypes['EditUser']> = {
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
};

export type ExistingAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExistingAccount'] = ResolversParentTypes['ExistingAccount']> = {
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSubscribed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ExistingTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExistingTeam'] = ResolversParentTypes['ExistingTeam']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ExistingUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExistingUser'] = ResolversParentTypes['ExistingUser']> = {
  account?: Resolver<Maybe<ResolversTypes['ExistingAccount']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teams?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExistingTeam']>>>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type FeatureActivationResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureActivation'] = ResolversParentTypes['FeatureActivation']> = {
  featureName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isActivated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type FlagNoteToSupportResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlagNoteToSupport'] = ResolversParentTypes['FlagNoteToSupport']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type GenerateAdaptiveClientSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateAdaptiveClientSummary'] = ResolversParentTypes['GenerateAdaptiveClientSummary']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type GenerateAgentSessionTitleResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateAgentSessionTitle'] = ResolversParentTypes['GenerateAgentSessionTitle']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type GenerateClientSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateClientSummary'] = ResolversParentTypes['GenerateClientSummary']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type GenerateClientSummaryNextResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateClientSummaryNext'] = ResolversParentTypes['GenerateClientSummaryNext']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type GenerateLlmCustomizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateLLMCustomization'] = ResolversParentTypes['GenerateLLMCustomization']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamingTaskUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export interface GenericScalarScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GenericScalar'], any> {
  name: 'GenericScalar';
}

export type GoogleAuthResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoogleAuthResponse'] = ResolversParentTypes['GoogleAuthResponse']> = {
  accessCsrf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type HardDeleteNotesResolvers<ContextType = any, ParentType extends ResolversParentTypes['HardDeleteNotes'] = ResolversParentTypes['HardDeleteNotes']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type HardDeleteUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['HardDeleteUser'] = ResolversParentTypes['HardDeleteUser']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type InboxNotesResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboxNotes'] = ResolversParentTypes['InboxNotes']> = {
  notes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Note']>>>, ParentType, ContextType>;
  totalNotes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type InboxTabCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboxTabCount'] = ResolversParentTypes['InboxTabCount']> = {
  numExportedItems?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numForExport?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numForReview?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numNowProcessing?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numSavedDrafts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type IncrementAutoUsageResolvers<ContextType = any, ParentType extends ResolversParentTypes['IncrementAutoUsage'] = ResolversParentTypes['IncrementAutoUsage']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type InitializeStreamResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitializeStream'] = ResolversParentTypes['InitializeStream']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type InventoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Inventory'] = ResolversParentTypes['Inventory']> = {
  companionSessions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CompanionSession']>>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  inventoryUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  search?: Resolver<Maybe<Array<Maybe<ResolversTypes['InventoryItem']>>>, ParentType, ContextType, RequireFields<InventorySearchArgs, 'query'>>;
  status?: Resolver<ResolversTypes['InventoryStatusEnum'], ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
};

export type InventoryItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryItem'] = ResolversParentTypes['InventoryItem']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dispensingFeeCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inventory?: Resolver<Maybe<ResolversTypes['Inventory']>, ParentType, ContextType>;
  inventoryItemUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inventoryUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priceCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  productCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type InviteUsersToTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteUsersToTeam'] = ResolversParentTypes['InviteUsersToTeam']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  provisionedUsers?: Resolver<Maybe<ResolversTypes['ProvisionedUsers']>, ParentType, ContextType>;
};

export interface JsonStringScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSONString'], any> {
  name: 'JSONString';
}

export type LinkRecordingConsentToNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkRecordingConsentToNote'] = ResolversParentTypes['LinkRecordingConsentToNote']> = {
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type LogRecordingConsentResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogRecordingConsent'] = ResolversParentTypes['LogRecordingConsent']> = {
  consentEventUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
};

export type LogScribephoneConsentResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogScribephoneConsent'] = ResolversParentTypes['LogScribephoneConsent']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type LoginUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginUser'] = ResolversParentTypes['LoginUser']> = {
  accessCsrf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accessJwt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refreshJwt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['LoginUserResponse']>, ParentType, ContextType>;
};

export type LoginUserAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginUserAccount'] = ResolversParentTypes['LoginUserAccount']> = {
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  freeTrialExpiresAt?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSubscribed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type LoginUserOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginUserOrganization'] = ResolversParentTypes['LoginUserOrganization']> = {
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type LoginUserResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginUserResponse'] = ResolversParentTypes['LoginUserResponse']> = {
  account?: Resolver<Maybe<ResolversTypes['LoginUserAccount']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isConfirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['LoginUserOrganization']>, ParentType, ContextType>;
  teams?: Resolver<Maybe<Array<Maybe<ResolversTypes['LoginUserTeam']>>>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type LoginUserTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginUserTeam'] = ResolversParentTypes['LoginUserTeam']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type LogoutUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogoutUser'] = ResolversParentTypes['LogoutUser']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type MarkAgentSessionAttachmentsSentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkAgentSessionAttachmentsSent'] = ResolversParentTypes['MarkAgentSessionAttachmentsSent']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type MarkAgentToolPermissionGrantUsedResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkAgentToolPermissionGrantUsed'] = ResolversParentTypes['MarkAgentToolPermissionGrantUsed']> = {
  grant?: Resolver<Maybe<ResolversTypes['AgentToolPermissionGrant']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type MarkNotificationReadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkNotificationRead'] = ResolversParentTypes['MarkNotificationRead']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type MarkUserForDeletionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkUserForDeletion'] = ResolversParentTypes['MarkUserForDeletion']> = {
  user?: Resolver<Maybe<ResolversTypes['AdminUserInfo']>, ParentType, ContextType>;
};

export type ModifiedUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModifiedUser'] = ResolversParentTypes['ModifiedUser']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inviteUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isExistingUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ModifyNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModifyNote'] = ResolversParentTypes['ModifyNote']> = {
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  successMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ModifyNotesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModifyNotes'] = ResolversParentTypes['ModifyNotes']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type MoveNotesToPatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoveNotesToPatient'] = ResolversParentTypes['MoveNotesToPatient']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type MutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutations'] = ResolversParentTypes['Mutations']> = {
  acceptLlmCustomization?: Resolver<Maybe<ResolversTypes['AcceptLLMCustomization']>, ParentType, ContextType, RequireFields<MutationsAcceptLlmCustomizationArgs, 'acceptLlmCustomizationInput'>>;
  acceptTeamInvitation?: Resolver<Maybe<ResolversTypes['AcceptTeamInvitation']>, ParentType, ContextType, Partial<MutationsAcceptTeamInvitationArgs>>;
  addFeedbackToCustomization?: Resolver<Maybe<ResolversTypes['AddFeedbackToCustomization']>, ParentType, ContextType, RequireFields<MutationsAddFeedbackToCustomizationArgs, 'addFeedbackInput'>>;
  addFeedbackToLog?: Resolver<Maybe<ResolversTypes['AddFeedbackToLog']>, ParentType, ContextType, Partial<MutationsAddFeedbackToLogArgs>>;
  addMphCompanionMembers?: Resolver<Maybe<ResolversTypes['AddMphCompanionMembers']>, ParentType, ContextType, RequireFields<MutationsAddMphCompanionMembersArgs, 'userUuids'>>;
  addNoteToGroup?: Resolver<Maybe<ResolversTypes['AddNoteToGroup']>, ParentType, ContextType, RequireFields<MutationsAddNoteToGroupArgs, 'noteUuid' | 'targetUuid'>>;
  addOrgAdmin?: Resolver<Maybe<ResolversTypes['AddOrgAdmin']>, ParentType, ContextType, RequireFields<MutationsAddOrgAdminArgs, 'orgUuid' | 'userUuid'>>;
  addUsersToTeam?: Resolver<Maybe<ResolversTypes['AddUsersToTeam']>, ParentType, ContextType, RequireFields<MutationsAddUsersToTeamArgs, 'addUsersToTeamInput'>>;
  adminBulkMarkUsersForDeletion?: Resolver<Maybe<ResolversTypes['AdminBulkMarkUsersForDeletion']>, ParentType, ContextType, RequireFields<MutationsAdminBulkMarkUsersForDeletionArgs, 'dryRun' | 'rows'>>;
  adminDeleteTeam?: Resolver<Maybe<ResolversTypes['AdminDeleteTeam']>, ParentType, ContextType, RequireFields<MutationsAdminDeleteTeamArgs, 'uuid'>>;
  adminDeleteVerifiedPhoneNumber?: Resolver<Maybe<ResolversTypes['AdminDeleteVerifiedPhoneNumber']>, ParentType, ContextType, RequireFields<MutationsAdminDeleteVerifiedPhoneNumberArgs, 'userUuid' | 'verifiedPhoneNumberUuid'>>;
  adminEditAccount?: Resolver<Maybe<ResolversTypes['AdminEditAccount']>, ParentType, ContextType, RequireFields<MutationsAdminEditAccountArgs, 'uuid'>>;
  adminEditOrganization?: Resolver<Maybe<ResolversTypes['AdminEditOrganization']>, ParentType, ContextType, RequireFields<MutationsAdminEditOrganizationArgs, 'uuid'>>;
  adminEditOrganizationEmailSettings?: Resolver<Maybe<ResolversTypes['AdminEditOrganizationEmailSettings']>, ParentType, ContextType, RequireFields<MutationsAdminEditOrganizationEmailSettingsArgs, 'settings' | 'uuid'>>;
  adminEditOrganizationRecordingConsent?: Resolver<Maybe<ResolversTypes['AdminEditOrganizationRecordingConsent']>, ParentType, ContextType, RequireFields<MutationsAdminEditOrganizationRecordingConsentArgs, 'uuid'>>;
  adminEditTeam?: Resolver<Maybe<ResolversTypes['AdminEditTeam']>, ParentType, ContextType, RequireFields<MutationsAdminEditTeamArgs, 'uuid'>>;
  adminEditTeamMember?: Resolver<Maybe<ResolversTypes['AdminEditTeamMember']>, ParentType, ContextType, RequireFields<MutationsAdminEditTeamMemberArgs, 'teamUuid' | 'userUuid'>>;
  adminEditUser?: Resolver<Maybe<ResolversTypes['AdminEditUser']>, ParentType, ContextType, RequireFields<MutationsAdminEditUserArgs, 'uuid'>>;
  adminGiveTreats?: Resolver<Maybe<ResolversTypes['AdminGiveTreats']>, ParentType, ContextType, RequireFields<MutationsAdminGiveTreatsArgs, 'amount' | 'userUuid'>>;
  adminMoveTeamToOrg?: Resolver<Maybe<ResolversTypes['AdminMoveTeamToOrg']>, ParentType, ContextType, RequireFields<MutationsAdminMoveTeamToOrgArgs, 'targetOrgUuid' | 'teamUuid'>>;
  adminMphBulkAssignTeamRoles?: Resolver<Maybe<ResolversTypes['AdminMphBulkAssignTeamRoles']>, ParentType, ContextType, RequireFields<MutationsAdminMphBulkAssignTeamRolesArgs, 'dryRun' | 'rows'>>;
  adminMphBulkReassignTeams?: Resolver<Maybe<ResolversTypes['AdminMphBulkReassignTeams']>, ParentType, ContextType, RequireFields<MutationsAdminMphBulkReassignTeamsArgs, 'dryRun' | 'rows'>>;
  adminRemoveTeamMember?: Resolver<Maybe<ResolversTypes['AdminRemoveTeamMember']>, ParentType, ContextType, RequireFields<MutationsAdminRemoveTeamMemberArgs, 'teamUuid' | 'userUuid'>>;
  adminResendInvitation?: Resolver<Maybe<ResolversTypes['AdminResendInvitation']>, ParentType, ContextType, Partial<MutationsAdminResendInvitationArgs>>;
  adminRevokeInvitation?: Resolver<Maybe<ResolversTypes['AdminRevokeInvitation']>, ParentType, ContextType, Partial<MutationsAdminRevokeInvitationArgs>>;
  adminRevokeOrganizationStripeCustomer?: Resolver<Maybe<ResolversTypes['AdminRevokeOrganizationStripeCustomer']>, ParentType, ContextType, RequireFields<MutationsAdminRevokeOrganizationStripeCustomerArgs, 'uuid'>>;
  adminSetOrganizationAdmin?: Resolver<Maybe<ResolversTypes['AdminSetOrganizationAdmin']>, ParentType, ContextType, RequireFields<MutationsAdminSetOrganizationAdminArgs, 'isAdmin' | 'userUuid' | 'uuid'>>;
  adminUnwireAccount?: Resolver<Maybe<ResolversTypes['AdminUnwireAccount']>, ParentType, ContextType, RequireFields<MutationsAdminUnwireAccountArgs, 'userUuid'>>;
  adminUpdateOrganizationStripeCustomer?: Resolver<Maybe<ResolversTypes['AdminUpdateOrganizationStripeCustomer']>, ParentType, ContextType, RequireFields<MutationsAdminUpdateOrganizationStripeCustomerArgs, 'stripeCustomerId' | 'uuid'>>;
  adminWireUpAccount?: Resolver<Maybe<ResolversTypes['AdminWireUpAccount']>, ParentType, ContextType, RequireFields<MutationsAdminWireUpAccountArgs, 'stripeCustomerId' | 'userUuid'>>;
  appendRecording?: Resolver<Maybe<ResolversTypes['AppendRecording']>, ParentType, ContextType, Partial<MutationsAppendRecordingArgs>>;
  associateQuicknotesWithPatient?: Resolver<Maybe<ResolversTypes['AssociateQuicknotesWithPatient']>, ParentType, ContextType, Partial<MutationsAssociateQuicknotesWithPatientArgs>>;
  bulkRestoreUsers?: Resolver<Maybe<ResolversTypes['BulkRestoreUsers']>, ParentType, ContextType, RequireFields<MutationsBulkRestoreUsersArgs, 'uuids'>>;
  bulkSetExpiryPolicy?: Resolver<Maybe<ResolversTypes['BulkSetExpiryPolicy']>, ParentType, ContextType, Partial<MutationsBulkSetExpiryPolicyArgs>>;
  bulkSetRole?: Resolver<Maybe<ResolversTypes['BulkSetRole']>, ParentType, ContextType, Partial<MutationsBulkSetRoleArgs>>;
  cancelBroadcastNotification?: Resolver<Maybe<ResolversTypes['CancelBroadcastNotification']>, ParentType, ContextType, RequireFields<MutationsCancelBroadcastNotificationArgs, 'notificationUuid'>>;
  cancelNotification?: Resolver<Maybe<ResolversTypes['CancelNotification']>, ParentType, ContextType, RequireFields<MutationsCancelNotificationArgs, 'notificationUuid'>>;
  changeScribephoneConsentMode?: Resolver<Maybe<ResolversTypes['ChangeScribephoneConsentMode']>, ParentType, ContextType, RequireFields<MutationsChangeScribephoneConsentModeArgs, 'consentMode'>>;
  checkinNote?: Resolver<Maybe<ResolversTypes['CheckinNote']>, ParentType, ContextType, Partial<MutationsCheckinNoteArgs>>;
  checkoutNote?: Resolver<Maybe<ResolversTypes['CheckoutNote']>, ParentType, ContextType, Partial<MutationsCheckoutNoteArgs>>;
  closeCompanionSession?: Resolver<Maybe<ResolversTypes['CloseCompanionSession']>, ParentType, ContextType, RequireFields<MutationsCloseCompanionSessionArgs, 'companionSessionUuid'>>;
  confirmUser?: Resolver<Maybe<ResolversTypes['ConfirmUser']>, ParentType, ContextType, Partial<MutationsConfirmUserArgs>>;
  copyAutoTemplate?: Resolver<Maybe<ResolversTypes['CopyAutoTemplate']>, ParentType, ContextType, RequireFields<MutationsCopyAutoTemplateArgs, 'templateUuid'>>;
  copyNotesToPatient?: Resolver<Maybe<ResolversTypes['CopyNotesToPatient']>, ParentType, ContextType, Partial<MutationsCopyNotesToPatientArgs>>;
  correctPatientNameInNote?: Resolver<Maybe<ResolversTypes['CorrectPatientNameInNote']>, ParentType, ContextType, RequireFields<MutationsCorrectPatientNameInNoteArgs, 'newName' | 'noteUuid' | 'oldName'>>;
  createAgentSession?: Resolver<Maybe<ResolversTypes['CreateAgentSession']>, ParentType, ContextType, RequireFields<MutationsCreateAgentSessionArgs, 'effort' | 'managedSessionId' | 'modelName'>>;
  createAgentToolPermissionGrant?: Resolver<Maybe<ResolversTypes['CreateAgentToolPermissionGrant']>, ParentType, ContextType, RequireFields<MutationsCreateAgentToolPermissionGrantArgs, 'displayName' | 'policyVersion' | 'toolAction' | 'toolName'>>;
  createAutoTemplate?: Resolver<Maybe<ResolversTypes['CreateAutoTemplate']>, ParentType, ContextType, RequireFields<MutationsCreateAutoTemplateArgs, 'createTemplateInput'>>;
  createBroadcastNotification?: Resolver<Maybe<ResolversTypes['CreateBroadcastNotification']>, ParentType, ContextType, RequireFields<MutationsCreateBroadcastNotificationArgs, 'type'>>;
  createCompanionSession?: Resolver<Maybe<ResolversTypes['CreateCompanionSession']>, ParentType, ContextType, Partial<MutationsCreateCompanionSessionArgs>>;
  createCustomOrg?: Resolver<Maybe<ResolversTypes['CreateCustomOrg']>, ParentType, ContextType, RequireFields<MutationsCreateCustomOrgArgs, 'billingModeId' | 'orgName'>>;
  createGroupedNotes?: Resolver<Maybe<ResolversTypes['CreateGroupedNotes']>, ParentType, ContextType, RequireFields<MutationsCreateGroupedNotesArgs, 'storageObjectName' | 'templateGroupUuid'>>;
  createNote?: Resolver<Maybe<ResolversTypes['CreateNote']>, ParentType, ContextType, Partial<MutationsCreateNoteArgs>>;
  createOrganization?: Resolver<Maybe<ResolversTypes['CreateOrganization']>, ParentType, ContextType, RequireFields<MutationsCreateOrganizationArgs, 'createOrgInput'>>;
  createPatient?: Resolver<Maybe<ResolversTypes['CreatePatient']>, ParentType, ContextType, Partial<MutationsCreatePatientArgs>>;
  createPatientNote?: Resolver<Maybe<ResolversTypes['CreatePatientNote']>, ParentType, ContextType, Partial<MutationsCreatePatientNoteArgs>>;
  createQuickNote?: Resolver<Maybe<ResolversTypes['CreateQuickNote']>, ParentType, ContextType, Partial<MutationsCreateQuickNoteArgs>>;
  createTeam?: Resolver<Maybe<ResolversTypes['CreateTeam']>, ParentType, ContextType, RequireFields<MutationsCreateTeamArgs, 'teamName'>>;
  createTeamUnderOrg?: Resolver<Maybe<ResolversTypes['CreateTeamUnderOrg']>, ParentType, ContextType, RequireFields<MutationsCreateTeamUnderOrgArgs, 'orgId' | 'teamName'>>;
  createTemplateGroup?: Resolver<Maybe<ResolversTypes['CreateTemplateGroup']>, ParentType, ContextType, RequireFields<MutationsCreateTemplateGroupArgs, 'name' | 'templateUuids'>>;
  createTemplatePreview?: Resolver<Maybe<ResolversTypes['CreateTemplatePreview']>, ParentType, ContextType, RequireFields<MutationsCreateTemplatePreviewArgs, 'createTemplatePreviewInput'>>;
  createTestUser?: Resolver<Maybe<ResolversTypes['CreateTestUser']>, ParentType, ContextType, RequireFields<MutationsCreateTestUserArgs, 'testUserData'>>;
  createUser?: Resolver<Maybe<ResolversTypes['CreateUser']>, ParentType, ContextType, Partial<MutationsCreateUserArgs>>;
  createUserFromTeamInvitation?: Resolver<Maybe<ResolversTypes['CreateUserFromTeamInvitation']>, ParentType, ContextType, Partial<MutationsCreateUserFromTeamInvitationArgs>>;
  createV1Team?: Resolver<Maybe<ResolversTypes['CreateV1Team']>, ParentType, ContextType, RequireFields<MutationsCreateV1TeamArgs, 'teamData'>>;
  deactivateOrgTeamUser?: Resolver<Maybe<ResolversTypes['DeactivateOrgTeamUser']>, ParentType, ContextType, RequireFields<MutationsDeactivateOrgTeamUserArgs, 'rmTeamUserInput'>>;
  deductAgentSessionTreats?: Resolver<Maybe<ResolversTypes['DeductAgentSessionTreats']>, ParentType, ContextType, RequireFields<MutationsDeductAgentSessionTreatsArgs, 'agentSessionUuid' | 'cacheCreationInputTokens' | 'cacheReadInputTokens' | 'inputTokens' | 'outputTokens'>>;
  deleteAgentSession?: Resolver<Maybe<ResolversTypes['DeleteAgentSession']>, ParentType, ContextType, RequireFields<MutationsDeleteAgentSessionArgs, 'agentSessionUuid'>>;
  deleteAttachment?: Resolver<Maybe<ResolversTypes['DeleteAttachment']>, ParentType, ContextType, Partial<MutationsDeleteAttachmentArgs>>;
  deleteAutoTemplate?: Resolver<Maybe<ResolversTypes['DeleteAutoTemplate']>, ParentType, ContextType, RequireFields<MutationsDeleteAutoTemplateArgs, 'templateUuid'>>;
  deleteCompanionSession?: Resolver<Maybe<ResolversTypes['DeleteCompanionSession']>, ParentType, ContextType, RequireFields<MutationsDeleteCompanionSessionArgs, 'companionSessionUuid'>>;
  deleteHeaderImage?: Resolver<Maybe<ResolversTypes['DeleteHeaderImage']>, ParentType, ContextType>;
  deleteNote?: Resolver<Maybe<ResolversTypes['DeleteNote']>, ParentType, ContextType, Partial<MutationsDeleteNoteArgs>>;
  deleteNoteAudioRecording?: Resolver<Maybe<ResolversTypes['DeleteNoteAudioRecording']>, ParentType, ContextType, Partial<MutationsDeleteNoteAudioRecordingArgs>>;
  deleteNotes?: Resolver<Maybe<ResolversTypes['DeleteNotes']>, ParentType, ContextType, Partial<MutationsDeleteNotesArgs>>;
  deletePatient?: Resolver<Maybe<ResolversTypes['DeletePatient']>, ParentType, ContextType, Partial<MutationsDeletePatientArgs>>;
  deleteTeam?: Resolver<Maybe<ResolversTypes['DeleteTeam']>, ParentType, ContextType, RequireFields<MutationsDeleteTeamArgs, 'teamUuid'>>;
  deleteTemplate?: Resolver<Maybe<ResolversTypes['DeleteTemplate']>, ParentType, ContextType, Partial<MutationsDeleteTemplateArgs>>;
  deleteTemplateGroup?: Resolver<Maybe<ResolversTypes['DeleteTemplateGroup']>, ParentType, ContextType, RequireFields<MutationsDeleteTemplateGroupArgs, 'groupUuid'>>;
  deleteUser?: Resolver<Maybe<ResolversTypes['DeleteUser']>, ParentType, ContextType>;
  deleteVerifiedPhoneNumber?: Resolver<Maybe<ResolversTypes['DeleteVerifiedPhoneNumber']>, ParentType, ContextType, RequireFields<MutationsDeleteVerifiedPhoneNumberArgs, 'verifiedPhoneUuid'>>;
  denyTeamInvitation?: Resolver<Maybe<ResolversTypes['DenyTeamInvitation']>, ParentType, ContextType, Partial<MutationsDenyTeamInvitationArgs>>;
  descopeAdminPortalSession?: Resolver<Maybe<ResolversTypes['DescopeAdminPortalSession']>, ParentType, ContextType>;
  descopeMobileSession?: Resolver<Maybe<ResolversTypes['DescopeMobileSession']>, ParentType, ContextType>;
  descopeWebSession?: Resolver<Maybe<ResolversTypes['DescopeWebSession']>, ParentType, ContextType>;
  detachNotesFromPatient?: Resolver<Maybe<ResolversTypes['DetachNotesFromPatient']>, ParentType, ContextType, Partial<MutationsDetachNotesFromPatientArgs>>;
  dismissNotification?: Resolver<Maybe<ResolversTypes['DismissNotification']>, ParentType, ContextType, RequireFields<MutationsDismissNotificationArgs, 'notificationUuid'>>;
  dismissNotificationsByNote?: Resolver<Maybe<ResolversTypes['DismissNotificationsByNote']>, ParentType, ContextType, RequireFields<MutationsDismissNotificationsByNoteArgs, 'noteUuid' | 'notificationType'>>;
  editAccountPreferences?: Resolver<Maybe<ResolversTypes['EditAccountPreferences']>, ParentType, ContextType, Partial<MutationsEditAccountPreferencesArgs>>;
  editClientSummaryPreferences?: Resolver<Maybe<ResolversTypes['EditClientSummaryPreferences']>, ParentType, ContextType, Partial<MutationsEditClientSummaryPreferencesArgs>>;
  editObjectiveNormalDefaults?: Resolver<Maybe<ResolversTypes['EditObjectiveNormalDefaults']>, ParentType, ContextType, RequireFields<MutationsEditObjectiveNormalDefaultsArgs, 'objectiveNormalDefaultsInput'>>;
  editPatient?: Resolver<Maybe<ResolversTypes['EditPatient']>, ParentType, ContextType, Partial<MutationsEditPatientArgs>>;
  editPdfSettings?: Resolver<Maybe<ResolversTypes['EditPDFSettings']>, ParentType, ContextType, Partial<MutationsEditPdfSettingsArgs>>;
  editTemplate?: Resolver<Maybe<ResolversTypes['EditTemplate']>, ParentType, ContextType, Partial<MutationsEditTemplateArgs>>;
  editUser?: Resolver<Maybe<ResolversTypes['EditUser']>, ParentType, ContextType, Partial<MutationsEditUserArgs>>;
  exchangeGoogleToken?: Resolver<Maybe<ResolversTypes['GoogleAuthResponse']>, ParentType, ContextType, RequireFields<MutationsExchangeGoogleTokenArgs, 'input'>>;
  flagNoteToSupport?: Resolver<Maybe<ResolversTypes['FlagNoteToSupport']>, ParentType, ContextType, Partial<MutationsFlagNoteToSupportArgs>>;
  generateAdaptiveClientSummary?: Resolver<Maybe<ResolversTypes['GenerateAdaptiveClientSummary']>, ParentType, ContextType, RequireFields<MutationsGenerateAdaptiveClientSummaryArgs, 'noteUuid' | 'templateUuid'>>;
  generateAgentSessionTitle?: Resolver<Maybe<ResolversTypes['GenerateAgentSessionTitle']>, ParentType, ContextType, RequireFields<MutationsGenerateAgentSessionTitleArgs, 'agentSessionUuid' | 'firstMessage' | 'firstResponse'>>;
  generateClientSummary?: Resolver<Maybe<ResolversTypes['GenerateClientSummary']>, ParentType, ContextType, RequireFields<MutationsGenerateClientSummaryArgs, 'noteUuid'>>;
  generateClientSummaryNext?: Resolver<Maybe<ResolversTypes['GenerateClientSummaryNext']>, ParentType, ContextType, Partial<MutationsGenerateClientSummaryNextArgs>>;
  generateLlmCustomizations?: Resolver<Maybe<ResolversTypes['GenerateLLMCustomization']>, ParentType, ContextType, RequireFields<MutationsGenerateLlmCustomizationsArgs, 'createLlmCustomizationInput'>>;
  hardDeleteNotes?: Resolver<Maybe<ResolversTypes['HardDeleteNotes']>, ParentType, ContextType, Partial<MutationsHardDeleteNotesArgs>>;
  hardDeleteUser?: Resolver<Maybe<ResolversTypes['HardDeleteUser']>, ParentType, ContextType, Partial<MutationsHardDeleteUserArgs>>;
  incrementAutoUsage?: Resolver<Maybe<ResolversTypes['IncrementAutoUsage']>, ParentType, ContextType, Partial<MutationsIncrementAutoUsageArgs>>;
  initializeStream?: Resolver<Maybe<ResolversTypes['InitializeStream']>, ParentType, ContextType, RequireFields<MutationsInitializeStreamArgs, 'taskUuid'>>;
  inviteUsersToTeam?: Resolver<Maybe<ResolversTypes['InviteUsersToTeam']>, ParentType, ContextType, RequireFields<MutationsInviteUsersToTeamArgs, 'inviteUsersToTeamInput'>>;
  linkRecordingConsentToNote?: Resolver<Maybe<ResolversTypes['LinkRecordingConsentToNote']>, ParentType, ContextType, RequireFields<MutationsLinkRecordingConsentToNoteArgs, 'consentEventUuid' | 'noteUuid'>>;
  logRecordingConsent?: Resolver<Maybe<ResolversTypes['LogRecordingConsent']>, ParentType, ContextType, RequireFields<MutationsLogRecordingConsentArgs, 'action' | 'source' | 'surface'>>;
  logScribephoneConsent?: Resolver<Maybe<ResolversTypes['LogScribephoneConsent']>, ParentType, ContextType>;
  loginUser?: Resolver<Maybe<ResolversTypes['LoginUser']>, ParentType, ContextType, Partial<MutationsLoginUserArgs>>;
  logoutUser?: Resolver<Maybe<ResolversTypes['LogoutUser']>, ParentType, ContextType>;
  markAgentSessionAttachmentsSent?: Resolver<Maybe<ResolversTypes['MarkAgentSessionAttachmentsSent']>, ParentType, ContextType, RequireFields<MutationsMarkAgentSessionAttachmentsSentArgs, 'agentSessionUuid' | 'attachmentUuids' | 'eventId'>>;
  markAgentToolPermissionGrantUsed?: Resolver<Maybe<ResolversTypes['MarkAgentToolPermissionGrantUsed']>, ParentType, ContextType, RequireFields<MutationsMarkAgentToolPermissionGrantUsedArgs, 'policyVersion' | 'toolAction' | 'toolName'>>;
  markNotificationRead?: Resolver<Maybe<ResolversTypes['MarkNotificationRead']>, ParentType, ContextType, RequireFields<MutationsMarkNotificationReadArgs, 'notificationUuid'>>;
  markUserForDeletion?: Resolver<Maybe<ResolversTypes['MarkUserForDeletion']>, ParentType, ContextType, RequireFields<MutationsMarkUserForDeletionArgs, 'uuid'>>;
  modifyNote?: Resolver<Maybe<ResolversTypes['ModifyNote']>, ParentType, ContextType, Partial<MutationsModifyNoteArgs>>;
  modifyNotes?: Resolver<Maybe<ResolversTypes['ModifyNotes']>, ParentType, ContextType, Partial<MutationsModifyNotesArgs>>;
  moveNotesToPatient?: Resolver<Maybe<ResolversTypes['MoveNotesToPatient']>, ParentType, ContextType, Partial<MutationsMoveNotesToPatientArgs>>;
  persistentLoginUser?: Resolver<Maybe<ResolversTypes['PersistentLoginUser']>, ParentType, ContextType>;
  populateUserSampleTemplates?: Resolver<Maybe<ResolversTypes['PopulateUserSampleTemplates']>, ParentType, ContextType>;
  proposeLlmEdit?: Resolver<Maybe<ResolversTypes['ProposeLLMEdit']>, ParentType, ContextType, RequireFields<MutationsProposeLlmEditArgs, 'proposeLlmEditInput'>>;
  protectNote?: Resolver<Maybe<ResolversTypes['ProtectNote']>, ParentType, ContextType, Partial<MutationsProtectNoteArgs>>;
  redeemCredits?: Resolver<Maybe<ResolversTypes['RedeemCredits']>, ParentType, ContextType, RequireFields<MutationsRedeemCreditsArgs, 'amountCents'>>;
  refreshUserToken?: Resolver<Maybe<ResolversTypes['RefreshUserToken']>, ParentType, ContextType>;
  removeOrganizationDefaultTemplate?: Resolver<Maybe<ResolversTypes['RemoveOrganizationDefaultTemplate']>, ParentType, ContextType, RequireFields<MutationsRemoveOrganizationDefaultTemplateArgs, 'orgUuid' | 'templateUuid'>>;
  removeTeamDefaultTemplate?: Resolver<Maybe<ResolversTypes['RemoveTeamDefaultTemplate']>, ParentType, ContextType, RequireFields<MutationsRemoveTeamDefaultTemplateArgs, 'teamUuids' | 'templateUuid'>>;
  removeUserFromOrgTeam?: Resolver<Maybe<ResolversTypes['RemoveUserFromOrgTeam']>, ParentType, ContextType, RequireFields<MutationsRemoveUserFromOrgTeamArgs, 'rmTeamUserInput'>>;
  removeUserFromTeam?: Resolver<Maybe<ResolversTypes['RemoveUserFromTeam']>, ParentType, ContextType, RequireFields<MutationsRemoveUserFromTeamArgs, 'teamUuid' | 'userUuid'>>;
  requestPhoneVerification?: Resolver<Maybe<ResolversTypes['RequestPhoneVerification']>, ParentType, ContextType, RequireFields<MutationsRequestPhoneVerificationArgs, 'phoneNumber'>>;
  requestTeamSetup?: Resolver<Maybe<ResolversTypes['RequestTeamSetup']>, ParentType, ContextType, RequireFields<MutationsRequestTeamSetupArgs, 'customMessage' | 'email'>>;
  resendConfirmUser?: Resolver<Maybe<ResolversTypes['ResendUserConfirmation']>, ParentType, ContextType>;
  restoreUser?: Resolver<Maybe<ResolversTypes['RestoreUser']>, ParentType, ContextType, RequireFields<MutationsRestoreUserArgs, 'uuid'>>;
  retoolCreateQuickNote?: Resolver<Maybe<ResolversTypes['RetoolCreateQuickNote']>, ParentType, ContextType, Partial<MutationsRetoolCreateQuickNoteArgs>>;
  retoolDeleteNotes?: Resolver<Maybe<ResolversTypes['RetoolDeleteNotes']>, ParentType, ContextType, Partial<MutationsRetoolDeleteNotesArgs>>;
  retryFailedAutoSoap?: Resolver<Maybe<ResolversTypes['RetryFailedAutoSoap']>, ParentType, ContextType, Partial<MutationsRetryFailedAutoSoapArgs>>;
  revokeAgentToolPermissionGrant?: Resolver<Maybe<ResolversTypes['RevokeAgentToolPermissionGrant']>, ParentType, ContextType, RequireFields<MutationsRevokeAgentToolPermissionGrantArgs, 'uuid'>>;
  scheduleNotification?: Resolver<Maybe<ResolversTypes['ScheduleNotification']>, ParentType, ContextType, RequireFields<MutationsScheduleNotificationArgs, 'type'>>;
  sendClientSummaryEmail?: Resolver<Maybe<ResolversTypes['SendClientSummaryEmail']>, ParentType, ContextType, Partial<MutationsSendClientSummaryEmailArgs>>;
  sendCompanionSessionMessage?: Resolver<Maybe<ResolversTypes['SendCompanionSessionMessage']>, ParentType, ContextType, RequireFields<MutationsSendCompanionSessionMessageArgs, 'companionSessionUuid' | 'textContent'>>;
  sendDashboardDesktopLink?: Resolver<Maybe<ResolversTypes['SendDashboardDesktopLink']>, ParentType, ContextType>;
  sendExportNoteEmail?: Resolver<Maybe<ResolversTypes['SendExportNoteEmail']>, ParentType, ContextType, Partial<MutationsSendExportNoteEmailArgs>>;
  sendForgotPasswordEmail?: Resolver<Maybe<ResolversTypes['SendForgotPasswordEmail']>, ParentType, ContextType, Partial<MutationsSendForgotPasswordEmailArgs>>;
  sendNoteDesktopLink?: Resolver<Maybe<ResolversTypes['SendNoteDesktopLink']>, ParentType, ContextType, RequireFields<MutationsSendNoteDesktopLinkArgs, 'noteUuid'>>;
  setAccountPreference?: Resolver<Maybe<ResolversTypes['SetAccountPreference']>, ParentType, ContextType, RequireFields<MutationsSetAccountPreferenceArgs, 'key' | 'value'>>;
  setOrganizationDefaultTemplate?: Resolver<Maybe<ResolversTypes['SetOrganizationDefaultTemplate']>, ParentType, ContextType, RequireFields<MutationsSetOrganizationDefaultTemplateArgs, 'orgUuid' | 'templateUuid'>>;
  setTeamDefaultTemplate?: Resolver<Maybe<ResolversTypes['SetTeamDefaultTemplate']>, ParentType, ContextType, RequireFields<MutationsSetTeamDefaultTemplateArgs, 'teamUuids' | 'templateUuid'>>;
  transferNoteOwnership?: Resolver<Maybe<ResolversTypes['TransferNoteOwnership']>, ParentType, ContextType, Partial<MutationsTransferNoteOwnershipArgs>>;
  triggerDentalChartExtraction?: Resolver<Maybe<ResolversTypes['TriggerDentalChartExtraction']>, ParentType, ContextType, RequireFields<MutationsTriggerDentalChartExtractionArgs, 'noteUuid'>>;
  ungroupNote?: Resolver<Maybe<ResolversTypes['UngroupNote']>, ParentType, ContextType, RequireFields<MutationsUngroupNoteArgs, 'noteUuid'>>;
  updateAccountPlan?: Resolver<Maybe<ResolversTypes['UpdateAccountPlan']>, ParentType, ContextType, RequireFields<MutationsUpdateAccountPlanArgs, 'accountType' | 'accountUuid'>>;
  updateAgentSessionTitle?: Resolver<Maybe<ResolversTypes['UpdateAgentSessionTitle']>, ParentType, ContextType, RequireFields<MutationsUpdateAgentSessionTitleArgs, 'agentSessionUuid' | 'title'>>;
  updateAutoTemplate?: Resolver<Maybe<ResolversTypes['UpdateAutoTemplate']>, ParentType, ContextType, RequireFields<MutationsUpdateAutoTemplateArgs, 'updateTemplateInput'>>;
  updateForgottenPassword?: Resolver<Maybe<ResolversTypes['UpdateForgottenPassword']>, ParentType, ContextType, Partial<MutationsUpdateForgottenPasswordArgs>>;
  updateScribeMd?: Resolver<Maybe<ResolversTypes['UpdateScribeMd']>, ParentType, ContextType, RequireFields<MutationsUpdateScribeMdArgs, 'content'>>;
  updateTemplateGroup?: Resolver<Maybe<ResolversTypes['UpdateTemplateGroup']>, ParentType, ContextType, RequireFields<MutationsUpdateTemplateGroupArgs, 'groupUuid'>>;
  updateTemplateSharing?: Resolver<Maybe<ResolversTypes['UpdateTemplateSharing']>, ParentType, ContextType, RequireFields<MutationsUpdateTemplateSharingArgs, 'sharingType' | 'templateUuid'>>;
  updateUserFfSegment?: Resolver<Maybe<ResolversTypes['UpdateUserFFSegment']>, ParentType, ContextType, RequireFields<MutationsUpdateUserFfSegmentArgs, 'action' | 'segmentKey'>>;
  updateUserTeam?: Resolver<Maybe<ResolversTypes['UpdateUserTeam']>, ParentType, ContextType, RequireFields<MutationsUpdateUserTeamArgs, 'teamUuid' | 'userUuid'>>;
  updateVerifiedPhoneNumberSharing?: Resolver<Maybe<ResolversTypes['UpdateVerifiedPhoneNumberSharing']>, ParentType, ContextType, RequireFields<MutationsUpdateVerifiedPhoneNumberSharingArgs, 'verifiedPhoneUuid'>>;
  uploadAgentSessionAttachment?: Resolver<Maybe<ResolversTypes['UploadAgentSessionAttachment']>, ParentType, ContextType, RequireFields<MutationsUploadAgentSessionAttachmentArgs, 'agentSessionUuid' | 'contentType' | 'fileName' | 'storageObjectName'>>;
  uploadCompanionSessionAttachment?: Resolver<Maybe<ResolversTypes['UploadCompanionSessionAttachment']>, ParentType, ContextType, RequireFields<MutationsUploadCompanionSessionAttachmentArgs, 'companionSessionUuid' | 'contentType' | 'fileName' | 'storageObjectName'>>;
  uploadHeaderImage?: Resolver<Maybe<ResolversTypes['UploadHeaderImage']>, ParentType, ContextType, RequireFields<MutationsUploadHeaderImageArgs, 'logoContentType' | 'logoStorageObjectName'>>;
  uploadNoteAttachments?: Resolver<Maybe<ResolversTypes['UploadNoteAttachments']>, ParentType, ContextType, RequireFields<MutationsUploadNoteAttachmentsArgs, 'attachments' | 'createdAt' | 'noteUuid'>>;
  uploadPatientAttachments?: Resolver<Maybe<ResolversTypes['UploadPatientAttachments']>, ParentType, ContextType, RequireFields<MutationsUploadPatientAttachmentsArgs, 'attachments' | 'createdAt' | 'patientUuid'>>;
  uploadPdfAndExtractText?: Resolver<Maybe<ResolversTypes['UploadPdfAndExtractText']>, ParentType, ContextType, RequireFields<MutationsUploadPdfAndExtractTextArgs, 'storageObjectName' | 'templateType'>>;
  uploadSpeedTest?: Resolver<Maybe<ResolversTypes['UploadSpeedTest']>, ParentType, ContextType, RequireFields<MutationsUploadSpeedTestArgs, 'file'>>;
};

export type NoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['Note'] = ResolversParentTypes['Note']> = {
  additionalNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assessment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Attachment']>>>, ParentType, ContextType>;
  audioStorageLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auditTrail?: Resolver<Maybe<Array<Maybe<ResolversTypes['AuditTrail']>>>, ParentType, ContextType>;
  autoTemplates?: Resolver<Maybe<ResolversTypes['AutoTemplate']>, ParentType, ContextType>;
  bodyConditionScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  capillaryRefillTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardiovascular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientSummary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coatAndSkin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companionSession?: Resolver<Maybe<ResolversTypes['CompanionSession']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  customFormFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomFormField']>>>, ParentType, ContextType>;
  customObjectiveFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomObjectiveField']>>>, ParentType, ContextType>;
  dataExtraction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dentalChartData?: Resolver<Maybe<ResolversTypes['JSONString']>, ParentType, ContextType>;
  dentalChartStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ears?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  evaluatorSessionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eyes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gastrointestinal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasBeenExported?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  heartRate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isApproved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isAutoSoap?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isBeingScribed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDraft?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFree?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isHallucinating?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isIncomplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isMadeWithScribephone?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMarkedAsFailed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMarkedAsProcessing?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMarkedAsReview?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMarkedAsSubmitted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isNewRecording?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProcessing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTagged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isUnacceptable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  jobType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jobTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyHistory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyMedications?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lymphatic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  musculoskeletal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  neurological?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteGroup?: Resolver<Maybe<ResolversTypes['NoteGroup']>, ParentType, ContextType>;
  noteGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objective?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oral?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  overall?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  patientId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  plan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quickNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordingLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reproductiveAndUrinary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  respiratory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  respiratoryRate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shouldUseCustomForm?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shouldUseGenericObjective?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['NoteStatus']>, ParentType, ContextType>;
  storageObjectName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subjective?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taggedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>;
  teamId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  temperature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  template?: Resolver<Maybe<ResolversTypes['Template']>, ParentType, ContextType>;
  templateId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  templatePreviews?: Resolver<Maybe<Array<Maybe<ResolversTypes['TemplatePreviews']>>>, ParentType, ContextType>;
  thumbsUp?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  timeToProcess?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transcription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transcriptionJsonStorageLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transcriptionJsonStorageName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vaccinationStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type NoteGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoteGroup'] = ResolversParentTypes['NoteGroup']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<Array<Maybe<ResolversTypes['NoteGroupNote']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type NoteGroupNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoteGroupNote'] = ResolversParentTypes['NoteGroupNote']> = {
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ObjectiveNormalDefaultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObjectiveNormalDefaults'] = ResolversParentTypes['ObjectiveNormalDefaults']> = {
  bodyConditionScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  capillaryRefillTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardiovascular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ears?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eyes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fearAnxietyStressScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  furSkin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gastrointestinal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heartRate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hydrationStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lymphatic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  masses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mucousMembranes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  musculoskeletal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nasal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  neurological?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oralDental?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  painScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reproductiveUrinary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  respiratory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  respiratoryRate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shouldUse?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  temperature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type OnboardingProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingProgress'] = ResolversParentTypes['OnboardingProgress']> = {
  distinctNoteCreationDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hasApprovedNote?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasCreatedTemplate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasExportedNote?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  onboardingMilestones?: Resolver<Maybe<ResolversTypes['GenericScalar']>, ParentType, ContextType>;
};

export type OrgBillingShareResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrgBillingShare'] = ResolversParentTypes['OrgBillingShare']> = {
  billableCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  billingBasis?: Resolver<Maybe<ResolversTypes['OrgBillingBasis']>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['AdminOrganizationSummary'], ParentType, ContextType>;
};

export type OrgStripeWarningResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrgStripeWarning'] = ResolversParentTypes['OrgStripeWarning']> = {
  organizationNames?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  organizations?: Resolver<Array<ResolversTypes['OrgStripeWarningOrganization']>, ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['OrgStripeWarningReason'], ParentType, ContextType>;
};

export type OrgStripeWarningOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrgStripeWarningOrganization'] = ResolversParentTypes['OrgStripeWarningOrganization']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = {
  admins?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType>;
  allowsDirectMemberAdd?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  billingModeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  defaultPassword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultTemplates?: Resolver<Array<Maybe<ResolversTypes['AutoTemplate']>>, ParentType, ContextType>;
  emailDomain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailDomainSecondary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailDomainTertiary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  globalScribephoneConsentMode?: Resolver<Maybe<ResolversTypes['ScribephoneConsentEnum']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAutomatedBilling?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isManualBilling?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  location?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numTeams?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numUsers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teams?: Resolver<Maybe<Array<Maybe<ResolversTypes['Team']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrganizationRecordingConsentEventsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationRecordingConsentEvents'] = ResolversParentTypes['OrganizationRecordingConsentEvents']> = {
  events?: Resolver<Array<ResolversTypes['RecordingConsentEvent']>, ParentType, ContextType>;
  nextCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ParsedPatientSignalmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ParsedPatientSignalment'] = ResolversParentTypes['ParsedPatientSignalment']> = {
  breed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  patientName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  species?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['Patient'] = ResolversParentTypes['Patient']> = {
  age?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Attachment']>>>, ParentType, ContextType>;
  auditTrail?: Resolver<Maybe<Array<Maybe<ResolversTypes['AuditTrail']>>>, ParentType, ContextType>;
  birthday?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  birthdayParts?: Resolver<Maybe<ResolversTypes['BirthdayParts']>, ParentType, ContextType>;
  breed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  emergencyContactInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isIntact?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  keyHistory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyMedications?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastNameOfOwner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  microchip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Note']>>>, ParentType, ContextType, Partial<PatientNotesArgs>>;
  ownerContactInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  species?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vaccinationStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PersistentLoginUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersistentLoginUser'] = ResolversParentTypes['PersistentLoginUser']> = {
  accessCsrf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accessJwt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refreshJwt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['LoginUserResponse']>, ParentType, ContextType>;
};

export type PopulateUserSampleTemplatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PopulateUserSampleTemplates'] = ResolversParentTypes['PopulateUserSampleTemplates']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ProposeLlmEditResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProposeLLMEdit'] = ResolversParentTypes['ProposeLLMEdit']> = {
  llmCustomizationUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ProtectNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtectNote'] = ResolversParentTypes['ProtectNote']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ProvisionedUsersResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProvisionedUsers'] = ResolversParentTypes['ProvisionedUsers']> = {
  existing?: Resolver<Maybe<Array<Maybe<ResolversTypes['ModifiedUser']>>>, ParentType, ContextType>;
  newUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['ModifiedUser']>>>, ParentType, ContextType>;
};

export type RecordingConsentEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordingConsentEvent'] = ResolversParentTypes['RecordingConsentEvent']> = {
  action?: Resolver<ResolversTypes['RecordingConsentAction'], ParentType, ContextType>;
  consentText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  consentTextVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  noteUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['RecordingConsentSource'], ParentType, ContextType>;
  surface?: Resolver<ResolversTypes['RecordingConsentSurface'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
};

export type RedeemCreditsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RedeemCredits'] = ResolversParentTypes['RedeemCredits']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  remainingBalanceCents?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ReferralResolvers<ContextType = any, ParentType extends ResolversParentTypes['Referral'] = ResolversParentTypes['Referral']> = {
  canRedeem?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  creditsBalance?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditsBalanceCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hasReferrer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  minRedemptionAmountCents?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numPaidReferrals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numPremiumReferralsMade?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numReferralsMade?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numReferredSignups?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referrerEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referrerUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  signUpReferrerType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionReferrerType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCreditsEarned?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCreditsEarnedCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCreditsRedeemed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCreditsRedeemedCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type RefreshUserTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefreshUserToken'] = ResolversParentTypes['RefreshUserToken']> = {
  accessJwt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type RemoveOrganizationDefaultTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveOrganizationDefaultTemplate'] = ResolversParentTypes['RemoveOrganizationDefaultTemplate']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type RemoveTeamDefaultTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveTeamDefaultTemplate'] = ResolversParentTypes['RemoveTeamDefaultTemplate']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type RemoveUserFromOrgTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveUserFromOrgTeam'] = ResolversParentTypes['RemoveUserFromOrgTeam']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type RemoveUserFromTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveUserFromTeam'] = ResolversParentTypes['RemoveUserFromTeam']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  removedUser?: Resolver<Maybe<ResolversTypes['ModifiedUser']>, ParentType, ContextType>;
};

export type RequestPhoneVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestPhoneVerification'] = ResolversParentTypes['RequestPhoneVerification']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  validationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verifiedPhoneUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type RequestTeamSetupResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestTeamSetup'] = ResolversParentTypes['RequestTeamSetup']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ResendUserConfirmationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResendUserConfirmation'] = ResolversParentTypes['ResendUserConfirmation']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type RestoreUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['RestoreUser'] = ResolversParentTypes['RestoreUser']> = {
  user?: Resolver<Maybe<ResolversTypes['AdminUserInfo']>, ParentType, ContextType>;
};

export type RetoolCreateQuickNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['RetoolCreateQuickNote'] = ResolversParentTypes['RetoolCreateQuickNote']> = {
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  successMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type RetoolDeleteNotesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RetoolDeleteNotes'] = ResolversParentTypes['RetoolDeleteNotes']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type RetryFailedAutoSoapResolvers<ContextType = any, ParentType extends ResolversParentTypes['RetryFailedAutoSoap'] = ResolversParentTypes['RetryFailedAutoSoap']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type RevokeAgentToolPermissionGrantResolvers<ContextType = any, ParentType extends ResolversParentTypes['RevokeAgentToolPermissionGrant'] = ResolversParentTypes['RevokeAgentToolPermissionGrant']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type RoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Role'] = ResolversParentTypes['Role']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type RootResolvers<ContextType = any, ParentType extends ResolversParentTypes['Root'] = ResolversParentTypes['Root']> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  activeCompanionSession?: Resolver<Maybe<ResolversTypes['CompanionSession']>, ParentType, ContextType>;
  adminAgentSession?: Resolver<Maybe<ResolversTypes['AdminAgentSessionDetail']>, ParentType, ContextType, RequireFields<RootAdminAgentSessionArgs, 'sessionUuid'>>;
  adminAgentSessionsForUser?: Resolver<Maybe<ResolversTypes['AdminAgentSessionListResult']>, ParentType, ContextType, RequireFields<RootAdminAgentSessionsForUserArgs, 'userUuid'>>;
  adminAuditLog?: Resolver<Maybe<ResolversTypes['AuditLogResult']>, ParentType, ContextType, Partial<RootAdminAuditLogArgs>>;
  adminBroadcastNotifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserNotification']>>>, ParentType, ContextType, Partial<RootAdminBroadcastNotificationsArgs>>;
  adminInactiveAccounts?: Resolver<Maybe<ResolversTypes['AdminUserListResult']>, ParentType, ContextType, Partial<RootAdminInactiveAccountsArgs>>;
  adminMphCompanionMembers?: Resolver<Maybe<ResolversTypes['AdminMphCompanionMembersResult']>, ParentType, ContextType, Partial<RootAdminMphCompanionMembersArgs>>;
  adminNotesTemplateOptions?: Resolver<Array<ResolversTypes['AdminNoteTemplateOption']>, ParentType, ContextType, Partial<RootAdminNotesTemplateOptionsArgs>>;
  adminOrgEmailTemplatePreview?: Resolver<Maybe<ResolversTypes['AdminOrgEmailTemplatePreview']>, ParentType, ContextType, RequireFields<RootAdminOrgEmailTemplatePreviewArgs, 'emailKey' | 'templateAlias'>>;
  adminOrganization?: Resolver<Maybe<ResolversTypes['AdminOrganizationDetail']>, ParentType, ContextType, RequireFields<RootAdminOrganizationArgs, 'orgUuid'>>;
  adminOrganizationBilling?: Resolver<Maybe<ResolversTypes['AdminOrganizationBilling']>, ParentType, ContextType, RequireFields<RootAdminOrganizationBillingArgs, 'orgUuid'>>;
  adminOrganizationMembers?: Resolver<Maybe<ResolversTypes['AdminOrganizationMembersPage']>, ParentType, ContextType, RequireFields<RootAdminOrganizationMembersArgs, 'orgUuid'>>;
  adminOrganizations?: Resolver<Maybe<ResolversTypes['AdminOrganizationsList']>, ParentType, ContextType, Partial<RootAdminOrganizationsArgs>>;
  adminRoleOptions?: Resolver<Array<ResolversTypes['AdminRoleOption']>, ParentType, ContextType>;
  adminSearchBillingCustomers?: Resolver<Maybe<ResolversTypes['AdminBillingCustomerSearchResult']>, ParentType, ContextType, RequireFields<RootAdminSearchBillingCustomersArgs, 'query'>>;
  adminSoftDeletedUsers?: Resolver<Maybe<ResolversTypes['AdminUserListResult']>, ParentType, ContextType, Partial<RootAdminSoftDeletedUsersArgs>>;
  adminStripeCustomerLinkage?: Resolver<Maybe<ResolversTypes['AdminStripeCustomerLinkage']>, ParentType, ContextType, RequireFields<RootAdminStripeCustomerLinkageArgs, 'stripeCustomerId'>>;
  adminTeam?: Resolver<Maybe<ResolversTypes['AdminTeamDetail']>, ParentType, ContextType, RequireFields<RootAdminTeamArgs, 'teamUuid'>>;
  adminTeamMembers?: Resolver<Maybe<ResolversTypes['AdminTeamMembersPage']>, ParentType, ContextType, RequireFields<RootAdminTeamMembersArgs, 'teamUuid'>>;
  adminTeamNotes?: Resolver<Maybe<ResolversTypes['AdminNotesPage']>, ParentType, ContextType, RequireFields<RootAdminTeamNotesArgs, 'teamUuid'>>;
  adminTeams?: Resolver<Maybe<ResolversTypes['AdminTeamsList']>, ParentType, ContextType, Partial<RootAdminTeamsArgs>>;
  adminUserCashOuts?: Resolver<Maybe<ResolversTypes['AdminCashOutsPage']>, ParentType, ContextType, RequireFields<RootAdminUserCashOutsArgs, 'userUuid'>>;
  adminUserLookup?: Resolver<Maybe<ResolversTypes['AdminUserLookupResult']>, ParentType, ContextType, Partial<RootAdminUserLookupArgs>>;
  adminUserMembership?: Resolver<Maybe<ResolversTypes['AdminUserMembershipResult']>, ParentType, ContextType, RequireFields<RootAdminUserMembershipArgs, 'uuid'>>;
  adminUserNote?: Resolver<Maybe<ResolversTypes['AdminNoteDetail']>, ParentType, ContextType, RequireFields<RootAdminUserNoteArgs, 'noteUuid'>>;
  adminUserNotes?: Resolver<Maybe<ResolversTypes['AdminNotesPage']>, ParentType, ContextType, RequireFields<RootAdminUserNotesArgs, 'userUuid'>>;
  adminUserReferredUsers?: Resolver<Maybe<ResolversTypes['AdminReferredUsersPage']>, ParentType, ContextType, RequireFields<RootAdminUserReferredUsersArgs, 'userUuid'>>;
  adminUserTemplate?: Resolver<Maybe<ResolversTypes['AdminTemplateDetail']>, ParentType, ContextType, RequireFields<RootAdminUserTemplateArgs, 'templateUuid'>>;
  adminUserTemplates?: Resolver<Maybe<ResolversTypes['AdminUserTemplatesPage']>, ParentType, ContextType, RequireFields<RootAdminUserTemplatesArgs, 'userUuid'>>;
  adminVerifiedPhoneLookup?: Resolver<Maybe<ResolversTypes['AdminVerifiedPhoneLookupResult']>, ParentType, ContextType, RequireFields<RootAdminVerifiedPhoneLookupArgs, 'phoneNumber'>>;
  agentSession?: Resolver<Maybe<ResolversTypes['AgentSession']>, ParentType, ContextType, RequireFields<RootAgentSessionArgs, 'agentSessionUuid'>>;
  agentSessionAttachments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Attachment']>>>, ParentType, ContextType, RequireFields<RootAgentSessionAttachmentsArgs, 'agentSessionUuid'>>;
  agentSessionEvents?: Resolver<Maybe<ResolversTypes['AgentSessionEventsPage']>, ParentType, ContextType, RequireFields<RootAgentSessionEventsArgs, 'agentSessionUuid'>>;
  agentSessions?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgentSession']>>>, ParentType, ContextType, Partial<RootAgentSessionsArgs>>;
  agentToolPermissionGrant?: Resolver<Maybe<ResolversTypes['AgentToolPermissionGrant']>, ParentType, ContextType, RequireFields<RootAgentToolPermissionGrantArgs, 'policyVersion' | 'toolAction' | 'toolName'>>;
  agentToolPermissionGrants?: Resolver<Array<ResolversTypes['AgentToolPermissionGrant']>, ParentType, ContextType>;
  allAllowedRoles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AllowedRole']>>>, ParentType, ContextType>;
  allNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Note']>>>, ParentType, ContextType>;
  auditTrail?: Resolver<Maybe<ResolversTypes['AuditTrail']>, ParentType, ContextType, Partial<RootAuditTrailArgs>>;
  autoTemplateById?: Resolver<Maybe<ResolversTypes['AutoTemplate']>, ParentType, ContextType, RequireFields<RootAutoTemplateByIdArgs, 'uuid'>>;
  autoTemplates?: Resolver<Maybe<Array<Maybe<ResolversTypes['AutoTemplate']>>>, ParentType, ContextType, Partial<RootAutoTemplatesArgs>>;
  companionContext?: Resolver<Maybe<ResolversTypes['CompanionContext']>, ParentType, ContextType, RequireFields<RootCompanionContextArgs, 'includeInitialContext'>>;
  companionSession?: Resolver<Maybe<ResolversTypes['CompanionSession']>, ParentType, ContextType, Partial<RootCompanionSessionArgs>>;
  companionSessions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CompanionSession']>>>, ParentType, ContextType, Partial<RootCompanionSessionsArgs>>;
  dashboardInboxNotes?: Resolver<Maybe<ResolversTypes['InboxNotes']>, ParentType, ContextType, Partial<RootDashboardInboxNotesArgs>>;
  defaultPhoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<RootDefaultPhoneNumberArgs>>;
  effectiveCompanionEffort?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<RootEffectiveCompanionEffortArgs, 'requestedEffort'>>;
  existingUsers?: Resolver<Maybe<ResolversTypes['UserChecks']>, ParentType, ContextType, Partial<RootExistingUsersArgs>>;
  inboxNotes?: Resolver<Maybe<ResolversTypes['InboxNotes']>, ParentType, ContextType, Partial<RootInboxNotesArgs>>;
  inboxTabCount?: Resolver<Maybe<ResolversTypes['InboxTabCount']>, ParentType, ContextType, Partial<RootInboxTabCountArgs>>;
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType, Partial<RootNoteArgs>>;
  notes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Note']>>>, ParentType, ContextType, Partial<RootNotesArgs>>;
  onboardingProgress?: Resolver<Maybe<ResolversTypes['OnboardingProgress']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType, Partial<RootOrganizationArgs>>;
  organizationRecordingConsentEvents?: Resolver<Maybe<ResolversTypes['OrganizationRecordingConsentEvents']>, ParentType, ContextType, RequireFields<RootOrganizationRecordingConsentEventsArgs, 'orgUuid'>>;
  parsedHtmlPatientSignalement?: Resolver<Maybe<ResolversTypes['ParsedPatientSignalment']>, ParentType, ContextType, RequireFields<RootParsedHtmlPatientSignalementArgs, 'rawHtml'>>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType, Partial<RootPatientArgs>>;
  patientAnalytics?: Resolver<Maybe<Array<Maybe<ResolversTypes['Patient']>>>, ParentType, ContextType, Partial<RootPatientAnalyticsArgs>>;
  patients?: Resolver<Maybe<Array<Maybe<ResolversTypes['Patient']>>>, ParentType, ContextType>;
  pendingUserTeamInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['TeamInvite']>>>, ParentType, ContextType>;
  pendingWritingCompanionProposals?: Resolver<Array<ResolversTypes['WritingCompanionProposal']>, ParentType, ContextType, RequireFields<RootPendingWritingCompanionProposalsArgs, 'noteUuid'>>;
  processingNote?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType, Partial<RootProcessingNoteArgs>>;
  quickNotes?: Resolver<Maybe<ResolversTypes['InboxNotes']>, ParentType, ContextType, Partial<RootQuickNotesArgs>>;
  role?: Resolver<Maybe<ResolversTypes['Role']>, ParentType, ContextType, Partial<RootRoleArgs>>;
  rootUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  scribeMd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchSupportDocs?: Resolver<Maybe<Array<Maybe<ResolversTypes['SupportDocSearchResult']>>>, ParentType, ContextType, RequireFields<RootSearchSupportDocsArgs, 'query'>>;
  sharedAccessNote?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType, Partial<RootSharedAccessNoteArgs>>;
  shouldUpdatePoll?: Resolver<Maybe<ResolversTypes['UserNotePollQuery']>, ParentType, ContextType>;
  shouldUpdateUserPoll?: Resolver<Maybe<ResolversTypes['UserNotePollQuery']>, ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType, Partial<RootTeamArgs>>;
  teamInvite?: Resolver<Maybe<ResolversTypes['TeamInviteResponse']>, ParentType, ContextType, Partial<RootTeamInviteArgs>>;
  teamUserNoteCounts?: Resolver<Maybe<ResolversTypes['TeamUserNoteCounts']>, ParentType, ContextType, Partial<RootTeamUserNoteCountsArgs>>;
  template?: Resolver<Maybe<ResolversTypes['TemplateResponse']>, ParentType, ContextType, Partial<RootTemplateArgs>>;
  templateGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['TemplateGroup']>>>, ParentType, ContextType>;
  treatBalance?: Resolver<Maybe<ResolversTypes['TreatBalance']>, ParentType, ContextType>;
  treatDailySummaries?: Resolver<Maybe<Array<ResolversTypes['TreatDailySummary']>>, ParentType, ContextType, RequireFields<RootTreatDailySummariesArgs, 'days'>>;
  unauthenticatedTeamInvite?: Resolver<Maybe<ResolversTypes['TeamInviteResponse']>, ParentType, ContextType, Partial<RootUnauthenticatedTeamInviteArgs>>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userNotifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserNotification']>>>, ParentType, ContextType, Partial<RootUserNotificationsArgs>>;
  verifiedPhoneNumbers?: Resolver<Maybe<Array<Maybe<ResolversTypes['VerifiedPhoneNumber']>>>, ParentType, ContextType>;
};

export type ScheduleNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduleNotification'] = ResolversParentTypes['ScheduleNotification']> = {
  notification?: Resolver<Maybe<ResolversTypes['UserNotification']>, ParentType, ContextType>;
};

export type SendClientSummaryEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendClientSummaryEmail'] = ResolversParentTypes['SendClientSummaryEmail']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SendCompanionSessionMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendCompanionSessionMessage'] = ResolversParentTypes['SendCompanionSessionMessage']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type SendDashboardDesktopLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendDashboardDesktopLink'] = ResolversParentTypes['SendDashboardDesktopLink']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type SendExportNoteEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendExportNoteEmail'] = ResolversParentTypes['SendExportNoteEmail']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SendForgotPasswordEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendForgotPasswordEmail'] = ResolversParentTypes['SendForgotPasswordEmail']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SendNoteDesktopLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendNoteDesktopLink'] = ResolversParentTypes['SendNoteDesktopLink']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type SetAccountPreferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetAccountPreference'] = ResolversParentTypes['SetAccountPreference']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type SetOrganizationDefaultTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetOrganizationDefaultTemplate'] = ResolversParentTypes['SetOrganizationDefaultTemplate']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type SetTeamDefaultTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetTeamDefaultTemplate'] = ResolversParentTypes['SetTeamDefaultTemplate']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type SupportDocSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportDocSearchResult'] = ResolversParentTypes['SupportDocSearchResult']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  distance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SymmetryLabelResolvers<ContextType = any, ParentType extends ResolversParentTypes['SymmetryLabel'] = ResolversParentTypes['SymmetryLabel']> = {
  left?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  right?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type TeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['Team'] = ResolversParentTypes['Team']> = {
  billingModeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  companionSessions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CompanionSession']>>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  defaultTemplates?: Resolver<Array<Maybe<ResolversTypes['AutoTemplate']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inventories?: Resolver<Maybe<Array<Maybe<ResolversTypes['Inventory']>>>, ParentType, ContextType>;
  isAutomatedBilling?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isManualBilling?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Note']>>>, ParentType, ContextType>;
  numUsers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType>;
  teamInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['TeamInvite']>>>, ParentType, ContextType>;
  userTeams?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserTeam']>>>, ParentType, ContextType>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verifiedPhoneNumbers?: Resolver<Maybe<Array<Maybe<ResolversTypes['VerifiedPhoneNumber']>>>, ParentType, ContextType>;
};

export type TeamInviteResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamInvite'] = ResolversParentTypes['TeamInvite']> = {
  accountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inviteeEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inviteeRoleId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isExistingUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sender?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  senderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>;
  teamId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  teamName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeResponded?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeSent?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type TeamInviteResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamInviteResponse'] = ResolversParentTypes['TeamInviteResponse']> = {
  inviteeEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teamName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type TeamUserNoteCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamUserNoteCount'] = ResolversParentTypes['TeamUserNoteCount']> = {
  noteCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  teamUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type TeamUserNoteCountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamUserNoteCounts'] = ResolversParentTypes['TeamUserNoteCounts']> = {
  noteCounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['TeamUserNoteCount']>>>, ParentType, ContextType>;
};

export type TemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Template'] = ResolversParentTypes['Template']> = {
  colorScheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isPreset?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  noteId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type TemplateGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateGroup'] = ResolversParentTypes['TemplateGroup']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sharingType?: Resolver<ResolversTypes['SharingTypeEnum'], ParentType, ContextType>;
  templates?: Resolver<Maybe<Array<Maybe<ResolversTypes['TemplateGroupAutoTemplate']>>>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['UserSummary']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TemplateGroupAutoTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateGroupAutoTemplate'] = ResolversParentTypes['TemplateGroupAutoTemplate']> = {
  autoTemplate?: Resolver<Maybe<ResolversTypes['AutoTemplate']>, ParentType, ContextType>;
  autoTemplateId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TemplatePreviewsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplatePreviews'] = ResolversParentTypes['TemplatePreviews']> = {
  autoTemplate?: Resolver<Maybe<ResolversTypes['AutoTemplate']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  noteId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  previewContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TemplateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateResponse'] = ResolversParentTypes['TemplateResponse']> = {
  colorScheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type TransferNoteOwnershipResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferNoteOwnership'] = ResolversParentTypes['TransferNoteOwnership']> = {
  failedNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type TreatBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatBalance'] = ResolversParentTypes['TreatBalance']> = {
  monthlyBalance?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  nextResetAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  permanentBalance?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalBalance?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  usageByCompanion?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatUsageByCompanion']>>>, ParentType, ContextType>;
};

export type TreatDailySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatDailySummary'] = ResolversParentTypes['TreatDailySummary']> = {
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  netChange?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  treatsCredited?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  treatsUsed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TreatUsageByCompanionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatUsageByCompanion'] = ResolversParentTypes['TreatUsageByCompanion']> = {
  companionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  treatsUsed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TriggerDentalChartExtractionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TriggerDentalChartExtraction'] = ResolversParentTypes['TriggerDentalChartExtraction']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export interface UuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UUID'], any> {
  name: 'UUID';
}

export type UngroupNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['UngroupNote'] = ResolversParentTypes['UngroupNote']> = {
  note?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type UpdateAccountPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAccountPlan'] = ResolversParentTypes['UpdateAccountPlan']> = {
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  freeTrialExpiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type UpdateAgentSessionTitleResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAgentSessionTitle'] = ResolversParentTypes['UpdateAgentSessionTitle']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type UpdateAutoTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAutoTemplate'] = ResolversParentTypes['UpdateAutoTemplate']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type UpdateForgottenPasswordResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateForgottenPassword'] = ResolversParentTypes['UpdateForgottenPassword']> = {
  ok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type UpdateScribeMdResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateScribeMd'] = ResolversParentTypes['UpdateScribeMd']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  scribeMd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type UpdateTemplateGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateTemplateGroup'] = ResolversParentTypes['UpdateTemplateGroup']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  templateGroup?: Resolver<Maybe<ResolversTypes['TemplateGroup']>, ParentType, ContextType>;
};

export type UpdateTemplateSharingResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateTemplateSharing'] = ResolversParentTypes['UpdateTemplateSharing']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type UpdateUserFfSegmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserFFSegment'] = ResolversParentTypes['UpdateUserFFSegment']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type UpdateUserTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserTeam'] = ResolversParentTypes['UpdateUserTeam']> = {
  billingImplication?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type UpdateVerifiedPhoneNumberSharingResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateVerifiedPhoneNumberSharing'] = ResolversParentTypes['UpdateVerifiedPhoneNumberSharing']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type UploadAgentSessionAttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadAgentSessionAttachment'] = ResolversParentTypes['UploadAgentSessionAttachment']> = {
  fileLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type UploadCompanionSessionAttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadCompanionSessionAttachment'] = ResolversParentTypes['UploadCompanionSessionAttachment']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type UploadHeaderImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadHeaderImage'] = ResolversParentTypes['UploadHeaderImage']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type UploadNoteAttachmentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadNoteAttachments'] = ResolversParentTypes['UploadNoteAttachments']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type UploadPatientAttachmentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadPatientAttachments'] = ResolversParentTypes['UploadPatientAttachments']> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type UploadPdfAndExtractTextResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadPdfAndExtractText'] = ResolversParentTypes['UploadPdfAndExtractText']> = {
  ASSESSMENT?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  CUSTOM?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  OBJECTIVE?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PLAN?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SUBJECTIVE?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type UploadSpeedTestResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadSpeedTest'] = ResolversParentTypes['UploadSpeedTest']> = {
  result?: Resolver<Maybe<ResolversTypes['UploadSpeedTestResult']>, ParentType, ContextType>;
};

export type UploadSpeedTestResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadSpeedTestResult'] = ResolversParentTypes['UploadSpeedTestResult']> = {
  fileSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  auditTrail?: Resolver<Maybe<Array<Maybe<ResolversTypes['AuditTrail']>>>, ParentType, ContextType>;
  autoExportEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  autoTemplates?: Resolver<Maybe<Array<Maybe<ResolversTypes['AutoTemplate']>>>, ParentType, ContextType>;
  bonusAppointments?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  canChangeScribephoneConsent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  clientSummaryPreferences?: Resolver<Maybe<ResolversTypes['ClientSummaryPreferences']>, ParentType, ContextType>;
  companionSessions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CompanionSession']>>>, ParentType, ContextType>;
  companionSubscription?: Resolver<Maybe<ResolversTypes['CompanionSubscription']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  distinctNoteCreationDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailExpiryDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  expiryPolicy?: Resolver<Maybe<ResolversTypes['JSONString']>, ParentType, ContextType>;
  featureActivations?: Resolver<Maybe<Array<Maybe<ResolversTypes['FeatureActivation']>>>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasApprovedNote?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasExportedNote?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasReachedAutoSoapLimit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasReachedNoteLimit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  inventories?: Resolver<Maybe<Array<Maybe<ResolversTypes['Inventory']>>>, ParentType, ContextType, RequireFields<UserInventoriesArgs, 'limit'>>;
  isAppointmentsBetaUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isConfirmed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDisabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isOnboardingComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isScribe?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastActive?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastLoggedInAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Note']>>>, ParentType, ContextType, Partial<UserNotesArgs>>;
  numAllowedStoredNotes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numAppointmentsAllowed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numAppointmentsUsed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numAutoSoapsUsedToday?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numReferralsMade?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numReferredSignups?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numStoredNotes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objectiveNormalDefaults?: Resolver<Maybe<ResolversTypes['ObjectiveNormalDefaults']>, ParentType, ContextType>;
  onboardingClinic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onboardingCorporateGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onboardingMilestones?: Resolver<Maybe<ResolversTypes['GenericScalar']>, ParentType, ContextType>;
  onboardingReferralSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType>;
  patients?: Resolver<Maybe<Array<Maybe<ResolversTypes['Patient']>>>, ParentType, ContextType>;
  pimsProvider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordingConsentHeader?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordingConsentText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordingConsentVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referral?: Resolver<Maybe<ResolversTypes['Referral']>, ParentType, ContextType>;
  requiresRecordingConsent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['Role']>, ParentType, ContextType>;
  roleId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roleInt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scribephoneConsentMode?: Resolver<Maybe<ResolversTypes['ScribephoneConsentEnum']>, ParentType, ContextType>;
  scribephoneConsentOptIn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shouldEmbedEmailExports?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shouldShowAutoSoapCounter?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shouldUseAutoSoaps?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  teams?: Resolver<Maybe<Array<Maybe<ResolversTypes['Team']>>>, ParentType, ContextType>;
  templates?: Resolver<Maybe<Array<Maybe<ResolversTypes['Template']>>>, ParentType, ContextType>;
  totalNotesCreated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userPermissions?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserPermission']>>>, ParentType, ContextType>;
  userTeams?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserTeam']>>>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verifiedPhoneNumbers?: Resolver<Maybe<Array<Maybe<ResolversTypes['VerifiedPhoneNumber']>>>, ParentType, ContextType>;
};

export type UserChecksResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserChecks'] = ResolversParentTypes['UserChecks']> = {
  deactivatedUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  existingUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExistingUser']>>>, ParentType, ContextType>;
  newUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
};

export type UserNotePollQueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNotePollQuery'] = ResolversParentTypes['UserNotePollQuery']> = {
  lastUpdated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type UserNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNotification'] = ResolversParentTypes['UserNotification']> = {
  actionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activeAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  dismissedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  extra?: Resolver<Maybe<ResolversTypes['JSONString']>, ParentType, ContextType>;
  isBroadcast?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notificationDomain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  readAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type UserPermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPermission'] = ResolversParentTypes['UserPermission']> = {
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  permissionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type UserSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSummary'] = ResolversParentTypes['UserSummary']> = {
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type UserTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTeam'] = ResolversParentTypes['UserTeam']> = {
  isAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSelfSubscribed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  roleId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
};

export type VerifiedPhoneNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerifiedPhoneNumber'] = ResolversParentTypes['VerifiedPhoneNumber']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  extension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isOwnedByCurrentUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>;
  teamUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  twilioVerificationApprovedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  twilioVerificationSid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  twilioVerificationStatus?: Resolver<Maybe<ResolversTypes['TwilioVerificationStatus']>, ParentType, ContextType>;
  twilioVerificationSubmittedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verifiedPhoneNumberUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type WireUpWarningResolvers<ContextType = any, ParentType extends ResolversParentTypes['WireUpWarning'] = ResolversParentTypes['WireUpWarning']> = {
  reason?: Resolver<ResolversTypes['WireUpWarningReason'], ParentType, ContextType>;
};

export type WritingCompanionProposalResolvers<ContextType = any, ParentType extends ResolversParentTypes['WritingCompanionProposal'] = ResolversParentTypes['WritingCompanionProposal']> = {
  accepted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  actionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  afterContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  beforeContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  noteSection?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  noteUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resolvedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AcceptLLMCustomization?: AcceptLlmCustomizationResolvers<ContextType>;
  AcceptTeamInvitation?: AcceptTeamInvitationResolvers<ContextType>;
  Account?: AccountResolvers<ContextType>;
  AccountDetails?: AccountDetailsResolvers<ContextType>;
  AddFeedbackToCustomization?: AddFeedbackToCustomizationResolvers<ContextType>;
  AddFeedbackToLog?: AddFeedbackToLogResolvers<ContextType>;
  AddMphCompanionMembers?: AddMphCompanionMembersResolvers<ContextType>;
  AddMphCompanionSkipped?: AddMphCompanionSkippedResolvers<ContextType>;
  AddNoteToGroup?: AddNoteToGroupResolvers<ContextType>;
  AddOrgAdmin?: AddOrgAdminResolvers<ContextType>;
  AddUsersToTeam?: AddUsersToTeamResolvers<ContextType>;
  AdminAccountInfo?: AdminAccountInfoResolvers<ContextType>;
  AdminAccountTypeCount?: AdminAccountTypeCountResolvers<ContextType>;
  AdminAgentSessionDetail?: AdminAgentSessionDetailResolvers<ContextType>;
  AdminAgentSessionListItem?: AdminAgentSessionListItemResolvers<ContextType>;
  AdminAgentSessionListResult?: AdminAgentSessionListResultResolvers<ContextType>;
  AdminAgentSessionTokens?: AdminAgentSessionTokensResolvers<ContextType>;
  AdminAgentSessionTotals?: AdminAgentSessionTotalsResolvers<ContextType>;
  AdminAgentSessionTreatLine?: AdminAgentSessionTreatLineResolvers<ContextType>;
  AdminBillingCustomerRow?: AdminBillingCustomerRowResolvers<ContextType>;
  AdminBillingCustomerSearchResult?: AdminBillingCustomerSearchResultResolvers<ContextType>;
  AdminBulkDeleteApplied?: AdminBulkDeleteAppliedResolvers<ContextType>;
  AdminBulkDeleteRejected?: AdminBulkDeleteRejectedResolvers<ContextType>;
  AdminBulkMarkUsersForDeletion?: AdminBulkMarkUsersForDeletionResolvers<ContextType>;
  AdminBulkTeamRef?: AdminBulkTeamRefResolvers<ContextType>;
  AdminCashOut?: AdminCashOutResolvers<ContextType>;
  AdminCashOutsPage?: AdminCashOutsPageResolvers<ContextType>;
  AdminDeleteTeam?: AdminDeleteTeamResolvers<ContextType>;
  AdminDeleteVerifiedPhoneNumber?: AdminDeleteVerifiedPhoneNumberResolvers<ContextType>;
  AdminEditAccount?: AdminEditAccountResolvers<ContextType>;
  AdminEditOrganization?: AdminEditOrganizationResolvers<ContextType>;
  AdminEditOrganizationEmailSettings?: AdminEditOrganizationEmailSettingsResolvers<ContextType>;
  AdminEditOrganizationRecordingConsent?: AdminEditOrganizationRecordingConsentResolvers<ContextType>;
  AdminEditTeam?: AdminEditTeamResolvers<ContextType>;
  AdminEditTeamMember?: AdminEditTeamMemberResolvers<ContextType>;
  AdminEditUser?: AdminEditUserResolvers<ContextType>;
  AdminGiveTreats?: AdminGiveTreatsResolvers<ContextType>;
  AdminLinkedOrg?: AdminLinkedOrgResolvers<ContextType>;
  AdminMemberRemovalBillingCheck?: AdminMemberRemovalBillingCheckResolvers<ContextType>;
  AdminMemberRemovalImpact?: AdminMemberRemovalImpactResolvers<ContextType>;
  AdminMemberRemovalPreflight?: AdminMemberRemovalPreflightResolvers<ContextType>;
  AdminMembershipOrgGroup?: AdminMembershipOrgGroupResolvers<ContextType>;
  AdminMembershipTeam?: AdminMembershipTeamResolvers<ContextType>;
  AdminMoveTeamToOrg?: AdminMoveTeamToOrgResolvers<ContextType>;
  AdminMphBulkAssignTeamRoles?: AdminMphBulkAssignTeamRolesResolvers<ContextType>;
  AdminMphBulkReassignApplied?: AdminMphBulkReassignAppliedResolvers<ContextType>;
  AdminMphBulkReassignRejected?: AdminMphBulkReassignRejectedResolvers<ContextType>;
  AdminMphBulkReassignTeams?: AdminMphBulkReassignTeamsResolvers<ContextType>;
  AdminMphBulkRoleApplied?: AdminMphBulkRoleAppliedResolvers<ContextType>;
  AdminMphBulkRoleRejected?: AdminMphBulkRoleRejectedResolvers<ContextType>;
  AdminMphCompanionMember?: AdminMphCompanionMemberResolvers<ContextType>;
  AdminMphCompanionMembersResult?: AdminMphCompanionMembersResultResolvers<ContextType>;
  AdminMphCompanionTeam?: AdminMphCompanionTeamResolvers<ContextType>;
  AdminNoteDetail?: AdminNoteDetailResolvers<ContextType>;
  AdminNoteFields?: AdminNoteFieldsResolvers<ContextType>;
  AdminNoteRow?: AdminNoteRowResolvers<ContextType>;
  AdminNoteTemplateOption?: AdminNoteTemplateOptionResolvers<ContextType>;
  AdminNotesPage?: AdminNotesPageResolvers<ContextType>;
  AdminOrgEmailTemplatePreview?: AdminOrgEmailTemplatePreviewResolvers<ContextType>;
  AdminOrganizationAdmin?: AdminOrganizationAdminResolvers<ContextType>;
  AdminOrganizationBilling?: AdminOrganizationBillingResolvers<ContextType>;
  AdminOrganizationDetail?: AdminOrganizationDetailResolvers<ContextType>;
  AdminOrganizationEmailSetting?: AdminOrganizationEmailSettingResolvers<ContextType>;
  AdminOrganizationInfo?: AdminOrganizationInfoResolvers<ContextType>;
  AdminOrganizationMember?: AdminOrganizationMemberResolvers<ContextType>;
  AdminOrganizationMemberTeam?: AdminOrganizationMemberTeamResolvers<ContextType>;
  AdminOrganizationMembersPage?: AdminOrganizationMembersPageResolvers<ContextType>;
  AdminOrganizationSummary?: AdminOrganizationSummaryResolvers<ContextType>;
  AdminOrganizationTeam?: AdminOrganizationTeamResolvers<ContextType>;
  AdminOrganizationTeamsPage?: AdminOrganizationTeamsPageResolvers<ContextType>;
  AdminOrganizationsList?: AdminOrganizationsListResolvers<ContextType>;
  AdminReferralInfo?: AdminReferralInfoResolvers<ContextType>;
  AdminReferredUser?: AdminReferredUserResolvers<ContextType>;
  AdminReferredUsersPage?: AdminReferredUsersPageResolvers<ContextType>;
  AdminRemoveTeamMember?: AdminRemoveTeamMemberResolvers<ContextType>;
  AdminResendInvitation?: AdminResendInvitationResolvers<ContextType>;
  AdminRevokeInvitation?: AdminRevokeInvitationResolvers<ContextType>;
  AdminRevokeOrganizationStripeCustomer?: AdminRevokeOrganizationStripeCustomerResolvers<ContextType>;
  AdminRoleOption?: AdminRoleOptionResolvers<ContextType>;
  AdminSetOrganizationAdmin?: AdminSetOrganizationAdminResolvers<ContextType>;
  AdminStripeCustomerLinkage?: AdminStripeCustomerLinkageResolvers<ContextType>;
  AdminTeamDeletionCheck?: AdminTeamDeletionCheckResolvers<ContextType>;
  AdminTeamDetail?: AdminTeamDetailResolvers<ContextType>;
  AdminTeamMember?: AdminTeamMemberResolvers<ContextType>;
  AdminTeamMembersPage?: AdminTeamMembersPageResolvers<ContextType>;
  AdminTeamMoveCheck?: AdminTeamMoveCheckResolvers<ContextType>;
  AdminTeamSummary?: AdminTeamSummaryResolvers<ContextType>;
  AdminTeamsList?: AdminTeamsListResolvers<ContextType>;
  AdminTemplateDefault?: AdminTemplateDefaultResolvers<ContextType>;
  AdminTemplateDetail?: AdminTemplateDetailResolvers<ContextType>;
  AdminTemplateField?: AdminTemplateFieldResolvers<ContextType>;
  AdminTreatBalanceInfo?: AdminTreatBalanceInfoResolvers<ContextType>;
  AdminTreatInfo?: AdminTreatInfoResolvers<ContextType>;
  AdminTreatPlan?: AdminTreatPlanResolvers<ContextType>;
  AdminUnwireAccount?: AdminUnwireAccountResolvers<ContextType>;
  AdminUpdateOrganizationStripeCustomer?: AdminUpdateOrganizationStripeCustomerResolvers<ContextType>;
  AdminUserCounts?: AdminUserCountsResolvers<ContextType>;
  AdminUserInfo?: AdminUserInfoResolvers<ContextType>;
  AdminUserListItem?: AdminUserListItemResolvers<ContextType>;
  AdminUserListResult?: AdminUserListResultResolvers<ContextType>;
  AdminUserLookupResult?: AdminUserLookupResultResolvers<ContextType>;
  AdminUserMembershipResult?: AdminUserMembershipResultResolvers<ContextType>;
  AdminUserOrg?: AdminUserOrgResolvers<ContextType>;
  AdminUserTeam?: AdminUserTeamResolvers<ContextType>;
  AdminUserTemplate?: AdminUserTemplateResolvers<ContextType>;
  AdminUserTemplatesPage?: AdminUserTemplatesPageResolvers<ContextType>;
  AdminVerifiedPhoneLookupResult?: AdminVerifiedPhoneLookupResultResolvers<ContextType>;
  AdminVerifiedPhoneVerification?: AdminVerifiedPhoneVerificationResolvers<ContextType>;
  AdminVerifiedPhoneVerifierTeam?: AdminVerifiedPhoneVerifierTeamResolvers<ContextType>;
  AdminVerifiedPhoneVerifierUser?: AdminVerifiedPhoneVerifierUserResolvers<ContextType>;
  AdminWireUpAccount?: AdminWireUpAccountResolvers<ContextType>;
  AgentSession?: AgentSessionResolvers<ContextType>;
  AgentSessionEvent?: AgentSessionEventResolvers<ContextType>;
  AgentSessionEventsPage?: AgentSessionEventsPageResolvers<ContextType>;
  AgentToolPermissionGrant?: AgentToolPermissionGrantResolvers<ContextType>;
  AllowedRole?: AllowedRoleResolvers<ContextType>;
  AppendRecording?: AppendRecordingResolvers<ContextType>;
  AssociateQuicknotesWithPatient?: AssociateQuicknotesWithPatientResolvers<ContextType>;
  Attachment?: AttachmentResolvers<ContextType>;
  AuditLogEntry?: AuditLogEntryResolvers<ContextType>;
  AuditLogResult?: AuditLogResultResolvers<ContextType>;
  AuditTrail?: AuditTrailResolvers<ContextType>;
  AutoTemplate?: AutoTemplateResolvers<ContextType>;
  AutoTemplateField?: AutoTemplateFieldResolvers<ContextType>;
  AutoUsageDetails?: AutoUsageDetailsResolvers<ContextType>;
  BirthdayParts?: BirthdayPartsResolvers<ContextType>;
  BulkRestoreSkipped?: BulkRestoreSkippedResolvers<ContextType>;
  BulkRestoreUsers?: BulkRestoreUsersResolvers<ContextType>;
  BulkSetExpiryPolicy?: BulkSetExpiryPolicyResolvers<ContextType>;
  BulkSetRole?: BulkSetRoleResolvers<ContextType>;
  CancelBroadcastNotification?: CancelBroadcastNotificationResolvers<ContextType>;
  CancelNotification?: CancelNotificationResolvers<ContextType>;
  ChangeScribephoneConsentMode?: ChangeScribephoneConsentModeResolvers<ContextType>;
  CheckinNote?: CheckinNoteResolvers<ContextType>;
  CheckoutNote?: CheckoutNoteResolvers<ContextType>;
  ClientSummaryPreferences?: ClientSummaryPreferencesResolvers<ContextType>;
  ClientSummaryPreferencesType?: ClientSummaryPreferencesTypeResolvers<ContextType>;
  CloseCompanionSession?: CloseCompanionSessionResolvers<ContextType>;
  CompanionAccountSettings?: CompanionAccountSettingsResolvers<ContextType>;
  CompanionContext?: CompanionContextResolvers<ContextType>;
  CompanionContextSettings?: CompanionContextSettingsResolvers<ContextType>;
  CompanionContextTeam?: CompanionContextTeamResolvers<ContextType>;
  CompanionContextUser?: CompanionContextUserResolvers<ContextType>;
  CompanionOrganizationSettings?: CompanionOrganizationSettingsResolvers<ContextType>;
  CompanionSession?: CompanionSessionResolvers<ContextType>;
  CompanionSessionEstimate?: CompanionSessionEstimateResolvers<ContextType>;
  CompanionSessionEstimateItem?: CompanionSessionEstimateItemResolvers<ContextType>;
  CompanionSessionEstimateItemChoice?: CompanionSessionEstimateItemChoiceResolvers<ContextType>;
  CompanionSessionKnowledge?: CompanionSessionKnowledgeResolvers<ContextType>;
  CompanionSessionMessage?: CompanionSessionMessageResolvers<ContextType>;
  CompanionSessionMessageStatusSummary?: CompanionSessionMessageStatusSummaryResolvers<ContextType>;
  CompanionSessionStatusSummary?: CompanionSessionStatusSummaryResolvers<ContextType>;
  CompanionSessionTask?: CompanionSessionTaskResolvers<ContextType>;
  CompanionSessionTaskStatusSummary?: CompanionSessionTaskStatusSummaryResolvers<ContextType>;
  CompanionSubscription?: CompanionSubscriptionResolvers<ContextType>;
  CompanionToolPermissionDetail?: CompanionToolPermissionDetailResolvers<ContextType>;
  CompanionToolPermissionRequest?: CompanionToolPermissionRequestResolvers<ContextType>;
  CompanionUserSettings?: CompanionUserSettingsResolvers<ContextType>;
  ConfirmUser?: ConfirmUserResolvers<ContextType>;
  CopyAutoTemplate?: CopyAutoTemplateResolvers<ContextType>;
  CopyNotesToPatient?: CopyNotesToPatientResolvers<ContextType>;
  CorrectPatientNameInNote?: CorrectPatientNameInNoteResolvers<ContextType>;
  CreateAgentSession?: CreateAgentSessionResolvers<ContextType>;
  CreateAgentToolPermissionGrant?: CreateAgentToolPermissionGrantResolvers<ContextType>;
  CreateAutoTemplate?: CreateAutoTemplateResolvers<ContextType>;
  CreateBroadcastNotification?: CreateBroadcastNotificationResolvers<ContextType>;
  CreateCompanionSession?: CreateCompanionSessionResolvers<ContextType>;
  CreateCustomOrg?: CreateCustomOrgResolvers<ContextType>;
  CreateGroupedNotes?: CreateGroupedNotesResolvers<ContextType>;
  CreateNote?: CreateNoteResolvers<ContextType>;
  CreateOrganization?: CreateOrganizationResolvers<ContextType>;
  CreatePatient?: CreatePatientResolvers<ContextType>;
  CreatePatientNote?: CreatePatientNoteResolvers<ContextType>;
  CreateQuickNote?: CreateQuickNoteResolvers<ContextType>;
  CreateTeam?: CreateTeamResolvers<ContextType>;
  CreateTeamUnderOrg?: CreateTeamUnderOrgResolvers<ContextType>;
  CreateTemplateGroup?: CreateTemplateGroupResolvers<ContextType>;
  CreateTemplatePreview?: CreateTemplatePreviewResolvers<ContextType>;
  CreateTestUser?: CreateTestUserResolvers<ContextType>;
  CreateUser?: CreateUserResolvers<ContextType>;
  CreateUserFromTeamInvitation?: CreateUserFromTeamInvitationResolvers<ContextType>;
  CreateV1Team?: CreateV1TeamResolvers<ContextType>;
  CustomFormField?: CustomFormFieldResolvers<ContextType>;
  CustomObjectiveField?: CustomObjectiveFieldResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  DeactivateOrgTeamUser?: DeactivateOrgTeamUserResolvers<ContextType>;
  DeductAgentSessionTreats?: DeductAgentSessionTreatsResolvers<ContextType>;
  DeleteAgentSession?: DeleteAgentSessionResolvers<ContextType>;
  DeleteAttachment?: DeleteAttachmentResolvers<ContextType>;
  DeleteAutoTemplate?: DeleteAutoTemplateResolvers<ContextType>;
  DeleteCompanionSession?: DeleteCompanionSessionResolvers<ContextType>;
  DeleteHeaderImage?: DeleteHeaderImageResolvers<ContextType>;
  DeleteNote?: DeleteNoteResolvers<ContextType>;
  DeleteNoteAudioRecording?: DeleteNoteAudioRecordingResolvers<ContextType>;
  DeleteNotes?: DeleteNotesResolvers<ContextType>;
  DeletePatient?: DeletePatientResolvers<ContextType>;
  DeleteTeam?: DeleteTeamResolvers<ContextType>;
  DeleteTemplate?: DeleteTemplateResolvers<ContextType>;
  DeleteTemplateGroup?: DeleteTemplateGroupResolvers<ContextType>;
  DeleteUser?: DeleteUserResolvers<ContextType>;
  DeleteVerifiedPhoneNumber?: DeleteVerifiedPhoneNumberResolvers<ContextType>;
  DenyTeamInvitation?: DenyTeamInvitationResolvers<ContextType>;
  DescopeAdminPortalSession?: DescopeAdminPortalSessionResolvers<ContextType>;
  DescopeMobileSession?: DescopeMobileSessionResolvers<ContextType>;
  DescopeWebSession?: DescopeWebSessionResolvers<ContextType>;
  DetachNotesFromPatient?: DetachNotesFromPatientResolvers<ContextType>;
  DismissNotification?: DismissNotificationResolvers<ContextType>;
  DismissNotificationsByNote?: DismissNotificationsByNoteResolvers<ContextType>;
  EditAccountPreferences?: EditAccountPreferencesResolvers<ContextType>;
  EditClientSummaryPreferences?: EditClientSummaryPreferencesResolvers<ContextType>;
  EditObjectiveNormalDefaults?: EditObjectiveNormalDefaultsResolvers<ContextType>;
  EditPDFSettings?: EditPdfSettingsResolvers<ContextType>;
  EditPatient?: EditPatientResolvers<ContextType>;
  EditTemplate?: EditTemplateResolvers<ContextType>;
  EditUser?: EditUserResolvers<ContextType>;
  ExistingAccount?: ExistingAccountResolvers<ContextType>;
  ExistingTeam?: ExistingTeamResolvers<ContextType>;
  ExistingUser?: ExistingUserResolvers<ContextType>;
  FeatureActivation?: FeatureActivationResolvers<ContextType>;
  FlagNoteToSupport?: FlagNoteToSupportResolvers<ContextType>;
  GenerateAdaptiveClientSummary?: GenerateAdaptiveClientSummaryResolvers<ContextType>;
  GenerateAgentSessionTitle?: GenerateAgentSessionTitleResolvers<ContextType>;
  GenerateClientSummary?: GenerateClientSummaryResolvers<ContextType>;
  GenerateClientSummaryNext?: GenerateClientSummaryNextResolvers<ContextType>;
  GenerateLLMCustomization?: GenerateLlmCustomizationResolvers<ContextType>;
  GenericScalar?: GraphQLScalarType;
  GoogleAuthResponse?: GoogleAuthResponseResolvers<ContextType>;
  HardDeleteNotes?: HardDeleteNotesResolvers<ContextType>;
  HardDeleteUser?: HardDeleteUserResolvers<ContextType>;
  InboxNotes?: InboxNotesResolvers<ContextType>;
  InboxTabCount?: InboxTabCountResolvers<ContextType>;
  IncrementAutoUsage?: IncrementAutoUsageResolvers<ContextType>;
  InitializeStream?: InitializeStreamResolvers<ContextType>;
  Inventory?: InventoryResolvers<ContextType>;
  InventoryItem?: InventoryItemResolvers<ContextType>;
  InviteUsersToTeam?: InviteUsersToTeamResolvers<ContextType>;
  JSONString?: GraphQLScalarType;
  LinkRecordingConsentToNote?: LinkRecordingConsentToNoteResolvers<ContextType>;
  LogRecordingConsent?: LogRecordingConsentResolvers<ContextType>;
  LogScribephoneConsent?: LogScribephoneConsentResolvers<ContextType>;
  LoginUser?: LoginUserResolvers<ContextType>;
  LoginUserAccount?: LoginUserAccountResolvers<ContextType>;
  LoginUserOrganization?: LoginUserOrganizationResolvers<ContextType>;
  LoginUserResponse?: LoginUserResponseResolvers<ContextType>;
  LoginUserTeam?: LoginUserTeamResolvers<ContextType>;
  LogoutUser?: LogoutUserResolvers<ContextType>;
  MarkAgentSessionAttachmentsSent?: MarkAgentSessionAttachmentsSentResolvers<ContextType>;
  MarkAgentToolPermissionGrantUsed?: MarkAgentToolPermissionGrantUsedResolvers<ContextType>;
  MarkNotificationRead?: MarkNotificationReadResolvers<ContextType>;
  MarkUserForDeletion?: MarkUserForDeletionResolvers<ContextType>;
  ModifiedUser?: ModifiedUserResolvers<ContextType>;
  ModifyNote?: ModifyNoteResolvers<ContextType>;
  ModifyNotes?: ModifyNotesResolvers<ContextType>;
  MoveNotesToPatient?: MoveNotesToPatientResolvers<ContextType>;
  Mutations?: MutationsResolvers<ContextType>;
  Note?: NoteResolvers<ContextType>;
  NoteGroup?: NoteGroupResolvers<ContextType>;
  NoteGroupNote?: NoteGroupNoteResolvers<ContextType>;
  ObjectiveNormalDefaults?: ObjectiveNormalDefaultsResolvers<ContextType>;
  OnboardingProgress?: OnboardingProgressResolvers<ContextType>;
  OrgBillingShare?: OrgBillingShareResolvers<ContextType>;
  OrgStripeWarning?: OrgStripeWarningResolvers<ContextType>;
  OrgStripeWarningOrganization?: OrgStripeWarningOrganizationResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  OrganizationRecordingConsentEvents?: OrganizationRecordingConsentEventsResolvers<ContextType>;
  ParsedPatientSignalment?: ParsedPatientSignalmentResolvers<ContextType>;
  Patient?: PatientResolvers<ContextType>;
  PersistentLoginUser?: PersistentLoginUserResolvers<ContextType>;
  PopulateUserSampleTemplates?: PopulateUserSampleTemplatesResolvers<ContextType>;
  ProposeLLMEdit?: ProposeLlmEditResolvers<ContextType>;
  ProtectNote?: ProtectNoteResolvers<ContextType>;
  ProvisionedUsers?: ProvisionedUsersResolvers<ContextType>;
  RecordingConsentEvent?: RecordingConsentEventResolvers<ContextType>;
  RedeemCredits?: RedeemCreditsResolvers<ContextType>;
  Referral?: ReferralResolvers<ContextType>;
  RefreshUserToken?: RefreshUserTokenResolvers<ContextType>;
  RemoveOrganizationDefaultTemplate?: RemoveOrganizationDefaultTemplateResolvers<ContextType>;
  RemoveTeamDefaultTemplate?: RemoveTeamDefaultTemplateResolvers<ContextType>;
  RemoveUserFromOrgTeam?: RemoveUserFromOrgTeamResolvers<ContextType>;
  RemoveUserFromTeam?: RemoveUserFromTeamResolvers<ContextType>;
  RequestPhoneVerification?: RequestPhoneVerificationResolvers<ContextType>;
  RequestTeamSetup?: RequestTeamSetupResolvers<ContextType>;
  ResendUserConfirmation?: ResendUserConfirmationResolvers<ContextType>;
  RestoreUser?: RestoreUserResolvers<ContextType>;
  RetoolCreateQuickNote?: RetoolCreateQuickNoteResolvers<ContextType>;
  RetoolDeleteNotes?: RetoolDeleteNotesResolvers<ContextType>;
  RetryFailedAutoSoap?: RetryFailedAutoSoapResolvers<ContextType>;
  RevokeAgentToolPermissionGrant?: RevokeAgentToolPermissionGrantResolvers<ContextType>;
  Role?: RoleResolvers<ContextType>;
  Root?: RootResolvers<ContextType>;
  ScheduleNotification?: ScheduleNotificationResolvers<ContextType>;
  SendClientSummaryEmail?: SendClientSummaryEmailResolvers<ContextType>;
  SendCompanionSessionMessage?: SendCompanionSessionMessageResolvers<ContextType>;
  SendDashboardDesktopLink?: SendDashboardDesktopLinkResolvers<ContextType>;
  SendExportNoteEmail?: SendExportNoteEmailResolvers<ContextType>;
  SendForgotPasswordEmail?: SendForgotPasswordEmailResolvers<ContextType>;
  SendNoteDesktopLink?: SendNoteDesktopLinkResolvers<ContextType>;
  SetAccountPreference?: SetAccountPreferenceResolvers<ContextType>;
  SetOrganizationDefaultTemplate?: SetOrganizationDefaultTemplateResolvers<ContextType>;
  SetTeamDefaultTemplate?: SetTeamDefaultTemplateResolvers<ContextType>;
  SupportDocSearchResult?: SupportDocSearchResultResolvers<ContextType>;
  SymmetryLabel?: SymmetryLabelResolvers<ContextType>;
  Team?: TeamResolvers<ContextType>;
  TeamInvite?: TeamInviteResolvers<ContextType>;
  TeamInviteResponse?: TeamInviteResponseResolvers<ContextType>;
  TeamUserNoteCount?: TeamUserNoteCountResolvers<ContextType>;
  TeamUserNoteCounts?: TeamUserNoteCountsResolvers<ContextType>;
  Template?: TemplateResolvers<ContextType>;
  TemplateGroup?: TemplateGroupResolvers<ContextType>;
  TemplateGroupAutoTemplate?: TemplateGroupAutoTemplateResolvers<ContextType>;
  TemplatePreviews?: TemplatePreviewsResolvers<ContextType>;
  TemplateResponse?: TemplateResponseResolvers<ContextType>;
  TransferNoteOwnership?: TransferNoteOwnershipResolvers<ContextType>;
  TreatBalance?: TreatBalanceResolvers<ContextType>;
  TreatDailySummary?: TreatDailySummaryResolvers<ContextType>;
  TreatUsageByCompanion?: TreatUsageByCompanionResolvers<ContextType>;
  TriggerDentalChartExtraction?: TriggerDentalChartExtractionResolvers<ContextType>;
  UUID?: GraphQLScalarType;
  UngroupNote?: UngroupNoteResolvers<ContextType>;
  UpdateAccountPlan?: UpdateAccountPlanResolvers<ContextType>;
  UpdateAgentSessionTitle?: UpdateAgentSessionTitleResolvers<ContextType>;
  UpdateAutoTemplate?: UpdateAutoTemplateResolvers<ContextType>;
  UpdateForgottenPassword?: UpdateForgottenPasswordResolvers<ContextType>;
  UpdateScribeMd?: UpdateScribeMdResolvers<ContextType>;
  UpdateTemplateGroup?: UpdateTemplateGroupResolvers<ContextType>;
  UpdateTemplateSharing?: UpdateTemplateSharingResolvers<ContextType>;
  UpdateUserFFSegment?: UpdateUserFfSegmentResolvers<ContextType>;
  UpdateUserTeam?: UpdateUserTeamResolvers<ContextType>;
  UpdateVerifiedPhoneNumberSharing?: UpdateVerifiedPhoneNumberSharingResolvers<ContextType>;
  UploadAgentSessionAttachment?: UploadAgentSessionAttachmentResolvers<ContextType>;
  UploadCompanionSessionAttachment?: UploadCompanionSessionAttachmentResolvers<ContextType>;
  UploadHeaderImage?: UploadHeaderImageResolvers<ContextType>;
  UploadNoteAttachments?: UploadNoteAttachmentsResolvers<ContextType>;
  UploadPatientAttachments?: UploadPatientAttachmentsResolvers<ContextType>;
  UploadPdfAndExtractText?: UploadPdfAndExtractTextResolvers<ContextType>;
  UploadSpeedTest?: UploadSpeedTestResolvers<ContextType>;
  UploadSpeedTestResult?: UploadSpeedTestResultResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserChecks?: UserChecksResolvers<ContextType>;
  UserNotePollQuery?: UserNotePollQueryResolvers<ContextType>;
  UserNotification?: UserNotificationResolvers<ContextType>;
  UserPermission?: UserPermissionResolvers<ContextType>;
  UserSummary?: UserSummaryResolvers<ContextType>;
  UserTeam?: UserTeamResolvers<ContextType>;
  VerifiedPhoneNumber?: VerifiedPhoneNumberResolvers<ContextType>;
  WireUpWarning?: WireUpWarningResolvers<ContextType>;
  WritingCompanionProposal?: WritingCompanionProposalResolvers<ContextType>;
};

